{
  "DESKTOP.json": {
    "$id": "urn:dm:schemas:DESKTOP.json",
    "DesignQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PropertyQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StyleId": {
      "type": [
        "null",
        "string"
      ]
    },
    "MobileHintsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BehaviorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ConnectionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "AnchorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransformationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransitionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "y": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "width": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "height": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "rotationInDegrees": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360
                  },
                  "fixedPosition": {
                    "type": "boolean"
                  },
                  "scale": {
                    "type": "number"
                  },
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": {
                          "type": "number",
                          "default": 0
                        },
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": {
                          "type": "boolean",
                          "default": false
                        },
                        "targetComponent": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "propertyQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "styleId": {
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "y": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "height": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "RepeaterVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components",
        "documentType"
      ]
    },
    "Parent": {
      "type": [
        "null",
        "string"
      ]
    },
    "ClassnamesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ContentRoleQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ControllersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "CursorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DiscussionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EditorsettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EffectsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "FixerVersionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "GroupingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsMetaDataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "IntentQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutSettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ManifestQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MeasurementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MigrationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NamingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NotificationsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PageSectionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PatternsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PresetsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ReactionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SlotsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SourceQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StatesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ThemeConfigQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TriggersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariablesQuery": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "MOBILE.json": {
    "$id": "urn:dm:schemas:MOBILE.json",
    "DesignQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PropertyQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StyleId": {
      "type": [
        "null",
        "string"
      ]
    },
    "MobileHintsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BehaviorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ConnectionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "AnchorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransformationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransitionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "y": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "width": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "height": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "rotationInDegrees": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360
                  },
                  "fixedPosition": {
                    "type": "boolean"
                  },
                  "scale": {
                    "type": "number"
                  },
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": {
                          "type": "number",
                          "default": 0
                        },
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": {
                          "type": "boolean",
                          "default": false
                        },
                        "targetComponent": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "propertyQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "styleId": {
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "y": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "height": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "RepeaterVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components",
        "documentType"
      ]
    },
    "Parent": {
      "type": [
        "null",
        "string"
      ]
    },
    "ClassnamesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ContentRoleQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ControllersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "CursorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DiscussionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EditorsettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EffectsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "FixerVersionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "GroupingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsMetaDataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "IntentQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutSettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ManifestQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MeasurementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MigrationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NamingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NotificationsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PageSectionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PatternsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PresetsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ReactionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SlotsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SourceQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StatesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ThemeConfigQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TriggersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariablesQuery": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "anchors_data.json": {
    "$id": "urn:dm:schemas:anchors_data.json",
    "AnchorInfo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "urlFragment": {
          "type": "string",
          "maxLength": 60
        }
      }
    }
  },
  "atomicScopes.json": {
    "$id": "urn:dm:schemas:atomicScopes.json",
    "AtomicScope": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    }
  },
  "behaviors_data.json": {
    "$id": "urn:dm:schemas:behaviors_data.json",
    "ObsoleteBehaviorsList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "type": [
            "string"
          ]
        }
      }
    }
  },
  "breakpoints_data.json": {
    "$id": "urn:dm:schemas:breakpoints_data.json",
    "BreakpointsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "values"
      ]
    },
    "BreakpointRange": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "min": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "max": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "canvasSize": {
          "type": "number",
          "multipleOf": 1
        }
      }
    }
  },
  "classnames.json": {
    "$id": "urn:dm:schemas:classnames.json",
    "Classnames": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "classnames": {
          "type": "array",
          "items": {
            "type": "string",
            "pattern": "^-?[_a-zA-Z]+[_a-zA-Z0-9-]*$",
            "maxLength": 200
          },
          "default": [],
          "maxItems": 20
        }
      },
      "required": [
        "classnames"
      ]
    }
  },
  "commonSchemas.json": {
    "$id": "urn:dm:schemas:commonSchemas.json",
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "BreakpointRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "breakpoint": {
          "type": [
            "string"
          ]
        },
        "ref": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "breakpoint",
        "ref"
      ]
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    },
    "MinimalUnitSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "percentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "fr",
            "percentage",
            "vh",
            "vw",
            "spx",
            "siteWidthPercentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "SPXReferenceDefinition": {
      "type": "object",
      "required": [
        "refWidth",
        "resolverType"
      ],
      "properties": {
        "refWidth": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "resolverType": {
          "type": "string",
          "enum": [
            "scale",
            "fixed"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitLength": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitLengthPercentage": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "percentage",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitAngle": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "deg",
            "percentage"
          ]
        }
      },
      "additionalProperties": false
    },
    "UnitSizeArea": {
      "type": "object",
      "properties": {
        "width": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "UnitSizePoint": {
      "type": "object",
      "properties": {
        "x": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "y": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BreakpointsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "values"
      ]
    },
    "BreakpointRange": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "min": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "max": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "canvasSize": {
          "type": "number",
          "multipleOf": 1
        }
      }
    },
    "NumberThatCanConnectToAVariable": {
      "type": "number"
    },
    "LinkReference": {
      "pattern": "^$|^#",
      "type": [
        "null",
        "string"
      ]
    },
    "Common_Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "description": "Original Image before edit",
          "type": [
            "null",
            "string"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "description": "Information about the artist of the image.",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Common_SVGItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "ColorLayers": {
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "GradientLinearLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientCircleLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "value",
                    "type"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                },
                {
                  "required": [],
                  "maxProperties": 0
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientEllipseLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "width",
                    "height"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientMeshLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "oneOf": [
                      {
                        "required": [
                          "value",
                          "type"
                        ]
                      },
                      {
                        "required": [
                          "keyword"
                        ]
                      },
                      {
                        "required": [],
                        "maxProperties": 0
                      }
                    ],
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientConicLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SolidColorLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientLinear": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientLinear"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "required": [
                  "value",
                  "type"
                ],
                "properties": {
                  "value": {
                    "type": "number"
                  },
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientCircleSize": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "value",
            "type"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        },
        {
          "required": [],
          "maxProperties": 0
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "value": {
          "type": "number"
        },
        "type": {
          "enum": [
            "px",
            "em",
            "rem",
            "vh",
            "vw",
            "vmin",
            "vmax"
          ]
        }
      },
      "additionalProperties": false
    },
    "GradientCircle": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientCircle"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "size": {
          "type": "object",
          "oneOf": [
            {
              "required": [
                "value",
                "type"
              ]
            },
            {
              "required": [
                "keyword"
              ]
            },
            {
              "required": [],
              "maxProperties": 0
            }
          ],
          "properties": {
            "keyword": {
              "type": "string",
              "enum": [
                "closest-side",
                "closest-corner",
                "farthest-side",
                "farthest-corner"
              ]
            },
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "required": [
                  "value",
                  "type"
                ],
                "properties": {
                  "value": {
                    "type": "number"
                  },
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientEllipseSize": {
      "type": "object",
      "oneOf": [
        {
          "required": [
            "width",
            "height"
          ]
        },
        {
          "required": [
            "keyword"
          ]
        }
      ],
      "properties": {
        "keyword": {
          "type": "string",
          "enum": [
            "closest-side",
            "closest-corner",
            "farthest-side",
            "farthest-corner"
          ]
        },
        "width": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "GradientEllipse": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientEllipse"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "size": {
          "type": "object",
          "oneOf": [
            {
              "required": [
                "width",
                "height"
              ]
            },
            {
              "required": [
                "keyword"
              ]
            }
          ],
          "properties": {
            "keyword": {
              "type": "string",
              "enum": [
                "closest-side",
                "closest-corner",
                "farthest-side",
                "farthest-corner"
              ]
            },
            "width": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "required": [
                  "value",
                  "type"
                ],
                "properties": {
                  "value": {
                    "type": "number"
                  },
                  "type": {
                    "enum": [
                      "px",
                      "em",
                      "rem",
                      "percentage",
                      "vh",
                      "vw",
                      "vmin",
                      "vmax"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "GradientConic": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientConic"
          ]
        },
        "repeat": {
          "type": "boolean"
        },
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "position": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "colorStops": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "size": {
                "type": "object",
                "required": [
                  "value",
                  "type"
                ],
                "properties": {
                  "value": {
                    "type": "number"
                  },
                  "type": {
                    "enum": [
                      "deg",
                      "percentage"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "color": {
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "opacity": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "SolidColor": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SolidColor"
          ]
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        }
      },
      "additionalProperties": false
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "GradientColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "additionalProperties": false
    },
    "GradientAngularColorStop": {
      "type": "object",
      "properties": {
        "size": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "deg",
                "percentage"
              ]
            }
          },
          "additionalProperties": false
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "additionalProperties": false
    }
  },
  "component_properties.json": {
    "$id": "urn:dm:schemas:component_properties.json",
    "FontsEnum": {
      "langsKey": "System.font",
      "type": "string",
      "default": "arial",
      "enum": [
        "lucidaSansConsole",
        "palatinoLinotype",
        "americantypwrteritcw01--731025",
        "anton",
        "arial",
        "arialBlack",
        "avenida-w01",
        "basic",
        "caudex",
        "clarendon-w01-medium-692107",
        "comicSansMS",
        "cookie",
        "coquette-w00-light",
        "courierNew",
        "din-next-w01-light",
        "droid-serif-w01-regular",
        "eb garamond",
        "enriqueta",
        "forum",
        "georgia",
        "helvetica-w01-roman",
        "helvetica-w01-bold",
        "helvetica-w01-light",
        "impact",
        "jockey one",
        "jura",
        "kelly slab",
        "lobster",
        "lucidaConsole",
        "marck script",
        "monoton",
        "noticia text",
        "open sans",
        "open sans condensed",
        "palatino linotype",
        "patrick hand",
        "play",
        "reklamescriptw00-medium",
        "sacramento",
        "sarina",
        "signika",
        "soho-w01-thin-condensed",
        "tahoma",
        "timesNewRoman",
        "verdana",
        "bodoni-w01-poster",
        "ｍｓ ゴシック",
        "ｍｓ 明朝",
        "ｍｓ ｐゴシック",
        "ｍｓ ｐ明朝",
        "meiryo",
        "メイリオ",
        "bm-hanna",
        "돋움",
        "fbbluegothicl",
        "fbchamblue",
        "fbgreen",
        "fbneogothic",
        "fbplum",
        "굴림",
        "맑은 고딕",
        "nanumgothic-regular",
        "ahmedltw20-outlineregul",
        "amiri",
        "arabictypesettingw23-re",
        "arian-lt-w20-regular",
        "arian-lt-w20-light",
        "coheadlinew23-arabicbol",
        "dinnextltw23-ultralight",
        "droid-naskh",
        "janna-lt-w20-regular",
        "kufi-lt-w20-regular",
        "midan-w20",
        "helveticaneueltw20-ligh",
        "tanseekmodernw20-light",
        "adler-w26-regular",
        "alef-regular",
        "almoni-dl-aaa-700",
        "almoni-dl-aaa-300",
        "almoni-dl-aaa-400",
        "asimon-aaa-400",
        "atlas-aaa-500",
        "chips-w26-normal",
        "frank-ruhl-w26-regular",
        "gulash-w26-regular",
        "haim-arukeem-w26-medium",
        "miriam-w26-medium",
        "mixtape-aaa-400",
        "museum-aaa-400",
        "nekudot-w26-bold",
        "omes-aaa-400",
        "opensanshebrewcondensed-regular",
        "shabazi-w26-bold",
        "amatic sc",
        "braggadocio-w01",
        "chelsea market",
        "corben",
        "fredericka the great",
        "geotica-w01-four-open",
        "helvetica neue",
        "helvetica neue italic",
        "helvetica neue medium",
        "helvetica neue thin",
        "itc-arecibo-w01-regular",
        "josefin slab",
        "lucida sans unicode",
        "marzo-w00-regular",
        "mr de haviland",
        "museo-w01-700",
        "museo-slab-w01-100",
        "niconne",
        "nimbus-sans-tw01con",
        "overlock",
        "pacifica-w00-condensed",
        "raleway",
        "rosewood-w01-regular",
        "snellroundhandw01-scrip",
        "spinnaker",
        "stencil-w01-bold"
      ]
    },
    "DefaultProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FlipProperties": {
      "type": "object",
      "properties": {
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        }
      },
      "additionalProperties": false
    },
    "VideoBackgroundProperties": {
      "type": "object",
      "properties": {
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      },
      "additionalProperties": false
    },
    "CardsLayoutProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right",
            "justify"
          ],
          "default": "left"
        },
        "gap": {
          "type": "object",
          "default": {},
          "properties": {
            "vertical": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0,
              "description": "sets the vertical gap (in px) between items of a repeater"
            },
            "horizontal": {
              "type": "number",
              "minimum": 0,
              "maximum": 100,
              "default": 0,
              "description": "sets the horizontal gap (in px) between items of a repeater"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VerticalLayoutProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "gap": {
          "type": "number",
          "default": 10,
          "description": "sets the gap (in px) between items of a vertical repeater"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "DisableableProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ClassicSectionProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mediaBackgroundPadding": {
          "type": [
            "object",
            "null"
          ],
          "maxProperties": 1,
          "properties": {
            "top": {
              "type": [
                "number",
                "null"
              ],
              "minimum": 0,
              "description": "value of the mediaBackgroundPadding"
            },
            "bottom": {
              "type": [
                "number",
                "null"
              ],
              "minimum": 0,
              "description": "value of the mediaBackgroundPadding"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "StripColumnsContainerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "columnsMargin": {
          "type": "number",
          "default": 15
        },
        "frameMargin": {
          "type": "number",
          "default": 15
        },
        "fullWidth": {
          "type": "boolean",
          "default": true
        },
        "fullHeight": {
          "type": "boolean",
          "default": false
        },
        "rowMargin": {
          "type": "number",
          "default": 15
        },
        "siteMargin": {
          "type": "number",
          "default": 30
        },
        "horizontalPaddingOnMobile": {
          "type": "number"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "ColumnProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        },
        "alignment": {
          "type": "number",
          "default": 50,
          "minimum": 0,
          "maximum": 100,
          "description": "The alignment of the content relative to the whole column, represented as percentage (e.g. 0 for left, 50 for center and 100 for right)"
        },
        "mediaBackgroundPadding": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "maxProperties": 1,
              "properties": {
                "top": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "default": 18,
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    }
                  ]
                },
                "bottom": {
                  "oneOf": [
                    {
                      "type": "null"
                    },
                    {
                      "type": "number",
                      "default": 18,
                      "minimum": 0,
                      "description": "value of the mediaBackgroundPadding"
                    }
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "InputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "InputElementsErrorProperties": {
      "type": "object",
      "properties": {
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "colorScheme": {
          "type": "string",
          "enum": [
            "black",
            "grey",
            "brand"
          ],
          "default": "brand"
        },
        "invertColors": {
          "type": "boolean",
          "default": true
        },
        "hideText": {
          "type": "boolean",
          "default": true
        },
        "alignment": {
          "type": "string",
          "enum": [
            "right",
            "left"
          ],
          "default": "right"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PhotoProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageSize": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ],
          "default": "medium",
          "description": "size of the image in runtime"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FacebookLikeBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transparentBg": {
          "type": "boolean",
          "default": false,
          "description": "Sets a transparent background for the like box"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ImageButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "fade"
          ],
          "default": "fade"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MultiSelectionProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "placeholder": {
          "type": "string",
          "default": "Enter text here...",
          "description": "The placeholder for the input skinpart",
          "maxLength": 4000
        },
        "newItemText": {
          "type": "string",
          "default": "(New)",
          "description": "The text that will appear on a new item in the dropdown"
        },
        "selectionOnly": {
          "type": "boolean",
          "default": false,
          "description": "Restricts component to selection only"
        },
        "maxTextLength": {
          "type": "number",
          "default": 30,
          "description": "The max text length for the input skinpart"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MultiSelectionItemProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "NumericStepperProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "minValue": {
          "type": "number",
          "default": 0,
          "description": "Min value for input"
        },
        "maxValue": {
          "type": "number",
          "default": 999,
          "description": "Max value for input"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PinterestPinItProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "size": {
          "type": "string",
          "enum": [
            "small",
            "large"
          ],
          "default": "small"
        },
        "color": {
          "type": "string",
          "enum": [
            "gray",
            "red",
            "white"
          ],
          "default": "gray"
        },
        "counterPosition": {
          "type": "string",
          "enum": [
            "none",
            "above",
            "beside"
          ],
          "default": "none"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SingleAudioPlayerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "volume": {
          "type": "number",
          "default": 50,
          "description": "Volume"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": "Autoplay MP3"
        },
        "loop": {
          "type": "boolean",
          "default": false,
          "description": "Loop MP3"
        },
        "showArtist": {
          "type": "boolean",
          "default": true,
          "description": "Display Artist"
        },
        "showTrack": {
          "type": "boolean",
          "default": true,
          "description": "Display Track"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SkypeCallButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageSize": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "large"
          ],
          "default": "medium"
        },
        "imageColor": {
          "type": "string",
          "enum": [
            "blue",
            "white"
          ],
          "default": "blue"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SpotifyFollowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "size": {
          "type": "string",
          "enum": [
            "small",
            "large"
          ],
          "default": "large"
        },
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ],
          "default": "light"
        },
        "showFollowersCount": {
          "type": "boolean",
          "default": true
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SpotifyPlayerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "size": {
          "type": "string",
          "enum": [
            "compact",
            "large"
          ],
          "default": "compact",
          "description": "Size of the player"
        },
        "color": {
          "type": "string",
          "enum": [
            "black",
            "white"
          ],
          "default": "black",
          "description": "Theme of the player"
        },
        "style": {
          "type": "string",
          "enum": [
            "list",
            "coverart"
          ],
          "default": "list",
          "description": "Style of the player"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SubscribeFormProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "hiddenFirstNameField": {
          "type": "boolean",
          "default": false
        },
        "hiddenLastNameField": {
          "type": "boolean",
          "default": false
        },
        "hiddenEmailField": {
          "type": "boolean",
          "default": true
        },
        "hiddenPhoneField": {
          "type": "boolean",
          "default": false
        },
        "requiredFirstNameField": {
          "type": "boolean",
          "default": false
        },
        "requiredLastNameField": {
          "type": "boolean",
          "default": false
        },
        "requiredEmailField": {
          "type": "boolean",
          "default": true
        },
        "requiredPhoneField": {
          "type": "boolean",
          "default": false
        },
        "useCookie": {
          "type": "boolean",
          "default": true
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VerticalMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left",
          "description": "alignment of the menu items"
        },
        "subMenuOpenSide": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "right",
          "description": "Opening direction of sub-menus"
        },
        "originalHeight": {
          "type": "number",
          "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
        },
        "menuItemHeight": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number"
            }
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "YouTubeSubscribeButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "layout": {
          "type": "string",
          "enum": [
            "default",
            "full"
          ],
          "default": "full",
          "description": "the layout of the youtube subscribe button"
        },
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ],
          "default": "light",
          "description": "the theme of the youtube subscribe button"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "BgImageStripProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "bgUrl": {
          "type": [
            "string",
            "null"
          ],
          "default": "",
          "description": "Set image background"
        },
        "bgSize": {
          "type": "string",
          "enum": [
            "auto",
            "cover",
            "contain"
          ],
          "default": "auto",
          "description": "Set background mode"
        },
        "bgRepeat": {
          "type": "string",
          "enum": [
            "no-repeat",
            "repeat-x",
            "repeat-y",
            "repeat"
          ],
          "default": "repeat",
          "description": "Set background tile direction"
        },
        "bgPosition": {
          "type": "string",
          "enum": [
            "top left",
            "top center",
            "top right",
            "center left",
            "center",
            "center right",
            "bottom left",
            "bottom center",
            "bottom right"
          ],
          "default": "center",
          "description": "Set background position"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "BgImageStripUnifiedProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "actual_size",
            "tile",
            "fit_and_tile",
            "tile_horizontal",
            "tile_vertical",
            "legacy_strip_tile",
            "legacy_strip_tile_horizontal",
            "legacy_strip_tile_vertical",
            "legacy_strip_original_size",
            "legacy_strip_fill",
            "legacy_strip_fit",
            "legacy_strip_fit_and_tile"
          ],
          "default": "fill",
          "description": "Set image fitting type"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top_left",
            "top",
            "top_right",
            "left",
            "center",
            "right",
            "bottom_left",
            "bottom",
            "bottom_right"
          ],
          "default": "center",
          "description": "Set image alignment"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FileUploaderProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonAlignment": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr",
          "description": "alignment of the label to the button"
        },
        "filesAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left",
          "description": "alignment of the file name to the component"
        },
        "showPlaceholder": {
          "type": "boolean",
          "default": true,
          "description": "should show placeholder"
        },
        "filesType": {
          "type": "string",
          "enum": [
            "Image",
            "Document",
            "Video",
            "Audio",
            "Archive",
            "Gallery"
          ],
          "default": "Image",
          "description": "the file type allowed for upload by the component"
        },
        "filesSizeLimit": {
          "type": "number",
          "default": 15,
          "minimum": 1,
          "maximum": 15,
          "description": "the maximum file size allowed to upload by the component"
        },
        "numFilesLimit": {
          "type": "number",
          "default": 1,
          "minimum": 1,
          "maximum": 50,
          "description": "the maximum number of files allowed to be uploaded by the component"
        },
        "showFileName": {
          "type": "boolean"
        },
        "textBelowButtonMobileFontSize": {
          "type": "number"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "UploadNameProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "align": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "center",
          "description": "alignment of the menu"
        },
        "margin": {
          "type": "number",
          "default": 0,
          "description": "text left and right margins"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "LoginSocialBarProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonsDirection": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ],
          "description": "alignment of the buttons"
        },
        "iconSize": {
          "type": "number",
          "default": 26,
          "description": "size of the buttons' icons"
        },
        "loggedOutIconSize": {
          "type": "number",
          "description": "size of the loggedOut buttons' icons"
        },
        "dropDownTextAlignment": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "description": "alignment of the text in the dropdown menu"
        },
        "buttonsAlignment": {
          "type": "string",
          "default": "right",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "description": "alignment of the bar of the component itself"
        },
        "arrowShape": {
          "type": "string",
          "default": "line",
          "enum": [
            "none",
            "line",
            "full"
          ],
          "description": "arrow shape of login bar"
        },
        "arrowSize": {
          "type": "number",
          "default": 14,
          "description": "arrow size of login bar"
        },
        "showBellIcon": {
          "type": "boolean",
          "default": true,
          "description": "should show bell icon"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ComboBoxInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "textAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "default": "center",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "description": "the direction of the text",
              "maxLength": 100
            }
          ]
        },
        "textPadding": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number",
              "default": 18,
              "minimum": 0,
              "maximum": 100,
              "description": "the value of the textPadding"
            }
          ]
        },
        "placeholder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "value": {
                  "type": "string",
                  "default": "-1",
                  "description": "the value of the placeholder option",
                  "maxLength": 400
                },
                "text": {
                  "type": "string",
                  "default": "",
                  "description": "the text of the placeholder option",
                  "maxLength": 400
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "the placeholder option in case nothing is selected"
        },
        "size": {
          "type": [
            "null",
            "number"
          ],
          "description": "Amount of options to display"
        },
        "designableList": {
          "type": "boolean",
          "default": true,
          "description": "is the list designable"
        },
        "dropdownItemsSpacing": {
          "type": "number",
          "default": 16,
          "minimum": 0,
          "maximum": 100,
          "description": "the value of the dropdownItemsSpacing"
        },
        "autocomplete": {
          "type": "boolean",
          "description": "is the autocomplete enabled"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "RadioButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RadioGroupProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left",
          "description": "alignment of the text"
        },
        "layout": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ],
          "default": "vertical",
          "description": "the layout of the radio buttons child components"
        },
        "buttonsMargin": {
          "type": "number",
          "default": 24,
          "description": "Margin between each button item",
          "minimum": 0,
          "maximum": 100
        },
        "spacing": {
          "type": "number",
          "default": 12,
          "description": "Spacing between radio icon and text",
          "minimum": 0,
          "maximum": 100
        },
        "buttonSize": {
          "type": "number",
          "default": 18,
          "description": "radio button size size",
          "minimum": 6,
          "maximum": 100
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "CheckboxGroupProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left",
          "description": "alignment of the text"
        },
        "layout": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ],
          "default": "vertical",
          "description": "the layout of the checkboxes components"
        },
        "buttonsMargin": {
          "type": "number",
          "default": 24,
          "description": "Margin between each button item",
          "minimum": 0,
          "maximum": 100
        },
        "spacing": {
          "type": "number",
          "default": 12,
          "description": "Spacing between checkbox and text",
          "minimum": 0,
          "maximum": 100
        },
        "buttonSize": {
          "type": "number",
          "default": 18,
          "description": "checkbox size",
          "minimum": 6,
          "maximum": 100
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "ContactFormProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "hidden_emailFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "hidden_nameFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "hidden_phoneFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "hidden_addressFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "hidden_subjectFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "hidden_messageFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "required_emailFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "required_nameFieldLabel": {
          "type": "boolean",
          "default": true
        },
        "required_phoneFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "required_addressFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "required_subjectFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "required_messageFieldLabel": {
          "type": "boolean",
          "default": false
        },
        "useCookie": {
          "type": "boolean",
          "default": true
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "DocumentMediaProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showTitle": {
          "type": "boolean",
          "default": true,
          "description": "Toggle Document Title Display"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "EbayItemsBySellerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "headerImage": {
          "enum": [
            "0",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11"
          ],
          "default": "0",
          "description": "The widget's header"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FiveGridLineProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fullScreenModeOn": {
          "type": "boolean",
          "default": false,
          "description": "Toggle full screen mode"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FlashComponentProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "original",
            "fit",
            "stretch"
          ],
          "default": "original",
          "description": "displayMode of the movie"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "GalleryExpandProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "expandEnabled": {
          "type": "boolean",
          "default": true
        },
        "goToLinkText": {
          "type": [
            "null",
            "string"
          ],
          "default": "Go to link"
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ],
          "default": "zoomMode"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "GoogleMapProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showZoom": {
          "type": "boolean",
          "default": true,
          "description": "show zoom control"
        },
        "fullscreenControl": {
          "type": "boolean",
          "default": true,
          "description": "show fullscreen control"
        },
        "showPosition": {
          "type": "boolean",
          "default": true,
          "description": "show position control"
        },
        "showStreetView": {
          "type": "boolean",
          "default": true,
          "description": "show Street View control"
        },
        "showMapType": {
          "type": "boolean",
          "default": true,
          "description": "show map type control"
        },
        "zoom": {
          "type": "number",
          "default": 14,
          "description": "default map zoom level",
          "minimum": 0,
          "maximum": 20
        },
        "mapDragging": {
          "type": "boolean",
          "default": true,
          "description": "show map type control"
        },
        "showDirectionsLink": {
          "type": "boolean",
          "default": true,
          "description": "show directions link in infoWindow"
        },
        "mapType": {
          "type": "string",
          "enum": [
            "ROADMAP",
            "TERRAIN",
            "SATELLITE",
            "HYBRID"
          ],
          "default": "ROADMAP",
          "description": "show zoom control"
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "cs",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "zh",
            "th",
            "uk",
            "tr"
          ],
          "default": "en",
          "description": "Possible languages taken from https://developers.google.com/maps/faq?hl=en#languagesupport"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "HorizontalMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignButtons": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "center",
          "description": "alignment of the menu buttons"
        },
        "alignText": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "center",
          "description": "alignment of the menu buttons' text"
        },
        "sameWidthButtons": {
          "type": "boolean",
          "default": false,
          "description": "Keep buttons the same size"
        },
        "moreButtonLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "More",
          "description": "Label to use for 'more button'"
        },
        "moreItemHeight": {
          "type": "number",
          "default": 15,
          "description": "height of items in the more menu"
        },
        "stretchButtonsToMenuWidth": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "rtl": {
          "type": "boolean",
          "default": false,
          "description": "should display menu in RTL mode"
        },
        "autoTextDirection": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ImpressProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "textMode": {
          "langsPrefix": "System",
          "type": "string",
          "default": "titleAndDescription",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": {
          "type": "number",
          "default": 5,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "showPagination": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "cropAndFitStage": {
          "langsPrefix": "System",
          "type": "string",
          "default": "crop",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "transition": {
          "type": "string",
          "default": "random",
          "enum": [
            "none",
            "1",
            "2",
            "3",
            "4",
            "5",
            "random"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MasonryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "numCols": {
          "type": "number",
          "default": 3,
          "description": "Number of columns",
          "minimum": 1,
          "maximum": 10
        },
        "margin": {
          "type": "number",
          "default": 25,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 100
        },
        "textMode": {
          "langsPrefix": "System",
          "type": "string",
          "default": "titleAndDescription",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "boxShadowIsOn": {
          "type": "boolean",
          "default": true
        },
        "boxShadow": {
          "type": "string",
          "default": "0 1px 3px 0 rgba(0,0,0,0.33)"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StripShowcaseProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "galleryImageOnClickAction": {
          "langsKey": "System.centerImageClick",
          "type": "string",
          "default": "disabled",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "cropAndFitStage": {
          "langsPrefix": "System",
          "type": "string",
          "default": "fit",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "imageScale": {
          "type": "string",
          "default": "4:3",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ]
        },
        "imageMargin": {
          "type": "number",
          "default": 5,
          "description": "Margin between thumbnails",
          "minimum": 0,
          "maximum": 100
        },
        "showThumbnails": {
          "type": "boolean",
          "default": true
        },
        "thumbsScale": {
          "type": "string",
          "default": "4:3",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ]
        },
        "thumbsMargin": {
          "type": "number",
          "default": 5,
          "description": "Margin between thumbnails",
          "minimum": 0,
          "maximum": 100
        },
        "autoplay": {
          "type": "boolean",
          "default": false
        },
        "autoplayInterval": {
          "type": "number",
          "default": 5,
          "minimum": 0,
          "maximum": 30
        },
        "arrowMode": {
          "type": "boolean",
          "default": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StripSlideshowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "textMode": {
          "langsPrefix": "System",
          "type": "string",
          "default": "titleAndDescription",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": {
          "type": "number",
          "default": 5,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "showPlaybackControl": {
          "type": "boolean"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "transition": {
          "langsPrefix": "System",
          "type": "string",
          "default": "scroll",
          "enum": [
            "none",
            "crossFade",
            "slide",
            "scroll",
            "zoom",
            "random"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ThumbnailsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "cropAndFitStage": {
          "langsPrefix": "System",
          "type": "string",
          "default": "crop",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "componentScale": {
          "type": "string",
          "default": "4:3",
          "enum": [
            "16:9",
            "4:3",
            "1:1"
          ]
        },
        "margin": {
          "type": "number",
          "default": 5,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 100
        },
        "textMode": {
          "langsPrefix": "System",
          "type": "string",
          "default": "titleAndDescription",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "arrowMode": {
          "type": "boolean",
          "default": true
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "autoplayInterval": {
          "type": "number",
          "default": 5,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "transition": {
          "langsPrefix": "System",
          "type": "string",
          "default": "crossFade",
          "enum": [
            "none",
            "crossFade",
            "slide",
            "scroll",
            "zoom",
            "random"
          ]
        },
        "thumbnailsGravity": {
          "langsKey": "System.gravity",
          "type": "string",
          "default": "bottom",
          "enum": [
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "disabled",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "AccordionProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "descFont": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "langsKey": "System.textMode",
          "type": "string",
          "default": "titleOnly",
          "enum": [
            "titleOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "borderWidth": {
          "type": "number",
          "default": 0,
          "description": "Borer width between images",
          "minimum": 0,
          "maximum": 30
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "CollageProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "center",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "langsKey": "System.textMode",
          "type": "string",
          "default": "titleOnly",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "minImageSize": {
          "type": "number",
          "default": 1,
          "description": "minimum image size",
          "minimum": 1,
          "maximum": 10
        },
        "maxImageSize": {
          "type": "number",
          "default": 3,
          "description": "maximum image size",
          "minimum": 1,
          "maximum": 10
        },
        "avergeImageSize": {
          "type": "number",
          "default": 1,
          "description": "averge image size",
          "minimum": 1,
          "maximum": 10
        },
        "margin": {
          "type": "number",
          "default": 5,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 30
        },
        "fitToScreenWidth": {
          "type": "boolean",
          "default": false,
          "description": "fit component width to screen"
        },
        "showNavButtons": {
          "type": "boolean",
          "default": true,
          "description": "show navigation buttons"
        },
        "numOfCells": {
          "type": "number",
          "default": 5,
          "description": "number of grid cells",
          "minimum": 2,
          "maximum": 10
        },
        "orientation": {
          "langsKey": "System.orientation",
          "type": "string",
          "default": "vertical",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "layoutSeed": {
          "type": "number",
          "default": 50,
          "description": "seed for layout calculation",
          "minimum": 1,
          "maximum": 100
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "FreestyleProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "galleryImageOnClickAction": {
          "langsPrefix": "System",
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "layoutSeed": {
          "type": "number",
          "default": 50,
          "description": "seed for layout calculation",
          "minimum": 1,
          "maximum": 100
        },
        "cropAndFitStage": {
          "langsPrefix": "System",
          "type": "string",
          "default": "fit",
          "enum": [
            "crop",
            "fit"
          ]
        },
        "imageDecoration": {
          "langsPrefix": "System",
          "type": "string",
          "default": "none",
          "enum": [
            "none",
            "polaroid",
            "scotchTape",
            "vintageFrame",
            "random"
          ]
        },
        "borderWidth": {
          "type": "number",
          "default": 3,
          "description": "image border width",
          "minimum": 0,
          "maximum": 15
        },
        "orientation": {
          "type": "string",
          "default": "horizontal",
          "enum": [
            "vertical",
            "horizontal"
          ]
        },
        "applyRotationInLayout": {
          "type": "boolean",
          "default": true
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ItunesButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "jp",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ],
          "default": "en",
          "description": "Language of the button"
        },
        "openIn": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_blank",
          "description": "Where the link will be opened"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "LayoutProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "x": {
          "type": "number",
          "default": 0,
          "description": "x position"
        },
        "y": {
          "type": "number",
          "default": 0,
          "description": "y position"
        },
        "w": {
          "type": "number",
          "default": 100,
          "description": "width"
        },
        "h": {
          "type": "number",
          "default": 100,
          "description": "height"
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "description": "list of anchors"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "LinkBarProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "gallery": {
          "type": [
            "null",
            "string"
          ],
          "default": "clipart",
          "description": "gallery type (photos, icons, backgrounds, etc..)"
        },
        "iconSize": {
          "type": "number",
          "default": 30,
          "description": "Icon Size",
          "minimum": 16,
          "maximum": 128
        },
        "spacing": {
          "type": "number",
          "default": 5,
          "description": "Spacing",
          "minimum": 1,
          "maximum": 50
        },
        "bgScale": {
          "type": "number",
          "default": 1,
          "description": "Background scale",
          "minimum": 0,
          "maximum": 2
        },
        "orientation": {
          "type": "string",
          "enum": [
            "HORIZ",
            "VERT"
          ],
          "default": "HORIZ",
          "description": "Orientation"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MatrixGalleryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage",
            "flexibleWidthFixed"
          ],
          "default": "clipImage"
        },
        "itemHeight": {
          "type": [
            "null",
            "number"
          ],
          "description": "height of specific item"
        },
        "numCols": {
          "type": "number",
          "default": 3,
          "description": "Number of columns",
          "minimum": 1,
          "maximum": 10
        },
        "maxRows": {
          "type": "number",
          "default": 3,
          "description": "Maximum number of rows",
          "minimum": 1,
          "maximum": 10
        },
        "incRows": {
          "type": "number",
          "default": 2,
          "description": "Row number increase",
          "minimum": 1,
          "maximum": 10
        },
        "margin": {
          "type": "number",
          "default": 15,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 250
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "showMoreLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Show More",
          "description": "Show More"
        },
        "expandEnabled": {
          "type": "boolean",
          "default": true
        },
        "goToLinkText": {
          "type": [
            "null",
            "string"
          ],
          "default": "Go to link"
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ],
          "default": "zoomMode"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "NumberInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "minValue": {
          "type": "number",
          "default": 0,
          "description": "minimum allowed value"
        },
        "maxValue": {
          "type": "number",
          "default": 999,
          "description": "maximum allowed value"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PageGroupProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "swipeHorizontalFullScreen",
            "swipeVerticalFullScreen",
            "crossfade",
            "outIn",
            "slide"
          ],
          "default": "swipeHorizontalFullScreen",
          "description": "page transition"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PaginatedGridGalleryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage"
          ],
          "default": "clipImage"
        },
        "numCols": {
          "type": "number",
          "default": 3,
          "description": "Number of columns",
          "minimum": 1,
          "maximum": 10
        },
        "maxRows": {
          "type": "number",
          "default": 3,
          "description": "Maximum number of rows",
          "minimum": 1,
          "maximum": 10
        },
        "margin": {
          "type": "number",
          "default": 0,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 250
        },
        "transition": {
          "type": "string",
          "default": "seq_crossFade_All",
          "enum": [
            "none",
            "seq_crossFade_All",
            "seq_shrink_All",
            "swipe_horiz_All",
            "swipe_vert_All",
            "seq_random"
          ]
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "autoplayInterval": {
          "type": "number",
          "default": 3,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "showAutoplay": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "showNavigation": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "showCounter": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "expandEnabled": {
          "type": "boolean",
          "default": true
        },
        "goToLinkText": {
          "type": [
            "null",
            "string"
          ],
          "default": "Go to link"
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PayPalButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "buy",
            "donate"
          ],
          "default": "buy",
          "description": "buy or donate button"
        },
        "itemName": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "description": "some amazing description"
        },
        "itemID": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "description": "some amazing description"
        },
        "organizationName": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "description": "some amazing description"
        },
        "organizationID": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "description": "some amazing description"
        },
        "amount": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "description": "some amazing description"
        },
        "currencyCode": {
          "type": "string",
          "default": "USD",
          "description": "Currency Code"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_blank",
          "description": "Currency Code"
        },
        "showCreditCards": {
          "type": "boolean",
          "default": true,
          "description": "Show credit card symbols"
        },
        "smallButton": {
          "type": "boolean",
          "default": false,
          "description": "use small button"
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "ja",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ],
          "default": "en",
          "description": "https://developer.paypal.com/docs/classic/api/locale_codes/"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SiteSegmentContainerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fixedPosition": {
          "type": "boolean",
          "default": false,
          "description": "fixed positioning for components that inherit from SiteSegmentContainers"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SliderGalleryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageMode": {
          "type": "string",
          "default": "clipImage",
          "enum": [
            "clipImage",
            "flexibleWidth"
          ]
        },
        "margin": {
          "type": "number",
          "default": 15,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 250
        },
        "maxSpeed": {
          "type": "number",
          "default": 5,
          "minimum": 1,
          "maximum": 30,
          "description": "Speed"
        },
        "aspectRatio": {
          "type": "number",
          "minimum": 0.1,
          "maximum": 3,
          "default": 1,
          "description": ""
        },
        "aspectRatioPreset": {
          "type": "string",
          "enum": [
            "16:9",
            "4:3",
            "1:1",
            "3:4",
            "9:16"
          ],
          "default": "4:3"
        },
        "loop": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "showCounter": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "expandEnabled": {
          "type": "boolean",
          "default": true
        },
        "goToLinkText": {
          "type": [
            "null",
            "string"
          ],
          "default": "Go to link"
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ],
          "default": "zoomMode"
        },
        "autoplayInterval": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "transDuration": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "showAutoplay": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "autoplay": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SlideShowGalleryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "imageMode": {
          "type": "string",
          "enum": [
            "clipImage",
            "flexibleHeight",
            "flexibleWidthFixed"
          ],
          "default": "clipImage"
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "swipeVertical",
            "swipeHorizontal",
            "crossfade",
            "outIn"
          ],
          "default": "swipeHorizontal",
          "description": "Transition between items of the gallery"
        },
        "autoplayInterval": {
          "type": "number",
          "default": 5,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "bidirectional": {
          "type": "boolean",
          "default": true,
          "description": "Decides whether the transition direction reflects Prev/Next"
        },
        "reverse": {
          "type": "boolean",
          "default": false,
          "description": "If bidirectional, inverts the direction of transitions"
        },
        "showAutoplay": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "showNavigation": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "showCounter": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "expandEnabled": {
          "type": "boolean",
          "default": true
        },
        "goToLinkText": {
          "type": [
            "null",
            "string"
          ],
          "default": "Go to link"
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "showSocial": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "showExpand": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SvgShapeProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "maintainAspectRatio": {
          "type": "boolean",
          "default": true,
          "description": "should the shape maintain it's aspect ratio or stretch"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VectorImageProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "legacyFit",
            "fit",
            "stretch"
          ],
          "description": "should the shape maintain it's aspect ratio or stretch, 'legacy-fit' is for converted SvgShape"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        }
      }
    },
    "TableComponentProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "minHeight": {
          "type": "number",
          "default": -1,
          "description": "minimum allowed value"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "TinyMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ExpandableMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left",
          "description": "alignment of the menu items"
        },
        "subMenuOpenSide": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "right",
          "description": "Opening direction of sub-menus"
        },
        "originalHeight": {
          "type": "number",
          "description": "Used to determine if comp was saved with correct height (if value not empty), or height needs to be fixed in DataFixer (if value is empty)"
        },
        "menuItemHeight": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number"
            }
          ]
        },
        "menuArrowDirection": {
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "TwitterFeedProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "numOfTweets": {
          "type": "number",
          "default": 5,
          "description": "Number of tweets in feed"
        },
        "subject": {
          "type": [
            "null",
            "string"
          ],
          "default": "What's being said about...",
          "description": "subject line"
        },
        "title": {
          "type": [
            "null",
            "string"
          ],
          "default": "Me...",
          "description": "title line"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VideoProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": "video autoplay on load"
        },
        "loop": {
          "type": "boolean",
          "default": false,
          "description": "play video in a loop"
        },
        "showinfo": {
          "type": "boolean",
          "default": false,
          "description": "show video title and author"
        },
        "lightTheme": {
          "type": "boolean",
          "default": false,
          "description": "show video with light theme"
        },
        "showControls": {
          "type": "string",
          "enum": [
            "always_show",
            "always_hide",
            "temp_show"
          ],
          "default": "always_show",
          "description": "show / hide controls"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VKShareProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rightAngles": {
          "type": "boolean",
          "default": false,
          "description": "Button Right angles"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WFacebookCommentProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "numPosts": {
          "type": "number",
          "default": 2,
          "minimum": 0,
          "maximum": 10,
          "description": "the number of posts display by default"
        },
        "width": {
          "type": "number",
          "default": 555,
          "description": "the width of the plugin, in pixels"
        },
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ],
          "default": "light",
          "description": "the color scheme of the plugin"
        },
        "canBeShownOnAllPagesBug": {
          "type": "boolean",
          "default": false,
          "description": "The component was added after the bug who-145 fix, and will be shown on all pages"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "DisqusCommentsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "disqusId": {
          "type": "string",
          "description": "User id in disqus"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WFacebookLikeProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "layout": {
          "type": "string",
          "enum": [
            "standard",
            "button_count",
            "box_count"
          ],
          "default": "standard",
          "description": "the layout of the button"
        },
        "send": {
          "type": "boolean",
          "default": false,
          "description": "enable/disable the send button"
        },
        "show_faces": {
          "type": "boolean",
          "default": false,
          "description": "show the faces of your friends that liked this item"
        },
        "width": {
          "type": [
            "null",
            "string",
            "number"
          ],
          "default": "225",
          "description": "the width of the Like button"
        },
        "action": {
          "type": "string",
          "enum": [
            "like",
            "recommend"
          ],
          "default": "like",
          "description": " the verb to display on the button. Options: *like*, *recommend*"
        },
        "font": {
          "type": "string",
          "enum": [
            "helvetica",
            "arial",
            "lucida grande",
            "segoe ui",
            "tahoma",
            "trebuchet ms",
            "verdana"
          ],
          "default": "helvetica",
          "description": "the font to display in the button"
        },
        "colorScheme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ],
          "default": "dark",
          "description": "the color scheme for the like button"
        },
        "language": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "it",
            "ja",
            "kr",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ],
          "default": "en"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WGooglePlusOneProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "size": {
          "type": "string",
          "enum": [
            "small",
            "medium",
            "standard",
            "tall"
          ],
          "default": "standard",
          "description": "The button size to render"
        },
        "annotation": {
          "type": "string",
          "enum": [
            "none",
            "bubble",
            "inline"
          ],
          "default": "inline",
          "description": "The annotation to display next to the button."
        },
        "width": {
          "type": [
            "null",
            "number"
          ],
          "description": "If annotation is set to *inline*, the width in pixels to use for the button and its inline annotation. If omitted, a button and its inline annotation use 450px."
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WPhotoProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "fill",
            "full",
            "stretch",
            "fitWidth",
            "fitWidthStrict",
            "fitHeightStrict"
          ],
          "default": "fill",
          "description": "displayMode of the photo"
        },
        "autoFill": {
          "type": "boolean",
          "default": false,
          "description": "Should the photo should enable auto crop in the editor"
        },
        "onClickBehavior": {
          "type": "string",
          "enum": [
            "disabled",
            "goToLink",
            "zoomMode",
            "zoomAndPanMode"
          ],
          "default": "goToLink",
          "description": "goToLink"
        },
        "effectName": {
          "type": [
            "string",
            "null"
          ],
          "description": "An effect to apply on the image",
          "default": "none"
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "description": "An effect to apply on the image",
          "properties": {
            "effectType": {
              "type": "string"
            },
            "brightness": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "saturation": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "hue": {
              "type": "number",
              "minimum": -180,
              "maximum": 180
            },
            "duotoneDark": {
              "type": "string"
            },
            "duotoneLight": {
              "type": "string"
            },
            "invert": {
              "type": "boolean",
              "default": false
            },
            "isCustom": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "overrideCrop": {
          "description": "Overriding the image crop for Mobile view",
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": [
                "object"
              ],
              "minProperties": 4,
              "additionalProperties": false,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "horizontal",
                    "vertical",
                    "both",
                    "none"
                  ],
                  "default": "none",
                  "description": "Defines a flip axis for the content"
                }
              }
            }
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WRichTextProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "packed": {
          "type": "boolean",
          "default": false,
          "description": "Is the text component packed"
        },
        "brightness": {
          "type": "number",
          "default": 1
        },
        "overrideAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center",
                "justify"
              ]
            }
          ]
        },
        "overrideColor": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string"
            }
          ]
        },
        "minHeight": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number"
            }
          ]
        },
        "minWidth": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number"
            }
          ]
        },
        "verticalText": {
          "type": "boolean",
          "default": false,
          "description": "Vertical oriented text flag"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RefComponentProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "minHeight": {
          "type": "number"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WTwitterFollowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showCount": {
          "type": "boolean",
          "default": true,
          "description": "Followers count display"
        },
        "showScreenName": {
          "type": "boolean",
          "default": true,
          "description": "Show screen name"
        },
        "textColor": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
          "description": "HEX color code for the text color"
        },
        "linkColor": {
          "type": [
            "string",
            "null"
          ],
          "pattern": "^(#(([0-9|a-f|A-F]){3}){1,2})$",
          "description": "HEX color code for the Username link color"
        },
        "width": {
          "type": "number",
          "default": 100,
          "description": "width of the Follow Button"
        },
        "dataLang": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ],
          "default": "en",
          "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "WTwitterTweetProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "dataCount": {
          "type": "string",
          "enum": [
            "none",
            "horizontal",
            "vertical"
          ],
          "default": "horizontal",
          "description": "Count box position"
        },
        "dataLang": {
          "type": "string",
          "enum": [
            "userLang",
            "da",
            "de",
            "en",
            "es",
            "fr",
            "hi",
            "it",
            "ja",
            "ko",
            "nl",
            "no",
            "pl",
            "pt",
            "ru",
            "sv",
            "tr"
          ],
          "default": "en",
          "description": "The language for the Tweet Button (from https://dev.twitter.com/overview/general/adding-international-support-to-your-apps)"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "HoverBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mobileDisplayedModeId": {
          "type": [
            "string",
            "null"
          ],
          "description": "The mode to activate when in mobile view"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "TPAGluedProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "placement": {
          "type": [
            "null",
            "string"
          ],
          "default": "BOTTOM_RIGHT",
          "description": "widget placement"
        },
        "verticalMargin": {
          "type": [
            "null",
            "string",
            "number"
          ],
          "default": "",
          "description": "widget vertical margin"
        },
        "horizontalMargin": {
          "type": [
            "null",
            "string",
            "number"
          ],
          "default": "",
          "description": "widget horizontal margin"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "HoneycombProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "font": {
          "langsKey": "System.font",
          "type": "string",
          "default": "arial",
          "enum": [
            "lucidaSansConsole",
            "palatinoLinotype",
            "americantypwrteritcw01--731025",
            "anton",
            "arial",
            "arialBlack",
            "avenida-w01",
            "basic",
            "caudex",
            "clarendon-w01-medium-692107",
            "comicSansMS",
            "cookie",
            "coquette-w00-light",
            "courierNew",
            "din-next-w01-light",
            "droid-serif-w01-regular",
            "eb garamond",
            "enriqueta",
            "forum",
            "georgia",
            "helvetica-w01-roman",
            "helvetica-w01-bold",
            "helvetica-w01-light",
            "impact",
            "jockey one",
            "jura",
            "kelly slab",
            "lobster",
            "lucidaConsole",
            "marck script",
            "monoton",
            "noticia text",
            "open sans",
            "open sans condensed",
            "palatino linotype",
            "patrick hand",
            "play",
            "reklamescriptw00-medium",
            "sacramento",
            "sarina",
            "signika",
            "soho-w01-thin-condensed",
            "tahoma",
            "timesNewRoman",
            "verdana",
            "bodoni-w01-poster",
            "ｍｓ ゴシック",
            "ｍｓ 明朝",
            "ｍｓ ｐゴシック",
            "ｍｓ ｐ明朝",
            "meiryo",
            "メイリオ",
            "bm-hanna",
            "돋움",
            "fbbluegothicl",
            "fbchamblue",
            "fbgreen",
            "fbneogothic",
            "fbplum",
            "굴림",
            "맑은 고딕",
            "nanumgothic-regular",
            "ahmedltw20-outlineregul",
            "amiri",
            "arabictypesettingw23-re",
            "arian-lt-w20-regular",
            "arian-lt-w20-light",
            "coheadlinew23-arabicbol",
            "dinnextltw23-ultralight",
            "droid-naskh",
            "janna-lt-w20-regular",
            "kufi-lt-w20-regular",
            "midan-w20",
            "helveticaneueltw20-ligh",
            "tanseekmodernw20-light",
            "adler-w26-regular",
            "alef-regular",
            "almoni-dl-aaa-700",
            "almoni-dl-aaa-300",
            "almoni-dl-aaa-400",
            "asimon-aaa-400",
            "atlas-aaa-500",
            "chips-w26-normal",
            "frank-ruhl-w26-regular",
            "gulash-w26-regular",
            "haim-arukeem-w26-medium",
            "miriam-w26-medium",
            "mixtape-aaa-400",
            "museum-aaa-400",
            "nekudot-w26-bold",
            "omes-aaa-400",
            "opensanshebrewcondensed-regular",
            "shabazi-w26-bold",
            "amatic sc",
            "braggadocio-w01",
            "chelsea market",
            "corben",
            "fredericka the great",
            "geotica-w01-four-open",
            "helvetica neue",
            "helvetica neue italic",
            "helvetica neue medium",
            "helvetica neue thin",
            "itc-arecibo-w01-regular",
            "josefin slab",
            "lucida sans unicode",
            "marzo-w00-regular",
            "mr de haviland",
            "museo-w01-700",
            "museo-slab-w01-100",
            "niconne",
            "nimbus-sans-tw01con",
            "overlock",
            "pacifica-w00-condensed",
            "raleway",
            "rosewood-w01-regular",
            "snellroundhandw01-scrip",
            "spinnaker",
            "stencil-w01-bold"
          ]
        },
        "alignText": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "textMode": {
          "langsKey": "System.textMode",
          "type": "string",
          "default": "titleAndDescription",
          "enum": [
            "titleAndDescription",
            "titleOnly",
            "descriptionOnly",
            "noText"
          ]
        },
        "galleryImageOnClickAction": {
          "type": "string",
          "default": "zoomMode",
          "enum": [
            "disabled",
            "zoomMode",
            "goToLink"
          ]
        },
        "margin": {
          "type": "number",
          "default": 1,
          "description": "Margin around each item",
          "minimum": 0,
          "maximum": 30
        },
        "numOfColumns": {
          "type": "number",
          "default": 4,
          "description": "number of columns",
          "minimum": 2,
          "maximum": 10
        },
        "numOfHoles": {
          "type": "number",
          "default": 2,
          "description": "number of holes in the honeycomb",
          "minimum": 2,
          "maximum": 8
        },
        "layoutSeed": {
          "type": "number",
          "default": 50,
          "description": "seed for layout calculation",
          "minimum": 1,
          "maximum": 100
        },
        "rolloverAnimation": {
          "type": "string",
          "default": "colorOnly",
          "enum": [
            "colorOnly",
            "glow",
            "bounce"
          ]
        },
        "imageShape": {
          "type": "string",
          "default": "hexagon",
          "enum": [
            "hexagon",
            "square",
            "triangle"
          ]
        },
        "imageScale": {
          "type": "string",
          "default": "x1",
          "enum": [
            "x1",
            "x2",
            "x3"
          ]
        },
        "expandEnabled": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "AppPartProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RssButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "none",
            "fade",
            "float",
            "expand",
            "spin",
            "fly",
            "turn",
            "reveal",
            "slide",
            "puff",
            "flip",
            "fold",
            "arc"
          ],
          "default": "fade"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "BoxSlideShowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ],
          "default": "SlideHorizontal",
          "description": "Transition between items of the gallery"
        },
        "autoPlay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "autoPlayInterval": {
          "type": "number",
          "default": 3,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "showPlaybackControl": {
          "type": "boolean"
        },
        "direction": {
          "type": "string",
          "default": "RTL",
          "enum": [
            "LTR",
            "RTL"
          ]
        },
        "pauseAutoPlayOnMouseOver": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "shouldHideOverflowContent": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "flexibleBoxHeight": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "showNavigationButton": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "navigationButtonSize": {
          "type": "number",
          "minimum": 8,
          "maximum": 72,
          "default": 21,
          "description": "Size of the navigation arrow buttons"
        },
        "navigationButtonMargin": {
          "type": "number",
          "minimum": -72,
          "maximum": 72,
          "default": 0,
          "description": "Margin from the sides of the navigation arrow buttons"
        },
        "showNavigationDots": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "navigationDotsAlignment": {
          "type": "string",
          "default": "center",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "description": "Alignment of the navigation dots"
        },
        "navigationDotsSize": {
          "type": "number",
          "minimum": 6,
          "maximum": 24,
          "default": 6,
          "description": "Size of the navigation dots"
        },
        "navigationDotsMargin": {
          "type": "number",
          "minimum": -50,
          "maximum": 50,
          "default": 0,
          "description": "Margin from the sides of the navigation dots"
        },
        "navigationDotsGap": {
          "type": "number",
          "minimum": 0,
          "maximum": 24,
          "default": 0,
          "description": "Gap size (spacing) of the navigation dots"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "BoxSlideShowSlideProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "StateBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ],
          "default": "NoTransition",
          "description": "Transition between states"
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StateBoxStateProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "StateBoxFormStateProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "StripContainerSlideShowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "transition": {
          "type": "string",
          "enum": [
            "NoTransition",
            "SlideVertical",
            "SlideHorizontal",
            "CrossFade",
            "OutIn"
          ],
          "default": "SlideHorizontal",
          "description": "Transition between items of the gallery"
        },
        "autoPlay": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "showPlaybackControl": {
          "type": "boolean"
        },
        "autoPlayInterval": {
          "type": "number",
          "default": 2,
          "minimum": 0,
          "maximum": 30,
          "description": "Autplay interval"
        },
        "direction": {
          "type": "string",
          "default": "RTL",
          "enum": [
            "LTR",
            "RTL"
          ]
        },
        "pauseAutoPlayOnMouseOver": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "transDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 1,
          "description": "Duration of the transition in sec"
        },
        "shouldHideOverflowContent": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "flexibleBoxHeight": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "showNavigationButton": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "navigationButtonSize": {
          "type": "number",
          "minimum": 8,
          "maximum": 72,
          "default": 21,
          "description": "Size of the navigation arrow buttons"
        },
        "navigationButtonMargin": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 0,
          "description": "Margin from the sides of the navigation arrow buttons"
        },
        "showNavigationDots": {
          "type": "boolean",
          "default": true,
          "description": ""
        },
        "navigationDotsAlignment": {
          "type": "string",
          "default": "center",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "description": "Alignment of the navigation dots"
        },
        "navigationDotsSize": {
          "type": "number",
          "minimum": 6,
          "maximum": 24,
          "default": 6,
          "description": "Size of the navigation dots"
        },
        "navigationDotsMargin": {
          "type": "number",
          "minimum": -50,
          "maximum": 50,
          "default": 0,
          "description": "Margin from the sides of the navigation dots"
        },
        "navigationDotsGap": {
          "type": "number",
          "minimum": 0,
          "maximum": 24,
          "default": 0,
          "description": "Gap size (spacing) of the navigation dots"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StripContainerSlideShowSlideProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "VerticalAnchorsMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left",
          "description": "alignment of the menu items"
        },
        "orientation": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "right",
          "description": "menu orientation"
        },
        "autoColor": {
          "type": "boolean",
          "default": false,
          "description": "does the menu color change automatically according to the background brightness"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "TextInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "textAlignment": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "center"
              ],
              "maxLength": 100
            }
          ],
          "default": "left",
          "description": "the direction of the text"
        },
        "textPadding": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            }
          ],
          "default": 14,
          "description": "the value of the textPadding"
        },
        "placeholder": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected",
          "default": "Add your name"
        },
        "defaultTextType": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "none",
                "initialText",
                "placeholderText",
                "placeholderAndInitialText"
              ],
              "maxLength": 100
            }
          ],
          "default": "placeholderText",
          "description": "the type of the default text for the input"
        },
        "autoComplete": {
          "type": "boolean",
          "description": "can the field be auto completed by the browser"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "TextAreaInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "textAlignment": {
          "type": "string",
          "default": "center",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "description": "the direction of the text",
          "maxLength": 100
        },
        "textPadding": {
          "type": "number",
          "default": 18,
          "minimum": 0,
          "maximum": 100,
          "description": "the value of the textPadding"
        },
        "placeholder": {
          "type": "string",
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected"
        },
        "defaultTextType": {
          "type": "string",
          "default": "none",
          "enum": [
            "none",
            "initialText",
            "placeholderText",
            "placeholderAndInitialText"
          ],
          "description": "the type of the default text for the input",
          "maxLength": 100
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "errorMessageType": {
          "type": "string",
          "enum": [
            "inline",
            "tooltip"
          ]
        }
      }
    },
    "CheckboxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left",
          "description": "alignment of the text"
        },
        "buttonSize": {
          "type": "number",
          "default": 18,
          "description": "checkbox size",
          "minimum": 12,
          "maximum": 100
        },
        "spacing": {
          "type": "number",
          "default": 12,
          "description": "Spacing between checkbox and label",
          "minimum": 0,
          "maximum": 100
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "DatePickerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "textAlignment": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "description": "the direction of the text"
        },
        "textPadding": {
          "type": "number",
          "default": 18,
          "description": "the value of the text padding"
        },
        "placeholder": {
          "type": "string",
          "default": "",
          "maxLength": 200,
          "description": "placeholder text for date in input field"
        },
        "dateFormat": {
          "type": "string",
          "default": "MM/DD/YYYY",
          "enum": [
            "MM/DD/YYYY",
            "DD/MM/YYYY",
            "YYYY/MM/DD",
            "YYYY/M/D"
          ],
          "description": "date format for selected date presentation inside the date input field"
        },
        "defaultTextType": {
          "type": "string",
          "default": "none",
          "enum": [
            "none",
            "today",
            "placeholder"
          ],
          "description": "the type of the default text for the date input"
        },
        "dayToStart": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "enum": [
                "Sunday",
                "Monday"
              ],
              "description": "the day which the week starts on"
            }
          ]
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "GridProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "columns": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "id": {
                "type": "string"
              },
              "dataPath": {
                "type": "string"
              },
              "linkPath": {
                "type": "string"
              },
              "label": {
                "type": "string"
              },
              "width": {
                "type": "number",
                "default": 100
              },
              "visible": {
                "type": "boolean",
                "default": true
              },
              "type": {
                "type": "string",
                "enum": [
                  "number",
                  "string",
                  "date",
                  "image",
                  "bool",
                  "richText"
                ]
              },
              "imageAltPath": {
                "type": "string"
              }
            }
          }
        },
        "showHeader": {
          "type": "boolean"
        },
        "headerHeight": {
          "type": "number"
        },
        "rowHeight": {
          "type": "number"
        },
        "allowUserSorting": {
          "type": "boolean"
        },
        "allowUserFiltering": {
          "type": "boolean"
        },
        "allowUserEditing": {
          "type": "boolean"
        },
        "heightLayout": {
          "type": "string",
          "enum": [
            "manual",
            "auto"
          ]
        },
        "pagination": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "normal",
                "pagination",
                "virtual"
              ]
            },
            "rowsPerPage": {
              "type": "number",
              "multipleOf": 1
            },
            "manualHeightProps": {
              "type": "object",
              "properties": {
                "rowsPerPage": {
                  "type": "number",
                  "multipleOf": 1
                },
                "gridHeight": {
                  "type": "number",
                  "multipleOf": 1
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "normal",
                    "pagination",
                    "virtual"
                  ]
                }
              },
              "additionalProperties": false
            },
            "style": {
              "type": "string",
              "enum": [
                "text",
                "number",
                "simple"
              ],
              "default": "text"
            },
            "alignment": {
              "type": "string",
              "enum": [
                "left",
                "center",
                "right",
                "spread"
              ],
              "default": "right"
            }
          }
        },
        "userSelectionType": {
          "type": "string",
          "enum": [
            "none",
            "cell",
            "row"
          ],
          "default": "none"
        },
        "dateFormat": {
          "type": "string"
        },
        "sorting": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "colId": {
                "type": "string"
              },
              "sort": {
                "type": "string",
                "default": "none",
                "enum": [
                  "asc",
                  "desc",
                  "none"
                ]
              }
            }
          }
        },
        "linkTarget": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ]
        },
        "columnLayout": {
          "type": "string",
          "enum": [
            "equal",
            "fitContent",
            "manual"
          ]
        },
        "horizontalAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PagePropertiesForDevice": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "minHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "minimum page size"
        },
        "popup": {
          "type": "object",
          "properties": {
            "closeOnOverlayClick": {
              "type": "boolean",
              "default": true
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "PageProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "desktop": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "minHeight": {
              "type": [
                "number",
                "null"
              ],
              "description": "minimum page size"
            },
            "popup": {
              "type": "object",
              "properties": {
                "closeOnOverlayClick": {
                  "type": "boolean",
                  "default": true
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "mobile": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "minHeight": {
              "type": [
                "number",
                "null"
              ],
              "description": "minimum page size"
            },
            "popup": {
              "type": "object",
              "properties": {
                "closeOnOverlayClick": {
                  "type": "boolean",
                  "default": true
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PopupContainerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "horizontalAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "center",
          "description": ""
        },
        "verticalAlignment": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ],
          "default": "top",
          "description": ""
        },
        "alignmentType": {
          "type": "string",
          "enum": [
            "nineGrid",
            "fullHeight",
            "fullWidth"
          ],
          "default": "nineGrid",
          "description": ""
        },
        "horizontalOffset": {
          "type": "number",
          "default": 0,
          "description": ""
        },
        "verticalOffset": {
          "type": "number",
          "default": 0,
          "description": ""
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        }
      }
    },
    "MediaPlayerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean",
          "default": false
        },
        "playerInteraction": {
          "type": "object",
          "description": "The way the player itself interacts with user input",
          "default": {},
          "properties": {
            "click": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "toggle"
              ],
              "default": "toggle"
            },
            "rollIn": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "pause"
              ],
              "default": "none"
            },
            "rollOut": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "play",
                "pause"
              ],
              "default": "none"
            },
            "allowReplay": {
              "type": "boolean",
              "default": true
            }
          },
          "additionalProperties": false
        },
        "playerAudioInteraction": {
          "type": "object",
          "description": "The way the player itself interacts with user input",
          "default": {},
          "properties": {
            "rollIn": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "mute",
                "unmute"
              ],
              "default": "none"
            },
            "rollOut": {
              "type": [
                "string",
                "null"
              ],
              "enum": [
                "none",
                "mute",
                "unmute"
              ],
              "default": "none"
            }
          },
          "additionalProperties": false
        },
        "animatePoster": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "none",
            "fade"
          ],
          "default": "none"
        },
        "mute": {
          "type": "boolean",
          "description": "mute on load",
          "default": false
        },
        "disableAudio": {
          "type": "boolean",
          "description": "don't allow audio in player",
          "default": false
        },
        "loop": {
          "type": "boolean",
          "default": false
        },
        "overrideMask": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "description": "CSS mask using an image",
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ],
                  "default": "alpha"
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "enableBackgroundVideo": {
          "type": "boolean",
          "description": "sets the component ability to play its background video on mobile"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "horizontal",
            "vertical",
            "both",
            "none"
          ],
          "default": "none",
          "description": "Defines a flip axis for the content"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MediaControlsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showStoryboard": {
          "type": "string",
          "enum": [
            "videoAndTime",
            "time",
            "none"
          ],
          "default": "videoAndTime",
          "description": "The options of displaying video preview when hovering on the progress bar"
        },
        "playerId": {
          "type": "string",
          "default": ""
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MediaOverlayControlsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "playerId": {
          "type": "string",
          "default": ""
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "LanguageSelectorProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayMode": {
          "type": "string",
          "default": "dropdown",
          "enum": [
            "horizontal",
            "dropdown"
          ],
          "description": "the direction of the language labels"
        },
        "iconType": {
          "type": "string",
          "default": "circle",
          "enum": [
            "none",
            "circle",
            "square",
            "rounded"
          ],
          "description": "language selector flag shape"
        },
        "iconSize": {
          "type": [
            "null",
            "number"
          ],
          "description": "language selector icon size"
        },
        "hasArrow": {
          "type": "boolean"
        },
        "itemFormat": {
          "type": "string",
          "default": "shortName",
          "enum": [
            "shortName",
            "fullName",
            "iconOnly",
            "fullLocalizedName"
          ],
          "description": "language selector labels type"
        },
        "alignTabs": {
          "type": "string",
          "default": "center",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "description": "language selector tabs alignment"
        },
        "languagesOrder": {
          "type": "array",
          "default": [],
          "items": {
            "type": "string",
            "maxLength": 50
          },
          "description": "Override for the order of the languages in the selection"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MediaBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "allowOverflowContent": {
          "type": "boolean",
          "default": false,
          "description": ""
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PopoverProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "position": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right"
          ],
          "default": "top"
        },
        "alignment": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ],
          "default": "center"
        },
        "horizontalOffset": {
          "type": "number",
          "default": 0
        },
        "verticalOffset": {
          "type": "number",
          "default": 0
        },
        "closeMethod": {
          "type": "string",
          "enum": [
            "mouseOut",
            "outerClick",
            "manual"
          ],
          "default": "mouseOut"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "mobui.MobuiPickerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MobuiPickerItemType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "subtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isSelected": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "mobui.MobuiTextInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "hasInitialValue": {
          "default": true,
          "type": "boolean"
        },
        "multiline": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "hasPrefix": {
          "default": false,
          "type": "boolean"
        },
        "hasSuffix": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "autoCorrect": {
          "default": false,
          "type": "boolean"
        },
        "hasAutoComplete": {
          "default": false,
          "type": "boolean"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "AccordionContainerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultOpened": {
          "type": "string",
          "enum": [
            "close_all",
            "open_first",
            "open_all"
          ],
          "default": "close_all"
        },
        "multiple": {
          "type": "boolean",
          "default": false
        },
        "animated": {
          "type": "boolean",
          "default": false
        },
        "animationTime": {
          "type": "number",
          "minimum": 0,
          "default": 0.25
        },
        "icon": {
          "type": "string",
          "enum": [
            "arrow",
            "plus"
          ],
          "default": "arrow"
        }
      }
    },
    "AccordionItemProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isParentFullWidth": {
          "type": "boolean"
        }
      }
    },
    "AddressInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left"
        },
        "iconVisible": {
          "type": "boolean",
          "default": false
        },
        "dividerVisible": {
          "type": "boolean",
          "default": false
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "BoltComponentProperties": {
      "type": "object",
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "separator": {
          "type": "string",
          "enum": [
            "greater-than",
            "slash"
          ],
          "default": "slash",
          "description": "Defines type of separator between breadcrumbs items"
        },
        "shouldWrap": {
          "type": "boolean",
          "default": true,
          "description": "Defines flex wrapping of items"
        },
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr",
          "description": "Direction of breadcrumbs items"
        },
        "alignment": {
          "type": "string",
          "enum": [
            "flex-start",
            "center",
            "flex-end"
          ],
          "default": "flex-start",
          "description": "Alignment of breadcrumbs items"
        },
        "showHomePage": {
          "type": "boolean",
          "default": true,
          "description": "Should show home item"
        },
        "showHomePageAsIcon": {
          "type": "boolean",
          "default": false,
          "description": "Breadcrumbs will show HOME item as icon"
        },
        "showCurrentPage": {
          "type": "boolean",
          "default": true,
          "description": "Should show current page in breadcrumbs"
        },
        "showOnlyPreviousPageOnMobile": {
          "type": "boolean",
          "default": false,
          "description": "Show only previous page in mobile breadcrumbs"
        },
        "horizontalMargin": {
          "type": "number",
          "default": 0
        },
        "verticalMargin": {
          "type": "number",
          "default": 0
        },
        "isCollapsedByDefault": {
          "type": "boolean",
          "default": true
        },
        "itemsBeforeCollapse": {
          "type": "number",
          "default": 1
        },
        "itemsAfterCollapse": {
          "type": "number",
          "default": 1
        },
        "align": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ],
          "description": "Alignment of breadcrumbs items updated to new approach"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "CaptchaProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "theme": {
          "type": "string",
          "enum": [
            "light",
            "dark"
          ],
          "default": "light",
          "description": "When set changes the theme of the captcha (dark or light)"
        },
        "size": {
          "type": "string",
          "enum": [
            "normal",
            "compact"
          ],
          "default": "normal",
          "description": "When set changes the size of the captcha (normal or compact)"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "CollapsibleTextProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "ellipsis": {
          "type": "boolean",
          "default": true
        },
        "showExpandControl": {
          "type": "boolean",
          "default": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "align": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "left"
        },
        "alignButton": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "left"
        },
        "maxLines": {
          "type": "number",
          "default": 3
        },
        "wrappingStyle": {
          "type": "string",
          "enum": [
            "single-line",
            "multi-line"
          ],
          "default": "multi-line"
        },
        "expandControlSpacing": {
          "type": "number",
          "default": 10
        },
        "expandMode": {
          "type": "string",
          "enum": [
            "button",
            "link"
          ],
          "default": "link"
        },
        "isExpanded": {
          "type": "boolean",
          "default": false
        },
        "lastUserDefinedWidth": {
          "type": "number",
          "default": 300
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "HamburgerCloseButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "iconCollapsed": {
          "type": "boolean",
          "default": false
        },
        "isMaxContent": {
          "type": "boolean",
          "default": false
        },
        "isWrapText": {
          "type": "boolean",
          "default": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "HamburgerMenuContainerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fullWidth": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "HamburgerOpenButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "iconCollapsed": {
          "type": "boolean",
          "default": false
        },
        "isMaxContent": {
          "type": "boolean",
          "default": false
        },
        "isWrapText": {
          "type": "boolean",
          "default": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "LineShareButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonType": {
          "type": "string",
          "default": "button",
          "enum": [
            "button",
            "classicWithButton",
            "classicBig",
            "classicMedium",
            "classicSmall",
            "bubbleBig",
            "bubbleMedium",
            "bubbleSmall"
          ]
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "MusicPlayerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "layout": {
          "type": "string",
          "enum": [
            "classic",
            "icon"
          ],
          "default": "classic"
        },
        "source": {
          "type": "string",
          "enum": [
            "uploads",
            "url",
            "wixMusic"
          ],
          "default": "uploads"
        },
        "showCover": {
          "type": "boolean",
          "default": true
        },
        "showArtistName": {
          "type": "boolean",
          "default": true
        },
        "showTrackName": {
          "type": "boolean",
          "default": true
        },
        "showProgressBar": {
          "type": "boolean",
          "default": true
        },
        "showTimeStamp": {
          "type": "boolean",
          "default": true
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": "Autoplay audio"
        },
        "loop": {
          "type": "boolean",
          "default": false,
          "description": "Play audio on loop"
        },
        "showPlaylist": {
          "type": "boolean",
          "default": true,
          "description": "Show Tracklist"
        },
        "playlistTracksInfo": {
          "type": "string",
          "enum": [
            "trackName",
            "trackNameAndArtistName"
          ],
          "default": "trackName",
          "description": "Show track name or track name w/ artist name"
        },
        "playlistTracksAction": {
          "type": "string",
          "enum": [
            "onActive",
            "onAll"
          ],
          "default": "onActive",
          "description": "Show track actions on active track or all tracks"
        },
        "playlistTrackSpacing": {
          "type": "number",
          "minimum": 0,
          "maximum": 30,
          "description": "How much vertical space must be between each track in playlist",
          "default": 0
        },
        "iconId": {
          "type": "string",
          "default": "icon0",
          "description": "Design IconLayout id"
        },
        "consentToShareAlbum": {
          "type": "boolean",
          "default": false,
          "description": "Agreement to share album"
        },
        "consentToShareTracks": {
          "type": "boolean",
          "default": false,
          "description": "Agreement to share tracks"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "PaginationProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showFirstLastNavButtons": {
          "type": "boolean",
          "default": false
        },
        "showFirstPage": {
          "type": "boolean",
          "default": false
        },
        "showLastPage": {
          "type": "boolean",
          "default": false
        },
        "showInputModeTotalPages": {
          "type": "boolean",
          "default": true
        },
        "paginationMode": {
          "type": "string",
          "enum": [
            "pages",
            "input",
            "arrows"
          ],
          "default": "pages"
        },
        "navigationType": {
          "type": "string",
          "enum": [
            "arrows",
            "text"
          ],
          "default": "arrows"
        },
        "paginationDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "spread",
            "right"
          ],
          "default": "center"
        },
        "showPageNumbersBar": {
          "type": "boolean",
          "default": true
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ProGalleryProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "options": {
          "type": "object",
          "properties": {
            "controllers_optionsMap_behaviourParams_item_video_volume": {
              "type": "boolean",
              "default": false
            },
            "controllers_layoutParams_info_allowTitleAndDescription": {
              "type": "string",
              "default": ""
            },
            "layoutParams_structure_galleryLayout": {
              "type": "number",
              "default": 0
            },
            "layoutParams_structure_scrollDirection": {
              "type": "string",
              "default": "VERTICAL"
            },
            "layoutParams_structure_layoutOrientation": {
              "type": "string",
              "default": "VERTICAL"
            },
            "behaviourParams_gallery_layoutDirection": {
              "type": "string",
              "default": "LEFT_TO_RIGHT"
            },
            "layoutParams_structure_itemSpacing": {
              "type": "number",
              "default": 10
            },
            "layoutParams_structure_numberOfGridRows": {
              "type": "number",
              "default": 1
            },
            "layoutParams_structure_numberOfColumns": {
              "type": "number",
              "default": 3
            },
            "layoutParams_groups_density": {
              "type": "number",
              "default": 0.8
            },
            "layoutParams_targetItemSize_value": {
              "type": "number",
              "default": 48
            },
            "layoutParams_crop_method": {
              "type": "string",
              "default": "FILL"
            },
            "layoutParams_crop_ratios": {
              "type": "number",
              "default": 1
            },
            "layoutParams_structure_responsiveMode": {
              "type": "string",
              "default": "FIT_TO_SCREEN"
            },
            "layoutParams_thumbnails_alignment": {
              "type": "string",
              "default": "BOTTOM"
            },
            "layoutParams_thumbnails_size": {
              "type": "number",
              "default": 120
            },
            "layoutParams_thumbnails_spacing": {
              "type": "number",
              "default": 4
            },
            "controllers_layoutParams_thumbnails_marginToGallery": {
              "type": "number",
              "default": 4
            },
            "behaviourParams_gallery_vertical_loadMore_enable": {
              "type": "boolean",
              "default": false
            },
            "behaviourParams_gallery_vertical_loadMore_text": {
              "type": "string",
              "default": "Load More"
            },
            "behaviourParams_gallery_horizontal_navigationDuration": {
              "type": "number",
              "default": 800
            },
            "behaviourParams_gallery_horizontal_loop": {
              "type": "boolean",
              "default": false
            },
            "behaviourParams_gallery_horizontal_autoSlide_interval": {
              "type": "number",
              "default": 4
            },
            "behaviourParams_gallery_horizontal_autoSlide_speed": {
              "type": "number",
              "default": 50
            },
            "behaviourParams_gallery_horizontal_autoSlide_pauseOnHover": {
              "type": "boolean",
              "default": true
            },
            "behaviourParams_gallery_blockContextMenu": {
              "type": "boolean",
              "default": true
            },
            "layoutParams_navigationArrows_enable": {
              "type": "boolean",
              "default": true
            },
            "layoutParams_navigationArrows_size": {
              "type": "number",
              "default": 23
            },
            "layoutParams_navigationArrows_position": {
              "type": "string",
              "default": "ON_GALLERY"
            },
            "layoutParams_navigationArrows_container_type": {
              "type": "string",
              "default": "NONE"
            },
            "layoutParams_navigationArrows_mouseCursorContainerMaxWidth": {
              "type": "string",
              "default": "100"
            },
            "layoutParams_navigationArrows_verticalAlignment": {
              "type": "string",
              "default": "ITEM_CENTER"
            },
            "controllers_behaviourParams_item_overlay_hoverAnimationBehavior": {
              "type": "string",
              "default": "APPEARS"
            },
            "behaviourParams_item_content_hoverAnimation": {
              "type": "string",
              "default": "NO_EFFECT"
            },
            "behaviourParams_item_content_loader": {
              "type": "string",
              "default": "MAIN_COLOR"
            },
            "behaviourParams_item_content_placementAnimation": {
              "type": "string",
              "default": "NO_EFFECT"
            },
            "behaviourParams_gallery_scrollAnimation": {
              "type": "string",
              "default": "NO_EFFECT"
            },
            "behaviourParams_gallery_horizontal_slideAnimation": {
              "type": "string",
              "default": "SCROLL"
            },
            "behaviourParams_item_video_enablePlayButton": {
              "type": "boolean",
              "default": true
            },
            "behaviourParams_item_video_playTrigger": {
              "type": "string",
              "default": "HOVER"
            },
            "behaviourParams_item_video_speed": {
              "type": "number",
              "default": 1
            },
            "behaviourParams_item_video_volume": {
              "type": "number",
              "default": 0
            },
            "behaviourParams_item_video_loop": {
              "type": "boolean",
              "default": true
            },
            "behaviourParams_item_clickAction": {
              "type": "string",
              "default": "NOTHING"
            },
            "behaviourParams_item_content_magnificationValue": {
              "type": "number",
              "default": 2
            },
            "layoutParams_navigationArrows_padding": {
              "type": "number",
              "default": 23
            },
            "behaviourParams_gallery_vertical_loadMore_amount": {
              "type": "string",
              "default": "ALL"
            },
            "behaviourParams_gallery_horizontal_autoSlide_behaviour": {
              "type": "string",
              "default": "OFF"
            },
            "behaviourParams_gallery_horizontal_slideTransition": {
              "type": "string",
              "default": "cubic-bezier(0.46,0.1,0.25,1)"
            },
            "controllers_layoutParams_external_info_placement": {
              "type": "string",
              "default": "BELOW"
            },
            "controllers_layoutParams_external_info_CustomButtonHorizontalAlignment": {
              "type": "string",
              "default": "CENTER"
            },
            "controllers_layoutParams_internal_info_CustomButtonHorizontalAlignment": {
              "type": "string",
              "default": "CENTER"
            },
            "controllers_layoutParams_internal_info_CustomButtonCustomButtonText": {
              "type": "string",
              "default": "Click here"
            },
            "controllers_layoutParams_external_info_CustomButtonCustomButtonText": {
              "type": "string",
              "default": "Click here"
            },
            "controllers_layoutParams_external_info_SocialButtonsHorizontalAlignment": {
              "type": "string",
              "default": "LEFT"
            },
            "controllers_layoutParams_internal_info_SocialButtonsHorizontalAlignment": {
              "type": "string",
              "default": "LEFT"
            },
            "layoutParams_info_placement": {
              "type": "string",
              "default": "OVERLAY"
            },
            "controllers_layoutParams_info_allowTitle": {
              "type": "boolean",
              "default": false
            },
            "controllers_layoutParams_info_allowDescription": {
              "type": "boolean",
              "default": false
            },
            "controllers_layoutParams_info_verticalPadding": {
              "type": "number",
              "default": 0
            },
            "controllers_layoutParams_info_horizontalPadding": {
              "type": "number",
              "default": 0
            },
            "controllers_layoutParams_infoElementOptions_external_enabled": {
              "type": "string",
              "default": ""
            },
            "controllers_layoutParams_infoElementOptions_internal_enabled": {
              "type": "string",
              "default": ""
            },
            "controllers_experimental_useNewInfo": {
              "type": "string",
              "default": ""
            },
            "controllers_layoutParams_infoElementOptions_external_order": {
              "type": "string",
              "default": "top,Title,Description,CustomButton,middle,bottom,Social"
            },
            "controllers_layoutParams_infoElementOptions_internal_order": {
              "type": "string",
              "default": "top,Title,Description,CustomButton,middle,bottom,Social"
            },
            "controllers_layoutParams_info_verticalAlignment": {
              "type": "string",
              "default": "CENTER"
            },
            "controllers_layoutParams_info_horizontalAlignment": {
              "type": "string",
              "default": "CENTER"
            },
            "controllers_layoutParams_structure_imageWidth_method": {
              "type": "string",
              "default": "FIXED"
            },
            "controllers_layoutParams_structure_numberOfDisplayedItems": {
              "type": "number",
              "default": 3
            },
            "layoutParams_info_sizeUnits": {
              "type": "string",
              "default": "PIXEL"
            },
            "layoutParams_info_height": {
              "type": "number",
              "default": 200
            },
            "controllers_layoutParams_info_width_pixel": {
              "type": "number",
              "default": 200
            },
            "controllers_layoutParams_info_width_percent": {
              "type": "number",
              "default": 50
            },
            "behaviourParams_item_overlay_hoveringBehaviour": {
              "type": "string",
              "default": "NEVER_SHOW"
            },
            "controllers_behaviourParams_item_overlay_overlayType": {
              "type": "string",
              "default": "FULL"
            },
            "behaviourParams_item_overlay_sizeUnits": {
              "type": "string",
              "default": "PERCENT"
            },
            "controllers_behaviourParams_item_overlay_size_percent": {
              "type": "number",
              "default": 100
            },
            "controllers_behaviourParams_item_overlay_size_pixel": {
              "type": "number",
              "default": 100
            },
            "behaviourParams_item_overlay_position": {
              "type": "string",
              "default": "BOTTOM"
            },
            "behaviourParams_item_overlay_padding": {
              "type": "number",
              "default": 0
            },
            "behaviourParams_item_secondaryMedia_enableHoverTrigger": {
              "type": "boolean",
              "default": false
            },
            "behaviourParams_item_overlay_hoverAnimation": {
              "type": "string",
              "default": "NO_EFFECT"
            },
            "controllers_layoutParams_structure_galleryRatio_method": {
              "type": "string",
              "default": "MANUAL"
            },
            "controllers_layoutParams_structure_galleryRatio_value": {
              "type": "number",
              "default": 1
            },
            "controllers_fullscreen_allowTitleExpand": {
              "type": "boolean",
              "default": true
            },
            "controllers_behaviourParams_item_overlay_enabled": {
              "type": "boolean",
              "default": true
            },
            "controllers_layoutParams_info_newInfo_external_enabled": {
              "type": "boolean",
              "default": true
            },
            "controllers_fullscreen_allowDescriptionExpand": {
              "type": "boolean",
              "default": true
            },
            "controllers_fullscreen_allowLinkExpand": {
              "type": "boolean",
              "default": false
            },
            "controllers_fullscreen_expandInfoPosition": {
              "type": "string",
              "default": "SIDE"
            },
            "controllers_fullscreen_showInfoExpandButton": {
              "type": "boolean",
              "default": false
            },
            "controllers_fullscreen_whenToShowInfo": {
              "type": "string",
              "default": "ALWAYS"
            },
            "controllers_fullscreen_allowFullscreenExpand": {
              "type": "boolean",
              "default": true
            },
            "controllers_fullscreen_fullscreenLoop": {
              "type": "boolean",
              "default": false
            },
            "controllers_fullscreen_allowFullscreenMagnifyImage": {
              "type": "boolean",
              "default": false
            },
            "controllers_fullscreen_fullscreenMagnificationLevel": {
              "type": "number",
              "default": 2
            },
            "controllers_fullscreen_fullscreenMagnificationPercent": {
              "type": "number",
              "default": 200
            },
            "controllers_fullscreen_backgroundBlurFilter": {
              "type": "number",
              "default": 1
            },
            "controllers_fullscreen_backgroundGrayscaleFilter": {
              "type": "boolean",
              "default": false
            },
            "controllers_showManageMedia": {
              "type": "boolean",
              "default": false
            },
            "variant_count": {
              "type": "number",
              "default": 0
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ProgressBarProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RangeSliderProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "align": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ],
          "description": "Alignment of range slider"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RatingsDisplayProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showReviewsCount": {
          "type": "boolean",
          "default": true
        },
        "showRating": {
          "type": "boolean",
          "default": true
        },
        "noReviewsMode": {
          "type": "string",
          "enum": [
            "nothing",
            "emptyIcons",
            "placeholderText"
          ],
          "default": "emptyIcons"
        },
        "ratingPosition": {
          "type": "string",
          "enum": [
            "before",
            "after"
          ],
          "default": "before"
        },
        "shapeSize": {
          "type": "number",
          "minimum": 15,
          "maximum": 100,
          "default": 24
        },
        "shapeSpacing": {
          "type": "number",
          "minimum": 1,
          "maximum": 50,
          "default": 5
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "left"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "renderSeo": {
          "type": "boolean",
          "default": true
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RatingsInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showTitle": {
          "type": "boolean",
          "default": true
        },
        "showLabels": {
          "type": "boolean",
          "default": true
        },
        "labelPosition": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "side"
          ],
          "default": "top"
        },
        "a11yLabelPosition": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "side"
          ],
          "default": "side"
        },
        "labelAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "center"
        },
        "a11yLabelAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "center"
        },
        "shapeSize": {
          "type": "number",
          "minimum": 15,
          "maximum": 100,
          "default": 24
        },
        "shapeSpacing": {
          "type": "number",
          "minimum": 1,
          "maximum": 50,
          "default": 5
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "RichTextBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "textAlignment": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "description": "the text alignment",
          "maxLength": 100
        },
        "textPadding": {
          "type": "number",
          "default": 18,
          "minimum": 0,
          "maximum": 100,
          "description": "the value of the textPadding"
        },
        "toolbarPosition": {
          "type": "string",
          "default": "top",
          "enum": [
            "top",
            "bottom",
            "inline"
          ],
          "description": "the location of the toolbar",
          "maxLength": 20
        },
        "placeholder": {
          "type": "string",
          "description": "the placeholder",
          "default": "",
          "maxLength": 4000
        },
        "defaultTextType": {
          "type": "string",
          "default": "placeholderText",
          "enum": [
            "none",
            "initialText",
            "placeholderText",
            "placeholderAndInitialText"
          ],
          "description": "the type of the default text for the input",
          "maxLength": 100
        },
        "allowLinks": {
          "type": "boolean",
          "description": "Are links allowed"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SearchBoxProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "layout": {
          "type": "string",
          "enum": [
            "icon",
            "button",
            "icon-only",
            "expandable"
          ],
          "default": "icon"
        },
        "iconAlignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left"
        },
        "textAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center"
          ],
          "default": "left"
        },
        "textSpacing": {
          "type": "number",
          "default": 12,
          "description": "Setting the spacing from the side the text is aligned to",
          "minimum": 0,
          "maximum": 50
        },
        "iconSpacing": {
          "type": "number",
          "default": 12,
          "description": "In icon layout affects the side to which the icon is aligend to, for button layout affects both - left and right sides",
          "minimum": 0,
          "maximum": 50
        },
        "trendingItemsEnabled": {
          "type": "boolean",
          "default": true,
          "description": "Controls trending items visibility."
        },
        "isExpandable": {
          "type": "boolean",
          "default": false,
          "description": "Is component able to expand/collapse"
        },
        "expandedDirection": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left",
          "description": "Which direction the component should expand to"
        },
        "expandedWidth": {
          "type": "number",
          "default": 100,
          "description": "What's the expanded component width",
          "minimum": 0,
          "maximum": 1000
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SearchButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "iconCollapsed": {
          "type": "boolean",
          "default": false
        },
        "isMaxContent": {
          "type": "boolean",
          "default": false
        },
        "isWrapText": {
          "type": "boolean",
          "default": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SelectionTagsListProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr",
          "description": "Direction of tags"
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left",
          "description": "Alignment of tags"
        },
        "hasAutoHeight": {
          "type": "boolean",
          "description": "used in mapper to avoid adding min-height property"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SignatureInputProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "required": {
          "type": "boolean"
        },
        "titlePaddingStart": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "titleMarginBottom": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SingleTabProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isParentFullWidth": {
          "type": "boolean"
        }
      }
    },
    "SliderProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "trackSize": {
          "type": "number",
          "default": 25
        },
        "orientation": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical"
          ],
          "default": "horizontal"
        },
        "thumbShape": {
          "type": "string",
          "enum": [
            "circle",
            "square",
            "rectangle",
            "bar"
          ],
          "default": "circle"
        },
        "thumbSize": {
          "type": "number",
          "minimum": 18,
          "maximum": 100,
          "description": "Size of the slider thumb"
        },
        "tickMarksShape": {
          "type": "string",
          "enum": [
            "none",
            "line",
            "dot"
          ],
          "default": "line"
        },
        "tooltipVisibility": {
          "type": "string",
          "enum": [
            "none",
            "hover",
            "always"
          ],
          "default": "hover"
        },
        "tooltipPosition": {
          "type": "string",
          "enum": [
            "normal",
            "across"
          ],
          "default": "normal"
        },
        "tooltipPrefix": {
          "type": "string",
          "maxLength": 30
        },
        "tooltipSuffix": {
          "type": "string",
          "maxLength": 30
        },
        "tickMarksPosition": {
          "type": "string",
          "enum": [
            "normal",
            "middle",
            "across"
          ],
          "default": "normal"
        },
        "dir": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SlideshowProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "default": "SlideshowProperties",
          "maxLength": 120,
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHidden": {
          "type": "boolean"
        },
        "isCollapsed": {
          "type": "boolean"
        },
        "isPlaying": {
          "default": true,
          "type": "boolean"
        },
        "slideDuration": {
          "default": 5,
          "minimum": 3,
          "maximum": 30,
          "type": "number"
        },
        "pauseOnHover": {
          "default": true,
          "type": "boolean"
        },
        "showPlaybackControl": {
          "default": false,
          "type": "boolean"
        },
        "loop": {
          "default": true,
          "type": "boolean"
        },
        "previewItemId": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      },
      "required": [
        "isHidden",
        "isCollapsed"
      ]
    },
    "SlideshowButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "action": {
          "type": "string",
          "enum": [
            "prev",
            "next"
          ],
          "default": "next"
        },
        "iconCollapsed": {
          "type": "boolean",
          "default": false
        },
        "isMaxContent": {
          "type": "boolean",
          "default": false
        },
        "isWrapText": {
          "type": "boolean",
          "default": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "SocialAuthProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isSmallIcons": {
          "type": "boolean",
          "default": true
        },
        "isSocialLoginGoogleEnabled": {
          "type": "boolean",
          "default": true
        },
        "isSocialLoginFacebookEnabled": {
          "type": "boolean",
          "default": true
        },
        "mode": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "signup",
            "login"
          ]
        },
        "formType": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "default",
            "custom",
            "corvid"
          ],
          "default": "corvid"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StylableButtonProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "iconCollapsed": {
          "type": "boolean",
          "default": false
        },
        "isMaxContent": {
          "type": "boolean",
          "default": false
        },
        "isWrapText": {
          "type": "boolean",
          "default": false
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "StylableHorizontalMenuProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menuMode": {
          "type": "string",
          "enum": [
            "wrap",
            "scroll"
          ],
          "default": "wrap"
        },
        "submenuMode": {
          "type": "string",
          "enum": [
            "columnMenu",
            "columnStretched",
            "flyout"
          ],
          "description": "Submenu view modes",
          "default": "columnMenu"
        },
        "slotMap": {
          "type": "object"
        },
        "isContainerStretched": {
          "type": "boolean",
          "default": true
        },
        "submenuOrder": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ],
          "description": "Submenu items order",
          "default": "vertical"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "TabsProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemSpacing": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 0
        },
        "itemRowSpacing": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 0
        },
        "containerSpacing": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 0
        },
        "tabWidth": {
          "type": "number",
          "minimum": 10,
          "maximum": 500
        },
        "stretchTabsToMenuWidth": {
          "type": "boolean",
          "default": false
        },
        "fitTabsToTextWidth": {
          "type": "boolean",
          "default": false
        },
        "itemsOrientation": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical"
          ],
          "default": "horizontal"
        },
        "itemsAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left"
        },
        "contentAlignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left"
        },
        "itemsLogicalAlign": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ],
          "default": "start"
        },
        "contentLogicalAlign": {
          "type": "string",
          "enum": [
            "start",
            "center",
            "end"
          ],
          "default": "start"
        },
        "horizontalTabPadding": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 20
        },
        "verticalTabPadding": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "default": 20
        },
        "menuMode": {
          "type": "string",
          "enum": [
            "wrap",
            "scroll"
          ],
          "default": "scroll"
        },
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr"
        },
        "tabEnterAnimationName": {
          "type": "string",
          "enum": [
            "none",
            "fadeIn",
            "floatFromTop",
            "floatFromBottom"
          ],
          "default": "none",
          "description": "The animation that will be played when a tab is entered"
        },
        "tabExitAnimationName": {
          "type": "string",
          "enum": [
            "none",
            "fadeOut"
          ],
          "default": "none",
          "description": "The animation that will be played when a tab is exited"
        },
        "animationDuration": {
          "type": "number",
          "minimum": 0,
          "maximum": 5,
          "default": 0.3,
          "description": "Duration of the transition in sec"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "TimePickerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "center",
            "right"
          ],
          "default": "left"
        },
        "useAmPmFormat": {
          "type": "boolean",
          "default": false,
          "description": "Should the display format be 12 hours (or 24)"
        },
        "controller": {
          "type": "string",
          "enum": [
            "text",
            "stepper",
            "dropdown"
          ],
          "default": "text",
          "description": "The display of the time picker"
        },
        "initialTime": {
          "type": "string",
          "enum": [
            "none",
            "current",
            "value",
            "placeholder"
          ],
          "default": "current",
          "description": "What the time picker should display on load"
        },
        "margin": {
          "type": "number",
          "multipleOf": 1,
          "description": ""
        },
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startTime",
              "endTime"
            ],
            "properties": {
              "startTime": {
                "type": "string",
                "maxLength": 100
              },
              "endTime": {
                "type": "string",
                "maxLength": 100
              }
            }
          },
          "default": [],
          "maxItems": 5,
          "description": "array of disabled times"
        },
        "enabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startTime",
              "endTime"
            ],
            "properties": {
              "startTime": {
                "type": "string",
                "maxLength": 100
              },
              "endTime": {
                "type": "string",
                "maxLength": 100
              }
            }
          },
          "default": [],
          "maxItems": 5,
          "description": "array of enabled times"
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "ToggleSwitchProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayKnobIcons": {
          "type": "boolean"
        },
        "trackHeight": {
          "type": "number",
          "default": 100
        },
        "knobSize": {
          "type": "number",
          "default": 90
        },
        "alignment": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ],
          "default": "left"
        },
        "switchHeight": {
          "type": "number",
          "default": 24
        },
        "label": {
          "type": "string",
          "description": "input label"
        },
        "required": {
          "type": "boolean",
          "description": "is the input field required to have a value"
        },
        "autoFocus": {
          "type": "boolean",
          "description": "should the field be focused when loading the page"
        },
        "readOnly": {
          "type": "boolean",
          "description": "is the field readonly"
        },
        "tabIndex": {
          "type": "number",
          "description": "the tab index in the form"
        },
        "inputHeight": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "inputHeightMobile": {
          "type": [
            "number",
            "null"
          ],
          "description": "Height of input",
          "minimum": 25
        },
        "labelMargin": {
          "type": "number",
          "default": 14,
          "description": "Margin between label to input",
          "minimum": 0,
          "maximum": 100
        },
        "labelPadding": {
          "type": "number",
          "default": 0,
          "description": "Padding of label",
          "minimum": 0,
          "maximum": 100
        },
        "labelMobileFontSize": {
          "type": "number"
        },
        "inputMobileFontSize": {
          "type": "number"
        },
        "isDisabled": {
          "type": "boolean",
          "description": "disables the component"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    },
    "VideoPlayerProperties": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "schemaVersion": {
              "type": [
                "string",
                "null"
              ],
              "default": "1.0"
            },
            "autoGenerated": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showVideoTitle": {
          "type": "boolean",
          "default": true
        },
        "autoplay": {
          "type": "boolean",
          "default": false,
          "description": "Autoplay video"
        },
        "loop": {
          "type": "boolean",
          "default": false,
          "description": "Play video on loop"
        },
        "share": {
          "type": "boolean",
          "default": true,
          "description": "Allow to share video"
        },
        "controlsVisibility": {
          "type": "string",
          "enum": [
            "hover",
            "never"
          ],
          "default": "hover"
        },
        "animatePoster": {
          "type": "string",
          "enum": [
            "fade",
            "none"
          ],
          "default": "none",
          "description": "Animate video poster"
        },
        "isHidden": {
          "type": "boolean",
          "description": "sets visibility:hidden to the component style node"
        },
        "isCollapsed": {
          "type": "boolean",
          "description": "sets isCollapsed for component"
        },
        "ghost": {
          "type": "string",
          "enum": [
            "COLLAPSED"
          ],
          "description": "sets collapsed to hidden ref component"
        },
        "fontScale": {
          "type": "number"
        },
        "deleted": {
          "type": "boolean",
          "description": "allows the viewer to remove hidden comps from structure - to not render in the DOM"
        }
      }
    }
  },
  "connections_data.json": {
    "$id": "urn:dm:schemas:connections_data.json",
    "ConnectionList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "controllerId"
                ],
                "properties": {
                  "controllerId": {
                    "type": [
                      "string"
                    ]
                  },
                  "isPrimary": {
                    "type": "boolean"
                  },
                  "config": {
                    "type": "string",
                    "maxLength": 2000
                  },
                  "subRole": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "role": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "ConnectionItem"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "role": {
                    "type": "string"
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "WixCodeConnectionItem"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      }
    },
    "ConnectionItem": {
      "type": "object",
      "required": [
        "controllerId"
      ],
      "properties": {
        "controllerId": {
          "type": [
            "string"
          ]
        },
        "isPrimary": {
          "type": "boolean"
        },
        "config": {
          "type": "string",
          "maxLength": 2000
        },
        "subRole": {
          "type": "string",
          "maxLength": 100
        },
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "ConnectionItem"
          ]
        }
      },
      "additionalProperties": false
    },
    "WixCodeConnectionItem": {
      "type": "object",
      "properties": {
        "role": {
          "type": "string"
        },
        "type": {
          "type": "string",
          "enum": [
            "WixCodeConnectionItem"
          ]
        }
      },
      "additionalProperties": false
    }
  },
  "contentRole.json": {
    "$id": "urn:dm:schemas:contentRole.json",
    "ContainerRole": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "contentRole": {
          "type": "string",
          "maxLength": 50
        },
        "fieldRole": {
          "type": "string",
          "maxLength": 50
        },
        "listRole": {
          "type": "string",
          "maxLength": 30
        },
        "complexity": {
          "type": "string",
          "maxLength": 30
        },
        "allowedFlows": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "contentRole",
        "complexity"
      ]
    },
    "Field": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldRole": {
          "type": "string",
          "maxLength": 50
        },
        "listItemId": {
          "type": "number",
          "minimum": 0,
          "maximum": 128
        },
        "allowedFlows": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "fieldRole"
      ]
    }
  },
  "controllers.json": {
    "$id": "urn:dm:schemas:controllers.json",
    "ControllerList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "controllers": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    }
  },
  "css-value-definitions.schema.json": {
    "$id": "urn:dm:schemas:css-value-definitions.schema.json",
    "title": "CSS Value Definitions",
    "description": "Individual JSON Schema definitions for CSS value types, suitable for format registration",
    "definitions": {
      "<positive-value>": {
        "type": "string",
        "pattern": "^[^-]",
        "description": "CSS positive value"
      },
      "<length>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
          }
        ],
        "description": "CSS numeric length with all valid units"
      },
      "<positive-length>": {
        "allOf": [
          {
            "type": "string",
            "pattern": "^[^-]",
            "description": "CSS positive value"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          }
        ],
        "description": "CSS positive numeric length with all valid units"
      },
      "<percentage>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+%$"
          }
        ],
        "description": "Number followed by %"
      },
      "<positive-percentage>": {
        "allOf": [
          {
            "type": "string",
            "pattern": "^[^-]",
            "description": "CSS positive value"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "Positive number followed by %"
      },
      "<length-percentage>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "Accepts both <length> and <percentage>"
      },
      "<positive-length-percentage>": {
        "anyOf": [
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              }
            ],
            "description": "CSS positive numeric length with all valid units"
          },
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Positive number followed by %"
          }
        ],
        "description": "Accepts both <positive-length> and <positive-percentage>"
      },
      "<auto>": {
        "type": "string",
        "enum": [
          "auto"
        ],
        "description": "CSS auto keyword"
      },
      "<length-percentage-auto>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          },
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          }
        ],
        "description": "CSS length, percentage, or auto"
      },
      "<positive-length-percentage-auto>": {
        "anyOf": [
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              }
            ],
            "description": "CSS positive numeric length with all valid units"
          },
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Positive number followed by %"
          },
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          }
        ],
        "description": "CSS positive length, positive percentage, or auto"
      },
      "<number>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+$"
          }
        ],
        "description": "Decimal or integer number"
      },
      "<positive-number>": {
        "allOf": [
          {
            "type": "string",
            "pattern": "^[^-]",
            "description": "CSS positive value"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          }
        ],
        "description": "Positive decimal or integer number"
      },
      "<integer>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d+$"
          }
        ],
        "description": "Whole numbers only"
      },
      "height": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          },
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              }
            ],
            "description": "Accepts both <positive-length> and <positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content"
            ]
          }
        ],
        "description": "CSS height value"
      },
      "<angle>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
          }
        ],
        "description": "Used in rotation, direction, etc."
      },
      "<time>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
          }
        ],
        "description": "CSS durations (s, ms)"
      },
      "<resolution>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+(dpi|dpcm|dppx|x)$",
        "description": "Screen density/resolution units"
      },
      "<frequency>": {
        "oneOf": [
          {
            "type": "string",
            "pattern": "^calc\\([^(),]+\\)$",
            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
          },
          {
            "type": "string",
            "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
          }
        ],
        "description": "Used in aural CSS or media queries"
      },
      "<dimension>": {
        "type": "string",
        "pattern": "^-?\\d*\\.?\\d+[a-zA-Z]+$",
        "description": "Generic dimension (unit required)"
      },
      "<percentage-or-number>": {
        "oneOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "Matches numbers or percentages"
      },
      "<custom-ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "CSS identifiers (excluding keywords)"
      },
      "<ident>": {
        "type": "string",
        "pattern": "^[a-zA-Z_][\\w-]*$",
        "description": "Same as <custom-ident>"
      },
      "<string>": {
        "type": "string",
        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
        "description": "Quoted strings with escapes"
      },
      "<url>": {
        "type": "string",
        "pattern": "^url\\((['\"]?).*?\\1\\)$",
        "description": "Matches url(...) with optional quotes"
      },
      "<hex-color>": {
        "type": "string",
        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
      },
      "<rgb-color>": {
        "type": "string",
        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
      },
      "<hsl-color>": {
        "type": "string",
        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
      },
      "<named-color>": {
        "type": "string",
        "enum": [
          "transparent",
          "currentColor",
          "aliceblue",
          "antiquewhite",
          "aqua",
          "aquamarine",
          "azure",
          "beige",
          "bisque",
          "black",
          "blanchedalmond",
          "blue",
          "blueviolet",
          "brown",
          "burlywood",
          "cadetblue",
          "chartreuse",
          "chocolate",
          "coral",
          "cornflowerblue",
          "cornsilk",
          "crimson",
          "cyan",
          "darkblue",
          "darkcyan",
          "darkgoldenrod",
          "darkgray",
          "darkgrey",
          "darkgreen",
          "darkkhaki",
          "darkmagenta",
          "darkolivegreen",
          "darkorange",
          "darkorchid",
          "darkred",
          "darksalmon",
          "darkseagreen",
          "darkslateblue",
          "darkslategray",
          "darkslategrey",
          "darkturquoise",
          "darkviolet",
          "deeppink",
          "deepskyblue",
          "dimgray",
          "dimgrey",
          "dodgerblue",
          "firebrick",
          "floralwhite",
          "forestgreen",
          "fuchsia",
          "gainsboro",
          "ghostwhite",
          "gold",
          "goldenrod",
          "gray",
          "grey",
          "green",
          "greenyellow",
          "honeydew",
          "hotpink",
          "indianred",
          "indigo",
          "ivory",
          "khaki",
          "lavender",
          "lavenderblush",
          "lawngreen",
          "lemonchiffon",
          "lightblue",
          "lightcoral",
          "lightcyan",
          "lightgoldenrodyellow",
          "lightgray",
          "lightgrey",
          "lightgreen",
          "lightpink",
          "lightsalmon",
          "lightseagreen",
          "lightskyblue",
          "lightslategray",
          "lightslategrey",
          "lightsteelblue",
          "lightyellow",
          "lime",
          "limegreen",
          "linen",
          "magenta",
          "maroon",
          "mediumaquamarine",
          "mediumblue",
          "mediumorchid",
          "mediumpurple",
          "mediumseagreen",
          "mediumslateblue",
          "mediumspringgreen",
          "mediumturquoise",
          "mediumvioletred",
          "midnightblue",
          "mintcream",
          "mistyrose",
          "moccasin",
          "navajowhite",
          "navy",
          "oldlace",
          "olive",
          "olivedrab",
          "orange",
          "orangered",
          "orchid",
          "palegoldenrod",
          "palegreen",
          "paleturquoise",
          "palevioletred",
          "papayawhip",
          "peachpuff",
          "peru",
          "pink",
          "plum",
          "powderblue",
          "purple",
          "rebeccapurple",
          "red",
          "rosybrown",
          "royalblue",
          "saddlebrown",
          "salmon",
          "sandybrown",
          "seagreen",
          "seashell",
          "sienna",
          "silver",
          "skyblue",
          "slateblue",
          "slategray",
          "slategrey",
          "snow",
          "springgreen",
          "steelblue",
          "tan",
          "teal",
          "thistle",
          "tomato",
          "turquoise",
          "violet",
          "wheat",
          "white",
          "whitesmoke",
          "yellow",
          "yellowgreen"
        ],
        "description": "CSS named colors including transparent and currentColor"
      },
      "<color>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
            "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
          },
          {
            "type": "string",
            "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
            "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
          },
          {
            "type": "string",
            "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
            "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
          },
          {
            "type": "string",
            "enum": [
              "transparent",
              "currentColor",
              "aliceblue",
              "antiquewhite",
              "aqua",
              "aquamarine",
              "azure",
              "beige",
              "bisque",
              "black",
              "blanchedalmond",
              "blue",
              "blueviolet",
              "brown",
              "burlywood",
              "cadetblue",
              "chartreuse",
              "chocolate",
              "coral",
              "cornflowerblue",
              "cornsilk",
              "crimson",
              "cyan",
              "darkblue",
              "darkcyan",
              "darkgoldenrod",
              "darkgray",
              "darkgrey",
              "darkgreen",
              "darkkhaki",
              "darkmagenta",
              "darkolivegreen",
              "darkorange",
              "darkorchid",
              "darkred",
              "darksalmon",
              "darkseagreen",
              "darkslateblue",
              "darkslategray",
              "darkslategrey",
              "darkturquoise",
              "darkviolet",
              "deeppink",
              "deepskyblue",
              "dimgray",
              "dimgrey",
              "dodgerblue",
              "firebrick",
              "floralwhite",
              "forestgreen",
              "fuchsia",
              "gainsboro",
              "ghostwhite",
              "gold",
              "goldenrod",
              "gray",
              "grey",
              "green",
              "greenyellow",
              "honeydew",
              "hotpink",
              "indianred",
              "indigo",
              "ivory",
              "khaki",
              "lavender",
              "lavenderblush",
              "lawngreen",
              "lemonchiffon",
              "lightblue",
              "lightcoral",
              "lightcyan",
              "lightgoldenrodyellow",
              "lightgray",
              "lightgrey",
              "lightgreen",
              "lightpink",
              "lightsalmon",
              "lightseagreen",
              "lightskyblue",
              "lightslategray",
              "lightslategrey",
              "lightsteelblue",
              "lightyellow",
              "lime",
              "limegreen",
              "linen",
              "magenta",
              "maroon",
              "mediumaquamarine",
              "mediumblue",
              "mediumorchid",
              "mediumpurple",
              "mediumseagreen",
              "mediumslateblue",
              "mediumspringgreen",
              "mediumturquoise",
              "mediumvioletred",
              "midnightblue",
              "mintcream",
              "mistyrose",
              "moccasin",
              "navajowhite",
              "navy",
              "oldlace",
              "olive",
              "olivedrab",
              "orange",
              "orangered",
              "orchid",
              "palegoldenrod",
              "palegreen",
              "paleturquoise",
              "palevioletred",
              "papayawhip",
              "peachpuff",
              "peru",
              "pink",
              "plum",
              "powderblue",
              "purple",
              "rebeccapurple",
              "red",
              "rosybrown",
              "royalblue",
              "saddlebrown",
              "salmon",
              "sandybrown",
              "seagreen",
              "seashell",
              "sienna",
              "silver",
              "skyblue",
              "slateblue",
              "slategray",
              "slategrey",
              "snow",
              "springgreen",
              "steelblue",
              "tan",
              "teal",
              "thistle",
              "tomato",
              "turquoise",
              "violet",
              "wheat",
              "white",
              "whitesmoke",
              "yellow",
              "yellowgreen"
            ],
            "description": "CSS named colors including transparent and currentColor"
          }
        ],
        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
      },
      "<image>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^url\\((['\"]?).*?\\1\\)$",
            "description": "Matches url(...) with optional quotes"
          },
          {
            "type": "string",
            "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
            "description": "Gradient functions - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^image\\(.*\\)$",
            "description": "Image function - arguments cannot be fully validated with regex"
          }
        ],
        "description": "CSS image values including URLs, gradients, and image() functions"
      },
      "<position>": {
        "type": "string",
        "pattern": "^(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%))(\\s+(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%)))*$",
        "description": "Single position value. Full position syntax with multiple values and combinations requires complex parsing that cannot be fully validated with regex."
      },
      "<transform-function>": {
        "type": "string",
        "pattern": "^(matrix|matrix3d|perspective|rotate|rotate3d|rotateX|rotateY|rotateZ|scale|scale3d|scaleX|scaleY|scaleZ|skew|skewX|skewY|translate|translate3d|translateX|translateY|translateZ)\\(.*\\)$",
        "description": "Transform functions like rotate(), translate(), scale(). Function arguments cannot be fully validated with regex as they require parsing of nested expressions."
      },
      "<var()>": {
        "type": "string",
        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
        "description": "CSS var() function- resolving a variable value from the variable"
      },
      "<calc()>": {
        "type": "string",
        "pattern": "^calc\\([^(),]+\\)$",
        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
      },
      "<attr()>": {
        "type": "string",
        "pattern": "^attr\\(.*\\)$",
        "description": "CSS attr() function. Cannot fully validate fallback values and type hints with regex."
      },
      "<image-set()>": {
        "type": "string",
        "pattern": "^image-set\\(.*\\)$",
        "description": "CSS image-set() function. Cannot parse comma-separated URLs and resolution descriptors with regex."
      },
      "<basic-shape>": {
        "type": "string",
        "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
        "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
      },
      "<filter-function>": {
        "type": "string",
        "pattern": "^(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\)$",
        "description": "CSS filter functions. Function arguments cannot be fully validated with regex."
      },
      "<filter-value-list>": {
        "type": "string",
        "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
        "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
      },
      "<filter>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "type": "string",
            "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
            "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
          }
        ],
        "description": "CSS filter value"
      },
      "<line-width>": {
        "anyOf": [
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              }
            ],
            "description": "CSS positive numeric length with all valid units"
          },
          {
            "type": "string",
            "enum": [
              "thin",
              "medium",
              "thick"
            ]
          }
        ],
        "description": "CSS line width: length values or predefined keywords"
      },
      "<line-style>": {
        "type": "string",
        "enum": [
          "none",
          "hidden",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS line style keywords"
      },
      "<global-values>": {
        "type": "string",
        "enum": [
          "inherit",
          "initial",
          "unset",
          "revert",
          "revert-layer"
        ],
        "description": "Global values available for any CSS property"
      },
      "<flex>": {
        "type": "string",
        "pattern": "^\\d*\\.?\\d+fr$",
        "description": "CSS flex unit for grid and flexbox"
      },
      "<none>": {
        "type": "string",
        "enum": [
          "none"
        ],
        "description": "CSS none keyword"
      },
      "<normal>": {
        "type": "string",
        "enum": [
          "normal"
        ],
        "description": "CSS normal keyword"
      },
      "<shadow>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "type": "string",
            "pattern": "^(inset\\s+)?(-?\\d+\\w*\\s+){2,4}(#[a-fA-F0-9]{3,8}|rgba?\\(.*\\)|hsla?\\(.*\\)|[a-zA-Z]+)?$"
          }
        ],
        "description": "CSS shadow value (box-shadow, text-shadow). Complex syntax with optional inset, multiple length values, and color cannot be fully validated with regex."
      },
      "<font-family>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                "description": "Quoted strings with escapes"
              },
              {
                "type": "string",
                "pattern": "^[a-zA-Z_][\\w-]*$",
                "description": "CSS identifiers (excluding keywords)"
              }
            ],
            "description": "CSS font family name: quoted string or unquoted identifier"
          },
          {
            "type": "string",
            "enum": [
              "serif",
              "sans-serif",
              "monospace",
              "cursive",
              "fantasy",
              "system-ui",
              "ui-serif",
              "ui-sans-serif",
              "ui-monospace",
              "ui-rounded",
              "math",
              "emoji",
              "fangsong"
            ],
            "description": "CSS generic font families"
          },
          {
            "type": "string",
            "pattern": "^['\"]?([^0-9][\\w\\s\\-]*)['\"]?(,\\s*['\"]?([^0-9][\\w\\s\\-]*)['\"]?)*$",
            "description": "Complex family name with multiple family names separated by commas"
          }
        ],
        "description": "CSS font family: generic families, quoted family names, or unquoted family names"
      },
      "<font-weight>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold",
              "bolder",
              "lighter"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900)$"
          }
        ],
        "description": "CSS font weight: keywords or numeric values"
      },
      "<font-style>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "italic",
              "oblique"
            ]
          },
          {
            "type": "string",
            "pattern": "^oblique\\s+\\d+deg$"
          }
        ],
        "description": "CSS font style: keywords or oblique with angle"
      },
      "<font-size>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "xx-small",
              "x-small",
              "small",
              "medium",
              "large",
              "x-large",
              "xx-large",
              "xxx-large"
            ],
            "description": "CSS absolute font sizes"
          },
          {
            "type": "string",
            "enum": [
              "larger",
              "smaller"
            ],
            "description": "CSS relative font sizes"
          },
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              }
            ],
            "description": "Accepts both <positive-length> and <positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "math"
            ]
          }
        ],
        "description": "CSS font size: length, percentage, or keyword values"
      },
      "<display>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "table-row-group",
              "table-header-group",
              "table-footer-group",
              "table-row",
              "table-cell",
              "table-column-group",
              "table-column",
              "table-caption",
              "ruby-base",
              "ruby-text",
              "ruby-base-container",
              "ruby-text-container",
              "contents",
              "none",
              "inline-block",
              "inline-table",
              "inline-flex",
              "inline-grid"
            ]
          },
          {
            "type": "string",
            "description": "complex display value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS display property values"
      },
      "<overflow-block>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "clip",
          "scroll",
          "auto"
        ],
        "description": "CSS overflow-x and overflow-y property values"
      },
      "<overflow>": {
        "type": "string",
        "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
        "description": "CSS overflow property values"
      },
      "<text-align>": {
        "type": "string",
        "enum": [
          "left",
          "right",
          "center",
          "justify",
          "start",
          "end",
          "match-parent"
        ],
        "description": "CSS text-align property values"
      },
      "<align-items>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal"
            ],
            "description": "CSS normal keyword"
          },
          {
            "type": "string",
            "enum": [
              "stretch"
            ]
          },
          {
            "type": "string",
            "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
            "description": "CSS baseline position: baseline, first baseline, or last baseline"
          },
          {
            "type": "string",
            "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS align-items values"
      },
      "<vertical-align>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "baseline",
              "sub",
              "super",
              "text-top",
              "text-bottom",
              "middle",
              "top",
              "bottom"
            ]
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS vertical-align: keywords, length, or percentage"
      },
      "<border-radius>": {
        "type": "string",
        "pattern": "^(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3}(\\s*/\\s*(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3})?$",
        "description": "CSS border-radius shorthand. Complex syntax combining multiple radius values cannot be fully validated with regex."
      },
      "<border-top-left-radius>": {
        "type": "string",
        "pattern": "^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
        "description": "CSS border-top-left-radius shorthand"
      },
      "<border-style>": {
        "type": "string",
        "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$",
        "description": "CSS border-style shorthand"
      },
      "<border-width>": {
        "type": "string",
        "pattern": "^(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$",
        "description": "CSS border-width shorthand"
      },
      "<border>": {
        "type": "string",
        "description": "CSS border shorthand. Complex syntax combining line-width, line-style, and color cannot be fully validated with regex as it allows various combinations and orders."
      },
      "<background>": {
        "type": "string",
        "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
      },
      "<transition>": {
        "type": "string",
        "description": "CSS transition shorthand. Complex syntax combining property, duration, timing-function, and delay cannot be fully validated with regex."
      },
      "<animation>": {
        "type": "string",
        "description": "CSS animation shorthand. Complex syntax combining name, duration, timing-function, delay, iteration-count, direction, fill-mode, and play-state cannot be fully validated with regex."
      },
      "<grid-template>": {
        "type": "string",
        "description": "CSS grid template properties. Complex syntax with track sizes, line names, and repeat functions cannot be fully validated with regex."
      },
      "<flex-shorthand>": {
        "type": "string",
        "description": "CSS flex shorthand combining flex-grow, flex-shrink, and flex-basis. Complex parsing required to validate the various combinations."
      },
      "<blend-mode>": {
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ],
        "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
      },
      "<mix-blend-mode>": {
        "description": "CSS mix-blend-mode property values",
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ]
      },
      "<background-blend-mode>": {
        "description": "CSS background-blend-mode property values",
        "type": "string",
        "enum": [
          "normal",
          "multiply",
          "screen",
          "overlay",
          "darken",
          "lighten",
          "color-dodge",
          "color-burn",
          "hard-light",
          "soft-light",
          "difference",
          "exclusion",
          "hue",
          "saturation",
          "color",
          "luminosity"
        ]
      },
      "<timing-function>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "ease",
              "ease-in",
              "ease-out",
              "ease-in-out",
              "linear",
              "step-start",
              "step-end"
            ]
          },
          {
            "type": "string",
            "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
          }
        ],
        "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
      },
      "<repeat-style>": {
        "type": "string",
        "enum": [
          "repeat",
          "repeat-x",
          "repeat-y",
          "no-repeat",
          "space",
          "round"
        ],
        "description": "CSS background-repeat values"
      },
      "<attachment>": {
        "type": "string",
        "enum": [
          "scroll",
          "fixed",
          "local"
        ],
        "description": "CSS background-attachment values"
      },
      "<origin>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box"
        ],
        "description": "CSS background-origin values"
      },
      "<clip>": {
        "type": "string",
        "enum": [
          "border-box",
          "padding-box",
          "content-box",
          "text"
        ],
        "description": "CSS background-clip values"
      },
      "<sizing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS background-size values"
      },
      "<cursor>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto",
              "default",
              "none",
              "context-menu",
              "help",
              "pointer",
              "progress",
              "wait",
              "cell",
              "crosshair",
              "text",
              "vertical-text",
              "alias",
              "copy",
              "move",
              "no-drop",
              "not-allowed",
              "grab",
              "grabbing",
              "all-scroll",
              "col-resize",
              "row-resize",
              "n-resize",
              "e-resize",
              "s-resize",
              "w-resize",
              "ne-resize",
              "nw-resize",
              "se-resize",
              "sw-resize",
              "ew-resize",
              "ns-resize",
              "nesw-resize",
              "nwse-resize",
              "zoom-in",
              "zoom-out"
            ]
          },
          {
            "type": "string",
            "pattern": "^url\\((['\"]?).*?\\1\\)$",
            "description": "Matches url(...) with optional quotes"
          }
        ],
        "description": "CSS cursor: keywords or custom cursor URLs"
      },
      "<list-style-type>": {
        "type": "string",
        "enum": [
          "disc",
          "circle",
          "square",
          "decimal",
          "decimal-leading-zero",
          "lower-roman",
          "upper-roman",
          "lower-greek",
          "lower-latin",
          "upper-latin",
          "armenian",
          "georgian",
          "lower-alpha",
          "upper-alpha",
          "none"
        ],
        "description": "CSS list-style-type values"
      },
      "<z-index>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d+$"
              }
            ],
            "description": "Whole numbers only"
          }
        ],
        "description": "CSS z-index: auto or integer"
      },
      "<opacity>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS opacity: number (0-1) or percentage"
      },
      "<visibility>": {
        "type": "string",
        "enum": [
          "visible",
          "hidden",
          "collapse"
        ],
        "description": "CSS visibility values"
      },
      "<white-space>": {
        "type": "string",
        "enum": [
          "normal",
          "nowrap",
          "pre",
          "pre-wrap",
          "pre-line",
          "break-spaces"
        ],
        "description": "CSS white-space values"
      },
      "<text-decoration-line>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "underline",
              "overline",
              "line-through",
              "blink"
            ],
            "description": "single value text decoration line"
          },
          {
            "type": "string",
            "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
            "description": "multiple values text decoration line that cannot be fully validated with regex"
          }
        ],
        "description": "CSS text-decoration-line values"
      },
      "<text-decoration-style>": {
        "type": "string",
        "enum": [
          "solid",
          "double",
          "dotted",
          "dashed",
          "wavy"
        ],
        "description": "CSS text-decoration-style values"
      },
      "<text-transform>": {
        "type": "string",
        "enum": [
          "none",
          "capitalize",
          "uppercase",
          "lowercase",
          "full-width",
          "full-size-kana"
        ],
        "description": "CSS text-transform values"
      },
      "<word-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS word-wrap/overflow-wrap values"
      },
      "<user-select>": {
        "type": "string",
        "enum": [
          "auto",
          "text",
          "none",
          "contain",
          "all"
        ],
        "description": "CSS user-select values"
      },
      "<pointer-events>": {
        "type": "string",
        "enum": [
          "auto",
          "bounding-box",
          "none",
          "visiblePainted",
          "visibleFill",
          "visibleStroke",
          "visible",
          "painted",
          "fill",
          "stroke",
          "all"
        ],
        "description": "CSS pointer-events values"
      },
      "<box-sizing>": {
        "type": "string",
        "enum": [
          "content-box",
          "border-box"
        ],
        "description": "CSS box-sizing values"
      },
      "<resize>": {
        "type": "string",
        "enum": [
          "none",
          "both",
          "horizontal",
          "vertical",
          "block",
          "inline"
        ],
        "description": "CSS resize values"
      },
      "<outline>": {
        "type": "string",
        "description": "CSS outline shorthand. Complex syntax combining outline-width, outline-style, and outline-color cannot be fully validated with regex."
      },
      "<quotes>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none",
              "auto"
            ]
          },
          {
            "type": "string",
            "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
            "description": "Quoted strings with escapes"
          }
        ],
        "description": "CSS quotes: none, auto, or quoted string pairs"
      },
      "<content>": {
        "type": "string",
        "description": "CSS content property. Complex syntax with strings, counters, attr(), and url() cannot be fully validated with regex."
      },
      "<will-change>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          },
          {
            "type": "string",
            "enum": [
              "scroll-position",
              "contents"
            ]
          },
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          }
        ],
        "description": "CSS will-change: auto or property names"
      },
      "<contain>": {
        "type": "string",
        "enum": [
          "none",
          "strict",
          "content",
          "size",
          "inline-size",
          "layout",
          "style",
          "paint"
        ],
        "description": "CSS contain values"
      },
      "<isolation>": {
        "type": "string",
        "enum": [
          "auto",
          "isolate"
        ],
        "description": "CSS isolation values"
      },
      "<writing-mode>": {
        "type": "string",
        "enum": [
          "horizontal-tb",
          "vertical-rl",
          "vertical-lr",
          "sideways-rl",
          "sideways-lr"
        ],
        "description": "CSS writing-mode values"
      },
      "<direction>": {
        "type": "string",
        "enum": [
          "ltr",
          "rtl"
        ],
        "description": "CSS direction values"
      },
      "<unicode-bidi>": {
        "type": "string",
        "enum": [
          "normal",
          "embed",
          "isolate",
          "bidi-override",
          "isolate-override",
          "plaintext"
        ],
        "description": "CSS unicode-bidi values"
      },
      "<object-fit>": {
        "type": "string",
        "enum": [
          "fill",
          "contain",
          "cover",
          "none",
          "scale-down"
        ],
        "description": "CSS object-fit values"
      },
      "<object-position>": {
        "description": "CSS object-position: similar to position.",
        "type": "string",
        "pattern": "^(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%))(\\s+(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%)))*$"
      },
      "<scroll-behavior>": {
        "type": "string",
        "enum": [
          "auto",
          "smooth"
        ],
        "description": "CSS scroll-behavior values"
      },
      "<appearance>": {
        "type": "string",
        "enum": [
          "none",
          "auto",
          "base-select",
          "textfield",
          "searchfield",
          "textarea",
          "checkbox",
          "radio",
          "menulist",
          "menulist-button",
          "listbox",
          "meter",
          "progress-bar",
          "button"
        ],
        "description": "CSS appearance values"
      },
      "<outline-offset>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          }
        ],
        "description": "CSS outline-offset: length values"
      },
      "<tab-size>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d+$"
              }
            ],
            "description": "Whole numbers only"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          }
        ],
        "description": "CSS tab-size: integer or length"
      },
      "<hyphens>": {
        "type": "string",
        "enum": [
          "none",
          "manual",
          "auto"
        ],
        "description": "CSS hyphens values"
      },
      "<word-break>": {
        "type": "string",
        "enum": [
          "normal",
          "break-all",
          "keep-all",
          "break-word"
        ],
        "description": "CSS word-break values"
      },
      "<line-break>": {
        "type": "string",
        "enum": [
          "auto",
          "loose",
          "normal",
          "strict",
          "anywhere"
        ],
        "description": "CSS line-break values"
      },
      "<letter-spacing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal"
            ],
            "description": "CSS normal keyword"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          }
        ],
        "description": "CSS letter-spacing: normal or length"
      },
      "<word-spacing>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal"
            ],
            "description": "CSS normal keyword"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          }
        ],
        "description": "CSS word-spacing: normal, length, or percentage"
      },
      "<line-height>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal"
            ],
            "description": "CSS normal keyword"
          },
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+$"
                  }
                ],
                "description": "Decimal or integer number"
              }
            ],
            "description": "Positive decimal or integer number"
          },
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              }
            ],
            "description": "Accepts both <positive-length> and <positive-percentage>"
          }
        ],
        "description": "CSS line-height: normal, number, length, or percentage"
      },
      "<text-indent>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS text-indent: length or percentage"
      },
      "<text-overflow>": {
        "type": "string",
        "enum": [
          "clip",
          "ellipsis"
        ],
        "description": "CSS text-overflow values"
      },
      "<text-decoration>": {
        "type": "string",
        "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
      },
      "<text-shadow>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "type": "string",
            "description": "complex shadow value that cannot be fully validated with regex"
          }
        ],
        "description": "CSS text-shadow: none or shadow values"
      },
      "<list-style>": {
        "type": "string",
        "description": "CSS list-style shorthand. Complex syntax combining list-style-type, list-style-position, and list-style-image cannot be fully validated with regex."
      },
      "<list-style-position>": {
        "type": "string",
        "enum": [
          "inside",
          "outside"
        ],
        "description": "CSS list-style-position values"
      },
      "<list-style-image>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^url\\((['\"]?).*?\\1\\)$",
                "description": "Matches url(...) with optional quotes"
              },
              {
                "type": "string",
                "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                "description": "Gradient functions - arguments cannot be fully validated with regex"
              },
              {
                "type": "string",
                "pattern": "^image\\(.*\\)$",
                "description": "Image function - arguments cannot be fully validated with regex"
              }
            ],
            "description": "CSS image values including URLs, gradients, and image() functions"
          }
        ],
        "description": "CSS list-style-image: none or URL"
      },
      "<alpha-value>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS alpha value for colors: number (0-1) or percentage"
      },
      "<absolute-size>": {
        "type": "string",
        "enum": [
          "xx-small",
          "x-small",
          "small",
          "medium",
          "large",
          "x-large",
          "xx-large",
          "xxx-large"
        ],
        "description": "CSS absolute font sizes"
      },
      "<relative-size>": {
        "type": "string",
        "enum": [
          "larger",
          "smaller"
        ],
        "description": "CSS relative font sizes"
      },
      "<angle-percentage>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
              }
            ],
            "description": "Used in rotation, direction, etc."
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS angle or percentage"
      },
      "<number-percentage>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS number or percentage"
      },
      "<time-percentage>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
              }
            ],
            "description": "CSS durations (s, ms)"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS time or percentage"
      },
      "<frequency-percentage>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
              }
            ],
            "description": "Used in aural CSS or media queries"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS frequency or percentage"
      },
      "<baseline-position>": {
        "type": "string",
        "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
        "description": "CSS baseline position: baseline, first baseline, or last baseline"
      },
      "<content-distribution>": {
        "type": "string",
        "enum": [
          "space-between",
          "space-around",
          "space-evenly",
          "stretch"
        ],
        "description": "CSS content distribution values for alignment"
      },
      "<content-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS content position values for alignment"
      },
      "<self-position>": {
        "type": "string",
        "enum": [
          "center",
          "start",
          "end",
          "self-start",
          "self-end",
          "flex-start",
          "flex-end"
        ],
        "description": "CSS self position values for alignment"
      },
      "<overflow-position>": {
        "type": "string",
        "enum": [
          "unsafe",
          "safe"
        ],
        "description": "CSS overflow position modifiers"
      },
      "<justify-content>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal"
            ],
            "description": "CSS normal keyword"
          },
          {
            "type": "string",
            "enum": [
              "space-between",
              "space-around",
              "space-evenly",
              "stretch"
            ],
            "description": "CSS content distribution values for alignment"
          },
          {
            "type": "string",
            "enum": [
              "center",
              "start",
              "end",
              "flex-start",
              "flex-end"
            ],
            "description": "CSS content position values for alignment"
          },
          {
            "type": "string",
            "enum": [
              "left",
              "right"
            ]
          },
          {
            "type": "string",
            "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
          }
        ],
        "description": "CSS justify-content values"
      },
      "<visual-box>": {
        "type": "string",
        "enum": [
          "content-box",
          "padding-box",
          "border-box"
        ],
        "description": "CSS visual box types"
      },
      "<shape-box>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "content-box",
              "padding-box",
              "border-box"
            ],
            "description": "CSS visual box types"
          },
          {
            "type": "string",
            "enum": [
              "margin-box"
            ]
          }
        ],
        "description": "CSS shape box types"
      },
      "<geometry-box>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "content-box",
                  "padding-box",
                  "border-box"
                ],
                "description": "CSS visual box types"
              },
              {
                "type": "string",
                "enum": [
                  "margin-box"
                ]
              }
            ],
            "description": "CSS shape box types"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS geometry box types including visual box and additional geometry boxes"
      },
      "<paint-box>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "content-box",
              "padding-box",
              "border-box"
            ],
            "description": "CSS visual box types"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box"
            ]
          }
        ],
        "description": "CSS paint box types"
      },
      "<coord-box>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "content-box",
                  "padding-box",
                  "border-box"
                ],
                "description": "CSS visual box types"
              },
              {
                "type": "string",
                "enum": [
                  "fill-box",
                  "stroke-box"
                ]
              }
            ],
            "description": "CSS paint box types"
          },
          {
            "type": "string",
            "enum": [
              "fill-box",
              "stroke-box",
              "view-box"
            ]
          }
        ],
        "description": "CSS coordinate box types"
      },
      "<generic-family>": {
        "type": "string",
        "enum": [
          "serif",
          "sans-serif",
          "monospace",
          "cursive",
          "fantasy",
          "system-ui",
          "ui-serif",
          "ui-sans-serif",
          "ui-monospace",
          "ui-rounded",
          "math",
          "emoji",
          "fangsong"
        ],
        "description": "CSS generic font families"
      },
      "<family-name>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
            "description": "Quoted strings with escapes"
          },
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          }
        ],
        "description": "CSS font family name: quoted string or unquoted identifier"
      },
      "<system-family-name>": {
        "type": "string",
        "enum": [
          "caption",
          "icon",
          "menu",
          "message-box",
          "small-caption",
          "status-bar"
        ],
        "description": "CSS system font family names"
      },
      "<font-stretch-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "ultra-condensed",
              "extra-condensed",
              "condensed",
              "semi-condensed",
              "semi-expanded",
              "expanded",
              "extra-expanded",
              "ultra-expanded"
            ]
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS font stretch absolute values"
      },
      "<font-weight-absolute>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "normal",
              "bold"
            ]
          },
          {
            "type": "string",
            "pattern": "^(100|200|300|400|500|600|700|800|900|[1-9][0-9]{0,2})$"
          }
        ],
        "description": "CSS font weight absolute values: normal, bold, or number 1-1000"
      },
      "<grid-line>": {
        "type": "string",
        "description": "CSS grid line: auto, custom identifier, integer with optional identifier, or span notation. Complex syntax cannot be fully validated with regex."
      },
      "<track-breadth>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Accepts both <length> and <percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d*\\.?\\d+fr$",
            "description": "CSS flex unit for grid and flexbox"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS grid track breadth"
      },
      "<inflexible-breadth>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Accepts both <length> and <percentage>"
          },
          {
            "type": "string",
            "enum": [
              "min-content",
              "max-content",
              "auto"
            ]
          }
        ],
        "description": "CSS inflexible breadth (track breadth without flex)"
      },
      "<track-size>": {
        "type": "string",
        "description": "CSS grid track size: track-breadth, minmax(), or fit-content(). Complex syntax cannot be fully validated with regex."
      },
      "<easing-function>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "ease",
                  "ease-in",
                  "ease-out",
                  "ease-in-out",
                  "linear",
                  "step-start",
                  "step-end"
                ]
              },
              {
                "type": "string",
                "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
              },
              {
                "type": "string",
                "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
              }
            ],
            "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
          },
          {
            "type": "string",
            "pattern": "^linear\\(.*\\)$",
            "description": "Linear easing function - arguments cannot be fully validated with regex"
          },
          {
            "type": "string",
            "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end|jump-start|jump-end|jump-none|jump-both)\\s*)?\\)$"
          }
        ],
        "description": "CSS easing functions including cubic-bezier, steps, and linear"
      },
      "<single-animation-direction>": {
        "type": "string",
        "enum": [
          "normal",
          "reverse",
          "alternate",
          "alternate-reverse"
        ],
        "description": "CSS animation direction values"
      },
      "<single-animation-fill-mode>": {
        "type": "string",
        "enum": [
          "none",
          "forwards",
          "backwards",
          "both"
        ],
        "description": "CSS animation fill mode values"
      },
      "<single-animation-play-state>": {
        "type": "string",
        "enum": [
          "running",
          "paused"
        ],
        "description": "CSS animation play state values"
      },
      "<single-animation-iteration-count>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "type": "string",
            "enum": [
              "infinite"
            ]
          }
        ],
        "description": "CSS animation iteration count: number or infinite"
      },
      "<keyframes-name>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          },
          {
            "type": "string",
            "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
            "description": "Quoted strings with escapes"
          }
        ],
        "description": "CSS keyframes name: identifier or string"
      },
      "<single-transition-property>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "all"
            ]
          },
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          }
        ],
        "description": "CSS transition property: all or property name"
      },
      "<quote>": {
        "type": "string",
        "enum": [
          "open-quote",
          "close-quote",
          "no-open-quote",
          "no-close-quote"
        ],
        "description": "CSS quote values for generated content"
      },
      "<counter-style-name>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          },
          {
            "type": "string",
            "enum": [
              "decimal",
              "decimal-leading-zero",
              "lower-roman",
              "upper-roman",
              "lower-greek",
              "lower-latin",
              "upper-latin",
              "armenian",
              "georgian",
              "lower-alpha",
              "upper-alpha",
              "disc",
              "circle",
              "square",
              "none"
            ]
          }
        ],
        "description": "CSS counter style: predefined or custom identifier"
      },
      "<ratio>": {
        "type": "string",
        "pattern": "^\\d+(\\.\\d+)?\\s*/\\s*\\d+(\\.\\d+)?$",
        "description": "CSS ratio: number/number"
      },
      "<dasharray>": {
        "type": "string",
        "description": "CSS dash array for stroke-dasharray. Complex syntax with multiple length/percentage/number values cannot be fully validated with regex."
      },
      "<paint>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
              },
              {
                "type": "string",
                "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
              },
              {
                "type": "string",
                "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
              },
              {
                "type": "string",
                "enum": [
                  "transparent",
                  "currentColor",
                  "aliceblue",
                  "antiquewhite",
                  "aqua",
                  "aquamarine",
                  "azure",
                  "beige",
                  "bisque",
                  "black",
                  "blanchedalmond",
                  "blue",
                  "blueviolet",
                  "brown",
                  "burlywood",
                  "cadetblue",
                  "chartreuse",
                  "chocolate",
                  "coral",
                  "cornflowerblue",
                  "cornsilk",
                  "crimson",
                  "cyan",
                  "darkblue",
                  "darkcyan",
                  "darkgoldenrod",
                  "darkgray",
                  "darkgrey",
                  "darkgreen",
                  "darkkhaki",
                  "darkmagenta",
                  "darkolivegreen",
                  "darkorange",
                  "darkorchid",
                  "darkred",
                  "darksalmon",
                  "darkseagreen",
                  "darkslateblue",
                  "darkslategray",
                  "darkslategrey",
                  "darkturquoise",
                  "darkviolet",
                  "deeppink",
                  "deepskyblue",
                  "dimgray",
                  "dimgrey",
                  "dodgerblue",
                  "firebrick",
                  "floralwhite",
                  "forestgreen",
                  "fuchsia",
                  "gainsboro",
                  "ghostwhite",
                  "gold",
                  "goldenrod",
                  "gray",
                  "grey",
                  "green",
                  "greenyellow",
                  "honeydew",
                  "hotpink",
                  "indianred",
                  "indigo",
                  "ivory",
                  "khaki",
                  "lavender",
                  "lavenderblush",
                  "lawngreen",
                  "lemonchiffon",
                  "lightblue",
                  "lightcoral",
                  "lightcyan",
                  "lightgoldenrodyellow",
                  "lightgray",
                  "lightgrey",
                  "lightgreen",
                  "lightpink",
                  "lightsalmon",
                  "lightseagreen",
                  "lightskyblue",
                  "lightslategray",
                  "lightslategrey",
                  "lightsteelblue",
                  "lightyellow",
                  "lime",
                  "limegreen",
                  "linen",
                  "magenta",
                  "maroon",
                  "mediumaquamarine",
                  "mediumblue",
                  "mediumorchid",
                  "mediumpurple",
                  "mediumseagreen",
                  "mediumslateblue",
                  "mediumspringgreen",
                  "mediumturquoise",
                  "mediumvioletred",
                  "midnightblue",
                  "mintcream",
                  "mistyrose",
                  "moccasin",
                  "navajowhite",
                  "navy",
                  "oldlace",
                  "olive",
                  "olivedrab",
                  "orange",
                  "orangered",
                  "orchid",
                  "palegoldenrod",
                  "palegreen",
                  "paleturquoise",
                  "palevioletred",
                  "papayawhip",
                  "peachpuff",
                  "peru",
                  "pink",
                  "plum",
                  "powderblue",
                  "purple",
                  "rebeccapurple",
                  "red",
                  "rosybrown",
                  "royalblue",
                  "saddlebrown",
                  "salmon",
                  "sandybrown",
                  "seagreen",
                  "seashell",
                  "sienna",
                  "silver",
                  "skyblue",
                  "slateblue",
                  "slategray",
                  "slategrey",
                  "snow",
                  "springgreen",
                  "steelblue",
                  "tan",
                  "teal",
                  "thistle",
                  "tomato",
                  "turquoise",
                  "violet",
                  "wheat",
                  "white",
                  "whitesmoke",
                  "yellow",
                  "yellowgreen"
                ],
                "description": "CSS named colors including transparent and currentColor"
              }
            ],
            "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
          },
          {
            "type": "string",
            "pattern": "^url\\((['\"]?).*?\\1\\)$",
            "description": "Matches url(...) with optional quotes"
          },
          {
            "type": "string",
            "enum": [
              "context-fill",
              "context-stroke"
            ]
          }
        ],
        "description": "CSS paint values for SVG: none, color, URL, or context keywords"
      },
      "<overflow-wrap>": {
        "type": "string",
        "enum": [
          "normal",
          "break-word",
          "anywhere"
        ],
        "description": "CSS overflow-wrap values (same as word-wrap)"
      },
      "<text-decoration-thickness>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          },
          {
            "type": "string",
            "enum": [
              "from-font"
            ]
          }
        ],
        "description": "CSS text decoration thickness"
      },
      "<text-underline-offset>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "auto"
            ],
            "description": "CSS auto keyword"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
              }
            ],
            "description": "CSS numeric length with all valid units"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+%$"
              }
            ],
            "description": "Number followed by %"
          }
        ],
        "description": "CSS text underline offset"
      },
      "<text-emphasis-style>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "type": "string",
            "enum": [
              "filled",
              "open",
              "dot",
              "circle",
              "double-circle",
              "triangle",
              "sesame"
            ]
          },
          {
            "type": "string",
            "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
            "description": "Quoted strings with escapes"
          }
        ],
        "description": "CSS text emphasis style"
      },
      "<mask-composite>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS mask composite operation values"
      },
      "<mask-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS mask mode values"
      },
      "<clip-path>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "type": "string",
            "pattern": "^url\\((['\"]?).*?\\1\\)$",
            "description": "Matches url(...) with optional quotes"
          },
          {
            "type": "string",
            "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
            "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
          }
        ],
        "description": "CSS clip-path: none, URL, or basic shape"
      },
      "<shape-outside>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^url\\((['\"]?).*?\\1\\)$",
                "description": "Matches url(...) with optional quotes"
              },
              {
                "type": "string",
                "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                "description": "Gradient functions - arguments cannot be fully validated with regex"
              },
              {
                "type": "string",
                "pattern": "^image\\(.*\\)$",
                "description": "Image function - arguments cannot be fully validated with regex"
              }
            ],
            "description": "CSS image values including URLs, gradients, and image() functions"
          },
          {
            "type": "string",
            "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
            "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
          }
        ],
        "description": "CSS shape-outside: none, image, or basic shape"
      },
      "<intrinsic-size-keyword>": {
        "type": "string",
        "enum": [
          "auto",
          "min-content",
          "max-content",
          "fit-content"
        ],
        "description": "CSS intrinsic sizing keywords"
      },
      "<step-position>": {
        "type": "string",
        "enum": [
          "jump-start",
          "jump-end",
          "jump-none",
          "jump-both",
          "start",
          "end"
        ],
        "description": "CSS step position for steps() timing function"
      },
      "<system-color>": {
        "type": "string",
        "enum": [
          "AccentColor",
          "AccentColorText",
          "ActiveText",
          "ButtonBorder",
          "ButtonFace",
          "ButtonText",
          "Canvas",
          "CanvasText",
          "Field",
          "FieldText",
          "GrayText",
          "Highlight",
          "HighlightText",
          "LinkText",
          "Mark",
          "MarkText",
          "SelectedItem",
          "SelectedItemText",
          "VisitedText"
        ],
        "description": "CSS system colors"
      },
      "<deprecated-system-color>": {
        "type": "string",
        "enum": [
          "ActiveBorder",
          "ActiveCaption",
          "AppWorkspace",
          "Background",
          "ButtonHighlight",
          "ButtonShadow",
          "CaptionText",
          "InactiveBorder",
          "InactiveCaption",
          "InactiveCaptionText",
          "InfoBackground",
          "InfoText",
          "Menu",
          "MenuText",
          "Scrollbar",
          "ThreeDDarkShadow",
          "ThreeDFace",
          "ThreeDHighlight",
          "ThreeDLightShadow",
          "ThreeDShadow",
          "Window",
          "WindowFrame",
          "WindowText"
        ],
        "description": "CSS deprecated system colors"
      },
      "<bg-size>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              }
            ],
            "description": "Accepts both <positive-length> and <positive-percentage>"
          },
          {
            "type": "string",
            "enum": [
              "auto",
              "cover",
              "contain"
            ]
          },
          {
            "type": "string",
            "pattern": "^(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
            "description": "complex syntax with multiple values that cannot be fully validated with regex"
          }
        ],
        "description": "CSS background-size values"
      },
      "<bg-position>": {
        "type": "string",
        "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
      },
      "<bg-clip>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "content-box",
              "padding-box",
              "border-box"
            ],
            "description": "CSS visual box types"
          },
          {
            "type": "string",
            "enum": [
              "border-area",
              "text"
            ]
          }
        ],
        "description": "CSS background-clip values"
      },
      "<bg-image>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^url\\((['\"]?).*?\\1\\)$",
                "description": "Matches url(...) with optional quotes"
              },
              {
                "type": "string",
                "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                "description": "Gradient functions - arguments cannot be fully validated with regex"
              },
              {
                "type": "string",
                "pattern": "^image\\(.*\\)$",
                "description": "Image function - arguments cannot be fully validated with regex"
              }
            ],
            "description": "CSS image values including URLs, gradients, and image() functions"
          }
        ],
        "description": "CSS background-image values"
      },
      "<hue>": {
        "anyOf": [
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+$"
              }
            ],
            "description": "Decimal or integer number"
          },
          {
            "oneOf": [
              {
                "type": "string",
                "pattern": "^calc\\([^(),]+\\)$",
                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
              },
              {
                "type": "string",
                "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
              }
            ],
            "description": "Used in rotation, direction, etc."
          }
        ],
        "description": "CSS hue value: number or angle"
      },
      "<radial-shape>": {
        "type": "string",
        "enum": [
          "circle",
          "ellipse"
        ],
        "description": "CSS radial gradient shape"
      },
      "<radial-extent>": {
        "type": "string",
        "enum": [
          "closest-corner",
          "closest-side",
          "farthest-corner",
          "farthest-side"
        ],
        "description": "CSS radial gradient extent"
      },
      "<side-or-corner>": {
        "type": "string",
        "pattern": "^(left|right|top|bottom)$|^(left|right)\\s+(top|bottom)$|^(top|bottom)\\s+(left|right)$",
        "description": "CSS gradient side or corner direction"
      },
      "<color-stop-length>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Accepts both <length> and <percentage>"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?%\\s+\\d+(\\.\\d+)?%$"
          }
        ],
        "description": "CSS color stop length: single or double length-percentage"
      },
      "<color-stop-angle>": {
        "anyOf": [
          {
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
                  }
                ],
                "description": "Used in rotation, direction, etc."
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "CSS angle or percentage"
          },
          {
            "type": "string",
            "pattern": "^\\d+(\\.\\d+)?deg\\s+\\d+(\\.\\d+)?deg$"
          }
        ],
        "description": "CSS color stop angle: single or double angle-percentage"
      },
      "<masking-mode>": {
        "type": "string",
        "enum": [
          "alpha",
          "luminance",
          "match-source"
        ],
        "description": "CSS masking mode values"
      },
      "<mask-reference>": {
        "anyOf": [
          {
            "type": "string",
            "enum": [
              "none"
            ],
            "description": "CSS none keyword"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^url\\((['\"]?).*?\\1\\)$",
                "description": "Matches url(...) with optional quotes"
              },
              {
                "type": "string",
                "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                "description": "Gradient functions - arguments cannot be fully validated with regex"
              },
              {
                "type": "string",
                "pattern": "^image\\(.*\\)$",
                "description": "Image function - arguments cannot be fully validated with regex"
              }
            ],
            "description": "CSS image values including URLs, gradients, and image() functions"
          },
          {
            "type": "string",
            "pattern": "^url\\((['\"]?).*?\\1\\)$",
            "description": "Matches url(...) with optional quotes"
          }
        ],
        "description": "CSS mask reference values"
      },
      "<outline-line-style>": {
        "type": "string",
        "enum": [
          "none",
          "dotted",
          "dashed",
          "solid",
          "double",
          "groove",
          "ridge",
          "inset",
          "outset"
        ],
        "description": "CSS outline line style values"
      },
      "<counter-name>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          },
          {
            "type": "string",
            "enum": [
              "list-item"
            ]
          }
        ],
        "description": "CSS counter name: custom identifier or list-item"
      },
      "<symbol>": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
            "description": "Quoted strings with escapes"
          },
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^url\\((['\"]?).*?\\1\\)$",
                "description": "Matches url(...) with optional quotes"
              },
              {
                "type": "string",
                "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                "description": "Gradient functions - arguments cannot be fully validated with regex"
              },
              {
                "type": "string",
                "pattern": "^image\\(.*\\)$",
                "description": "Image function - arguments cannot be fully validated with regex"
              }
            ],
            "description": "CSS image values including URLs, gradients, and image() functions"
          },
          {
            "type": "string",
            "pattern": "^[a-zA-Z_][\\w-]*$",
            "description": "CSS identifiers (excluding keywords)"
          }
        ],
        "description": "CSS symbol values for counters"
      },
      "<symbols-type>": {
        "type": "string",
        "enum": [
          "cyclic",
          "numeric",
          "alphabetic",
          "symbolic",
          "fixed"
        ],
        "description": "CSS symbols() function type"
      },
      "<feature-tag-value>": {
        "type": "string",
        "description": "CSS font feature tag value. Complex syntax with string and optional integer/keyword cannot be fully validated with regex."
      },
      "<east-asian-variant-values>": {
        "type": "string",
        "enum": [
          "jis78",
          "jis83",
          "jis90",
          "jis04",
          "simplified",
          "traditional"
        ],
        "description": "CSS East Asian variant values"
      },
      "<east-asian-width-values>": {
        "type": "string",
        "enum": [
          "full-width",
          "proportional-width"
        ],
        "description": "CSS East Asian width values"
      },
      "<numeric-figure-values>": {
        "type": "string",
        "enum": [
          "lining-nums",
          "oldstyle-nums"
        ],
        "description": "CSS numeric figure values"
      },
      "<numeric-fraction-values>": {
        "type": "string",
        "enum": [
          "diagonal-fractions",
          "stacked-fractions"
        ],
        "description": "CSS numeric fraction values"
      },
      "<numeric-spacing-values>": {
        "type": "string",
        "enum": [
          "proportional-nums",
          "tabular-nums"
        ],
        "description": "CSS numeric spacing values"
      },
      "<common-lig-values>": {
        "type": "string",
        "enum": [
          "common-ligatures",
          "no-common-ligatures"
        ],
        "description": "CSS common ligature values"
      },
      "<discretionary-lig-values>": {
        "type": "string",
        "enum": [
          "discretionary-ligatures",
          "no-discretionary-ligatures"
        ],
        "description": "CSS discretionary ligature values"
      },
      "<historical-lig-values>": {
        "type": "string",
        "enum": [
          "historical-ligatures",
          "no-historical-ligatures"
        ],
        "description": "CSS historical ligature values"
      },
      "<contextual-alt-values>": {
        "type": "string",
        "enum": [
          "contextual",
          "no-contextual"
        ],
        "description": "CSS contextual alternates values"
      },
      "<composite-style>": {
        "type": "string",
        "enum": [
          "clear",
          "copy",
          "source-over",
          "source-in",
          "source-out",
          "source-atop",
          "destination-over",
          "destination-in",
          "destination-out",
          "destination-atop",
          "xor"
        ],
        "description": "CSS composite style values"
      },
      "<compositing-operator>": {
        "type": "string",
        "enum": [
          "add",
          "subtract",
          "intersect",
          "exclude"
        ],
        "description": "CSS compositing operator values"
      },
      "<axis>": {
        "type": "string",
        "enum": [
          "block",
          "inline",
          "x",
          "y"
        ],
        "description": "CSS axis values"
      },
      "<scroller>": {
        "type": "string",
        "enum": [
          "root",
          "nearest",
          "self"
        ],
        "description": "CSS scroller values"
      },
      "<try-size>": {
        "type": "string",
        "enum": [
          "most-width",
          "most-height",
          "most-block-size",
          "most-inline-size"
        ],
        "description": "CSS try size values"
      },
      "<try-tactic>": {
        "type": "string",
        "enum": [
          "flip-block",
          "flip-inline",
          "flip-start"
        ],
        "description": "CSS try tactic values"
      },
      "<font>": {
        "type": "string",
        "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
      },
      "<font-variant>": {
        "type": "string",
        "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
      },
      "<flex-direction>": {
        "type": "string",
        "enum": [
          "row",
          "row-reverse",
          "column",
          "column-reverse"
        ],
        "description": "CSS flex-direction values"
      },
      "<gap>": {
        "type": "string",
        "pattern": "^(normal|0|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
        "description": "CSS gap values"
      },
      "<padding>": {
        "type": "string",
        "pattern": "^(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))(\\s+(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))){0,3}$",
        "description": "CSS padding values"
      },
      "<padding-top>": {
        "description": "CSS padding-top values",
        "anyOf": [
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              }
            ],
            "description": "CSS positive numeric length with all valid units"
          },
          {
            "allOf": [
              {
                "type": "string",
                "pattern": "^[^-]",
                "description": "CSS positive value"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "Positive number followed by %"
          }
        ]
      }
    }
  },
  "cssPropertySchemas.json": {
    "$id": "urn:dm:schemas:cssPropertySchemas.json",
    "title": "CSS Property Schemas",
    "description": "Individual JSON Schema definitions for CSS property value types used within Wix",
    "definitions": {
      "CSS.Color": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-color",
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                    "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                  },
                  {
                    "type": "string",
                    "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                    "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                  },
                  {
                    "type": "string",
                    "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                    "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                  },
                  {
                    "type": "string",
                    "enum": [
                      "transparent",
                      "currentColor",
                      "aliceblue",
                      "antiquewhite",
                      "aqua",
                      "aquamarine",
                      "azure",
                      "beige",
                      "bisque",
                      "black",
                      "blanchedalmond",
                      "blue",
                      "blueviolet",
                      "brown",
                      "burlywood",
                      "cadetblue",
                      "chartreuse",
                      "chocolate",
                      "coral",
                      "cornflowerblue",
                      "cornsilk",
                      "crimson",
                      "cyan",
                      "darkblue",
                      "darkcyan",
                      "darkgoldenrod",
                      "darkgray",
                      "darkgrey",
                      "darkgreen",
                      "darkkhaki",
                      "darkmagenta",
                      "darkolivegreen",
                      "darkorange",
                      "darkorchid",
                      "darkred",
                      "darksalmon",
                      "darkseagreen",
                      "darkslateblue",
                      "darkslategray",
                      "darkslategrey",
                      "darkturquoise",
                      "darkviolet",
                      "deeppink",
                      "deepskyblue",
                      "dimgray",
                      "dimgrey",
                      "dodgerblue",
                      "firebrick",
                      "floralwhite",
                      "forestgreen",
                      "fuchsia",
                      "gainsboro",
                      "ghostwhite",
                      "gold",
                      "goldenrod",
                      "gray",
                      "grey",
                      "green",
                      "greenyellow",
                      "honeydew",
                      "hotpink",
                      "indianred",
                      "indigo",
                      "ivory",
                      "khaki",
                      "lavender",
                      "lavenderblush",
                      "lawngreen",
                      "lemonchiffon",
                      "lightblue",
                      "lightcoral",
                      "lightcyan",
                      "lightgoldenrodyellow",
                      "lightgray",
                      "lightgrey",
                      "lightgreen",
                      "lightpink",
                      "lightsalmon",
                      "lightseagreen",
                      "lightskyblue",
                      "lightslategray",
                      "lightslategrey",
                      "lightsteelblue",
                      "lightyellow",
                      "lime",
                      "limegreen",
                      "linen",
                      "magenta",
                      "maroon",
                      "mediumaquamarine",
                      "mediumblue",
                      "mediumorchid",
                      "mediumpurple",
                      "mediumseagreen",
                      "mediumslateblue",
                      "mediumspringgreen",
                      "mediumturquoise",
                      "mediumvioletred",
                      "midnightblue",
                      "mintcream",
                      "mistyrose",
                      "moccasin",
                      "navajowhite",
                      "navy",
                      "oldlace",
                      "olive",
                      "olivedrab",
                      "orange",
                      "orangered",
                      "orchid",
                      "palegoldenrod",
                      "palegreen",
                      "paleturquoise",
                      "palevioletred",
                      "papayawhip",
                      "peachpuff",
                      "peru",
                      "pink",
                      "plum",
                      "powderblue",
                      "purple",
                      "rebeccapurple",
                      "red",
                      "rosybrown",
                      "royalblue",
                      "saddlebrown",
                      "salmon",
                      "sandybrown",
                      "seagreen",
                      "seashell",
                      "sienna",
                      "silver",
                      "skyblue",
                      "slateblue",
                      "slategray",
                      "slategrey",
                      "snow",
                      "springgreen",
                      "steelblue",
                      "tan",
                      "teal",
                      "thistle",
                      "tomato",
                      "turquoise",
                      "violet",
                      "wheat",
                      "white",
                      "whitesmoke",
                      "yellow",
                      "yellowgreen"
                    ],
                    "description": "CSS named colors including transparent and currentColor"
                  }
                ],
                "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-blend-mode",
                "enum": [
                  "normal",
                  "multiply",
                  "screen",
                  "overlay",
                  "darken",
                  "lighten",
                  "color-dodge",
                  "color-burn",
                  "hard-light",
                  "soft-light",
                  "difference",
                  "exclusion",
                  "hue",
                  "saturation",
                  "color",
                  "luminosity"
                ],
                "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Angle": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-angle",
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
                  }
                ],
                "description": "Used in rotation, direction, etc."
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-length-percentage",
                "anyOf": [
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Accepts both <length> and <percentage>"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLengthPercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-length-percentage",
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  }
                ],
                "description": "Accepts both <positive-length> and <positive-percentage>"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Length": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-length",
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveLength": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-length",
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Number": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-number",
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+$"
                  }
                ],
                "description": "Decimal or integer number"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositiveNumber": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-number",
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+$"
                      }
                    ],
                    "description": "Decimal or integer number"
                  }
                ],
                "description": "Positive decimal or integer number"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Percentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-percentage",
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.PositivePercentage": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-percentage",
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.String": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-string",
                "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                "description": "Quoted strings with escapes"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Time": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-time",
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
                  }
                ],
                "description": "CSS durations (s, ms)"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-border-top-style",
                "enum": [
                  "none",
                  "hidden",
                  "dotted",
                  "dashed",
                  "solid",
                  "double",
                  "groove",
                  "ridge",
                  "inset",
                  "outset"
                ],
                "description": "CSS line style keywords"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-border-top-width",
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "thin",
                      "medium",
                      "thick"
                    ]
                  }
                ],
                "description": "CSS line width: length values or predefined keywords"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "format": "css-border-width",
                "pattern": "^(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "format": "css-border-style",
                "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderColor": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-color",
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                            "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                          },
                          {
                            "type": "string",
                            "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                          },
                          {
                            "type": "string",
                            "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                          },
                          {
                            "type": "string",
                            "enum": [
                              "transparent",
                              "currentColor",
                              "aliceblue",
                              "antiquewhite",
                              "aqua",
                              "aquamarine",
                              "azure",
                              "beige",
                              "bisque",
                              "black",
                              "blanchedalmond",
                              "blue",
                              "blueviolet",
                              "brown",
                              "burlywood",
                              "cadetblue",
                              "chartreuse",
                              "chocolate",
                              "coral",
                              "cornflowerblue",
                              "cornsilk",
                              "crimson",
                              "cyan",
                              "darkblue",
                              "darkcyan",
                              "darkgoldenrod",
                              "darkgray",
                              "darkgrey",
                              "darkgreen",
                              "darkkhaki",
                              "darkmagenta",
                              "darkolivegreen",
                              "darkorange",
                              "darkorchid",
                              "darkred",
                              "darksalmon",
                              "darkseagreen",
                              "darkslateblue",
                              "darkslategray",
                              "darkslategrey",
                              "darkturquoise",
                              "darkviolet",
                              "deeppink",
                              "deepskyblue",
                              "dimgray",
                              "dimgrey",
                              "dodgerblue",
                              "firebrick",
                              "floralwhite",
                              "forestgreen",
                              "fuchsia",
                              "gainsboro",
                              "ghostwhite",
                              "gold",
                              "goldenrod",
                              "gray",
                              "grey",
                              "green",
                              "greenyellow",
                              "honeydew",
                              "hotpink",
                              "indianred",
                              "indigo",
                              "ivory",
                              "khaki",
                              "lavender",
                              "lavenderblush",
                              "lawngreen",
                              "lemonchiffon",
                              "lightblue",
                              "lightcoral",
                              "lightcyan",
                              "lightgoldenrodyellow",
                              "lightgray",
                              "lightgrey",
                              "lightgreen",
                              "lightpink",
                              "lightsalmon",
                              "lightseagreen",
                              "lightskyblue",
                              "lightslategray",
                              "lightslategrey",
                              "lightsteelblue",
                              "lightyellow",
                              "lime",
                              "limegreen",
                              "linen",
                              "magenta",
                              "maroon",
                              "mediumaquamarine",
                              "mediumblue",
                              "mediumorchid",
                              "mediumpurple",
                              "mediumseagreen",
                              "mediumslateblue",
                              "mediumspringgreen",
                              "mediumturquoise",
                              "mediumvioletred",
                              "midnightblue",
                              "mintcream",
                              "mistyrose",
                              "moccasin",
                              "navajowhite",
                              "navy",
                              "oldlace",
                              "olive",
                              "olivedrab",
                              "orange",
                              "orangered",
                              "orchid",
                              "palegoldenrod",
                              "palegreen",
                              "paleturquoise",
                              "palevioletred",
                              "papayawhip",
                              "peachpuff",
                              "peru",
                              "pink",
                              "plum",
                              "powderblue",
                              "purple",
                              "rebeccapurple",
                              "red",
                              "rosybrown",
                              "royalblue",
                              "saddlebrown",
                              "salmon",
                              "sandybrown",
                              "seagreen",
                              "seashell",
                              "sienna",
                              "silver",
                              "skyblue",
                              "slateblue",
                              "slategray",
                              "slategrey",
                              "snow",
                              "springgreen",
                              "steelblue",
                              "tan",
                              "teal",
                              "thistle",
                              "tomato",
                              "turquoise",
                              "violet",
                              "wheat",
                              "white",
                              "whitesmoke",
                              "yellow",
                              "yellowgreen"
                            ],
                            "description": "CSS named colors including transparent and currentColor"
                          }
                        ],
                        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "description": "this ref needs to be changed to shorthand syntax of the ref",
                "format": "css-border-color",
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                    "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                  },
                  {
                    "type": "string",
                    "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                    "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                  },
                  {
                    "type": "string",
                    "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                    "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                  },
                  {
                    "type": "string",
                    "enum": [
                      "transparent",
                      "currentColor",
                      "aliceblue",
                      "antiquewhite",
                      "aqua",
                      "aquamarine",
                      "azure",
                      "beige",
                      "bisque",
                      "black",
                      "blanchedalmond",
                      "blue",
                      "blueviolet",
                      "brown",
                      "burlywood",
                      "cadetblue",
                      "chartreuse",
                      "chocolate",
                      "coral",
                      "cornflowerblue",
                      "cornsilk",
                      "crimson",
                      "cyan",
                      "darkblue",
                      "darkcyan",
                      "darkgoldenrod",
                      "darkgray",
                      "darkgrey",
                      "darkgreen",
                      "darkkhaki",
                      "darkmagenta",
                      "darkolivegreen",
                      "darkorange",
                      "darkorchid",
                      "darkred",
                      "darksalmon",
                      "darkseagreen",
                      "darkslateblue",
                      "darkslategray",
                      "darkslategrey",
                      "darkturquoise",
                      "darkviolet",
                      "deeppink",
                      "deepskyblue",
                      "dimgray",
                      "dimgrey",
                      "dodgerblue",
                      "firebrick",
                      "floralwhite",
                      "forestgreen",
                      "fuchsia",
                      "gainsboro",
                      "ghostwhite",
                      "gold",
                      "goldenrod",
                      "gray",
                      "grey",
                      "green",
                      "greenyellow",
                      "honeydew",
                      "hotpink",
                      "indianred",
                      "indigo",
                      "ivory",
                      "khaki",
                      "lavender",
                      "lavenderblush",
                      "lawngreen",
                      "lemonchiffon",
                      "lightblue",
                      "lightcoral",
                      "lightcyan",
                      "lightgoldenrodyellow",
                      "lightgray",
                      "lightgrey",
                      "lightgreen",
                      "lightpink",
                      "lightsalmon",
                      "lightseagreen",
                      "lightskyblue",
                      "lightslategray",
                      "lightslategrey",
                      "lightsteelblue",
                      "lightyellow",
                      "lime",
                      "limegreen",
                      "linen",
                      "magenta",
                      "maroon",
                      "mediumaquamarine",
                      "mediumblue",
                      "mediumorchid",
                      "mediumpurple",
                      "mediumseagreen",
                      "mediumslateblue",
                      "mediumspringgreen",
                      "mediumturquoise",
                      "mediumvioletred",
                      "midnightblue",
                      "mintcream",
                      "mistyrose",
                      "moccasin",
                      "navajowhite",
                      "navy",
                      "oldlace",
                      "olive",
                      "olivedrab",
                      "orange",
                      "orangered",
                      "orchid",
                      "palegoldenrod",
                      "palegreen",
                      "paleturquoise",
                      "palevioletred",
                      "papayawhip",
                      "peachpuff",
                      "peru",
                      "pink",
                      "plum",
                      "powderblue",
                      "purple",
                      "rebeccapurple",
                      "red",
                      "rosybrown",
                      "royalblue",
                      "saddlebrown",
                      "salmon",
                      "sandybrown",
                      "seagreen",
                      "seashell",
                      "sienna",
                      "silver",
                      "skyblue",
                      "slateblue",
                      "slategray",
                      "slategrey",
                      "snow",
                      "springgreen",
                      "steelblue",
                      "tan",
                      "teal",
                      "thistle",
                      "tomato",
                      "turquoise",
                      "violet",
                      "wheat",
                      "white",
                      "whitesmoke",
                      "yellow",
                      "yellowgreen"
                    ],
                    "description": "CSS named colors including transparent and currentColor"
                  }
                ]
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Border": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-border",
                "description": "CSS border shorthand. Complex syntax combining line-width, line-style, and color cannot be fully validated with regex as it allows various combinations and orders."
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "description": "border radius shorthand syntax",
                "format": "css-border-radius",
                "pattern": "^(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3}(\\s*/\\s*(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3})?$"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.BorderTopLeftRadius": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-length",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                      }
                                    ],
                                    "description": "CSS numeric length with all valid units"
                                  }
                                ],
                                "description": "CSS positive numeric length with all valid units"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-percentage",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^-?\\d*\\.?\\d+%$"
                                      }
                                    ],
                                    "description": "Number followed by %"
                                  }
                                ],
                                "description": "Positive number followed by %"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length-percentage",
                        "anyOf": [
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          }
                        ],
                        "description": "Accepts both <positive-length> and <positive-percentage>"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-border-top-left-radius",
                "pattern": "^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
                "description": "CSS border-top-left-radius shorthand"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Font": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font",
                "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontFamily": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-string",
                        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                        "description": "Quoted strings with escapes"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-family",
                "anyOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                        "description": "Quoted strings with escapes"
                      },
                      {
                        "type": "string",
                        "pattern": "^[a-zA-Z_][\\w-]*$",
                        "description": "CSS identifiers (excluding keywords)"
                      }
                    ],
                    "description": "CSS font family name: quoted string or unquoted identifier"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "serif",
                      "sans-serif",
                      "monospace",
                      "cursive",
                      "fantasy",
                      "system-ui",
                      "ui-serif",
                      "ui-sans-serif",
                      "ui-monospace",
                      "ui-rounded",
                      "math",
                      "emoji",
                      "fangsong"
                    ],
                    "description": "CSS generic font families"
                  },
                  {
                    "type": "string",
                    "pattern": "^['\"]?([^0-9][\\w\\s\\-]*)['\"]?(,\\s*['\"]?([^0-9][\\w\\s\\-]*)['\"]?)*$",
                    "description": "Complex family name with multiple family names separated by commas"
                  }
                ],
                "description": "CSS font family: generic families, quoted family names, or unquoted family names"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontSize": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-size",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "xx-small",
                      "x-small",
                      "small",
                      "medium",
                      "large",
                      "x-large",
                      "xx-large",
                      "xxx-large"
                    ],
                    "description": "CSS absolute font sizes"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "larger",
                      "smaller"
                    ],
                    "description": "CSS relative font sizes"
                  },
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      }
                    ],
                    "description": "Accepts both <positive-length> and <positive-percentage>"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "math"
                    ]
                  }
                ],
                "description": "CSS font size: length, percentage, or keyword values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStretch": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-stretch",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal",
                      "ultra-condensed",
                      "extra-condensed",
                      "condensed",
                      "semi-condensed",
                      "semi-expanded",
                      "expanded",
                      "extra-expanded",
                      "ultra-expanded"
                    ]
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "CSS font stretch absolute values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-style",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic",
                      "oblique"
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^oblique\\s+\\d+deg$"
                  }
                ],
                "description": "CSS font style: keywords or oblique with angle"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontVariant": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-variant",
                "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FontWeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-font-weight",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter"
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^(100|200|300|400|500|600|700|800|900)$"
                  }
                ],
                "description": "CSS font weight: keywords or numeric values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LineHeight": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-number",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+$"
                              }
                            ],
                            "description": "Decimal or integer number"
                          }
                        ],
                        "description": "Positive decimal or integer number"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-line-height",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal"
                    ],
                    "description": "CSS normal keyword"
                  },
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+$"
                          }
                        ],
                        "description": "Decimal or integer number"
                      }
                    ],
                    "description": "Positive decimal or integer number"
                  },
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      }
                    ],
                    "description": "Accepts both <positive-length> and <positive-percentage>"
                  }
                ],
                "description": "CSS line-height: normal, number, length, or percentage"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.LetterSpacing": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-letter-spacing",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal"
                    ],
                    "description": "CSS normal keyword"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS letter-spacing: normal or length"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextAlign": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-align",
                "enum": [
                  "left",
                  "right",
                  "center",
                  "justify",
                  "start",
                  "end",
                  "match-parent"
                ],
                "description": "CSS text-align property values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextTransform": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-transform",
                "enum": [
                  "none",
                  "capitalize",
                  "uppercase",
                  "lowercase",
                  "full-width",
                  "full-size-kana"
                ],
                "description": "CSS text-transform values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextShadow": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-shadow",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "none"
                    ],
                    "description": "CSS none keyword"
                  },
                  {
                    "type": "string",
                    "description": "complex shadow value that cannot be fully validated with regex"
                  }
                ],
                "description": "CSS text-shadow: none or shadow values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecoration": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-decoration",
                "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationLine": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-decoration-line",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "none",
                      "underline",
                      "overline",
                      "line-through",
                      "blink"
                    ],
                    "description": "single value text decoration line"
                  },
                  {
                    "type": "string",
                    "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
                    "description": "multiple values text decoration line that cannot be fully validated with regex"
                  }
                ],
                "description": "CSS text-decoration-line values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationStyle": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-decoration-style",
                "enum": [
                  "solid",
                  "double",
                  "dotted",
                  "dashed",
                  "wavy"
                ],
                "description": "CSS text-decoration-style values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextDecorationThickness": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-decoration-thickness",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "auto"
                    ],
                    "description": "CSS auto keyword"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "from-font"
                    ]
                  }
                ],
                "description": "CSS text decoration thickness"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.TextOverflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-text-overflow",
                "enum": [
                  "clip",
                  "ellipsis"
                ],
                "description": "CSS text-overflow values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Padding": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-padding",
            "description": "padding shorthand syntax",
            "pattern": "^(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))(\\s+(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))){0,3}$"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.PaddingTop": {
        "anyOf": [
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-length",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-percentage",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length-percentage",
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      }
                    ],
                    "description": "Accepts both <positive-length> and <positive-percentage>"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-percentage",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-padding-top",
            "description": "CSS padding-top values",
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              }
            ]
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.Margin": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "description": "margin shorthand syntax",
            "format": "css-margin"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.MarginTop": {
        "anyOf": [
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-length",
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-percentage",
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length-percentage",
                    "anyOf": [
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Accepts both <length> and <percentage>"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length",
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-percentage",
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-margin-top",
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                  }
                ],
                "description": "CSS numeric length with all valid units"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              },
              {
                "type": "string",
                "enum": [
                  "auto"
                ],
                "description": "CSS auto keyword"
              }
            ],
            "description": "CSS length, percentage, or auto"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BoxShadow": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-box-shadow"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.Opacity": {
        "anyOf": [
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-number",
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+$"
                      }
                    ],
                    "description": "Decimal or integer number"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-percentage",
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-opacity",
            "anyOf": [
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+$"
                  }
                ],
                "description": "Decimal or integer number"
              },
              {
                "oneOf": [
                  {
                    "type": "string",
                    "pattern": "^calc\\([^(),]+\\)$",
                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                  },
                  {
                    "type": "string",
                    "pattern": "^-?\\d*\\.?\\d+%$"
                  }
                ],
                "description": "Number followed by %"
              }
            ],
            "description": "CSS opacity: number (0-1) or percentage"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.Background": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background",
            "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundSize": {
        "anyOf": [
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-length",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-percentage",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length-percentage",
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      }
                    ],
                    "description": "Accepts both <positive-length> and <positive-percentage>"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-percentage",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-size",
            "anyOf": [
              {
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  }
                ],
                "description": "Accepts both <positive-length> and <positive-percentage>"
              },
              {
                "type": "string",
                "enum": [
                  "auto",
                  "cover",
                  "contain"
                ]
              },
              {
                "type": "string",
                "pattern": "^(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
                "description": "complex syntax with multiple values that cannot be fully validated with regex"
              }
            ],
            "description": "CSS background-size values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundImage": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-image",
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "none"
                ],
                "description": "CSS none keyword"
              },
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^url\\((['\"]?).*?\\1\\)$",
                    "description": "Matches url(...) with optional quotes"
                  },
                  {
                    "type": "string",
                    "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
                    "description": "Gradient functions - arguments cannot be fully validated with regex"
                  },
                  {
                    "type": "string",
                    "pattern": "^image\\(.*\\)$",
                    "description": "Image function - arguments cannot be fully validated with regex"
                  }
                ],
                "description": "CSS image values including URLs, gradients, and image() functions"
              }
            ],
            "description": "CSS background-image values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.AlignSelf": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-align-self",
            "enum": [
              "center",
              "start",
              "end",
              "self-start",
              "self-end",
              "flex-start",
              "flex-end"
            ],
            "description": "CSS self position values for alignment"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.HeightOrWidth": {
        "anyOf": [
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-length",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "allOf": [
                      {
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                            "description": "CSS var() function- resolving a variable value from the variable"
                          },
                          {
                            "type": "string",
                            "format": "css-percentage",
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          },
                          {
                            "type": "string",
                            "enum": [
                              "inherit",
                              "initial",
                              "unset",
                              "revert",
                              "revert-layer"
                            ],
                            "description": "Global values available for any CSS property"
                          }
                        ]
                      },
                      {
                        "maxLength": 150
                      }
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length-percentage",
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      }
                    ],
                    "description": "Accepts both <positive-length> and <positive-percentage>"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-length",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "allOf": [
              {
                "anyOf": [
                  {
                    "type": "string",
                    "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                    "description": "CSS var() function- resolving a variable value from the variable"
                  },
                  {
                    "type": "string",
                    "format": "css-percentage",
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "inherit",
                      "initial",
                      "unset",
                      "revert",
                      "revert-layer"
                    ],
                    "description": "Global values available for any CSS property"
                  }
                ]
              },
              {
                "maxLength": 150
              }
            ]
          },
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-height-or-width",
            "anyOf": [
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  }
                ],
                "description": "CSS positive numeric length with all valid units"
              },
              {
                "allOf": [
                  {
                    "type": "string",
                    "pattern": "^[^-]",
                    "description": "CSS positive value"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Positive number followed by %"
              },
              {
                "type": "string",
                "enum": [
                  "auto"
                ],
                "description": "CSS auto keyword"
              }
            ],
            "description": "CSS positive length, positive percentage, or auto"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundClip": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-clip",
            "anyOf": [
              {
                "type": "string",
                "enum": [
                  "content-box",
                  "padding-box",
                  "border-box"
                ],
                "description": "CSS visual box types"
              },
              {
                "type": "string",
                "enum": [
                  "border-area",
                  "text"
                ]
              }
            ],
            "description": "CSS background-clip values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundOrigin": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-origin",
            "enum": [
              "border-box",
              "padding-box",
              "content-box"
            ],
            "description": "CSS background-origin values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundPosition": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-position",
            "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundRepeat": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-repeat",
            "enum": [
              "repeat",
              "repeat-x",
              "repeat-y",
              "no-repeat",
              "space",
              "round"
            ],
            "description": "CSS background-repeat values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.BackgroundAttachment": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-background-attachment",
            "enum": [
              "scroll",
              "fixed",
              "local"
            ],
            "description": "CSS background-attachment values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.Overflow": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-overflow",
                "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
                "description": "CSS overflow property values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowX": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-overflow-x",
                "enum": [
                  "visible",
                  "hidden",
                  "clip",
                  "scroll",
                  "auto"
                ],
                "description": "CSS overflow-x and overflow-y property values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.OverflowY": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-overflow-y",
                "enum": [
                  "visible",
                  "hidden",
                  "clip",
                  "scroll",
                  "auto"
                ],
                "description": "CSS overflow-x and overflow-y property values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.AlignItems": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-align-items",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal"
                    ],
                    "description": "CSS normal keyword"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "stretch"
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
                    "description": "CSS baseline position: baseline, first baseline, or last baseline"
                  },
                  {
                    "type": "string",
                    "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
                  }
                ],
                "description": "CSS align-items values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FlexDirection": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-flex-direction",
                "enum": [
                  "row",
                  "row-reverse",
                  "column",
                  "column-reverse"
                ],
                "description": "CSS flex-direction values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Gap": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-length",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                      }
                                    ],
                                    "description": "CSS numeric length with all valid units"
                                  }
                                ],
                                "description": "CSS positive numeric length with all valid units"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-percentage",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^-?\\d*\\.?\\d+%$"
                                      }
                                    ],
                                    "description": "Number followed by %"
                                  }
                                ],
                                "description": "Positive number followed by %"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length-percentage",
                        "anyOf": [
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          }
                        ],
                        "description": "Accepts both <positive-length> and <positive-percentage>"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-gap",
                "pattern": "^(normal|0|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
                "description": "CSS gap values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.SingleValueGap": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-length",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                      }
                                    ],
                                    "description": "CSS numeric length with all valid units"
                                  }
                                ],
                                "description": "CSS positive numeric length with all valid units"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-percentage",
                                "allOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^[^-]",
                                    "description": "CSS positive value"
                                  },
                                  {
                                    "oneOf": [
                                      {
                                        "type": "string",
                                        "pattern": "^calc\\([^(),]+\\)$",
                                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                      },
                                      {
                                        "type": "string",
                                        "pattern": "^-?\\d*\\.?\\d+%$"
                                      }
                                    ],
                                    "description": "Number followed by %"
                                  }
                                ],
                                "description": "Positive number followed by %"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length-percentage",
                        "anyOf": [
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              }
                            ],
                            "description": "CSS positive numeric length with all valid units"
                          },
                          {
                            "allOf": [
                              {
                                "type": "string",
                                "pattern": "^[^-]",
                                "description": "CSS positive value"
                              },
                              {
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              }
                            ],
                            "description": "Positive number followed by %"
                          }
                        ],
                        "description": "Accepts both <positive-length> and <positive-percentage>"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          }
                        ],
                        "description": "CSS positive numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "allOf": [
                          {
                            "type": "string",
                            "pattern": "^[^-]",
                            "description": "CSS positive value"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Positive number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-single-value-gap",
                "anyOf": [
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      }
                    ],
                    "description": "CSS positive numeric length with all valid units"
                  },
                  {
                    "allOf": [
                      {
                        "type": "string",
                        "pattern": "^[^-]",
                        "description": "CSS positive value"
                      },
                      {
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      }
                    ],
                    "description": "Positive number followed by %"
                  }
                ],
                "description": "Accepts both <positive-length> and <positive-percentage>"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.JustifyContent": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-justify-content",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "normal"
                    ],
                    "description": "CSS normal keyword"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "space-between",
                      "space-around",
                      "space-evenly",
                      "stretch"
                    ],
                    "description": "CSS content distribution values for alignment"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "center",
                      "start",
                      "end",
                      "flex-start",
                      "flex-end"
                    ],
                    "description": "CSS content position values for alignment"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "left",
                      "right"
                    ]
                  },
                  {
                    "type": "string",
                    "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
                  }
                ],
                "description": "CSS justify-content values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillWithURL": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-color",
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                            "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                          },
                          {
                            "type": "string",
                            "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                          },
                          {
                            "type": "string",
                            "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                          },
                          {
                            "type": "string",
                            "enum": [
                              "transparent",
                              "currentColor",
                              "aliceblue",
                              "antiquewhite",
                              "aqua",
                              "aquamarine",
                              "azure",
                              "beige",
                              "bisque",
                              "black",
                              "blanchedalmond",
                              "blue",
                              "blueviolet",
                              "brown",
                              "burlywood",
                              "cadetblue",
                              "chartreuse",
                              "chocolate",
                              "coral",
                              "cornflowerblue",
                              "cornsilk",
                              "crimson",
                              "cyan",
                              "darkblue",
                              "darkcyan",
                              "darkgoldenrod",
                              "darkgray",
                              "darkgrey",
                              "darkgreen",
                              "darkkhaki",
                              "darkmagenta",
                              "darkolivegreen",
                              "darkorange",
                              "darkorchid",
                              "darkred",
                              "darksalmon",
                              "darkseagreen",
                              "darkslateblue",
                              "darkslategray",
                              "darkslategrey",
                              "darkturquoise",
                              "darkviolet",
                              "deeppink",
                              "deepskyblue",
                              "dimgray",
                              "dimgrey",
                              "dodgerblue",
                              "firebrick",
                              "floralwhite",
                              "forestgreen",
                              "fuchsia",
                              "gainsboro",
                              "ghostwhite",
                              "gold",
                              "goldenrod",
                              "gray",
                              "grey",
                              "green",
                              "greenyellow",
                              "honeydew",
                              "hotpink",
                              "indianred",
                              "indigo",
                              "ivory",
                              "khaki",
                              "lavender",
                              "lavenderblush",
                              "lawngreen",
                              "lemonchiffon",
                              "lightblue",
                              "lightcoral",
                              "lightcyan",
                              "lightgoldenrodyellow",
                              "lightgray",
                              "lightgrey",
                              "lightgreen",
                              "lightpink",
                              "lightsalmon",
                              "lightseagreen",
                              "lightskyblue",
                              "lightslategray",
                              "lightslategrey",
                              "lightsteelblue",
                              "lightyellow",
                              "lime",
                              "limegreen",
                              "linen",
                              "magenta",
                              "maroon",
                              "mediumaquamarine",
                              "mediumblue",
                              "mediumorchid",
                              "mediumpurple",
                              "mediumseagreen",
                              "mediumslateblue",
                              "mediumspringgreen",
                              "mediumturquoise",
                              "mediumvioletred",
                              "midnightblue",
                              "mintcream",
                              "mistyrose",
                              "moccasin",
                              "navajowhite",
                              "navy",
                              "oldlace",
                              "olive",
                              "olivedrab",
                              "orange",
                              "orangered",
                              "orchid",
                              "palegoldenrod",
                              "palegreen",
                              "paleturquoise",
                              "palevioletred",
                              "papayawhip",
                              "peachpuff",
                              "peru",
                              "pink",
                              "plum",
                              "powderblue",
                              "purple",
                              "rebeccapurple",
                              "red",
                              "rosybrown",
                              "royalblue",
                              "saddlebrown",
                              "salmon",
                              "sandybrown",
                              "seagreen",
                              "seashell",
                              "sienna",
                              "silver",
                              "skyblue",
                              "slateblue",
                              "slategray",
                              "slategrey",
                              "snow",
                              "springgreen",
                              "steelblue",
                              "tan",
                              "teal",
                              "thistle",
                              "tomato",
                              "turquoise",
                              "violet",
                              "wheat",
                              "white",
                              "whitesmoke",
                              "yellow",
                              "yellowgreen"
                            ],
                            "description": "CSS named colors including transparent and currentColor"
                          }
                        ],
                        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-fill-with-url",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "none"
                    ],
                    "description": "CSS none keyword"
                  },
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                      },
                      {
                        "type": "string",
                        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                      },
                      {
                        "type": "string",
                        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                      },
                      {
                        "type": "string",
                        "enum": [
                          "transparent",
                          "currentColor",
                          "aliceblue",
                          "antiquewhite",
                          "aqua",
                          "aquamarine",
                          "azure",
                          "beige",
                          "bisque",
                          "black",
                          "blanchedalmond",
                          "blue",
                          "blueviolet",
                          "brown",
                          "burlywood",
                          "cadetblue",
                          "chartreuse",
                          "chocolate",
                          "coral",
                          "cornflowerblue",
                          "cornsilk",
                          "crimson",
                          "cyan",
                          "darkblue",
                          "darkcyan",
                          "darkgoldenrod",
                          "darkgray",
                          "darkgrey",
                          "darkgreen",
                          "darkkhaki",
                          "darkmagenta",
                          "darkolivegreen",
                          "darkorange",
                          "darkorchid",
                          "darkred",
                          "darksalmon",
                          "darkseagreen",
                          "darkslateblue",
                          "darkslategray",
                          "darkslategrey",
                          "darkturquoise",
                          "darkviolet",
                          "deeppink",
                          "deepskyblue",
                          "dimgray",
                          "dimgrey",
                          "dodgerblue",
                          "firebrick",
                          "floralwhite",
                          "forestgreen",
                          "fuchsia",
                          "gainsboro",
                          "ghostwhite",
                          "gold",
                          "goldenrod",
                          "gray",
                          "grey",
                          "green",
                          "greenyellow",
                          "honeydew",
                          "hotpink",
                          "indianred",
                          "indigo",
                          "ivory",
                          "khaki",
                          "lavender",
                          "lavenderblush",
                          "lawngreen",
                          "lemonchiffon",
                          "lightblue",
                          "lightcoral",
                          "lightcyan",
                          "lightgoldenrodyellow",
                          "lightgray",
                          "lightgrey",
                          "lightgreen",
                          "lightpink",
                          "lightsalmon",
                          "lightseagreen",
                          "lightskyblue",
                          "lightslategray",
                          "lightslategrey",
                          "lightsteelblue",
                          "lightyellow",
                          "lime",
                          "limegreen",
                          "linen",
                          "magenta",
                          "maroon",
                          "mediumaquamarine",
                          "mediumblue",
                          "mediumorchid",
                          "mediumpurple",
                          "mediumseagreen",
                          "mediumslateblue",
                          "mediumspringgreen",
                          "mediumturquoise",
                          "mediumvioletred",
                          "midnightblue",
                          "mintcream",
                          "mistyrose",
                          "moccasin",
                          "navajowhite",
                          "navy",
                          "oldlace",
                          "olive",
                          "olivedrab",
                          "orange",
                          "orangered",
                          "orchid",
                          "palegoldenrod",
                          "palegreen",
                          "paleturquoise",
                          "palevioletred",
                          "papayawhip",
                          "peachpuff",
                          "peru",
                          "pink",
                          "plum",
                          "powderblue",
                          "purple",
                          "rebeccapurple",
                          "red",
                          "rosybrown",
                          "royalblue",
                          "saddlebrown",
                          "salmon",
                          "sandybrown",
                          "seagreen",
                          "seashell",
                          "sienna",
                          "silver",
                          "skyblue",
                          "slateblue",
                          "slategray",
                          "slategrey",
                          "snow",
                          "springgreen",
                          "steelblue",
                          "tan",
                          "teal",
                          "thistle",
                          "tomato",
                          "turquoise",
                          "violet",
                          "wheat",
                          "white",
                          "whitesmoke",
                          "yellow",
                          "yellowgreen"
                        ],
                        "description": "CSS named colors including transparent and currentColor"
                      }
                    ],
                    "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                  },
                  {
                    "type": "string",
                    "pattern": "^url\\((['\"]?).*?\\1\\)$",
                    "description": "Matches url(...) with optional quotes"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "context-fill",
                      "context-stroke"
                    ]
                  }
                ],
                "description": "CSS paint values for SVG: none, color, URL, or context keywords"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Isolation": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-isolation",
            "enum": [
              "auto",
              "isolate"
            ],
            "description": "CSS isolation values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.MixBlendMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-blend-mode",
                        "enum": [
                          "normal",
                          "multiply",
                          "screen",
                          "overlay",
                          "darken",
                          "lighten",
                          "color-dodge",
                          "color-burn",
                          "hard-light",
                          "soft-light",
                          "difference",
                          "exclusion",
                          "hue",
                          "saturation",
                          "color",
                          "luminosity"
                        ],
                        "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-mix-blend-mode",
                "description": "CSS mix-blend-mode property values",
                "enum": [
                  "normal",
                  "multiply",
                  "screen",
                  "overlay",
                  "darken",
                  "lighten",
                  "color-dodge",
                  "color-burn",
                  "hard-light",
                  "soft-light",
                  "difference",
                  "exclusion",
                  "hue",
                  "saturation",
                  "color",
                  "luminosity"
                ]
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.ObjectFit": {
        "anyOf": [
          {
            "type": "string",
            "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
            "description": "CSS var() function- resolving a variable value from the variable"
          },
          {
            "type": "string",
            "format": "css-object-fit",
            "enum": [
              "fill",
              "contain",
              "cover",
              "none",
              "scale-down"
            ],
            "description": "CSS object-fit values"
          },
          {
            "type": "string",
            "enum": [
              "inherit",
              "initial",
              "unset",
              "revert",
              "revert-layer"
            ],
            "description": "Global values available for any CSS property"
          }
        ]
      },
      "CSS.ObjectPosition": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-object-position",
                "description": "CSS object-position: similar to position.",
                "pattern": "^(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%))(\\s+(left|center|right|top|bottom|0|\\d+(px|spx|em|rem|%)))*$"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.FillOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-number",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+$"
                          }
                        ],
                        "description": "Decimal or integer number"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-fill-opacity",
                "anyOf": [
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+$"
                      }
                    ],
                    "description": "Decimal or integer number"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "CSS alpha value for colors: number (0-1) or percentage"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Stroke": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-color",
                        "anyOf": [
                          {
                            "type": "string",
                            "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                            "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                          },
                          {
                            "type": "string",
                            "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                          },
                          {
                            "type": "string",
                            "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                            "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                          },
                          {
                            "type": "string",
                            "enum": [
                              "transparent",
                              "currentColor",
                              "aliceblue",
                              "antiquewhite",
                              "aqua",
                              "aquamarine",
                              "azure",
                              "beige",
                              "bisque",
                              "black",
                              "blanchedalmond",
                              "blue",
                              "blueviolet",
                              "brown",
                              "burlywood",
                              "cadetblue",
                              "chartreuse",
                              "chocolate",
                              "coral",
                              "cornflowerblue",
                              "cornsilk",
                              "crimson",
                              "cyan",
                              "darkblue",
                              "darkcyan",
                              "darkgoldenrod",
                              "darkgray",
                              "darkgrey",
                              "darkgreen",
                              "darkkhaki",
                              "darkmagenta",
                              "darkolivegreen",
                              "darkorange",
                              "darkorchid",
                              "darkred",
                              "darksalmon",
                              "darkseagreen",
                              "darkslateblue",
                              "darkslategray",
                              "darkslategrey",
                              "darkturquoise",
                              "darkviolet",
                              "deeppink",
                              "deepskyblue",
                              "dimgray",
                              "dimgrey",
                              "dodgerblue",
                              "firebrick",
                              "floralwhite",
                              "forestgreen",
                              "fuchsia",
                              "gainsboro",
                              "ghostwhite",
                              "gold",
                              "goldenrod",
                              "gray",
                              "grey",
                              "green",
                              "greenyellow",
                              "honeydew",
                              "hotpink",
                              "indianred",
                              "indigo",
                              "ivory",
                              "khaki",
                              "lavender",
                              "lavenderblush",
                              "lawngreen",
                              "lemonchiffon",
                              "lightblue",
                              "lightcoral",
                              "lightcyan",
                              "lightgoldenrodyellow",
                              "lightgray",
                              "lightgrey",
                              "lightgreen",
                              "lightpink",
                              "lightsalmon",
                              "lightseagreen",
                              "lightskyblue",
                              "lightslategray",
                              "lightslategrey",
                              "lightsteelblue",
                              "lightyellow",
                              "lime",
                              "limegreen",
                              "linen",
                              "magenta",
                              "maroon",
                              "mediumaquamarine",
                              "mediumblue",
                              "mediumorchid",
                              "mediumpurple",
                              "mediumseagreen",
                              "mediumslateblue",
                              "mediumspringgreen",
                              "mediumturquoise",
                              "mediumvioletred",
                              "midnightblue",
                              "mintcream",
                              "mistyrose",
                              "moccasin",
                              "navajowhite",
                              "navy",
                              "oldlace",
                              "olive",
                              "olivedrab",
                              "orange",
                              "orangered",
                              "orchid",
                              "palegoldenrod",
                              "palegreen",
                              "paleturquoise",
                              "palevioletred",
                              "papayawhip",
                              "peachpuff",
                              "peru",
                              "pink",
                              "plum",
                              "powderblue",
                              "purple",
                              "rebeccapurple",
                              "red",
                              "rosybrown",
                              "royalblue",
                              "saddlebrown",
                              "salmon",
                              "sandybrown",
                              "seagreen",
                              "seashell",
                              "sienna",
                              "silver",
                              "skyblue",
                              "slateblue",
                              "slategray",
                              "slategrey",
                              "snow",
                              "springgreen",
                              "steelblue",
                              "tan",
                              "teal",
                              "thistle",
                              "tomato",
                              "turquoise",
                              "violet",
                              "wheat",
                              "white",
                              "whitesmoke",
                              "yellow",
                              "yellowgreen"
                            ],
                            "description": "CSS named colors including transparent and currentColor"
                          }
                        ],
                        "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-stroke",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "none"
                    ],
                    "description": "CSS none keyword"
                  },
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                        "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                      },
                      {
                        "type": "string",
                        "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                        "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                      },
                      {
                        "type": "string",
                        "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                        "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                      },
                      {
                        "type": "string",
                        "enum": [
                          "transparent",
                          "currentColor",
                          "aliceblue",
                          "antiquewhite",
                          "aqua",
                          "aquamarine",
                          "azure",
                          "beige",
                          "bisque",
                          "black",
                          "blanchedalmond",
                          "blue",
                          "blueviolet",
                          "brown",
                          "burlywood",
                          "cadetblue",
                          "chartreuse",
                          "chocolate",
                          "coral",
                          "cornflowerblue",
                          "cornsilk",
                          "crimson",
                          "cyan",
                          "darkblue",
                          "darkcyan",
                          "darkgoldenrod",
                          "darkgray",
                          "darkgrey",
                          "darkgreen",
                          "darkkhaki",
                          "darkmagenta",
                          "darkolivegreen",
                          "darkorange",
                          "darkorchid",
                          "darkred",
                          "darksalmon",
                          "darkseagreen",
                          "darkslateblue",
                          "darkslategray",
                          "darkslategrey",
                          "darkturquoise",
                          "darkviolet",
                          "deeppink",
                          "deepskyblue",
                          "dimgray",
                          "dimgrey",
                          "dodgerblue",
                          "firebrick",
                          "floralwhite",
                          "forestgreen",
                          "fuchsia",
                          "gainsboro",
                          "ghostwhite",
                          "gold",
                          "goldenrod",
                          "gray",
                          "grey",
                          "green",
                          "greenyellow",
                          "honeydew",
                          "hotpink",
                          "indianred",
                          "indigo",
                          "ivory",
                          "khaki",
                          "lavender",
                          "lavenderblush",
                          "lawngreen",
                          "lemonchiffon",
                          "lightblue",
                          "lightcoral",
                          "lightcyan",
                          "lightgoldenrodyellow",
                          "lightgray",
                          "lightgrey",
                          "lightgreen",
                          "lightpink",
                          "lightsalmon",
                          "lightseagreen",
                          "lightskyblue",
                          "lightslategray",
                          "lightslategrey",
                          "lightsteelblue",
                          "lightyellow",
                          "lime",
                          "limegreen",
                          "linen",
                          "magenta",
                          "maroon",
                          "mediumaquamarine",
                          "mediumblue",
                          "mediumorchid",
                          "mediumpurple",
                          "mediumseagreen",
                          "mediumslateblue",
                          "mediumspringgreen",
                          "mediumturquoise",
                          "mediumvioletred",
                          "midnightblue",
                          "mintcream",
                          "mistyrose",
                          "moccasin",
                          "navajowhite",
                          "navy",
                          "oldlace",
                          "olive",
                          "olivedrab",
                          "orange",
                          "orangered",
                          "orchid",
                          "palegoldenrod",
                          "palegreen",
                          "paleturquoise",
                          "palevioletred",
                          "papayawhip",
                          "peachpuff",
                          "peru",
                          "pink",
                          "plum",
                          "powderblue",
                          "purple",
                          "rebeccapurple",
                          "red",
                          "rosybrown",
                          "royalblue",
                          "saddlebrown",
                          "salmon",
                          "sandybrown",
                          "seagreen",
                          "seashell",
                          "sienna",
                          "silver",
                          "skyblue",
                          "slateblue",
                          "slategray",
                          "slategrey",
                          "snow",
                          "springgreen",
                          "steelblue",
                          "tan",
                          "teal",
                          "thistle",
                          "tomato",
                          "turquoise",
                          "violet",
                          "wheat",
                          "white",
                          "whitesmoke",
                          "yellow",
                          "yellowgreen"
                        ],
                        "description": "CSS named colors including transparent and currentColor"
                      }
                    ],
                    "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                  },
                  {
                    "type": "string",
                    "pattern": "^url\\((['\"]?).*?\\1\\)$",
                    "description": "Matches url(...) with optional quotes"
                  },
                  {
                    "type": "string",
                    "enum": [
                      "context-fill",
                      "context-stroke"
                    ]
                  }
                ],
                "description": "CSS paint values for SVG: none, color, URL, or context keywords"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeWidth": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-length",
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                  }
                                ],
                                "description": "CSS numeric length with all valid units"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "allOf": [
                          {
                            "anyOf": [
                              {
                                "type": "string",
                                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                "description": "CSS var() function- resolving a variable value from the variable"
                              },
                              {
                                "type": "string",
                                "format": "css-percentage",
                                "oneOf": [
                                  {
                                    "type": "string",
                                    "pattern": "^calc\\([^(),]+\\)$",
                                    "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                  },
                                  {
                                    "type": "string",
                                    "pattern": "^-?\\d*\\.?\\d+%$"
                                  }
                                ],
                                "description": "Number followed by %"
                              },
                              {
                                "type": "string",
                                "enum": [
                                  "inherit",
                                  "initial",
                                  "unset",
                                  "revert",
                                  "revert-layer"
                                ],
                                "description": "Global values available for any CSS property"
                              }
                            ]
                          },
                          {
                            "maxLength": 150
                          }
                        ]
                      },
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length-percentage",
                        "anyOf": [
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                              }
                            ],
                            "description": "CSS numeric length with all valid units"
                          },
                          {
                            "oneOf": [
                              {
                                "type": "string",
                                "pattern": "^calc\\([^(),]+\\)$",
                                "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                              },
                              {
                                "type": "string",
                                "pattern": "^-?\\d*\\.?\\d+%$"
                              }
                            ],
                            "description": "Number followed by %"
                          }
                        ],
                        "description": "Accepts both <length> and <percentage>"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-length",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                          }
                        ],
                        "description": "CSS numeric length with all valid units"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-stroke-width",
                "anyOf": [
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                      }
                    ],
                    "description": "CSS numeric length with all valid units"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "Accepts both <length> and <percentage>"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.StrokeOpacity": {
        "allOf": [
          {
            "anyOf": [
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-number",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+$"
                          }
                        ],
                        "description": "Decimal or integer number"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "allOf": [
                  {
                    "anyOf": [
                      {
                        "type": "string",
                        "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                        "description": "CSS var() function- resolving a variable value from the variable"
                      },
                      {
                        "type": "string",
                        "format": "css-percentage",
                        "oneOf": [
                          {
                            "type": "string",
                            "pattern": "^calc\\([^(),]+\\)$",
                            "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                          },
                          {
                            "type": "string",
                            "pattern": "^-?\\d*\\.?\\d+%$"
                          }
                        ],
                        "description": "Number followed by %"
                      },
                      {
                        "type": "string",
                        "enum": [
                          "inherit",
                          "initial",
                          "unset",
                          "revert",
                          "revert-layer"
                        ],
                        "description": "Global values available for any CSS property"
                      }
                    ]
                  },
                  {
                    "maxLength": 150
                  }
                ]
              },
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-stroke-opacity",
                "anyOf": [
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+$"
                      }
                    ],
                    "description": "Decimal or integer number"
                  },
                  {
                    "oneOf": [
                      {
                        "type": "string",
                        "pattern": "^calc\\([^(),]+\\)$",
                        "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                      },
                      {
                        "type": "string",
                        "pattern": "^-?\\d*\\.?\\d+%$"
                      }
                    ],
                    "description": "Number followed by %"
                  }
                ],
                "description": "CSS alpha value for colors: number (0-1) or percentage"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Display": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-display",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "table-row-group",
                      "table-header-group",
                      "table-footer-group",
                      "table-row",
                      "table-cell",
                      "table-column-group",
                      "table-column",
                      "table-caption",
                      "ruby-base",
                      "ruby-text",
                      "ruby-base-container",
                      "ruby-text-container",
                      "contents",
                      "none",
                      "inline-block",
                      "inline-table",
                      "inline-flex",
                      "inline-grid"
                    ]
                  },
                  {
                    "type": "string",
                    "description": "complex display value that cannot be fully validated with regex"
                  }
                ],
                "description": "CSS display property values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.Filter": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-filter",
                "anyOf": [
                  {
                    "type": "string",
                    "enum": [
                      "none"
                    ],
                    "description": "CSS none keyword"
                  },
                  {
                    "type": "string",
                    "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
                    "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
                  }
                ],
                "description": "CSS filter value"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      },
      "CSS.WritingMode": {
        "allOf": [
          {
            "anyOf": [
              {
                "type": "string",
                "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                "description": "CSS var() function- resolving a variable value from the variable"
              },
              {
                "type": "string",
                "format": "css-writing-mode",
                "enum": [
                  "horizontal-tb",
                  "vertical-rl",
                  "vertical-lr",
                  "sideways-rl",
                  "sideways-lr"
                ],
                "description": "CSS writing-mode values"
              },
              {
                "type": "string",
                "enum": [
                  "inherit",
                  "initial",
                  "unset",
                  "revert",
                  "revert-layer"
                ],
                "description": "Global values available for any CSS property"
              }
            ]
          },
          {
            "maxLength": 150
          }
        ]
      }
    }
  },
  "cursor.json": {
    "$id": "urn:dm:schemas:cursor.json",
    "Cursor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "media": {
          "type": [
            "string"
          ]
        },
        "offsetX": {
          "type": "number",
          "default": 0,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "offsetY": {
          "type": "number",
          "default": 0,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "width": {
          "type": "number",
          "default": 32,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        },
        "height": {
          "type": "number",
          "default": 32,
          "minimum": 0,
          "maximum": 128,
          "multipleOf": 1
        }
      }
    },
    "Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "description": "Original Image before edit",
          "type": [
            "null",
            "string"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "description": "Information about the artist of the image.",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SVGItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "design_data.json": {
    "$id": "urn:dm:schemas:design_data.json",
    "MediaContainerDesignData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "charas": {
          "type": [
            "string",
            "null"
          ]
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataChangeBehaviors": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "trigger": {
                "type": "string"
              },
              "type": {
                "type": "string"
              },
              "part": {
                "type": "string"
              },
              "name": {
                "type": "string"
              },
              "params": {
                "type": "object"
              }
            },
            "additionalProperties": false
          }
        },
        "cssStyle": {
          "type": "object",
          "properties": {
            "cssBorder": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "required": [
                    "width",
                    "style",
                    "color"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "width": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "right": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "left": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        }
                      }
                    },
                    "style": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "right": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "bottom": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "left": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        }
                      }
                    },
                    "color": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "right": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "bottom": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "left": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        }
                      }
                    }
                  }
                }
              ]
            },
            "cssBoxShadow": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "array",
                  "items": {
                    "required": [
                      "inset",
                      "offsetX",
                      "offsetY",
                      "blurRadius",
                      "spreadRadius",
                      "color"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "inset": {
                        "type": "boolean",
                        "additionalProperties": false
                      },
                      "offsetX": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "offsetY": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "blurRadius": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "spreadRadius": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "color": {
                        "type": "object",
                        "required": [
                          "red",
                          "green",
                          "blue",
                          "alpha"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "red": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "green": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "blue": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "alpha": {
                            "type": "number",
                            "minimum": 0,
                            "maximum": 1
                          }
                        }
                      }
                    }
                  },
                  "minItems": 1
                }
              ]
            },
            "cssBorderRadius": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "required": [
                    "topLeft",
                    "topRight",
                    "bottomLeft",
                    "bottomRight"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "topLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "topRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "bottomLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "bottomRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    }
                  }
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "themeMappings": {
          "type": "object"
        },
        "mediaRef": {},
        "posterImageRef": {},
        "imageOverlay": {}
      }
    },
    "MediaContainerWithDividers": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        },
        "dividerTop": {
          "type": [
            "null",
            "string"
          ]
        },
        "dividerBottom": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ShapeDivider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string"
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "padding": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "height": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "offsetX": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "flip": {
          "type": "boolean"
        },
        "invert": {
          "type": "boolean"
        },
        "keepAspectRatio": {
          "type": "boolean"
        },
        "shouldRepeat": {
          "type": "boolean"
        },
        "repeatCount": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "layersEffect": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "required": [
                "size"
              ],
              "properties": {
                "size": {
                  "type": "number",
                  "minimum": 1,
                  "maximum": 10
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "pin": {
                  "type": "string",
                  "enum": [
                    "in",
                    "out"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "presetId": {
          "type": "string",
          "maxLength": 20
        }
      },
      "required": [
        "svgId"
      ]
    },
    "MediaPlayerDesignData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "charas": {
          "type": [
            "string",
            "null"
          ]
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        },
        "cssStyle": {
          "type": "object",
          "properties": {
            "cssBorder": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "required": [
                    "width",
                    "style",
                    "color"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "width": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "right": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "bottom": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        },
                        "left": {
                          "oneOf": [
                            {
                              "type": "object",
                              "required": [
                                "unit",
                                "value"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "unit": {
                                  "oneOf": [
                                    {
                                      "enum": [
                                        "px",
                                        "cm",
                                        "mm",
                                        "q",
                                        "in",
                                        "pt",
                                        "pc"
                                      ]
                                    },
                                    {
                                      "enum": [
                                        "em",
                                        "ex",
                                        "ch",
                                        "rem",
                                        "vw",
                                        "vh",
                                        "vmin",
                                        "vmax"
                                      ]
                                    }
                                  ]
                                },
                                "value": {
                                  "type": "number"
                                }
                              }
                            }
                          ]
                        }
                      }
                    },
                    "style": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "right": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "bottom": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        },
                        "left": {
                          "enum": [
                            "none",
                            "hidden",
                            "dotted",
                            "dashed",
                            "solid",
                            "double",
                            "groove",
                            "ridge",
                            "inset",
                            "outset"
                          ]
                        }
                      }
                    },
                    "color": {
                      "type": "object",
                      "required": [
                        "top",
                        "right",
                        "bottom",
                        "left"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "top": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "right": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "bottom": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        },
                        "left": {
                          "type": "object",
                          "required": [
                            "red",
                            "green",
                            "blue",
                            "alpha"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "red": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "green": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "blue": {
                              "type": "number",
                              "default": 0,
                              "multipleOf": 1,
                              "minimum": 0,
                              "maximum": 255
                            },
                            "alpha": {
                              "type": "number",
                              "minimum": 0,
                              "maximum": 1
                            }
                          }
                        }
                      }
                    }
                  }
                }
              ]
            },
            "cssBoxShadow": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "array",
                  "items": {
                    "required": [
                      "inset",
                      "offsetX",
                      "offsetY",
                      "blurRadius",
                      "spreadRadius",
                      "color"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "inset": {
                        "type": "boolean",
                        "additionalProperties": false
                      },
                      "offsetX": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "offsetY": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "blurRadius": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "spreadRadius": {
                        "type": "object",
                        "required": [
                          "unit",
                          "value"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "unit": {
                            "oneOf": [
                              {
                                "enum": [
                                  "px",
                                  "cm",
                                  "mm",
                                  "q",
                                  "in",
                                  "pt",
                                  "pc"
                                ]
                              },
                              {
                                "enum": [
                                  "em",
                                  "ex",
                                  "ch",
                                  "rem",
                                  "vw",
                                  "vh",
                                  "vmin",
                                  "vmax"
                                ]
                              }
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      },
                      "color": {
                        "type": "object",
                        "required": [
                          "red",
                          "green",
                          "blue",
                          "alpha"
                        ],
                        "additionalProperties": false,
                        "properties": {
                          "red": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "green": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "blue": {
                            "type": "number",
                            "default": 0,
                            "multipleOf": 1,
                            "minimum": 0,
                            "maximum": 255
                          },
                          "alpha": {
                            "type": "number",
                            "minimum": 0,
                            "maximum": 1
                          }
                        }
                      }
                    }
                  },
                  "minItems": 1
                }
              ]
            },
            "cssBorderRadius": {
              "oneOf": [
                {
                  "type": "null"
                },
                {
                  "type": "object",
                  "required": [
                    "topLeft",
                    "topRight",
                    "bottomLeft",
                    "bottomRight"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "topLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "topRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "bottomLeft": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "bottomRight": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "unit": {
                              "enum": [
                                "%"
                              ]
                            }
                          }
                        }
                      ]
                    }
                  }
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "themeMappings": {
          "type": "object"
        },
        "posterImageRef": {},
        "mediaRef": {},
        "imageOverlay": {}
      }
    },
    "TextFxDesign": {
      "type": "object",
      "properties": {
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                },
                "spreadRadius": {
                  "type": "number"
                },
                "blurRadius": {
                  "type": "number",
                  "minimum": 0
                },
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "color": {
                  "type": "string",
                  "description": "Hex or RGB color"
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "TextFxMask": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                },
                "spreadRadius": {
                  "type": "number"
                },
                "blurRadius": {
                  "type": "number",
                  "minimum": 0
                },
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "color": {
                  "type": "string",
                  "description": "Hex or RGB color"
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "media": {
          "type": [
            "null",
            "string"
          ]
        },
        "mediaRotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "mediaFlip": {
          "enum": [
            "none",
            "horizontal",
            "vertical",
            "both"
          ],
          "default": "none"
        },
        "viewBox": {
          "type": [
            "string",
            "null"
          ],
          "minimum": 7,
          "maximum": 200
        }
      }
    },
    "TextFxPath": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoScale": {
          "type": "boolean",
          "default": true,
          "description": "true - scale the text dynamically by layout, false - no scaling (text size by font size)"
        },
        "align": {
          "enum": [
            "start",
            "middle",
            "end"
          ],
          "default": "middle"
        },
        "family": {
          "type": "string",
          "maxLength": 150
        },
        "size": {
          "type": "number",
          "minimum": 6,
          "maximum": 999
        },
        "weight": {
          "enum": [
            "normal",
            "bold",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ],
          "default": "normal"
        },
        "style": {
          "enum": [
            "normal",
            "italic"
          ],
          "default": "normal"
        },
        "decoration": {
          "enum": [
            "none",
            "underline",
            "line-through"
          ],
          "default": "none"
        },
        "transform": {
          "enum": [
            "none",
            "capitalize",
            "uppercase",
            "lowercase"
          ],
          "default": "none"
        },
        "letterSpacing": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "lineHeight": {
          "type": "number",
          "minimum": 0,
          "maximum": 7,
          "default": 1
        },
        "outlineColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "outlineOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "outlineWidth": {
          "type": "number",
          "minimum": 0
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                },
                "spreadRadius": {
                  "type": "number"
                },
                "blurRadius": {
                  "type": "number",
                  "minimum": 0
                },
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "color": {
                  "type": "string",
                  "description": "Hex or RGB color"
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "path": {
          "type": "string",
          "maxLength": 1024
        },
        "keepAspectRatio": {
          "type": "boolean"
        },
        "keepFontSize": {
          "type": "boolean"
        },
        "inside": {
          "type": "boolean"
        },
        "verticalAlign": {
          "enum": [
            "top",
            "middle",
            "bottom"
          ],
          "default": "bottom"
        },
        "verticalOffset": {
          "type": "number"
        },
        "horizontalOffset": {
          "type": "number"
        },
        "spread": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "textColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fillColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fillOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "strokeColor": {
          "maxLength": 40,
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "strokeOpacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "strokeWidth": {
          "type": "number",
          "minimum": 0
        },
        "viewBox": {
          "type": [
            "string",
            "null"
          ],
          "minimum": 7,
          "maximum": 200
        },
        "presetId": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "css-keyword": {
      "type": "boolean",
      "additionalProperties": false
    },
    "css-percentage": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "value": {
          "type": "number"
        },
        "unit": {
          "enum": [
            "%"
          ]
        }
      }
    },
    "css-absolute-length-unit": {
      "enum": [
        "px",
        "cm",
        "mm",
        "q",
        "in",
        "pt",
        "pc"
      ]
    },
    "css-relative-length-unit": {
      "enum": [
        "em",
        "ex",
        "ch",
        "rem",
        "vw",
        "vh",
        "vmin",
        "vmax"
      ]
    },
    "css-length": {
      "type": "object",
      "required": [
        "unit",
        "value"
      ],
      "additionalProperties": false,
      "properties": {
        "unit": {
          "oneOf": [
            {
              "enum": [
                "px",
                "cm",
                "mm",
                "q",
                "in",
                "pt",
                "pc"
              ]
            },
            {
              "enum": [
                "em",
                "ex",
                "ch",
                "rem",
                "vw",
                "vh",
                "vmin",
                "vmax"
              ]
            }
          ]
        },
        "value": {
          "type": "number"
        }
      }
    },
    "css-length-or-percentage": {
      "oneOf": [
        {
          "type": "object",
          "required": [
            "unit",
            "value"
          ],
          "additionalProperties": false,
          "properties": {
            "unit": {
              "oneOf": [
                {
                  "enum": [
                    "px",
                    "cm",
                    "mm",
                    "q",
                    "in",
                    "pt",
                    "pc"
                  ]
                },
                {
                  "enum": [
                    "em",
                    "ex",
                    "ch",
                    "rem",
                    "vw",
                    "vh",
                    "vmin",
                    "vmax"
                  ]
                }
              ]
            },
            "value": {
              "type": "number"
            }
          }
        },
        {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "value": {
              "type": "number"
            },
            "unit": {
              "enum": [
                "%"
              ]
            }
          }
        }
      ]
    },
    "css-byte": {
      "type": "number",
      "default": 0,
      "multipleOf": 1,
      "minimum": 0,
      "maximum": 255
    },
    "css-color": {
      "type": "object",
      "required": [
        "red",
        "green",
        "blue",
        "alpha"
      ],
      "additionalProperties": false,
      "properties": {
        "red": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": 0,
          "maximum": 255
        },
        "green": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": 0,
          "maximum": 255
        },
        "blue": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": 0,
          "maximum": 255
        },
        "alpha": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "css-box-shadow": {
      "type": "array",
      "items": {
        "required": [
          "inset",
          "offsetX",
          "offsetY",
          "blurRadius",
          "spreadRadius",
          "color"
        ],
        "additionalProperties": false,
        "properties": {
          "inset": {
            "type": "boolean",
            "additionalProperties": false
          },
          "offsetX": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "offsetY": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "blurRadius": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "spreadRadius": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "color": {
            "type": "object",
            "required": [
              "red",
              "green",
              "blue",
              "alpha"
            ],
            "additionalProperties": false,
            "properties": {
              "red": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "green": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "blue": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "alpha": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            }
          }
        }
      },
      "minItems": 1
    },
    "css-border-radius": {
      "type": "object",
      "required": [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
      ],
      "additionalProperties": false,
      "properties": {
        "topLeft": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "topRight": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "bottomLeft": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "bottomRight": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        }
      }
    },
    "css-br-width": {
      "oneOf": [
        {
          "type": "object",
          "required": [
            "unit",
            "value"
          ],
          "additionalProperties": false,
          "properties": {
            "unit": {
              "oneOf": [
                {
                  "enum": [
                    "px",
                    "cm",
                    "mm",
                    "q",
                    "in",
                    "pt",
                    "pc"
                  ]
                },
                {
                  "enum": [
                    "em",
                    "ex",
                    "ch",
                    "rem",
                    "vw",
                    "vh",
                    "vmin",
                    "vmax"
                  ]
                }
              ]
            },
            "value": {
              "type": "number"
            }
          }
        }
      ]
    },
    "css-border-width": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            }
          ]
        },
        "right": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            }
          ]
        },
        "bottom": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            }
          ]
        },
        "left": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            }
          ]
        }
      }
    },
    "css-br-style": {
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ]
    },
    "css-border-style": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "right": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "bottom": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        },
        "left": {
          "enum": [
            "none",
            "hidden",
            "dotted",
            "dashed",
            "solid",
            "double",
            "groove",
            "ridge",
            "inset",
            "outset"
          ]
        }
      }
    },
    "css-border-color": {
      "type": "object",
      "required": [
        "top",
        "right",
        "bottom",
        "left"
      ],
      "additionalProperties": false,
      "properties": {
        "top": {
          "type": "object",
          "required": [
            "red",
            "green",
            "blue",
            "alpha"
          ],
          "additionalProperties": false,
          "properties": {
            "red": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "green": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "blue": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "alpha": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        },
        "right": {
          "type": "object",
          "required": [
            "red",
            "green",
            "blue",
            "alpha"
          ],
          "additionalProperties": false,
          "properties": {
            "red": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "green": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "blue": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "alpha": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        },
        "bottom": {
          "type": "object",
          "required": [
            "red",
            "green",
            "blue",
            "alpha"
          ],
          "additionalProperties": false,
          "properties": {
            "red": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "green": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "blue": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "alpha": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        },
        "left": {
          "type": "object",
          "required": [
            "red",
            "green",
            "blue",
            "alpha"
          ],
          "additionalProperties": false,
          "properties": {
            "red": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "green": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "blue": {
              "type": "number",
              "default": 0,
              "multipleOf": 1,
              "minimum": 0,
              "maximum": 255
            },
            "alpha": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          }
        }
      }
    },
    "css-border": {
      "type": "object",
      "required": [
        "width",
        "style",
        "color"
      ],
      "additionalProperties": false,
      "properties": {
        "width": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "right": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "bottom": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "left": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            }
          }
        },
        "style": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "right": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "bottom": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "left": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            }
          }
        },
        "color": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "right": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "bottom": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "left": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            }
          }
        }
      }
    },
    "cssBorder": {
      "type": "object",
      "required": [
        "width",
        "style",
        "color"
      ],
      "additionalProperties": false,
      "properties": {
        "width": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "right": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "bottom": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            },
            "left": {
              "oneOf": [
                {
                  "type": "object",
                  "required": [
                    "unit",
                    "value"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "unit": {
                      "oneOf": [
                        {
                          "enum": [
                            "px",
                            "cm",
                            "mm",
                            "q",
                            "in",
                            "pt",
                            "pc"
                          ]
                        },
                        {
                          "enum": [
                            "em",
                            "ex",
                            "ch",
                            "rem",
                            "vw",
                            "vh",
                            "vmin",
                            "vmax"
                          ]
                        }
                      ]
                    },
                    "value": {
                      "type": "number"
                    }
                  }
                }
              ]
            }
          }
        },
        "style": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "right": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "bottom": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            },
            "left": {
              "enum": [
                "none",
                "hidden",
                "dotted",
                "dashed",
                "solid",
                "double",
                "groove",
                "ridge",
                "inset",
                "outset"
              ]
            }
          }
        },
        "color": {
          "type": "object",
          "required": [
            "top",
            "right",
            "bottom",
            "left"
          ],
          "additionalProperties": false,
          "properties": {
            "top": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "right": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "bottom": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            },
            "left": {
              "type": "object",
              "required": [
                "red",
                "green",
                "blue",
                "alpha"
              ],
              "additionalProperties": false,
              "properties": {
                "red": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "green": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "blue": {
                  "type": "number",
                  "default": 0,
                  "multipleOf": 1,
                  "minimum": 0,
                  "maximum": 255
                },
                "alpha": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                }
              }
            }
          }
        }
      }
    },
    "cssBorderRadius": {
      "type": "object",
      "required": [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
      ],
      "additionalProperties": false,
      "properties": {
        "topLeft": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "topRight": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "bottomLeft": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        },
        "bottomRight": {
          "oneOf": [
            {
              "type": "object",
              "required": [
                "unit",
                "value"
              ],
              "additionalProperties": false,
              "properties": {
                "unit": {
                  "oneOf": [
                    {
                      "enum": [
                        "px",
                        "cm",
                        "mm",
                        "q",
                        "in",
                        "pt",
                        "pc"
                      ]
                    },
                    {
                      "enum": [
                        "em",
                        "ex",
                        "ch",
                        "rem",
                        "vw",
                        "vh",
                        "vmin",
                        "vmax"
                      ]
                    }
                  ]
                },
                "value": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "value": {
                  "type": "number"
                },
                "unit": {
                  "enum": [
                    "%"
                  ]
                }
              }
            }
          ]
        }
      }
    },
    "cssBoxShadow": {
      "type": "array",
      "items": {
        "required": [
          "inset",
          "offsetX",
          "offsetY",
          "blurRadius",
          "spreadRadius",
          "color"
        ],
        "additionalProperties": false,
        "properties": {
          "inset": {
            "type": "boolean",
            "additionalProperties": false
          },
          "offsetX": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "offsetY": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "blurRadius": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "spreadRadius": {
            "type": "object",
            "required": [
              "unit",
              "value"
            ],
            "additionalProperties": false,
            "properties": {
              "unit": {
                "oneOf": [
                  {
                    "enum": [
                      "px",
                      "cm",
                      "mm",
                      "q",
                      "in",
                      "pt",
                      "pc"
                    ]
                  },
                  {
                    "enum": [
                      "em",
                      "ex",
                      "ch",
                      "rem",
                      "vw",
                      "vh",
                      "vmin",
                      "vmax"
                    ]
                  }
                ]
              },
              "value": {
                "type": "number"
              }
            }
          },
          "color": {
            "type": "object",
            "required": [
              "red",
              "green",
              "blue",
              "alpha"
            ],
            "additionalProperties": false,
            "properties": {
              "red": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "green": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "blue": {
                "type": "number",
                "default": 0,
                "multipleOf": 1,
                "minimum": 0,
                "maximum": 255
              },
              "alpha": {
                "type": "number",
                "minimum": 0,
                "maximum": 1
              }
            }
          }
        }
      },
      "minItems": 1
    },
    "cssStyle": {
      "type": "object",
      "properties": {
        "cssBorder": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "required": [
                "width",
                "style",
                "color"
              ],
              "additionalProperties": false,
              "properties": {
                "width": {
                  "type": "object",
                  "required": [
                    "top",
                    "right",
                    "bottom",
                    "left"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "top": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        }
                      ]
                    },
                    "right": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        }
                      ]
                    },
                    "bottom": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        }
                      ]
                    },
                    "left": {
                      "oneOf": [
                        {
                          "type": "object",
                          "required": [
                            "unit",
                            "value"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "unit": {
                              "oneOf": [
                                {
                                  "enum": [
                                    "px",
                                    "cm",
                                    "mm",
                                    "q",
                                    "in",
                                    "pt",
                                    "pc"
                                  ]
                                },
                                {
                                  "enum": [
                                    "em",
                                    "ex",
                                    "ch",
                                    "rem",
                                    "vw",
                                    "vh",
                                    "vmin",
                                    "vmax"
                                  ]
                                }
                              ]
                            },
                            "value": {
                              "type": "number"
                            }
                          }
                        }
                      ]
                    }
                  }
                },
                "style": {
                  "type": "object",
                  "required": [
                    "top",
                    "right",
                    "bottom",
                    "left"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "top": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "right": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "bottom": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    },
                    "left": {
                      "enum": [
                        "none",
                        "hidden",
                        "dotted",
                        "dashed",
                        "solid",
                        "double",
                        "groove",
                        "ridge",
                        "inset",
                        "outset"
                      ]
                    }
                  }
                },
                "color": {
                  "type": "object",
                  "required": [
                    "top",
                    "right",
                    "bottom",
                    "left"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "top": {
                      "type": "object",
                      "required": [
                        "red",
                        "green",
                        "blue",
                        "alpha"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "red": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "green": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "blue": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "alpha": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      }
                    },
                    "right": {
                      "type": "object",
                      "required": [
                        "red",
                        "green",
                        "blue",
                        "alpha"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "red": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "green": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "blue": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "alpha": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      }
                    },
                    "bottom": {
                      "type": "object",
                      "required": [
                        "red",
                        "green",
                        "blue",
                        "alpha"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "red": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "green": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "blue": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "alpha": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      }
                    },
                    "left": {
                      "type": "object",
                      "required": [
                        "red",
                        "green",
                        "blue",
                        "alpha"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "red": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "green": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "blue": {
                          "type": "number",
                          "default": 0,
                          "multipleOf": 1,
                          "minimum": 0,
                          "maximum": 255
                        },
                        "alpha": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      }
                    }
                  }
                }
              }
            }
          ]
        },
        "cssBoxShadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "array",
              "items": {
                "required": [
                  "inset",
                  "offsetX",
                  "offsetY",
                  "blurRadius",
                  "spreadRadius",
                  "color"
                ],
                "additionalProperties": false,
                "properties": {
                  "inset": {
                    "type": "boolean",
                    "additionalProperties": false
                  },
                  "offsetX": {
                    "type": "object",
                    "required": [
                      "unit",
                      "value"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "unit": {
                        "oneOf": [
                          {
                            "enum": [
                              "px",
                              "cm",
                              "mm",
                              "q",
                              "in",
                              "pt",
                              "pc"
                            ]
                          },
                          {
                            "enum": [
                              "em",
                              "ex",
                              "ch",
                              "rem",
                              "vw",
                              "vh",
                              "vmin",
                              "vmax"
                            ]
                          }
                        ]
                      },
                      "value": {
                        "type": "number"
                      }
                    }
                  },
                  "offsetY": {
                    "type": "object",
                    "required": [
                      "unit",
                      "value"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "unit": {
                        "oneOf": [
                          {
                            "enum": [
                              "px",
                              "cm",
                              "mm",
                              "q",
                              "in",
                              "pt",
                              "pc"
                            ]
                          },
                          {
                            "enum": [
                              "em",
                              "ex",
                              "ch",
                              "rem",
                              "vw",
                              "vh",
                              "vmin",
                              "vmax"
                            ]
                          }
                        ]
                      },
                      "value": {
                        "type": "number"
                      }
                    }
                  },
                  "blurRadius": {
                    "type": "object",
                    "required": [
                      "unit",
                      "value"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "unit": {
                        "oneOf": [
                          {
                            "enum": [
                              "px",
                              "cm",
                              "mm",
                              "q",
                              "in",
                              "pt",
                              "pc"
                            ]
                          },
                          {
                            "enum": [
                              "em",
                              "ex",
                              "ch",
                              "rem",
                              "vw",
                              "vh",
                              "vmin",
                              "vmax"
                            ]
                          }
                        ]
                      },
                      "value": {
                        "type": "number"
                      }
                    }
                  },
                  "spreadRadius": {
                    "type": "object",
                    "required": [
                      "unit",
                      "value"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "unit": {
                        "oneOf": [
                          {
                            "enum": [
                              "px",
                              "cm",
                              "mm",
                              "q",
                              "in",
                              "pt",
                              "pc"
                            ]
                          },
                          {
                            "enum": [
                              "em",
                              "ex",
                              "ch",
                              "rem",
                              "vw",
                              "vh",
                              "vmin",
                              "vmax"
                            ]
                          }
                        ]
                      },
                      "value": {
                        "type": "number"
                      }
                    }
                  },
                  "color": {
                    "type": "object",
                    "required": [
                      "red",
                      "green",
                      "blue",
                      "alpha"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "red": {
                        "type": "number",
                        "default": 0,
                        "multipleOf": 1,
                        "minimum": 0,
                        "maximum": 255
                      },
                      "green": {
                        "type": "number",
                        "default": 0,
                        "multipleOf": 1,
                        "minimum": 0,
                        "maximum": 255
                      },
                      "blue": {
                        "type": "number",
                        "default": 0,
                        "multipleOf": 1,
                        "minimum": 0,
                        "maximum": 255
                      },
                      "alpha": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 1
                      }
                    }
                  }
                }
              },
              "minItems": 1
            }
          ]
        },
        "cssBorderRadius": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "required": [
                "topLeft",
                "topRight",
                "bottomLeft",
                "bottomRight"
              ],
              "additionalProperties": false,
              "properties": {
                "topLeft": {
                  "oneOf": [
                    {
                      "type": "object",
                      "required": [
                        "unit",
                        "value"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      }
                    }
                  ]
                },
                "topRight": {
                  "oneOf": [
                    {
                      "type": "object",
                      "required": [
                        "unit",
                        "value"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      }
                    }
                  ]
                },
                "bottomLeft": {
                  "oneOf": [
                    {
                      "type": "object",
                      "required": [
                        "unit",
                        "value"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      }
                    }
                  ]
                },
                "bottomRight": {
                  "oneOf": [
                    {
                      "type": "object",
                      "required": [
                        "unit",
                        "value"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "unit": {
                          "oneOf": [
                            {
                              "enum": [
                                "px",
                                "cm",
                                "mm",
                                "q",
                                "in",
                                "pt",
                                "pc"
                              ]
                            },
                            {
                              "enum": [
                                "em",
                                "ex",
                                "ch",
                                "rem",
                                "vw",
                                "vh",
                                "vmin",
                                "vmax"
                              ]
                            }
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "unit": {
                          "enum": [
                            "%"
                          ]
                        }
                      }
                    }
                  ]
                }
              }
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "LayersEffect": {
      "type": "object",
      "required": [
        "size"
      ],
      "properties": {
        "size": {
          "type": "number",
          "minimum": 1,
          "maximum": 10
        },
        "y": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "x": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "pin": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "additionalProperties": false
    },
    "dataChangeBehaviors": {
      "type": [
        "array",
        "null"
      ],
      "items": {
        "type": "object",
        "properties": {
          "trigger": {
            "type": "string"
          },
          "type": {
            "type": "string"
          },
          "part": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "params": {
            "type": "object"
          }
        },
        "additionalProperties": false
      }
    },
    "BackgroundMedia": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mediaRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": {
          "type": "number"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ],
          "default": "WixVideo"
        },
        "imageOverlay": {
          "type": [
            "null",
            "string"
          ]
        },
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": {
          "type": "number"
        },
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": {
              "type": "string"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "saturate": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "saturation": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "hue": {
              "type": "number",
              "minimum": -180,
              "maximum": 180
            },
            "duotoneDark": {
              "type": "string"
            },
            "duotoneLight": {
              "type": "string"
            },
            "invert": {
              "type": "boolean",
              "default": false
            },
            "isCustom": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "BlendMode": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "darken",
        "lighten",
        "overlay",
        "colorDodge",
        "colorBurn",
        "hardLight",
        "softLight",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ]
    },
    "Shadow": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "spreadRadius": {
          "type": "number"
        },
        "blurRadius": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "color": {
          "type": "string",
          "description": "Hex or RGB color"
        }
      },
      "additionalProperties": false
    },
    "filterEffect": {
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "effectType": {
          "type": "string",
          "enum": [
            "none",
            "normal",
            "ink",
            "kennedy",
            "feathered",
            "blur",
            "whistler",
            "3d",
            "blueray",
            "lighten",
            "darken",
            "pinkrinse",
            "redrum",
            "greenwash",
            "yellowstreak",
            "neonsky",
            "seaweed",
            "soledad",
            "sangria",
            "malibu",
            "candyfloss",
            "elmo",
            "unicorn",
            "kerouac",
            "koolaid",
            "hydra",
            "pixie",
            "nightrain",
            "bauhaus",
            "neptune",
            "orca",
            "manhattan",
            "goldie",
            "flamingo",
            "faded",
            "gotham",
            "hulk",
            "midnight",
            "lucille",
            "organic",
            "grayscale",
            "tvDuotone",
            "tvMonotoneDark",
            "tvMonotoneLight",
            "tvHue"
          ]
        },
        "brightness": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "saturation": {
          "type": "number",
          "minimum": 0,
          "maximum": 10
        },
        "hue": {
          "type": "number",
          "minimum": -180,
          "maximum": 180
        },
        "duotoneDark": {
          "type": "string"
        },
        "duotoneLight": {
          "type": "string"
        },
        "invert": {
          "type": "boolean",
          "default": false
        },
        "isCustom": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "overlayBlending": {
      "type": "object",
      "properties": {
        "color": {
          "type": "string"
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "contrast": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "saturate": {
          "type": "number",
          "minimum": 0,
          "maximum": 2
        },
        "blendMode": {
          "type": "string",
          "enum": [
            "normal",
            "multiply",
            "screen",
            "darken",
            "lighten",
            "overlay",
            "colorDodge",
            "colorBurn",
            "hardLight",
            "softLight",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
          ]
        }
      },
      "additionalProperties": false
    },
    "BackgroundTransforms": {
      "type": "object",
      "properties": {
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "additionalProperties": false
    },
    "ImageMask": {
      "type": "object",
      "description": "CSS mask using an image",
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "y": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "width": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "maximum": 100
        },
        "svgId": {
          "type": "string"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "description": "Defines whether the mask is flipped on the v or h axis"
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "mode": {
          "type": "string",
          "enum": [
            "alpha",
            "luminance"
          ],
          "default": "alpha"
        }
      },
      "additionalProperties": false
    },
    "WixVideo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number"
        },
        "loop": {
          "type": "boolean"
        },
        "autoplay": {
          "type": "boolean"
        },
        "playbackSpeed": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": {
          "type": "boolean",
          "description": "deprecated, moved to properties"
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "opacity": {
          "type": "number"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mediaFeatures": {
          "description": "Annotate which features does this video have, for example 'media is a video with alpha'",
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "array",
              "items": {
                "type": "string",
                "enum": [
                  "alpha",
                  "360"
                ]
              }
            }
          ]
        },
        "mask": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "description": "CSS mask using an image",
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ],
                  "default": "alpha"
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "focalPoint": {
          "type": "object",
          "required": [
            "x",
            "y"
          ],
          "properties": {
            "x": {
              "type": "number",
              "minimum": 0
            },
            "y": {
              "type": "number",
              "minimum": 0
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Video": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "videoId": {
          "type": "string"
        },
        "userId": {
          "type": "string"
        },
        "posterImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ],
          "default": "YOUTUBE"
        }
      }
    },
    "RepeatedData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "original": {
          "type": "object",
          "description": "the original data item of a component inside a repeater according to the specific component schema"
        },
        "overrides": {
          "type": "object",
          "description": "a map from itemId in a repeater to its data item according to the specific component schema"
        }
      }
    },
    "Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "description": "Original Image before edit",
          "type": [
            "null",
            "string"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "description": "Information about the artist of the image.",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "MediaControlsDesignData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "iconsDefaultDesign": {
          "description": "VectorImageDesignData reference to design all icons",
          "type": [
            "null",
            "string"
          ]
        },
        "icons": {
          "description": "ControlIconDesignData references",
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "iconDesign": {}
      }
    },
    "ControlIconDesignData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 50
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "iconDesign": {
          "description": "VectorImageDesignData reference to override the default design",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "VectorImageDesignData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "shadow": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "properties": {
                "x": {
                  "type": "number"
                },
                "y": {
                  "type": "number"
                },
                "spreadRadius": {
                  "type": "number"
                },
                "blurRadius": {
                  "type": "number",
                  "minimum": 0
                },
                "opacity": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "color": {
                  "type": "string",
                  "description": "Hex or RGB color"
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "shapeStyle": {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "strokeWidth": {
              "type": "number"
            },
            "fill": {
              "type": "string"
            },
            "fillOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "stroke": {
              "type": "string"
            },
            "strokeOpacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "enableStroke": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "overrideColors": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 1,
              "properties": {
                "color1": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color2": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color3": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color4": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color5": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color6": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color7": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "color8": {
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "GradientMesh": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GradientMesh"
          ]
        },
        "gradients": {
          "type": "array",
          "items": {
            "type": "object",
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientLinear"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "angle": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "oneOf": [
                      {
                        "required": [
                          "value",
                          "type"
                        ]
                      },
                      {
                        "required": [
                          "keyword"
                        ]
                      },
                      {
                        "required": [],
                        "maxProperties": 0
                      }
                    ],
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientEllipse"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "oneOf": [
                      {
                        "required": [
                          "width",
                          "height"
                        ]
                      },
                      {
                        "required": [
                          "keyword"
                        ]
                      }
                    ],
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "width": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "height": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientConic"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "angle": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "deg",
                                "percentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    },
    "GradientLinearLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientCircleLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "value",
                    "type"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                },
                {
                  "required": [],
                  "maxProperties": 0
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientEllipseLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "width",
                    "height"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientMeshLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "oneOf": [
                      {
                        "required": [
                          "value",
                          "type"
                        ]
                      },
                      {
                        "required": [
                          "keyword"
                        ]
                      },
                      {
                        "required": [],
                        "maxProperties": 0
                      }
                    ],
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientConicLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SolidColorLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      }
    }
  },
  "discussions.json": {
    "$id": "urn:dm:schemas:discussions.json",
    "Discussions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "discussions": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 100
          },
          "default": []
        }
      },
      "required": [
        "discussions"
      ]
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "document_data.json": {
    "$id": "urn:dm:schemas:document_data.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "vars": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "value": {
                "type": "string",
                "maxLength": 100
              },
              "type": {
                "type": "string",
                "enum": [
                  "AppPartParam"
                ]
              }
            }
          }
        },
        "appDefId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "SVGItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "SVGReference": {
      "type": [
        "null",
        "string"
      ]
    },
    "BackgroundImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string"
        },
        "positionx": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "center"
        },
        "imagesizew": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "imagesizeh": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "positiony": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ],
          "default": "center"
        },
        "width": {
          "type": "string"
        },
        "repeatx": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "repeaty": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "attachment": {
          "type": "string",
          "enum": [
            "scroll",
            "fixed",
            "inherit",
            "local"
          ],
          "default": "inherit"
        },
        "color": {
          "type": "string"
        }
      }
    },
    "BackgroundMedia": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mediaRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": {
          "type": "number"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ],
          "default": "WixVideo"
        },
        "imageOverlay": {
          "type": [
            "null",
            "string"
          ]
        },
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": {
          "type": "number"
        },
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": {
              "type": "string"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "saturate": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "saturation": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "hue": {
              "type": "number",
              "minimum": -180,
              "maximum": 180
            },
            "duotoneDark": {
              "type": "string"
            },
            "duotoneLight": {
              "type": "string"
            },
            "invert": {
              "type": "boolean",
              "default": false
            },
            "isCustom": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "WixVideo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "loop": {
          "type": "boolean"
        },
        "autoplay": {
          "type": "boolean"
        },
        "playbackSpeed": {
          "type": "number"
        },
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": {
          "type": "boolean",
          "description": "deprecated, moved to properties"
        },
        "opacity": {
          "type": "number"
        },
        "mediaFeatures": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "alpha"
            ]
          }
        },
        "mask": {
          "anyOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "description": "CSS mask using an image",
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ],
                  "default": "alpha"
                }
              },
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "WixVideoData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Document": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "siteName": {
          "type": "string",
          "maxLength": 1000
        },
        "usedFonts": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 1000
          }
        },
        "characterSets": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "renderModifiers": {
          "type": "object"
        },
        "name": {
          "type": "string"
        },
        "mainPage": {
          "type": [
            "null",
            "string"
          ]
        },
        "mainPageId": {
          "type": "string"
        },
        "smSettings": {
          "type": [
            "object"
          ],
          "additionalProperties": false,
          "properties": {
            "socialLoginGoogleEnabled": {
              "type": "boolean"
            },
            "socialLoginFacebookEnabled": {
              "type": "boolean"
            },
            "privacyNoteType": {
              "type": "string",
              "enum": [
                "CHECKBOX",
                "NOTE"
              ]
            },
            "joinCommunityCheckedByDefault": {
              "type": "boolean"
            },
            "customSignUpPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "customSignInPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "customNoPermissionsPageId": {
              "type": [
                "string"
              ]
            },
            "termsOfUse": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "privacyPolicy": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "codeOfConduct": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "smFirstDialogLogin": {
              "type": [
                "boolean",
                "null"
              ]
            }
          }
        },
        "styleSettings": {
          "type": "object",
          "properties": {
            "stylesPerPage": {
              "type": "string",
              "maxLength": 20
            }
          },
          "additionalProperties": false
        },
        "accessibilitySettings": {
          "type": "object",
          "properties": {
            "visualFocusDisabled": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "skipToContent": {
              "default": true,
              "type": [
                "boolean",
                "null"
              ]
            },
            "isRtlSupportEnabled": {
              "default": false,
              "type": [
                "boolean",
                "null"
              ]
            },
            "currentSiteDirection": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ]
            }
          },
          "additionalProperties": false
        },
        "mobileSettings": {
          "type": "object",
          "properties": {
            "animationsEnabled": {
              "type": [
                "boolean",
                "null"
              ]
            }
          },
          "additionalProperties": false
        },
        "layoutSettings": {
          "type": "object",
          "properties": {
            "useDesktopSectionsLayout": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "isFluid": {
              "type": [
                "boolean"
              ]
            },
            "headerToPagesGap": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            },
            "pagesToFooterGap": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            },
            "mechanism": {
              "type": [
                "string"
              ],
              "enum": [
                "mesh",
                "anchors"
              ]
            },
            "soapCompsAroundPagesContainer": {
              "type": [
                "boolean",
                "null"
              ]
            }
          },
          "additionalProperties": false
        },
        "appStudioData": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean"
          ]
        },
        "anchorLockThreshold": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "supportMobile": {
          "type": "boolean"
        },
        "autoDomReorder": {
          "type": "boolean"
        },
        "appsInstallState": {
          "type": [
            "null",
            "string"
          ]
        },
        "usesNewAnimations": {
          "type": "boolean"
        }
      }
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "skipToContent": {
          "default": true,
          "type": [
            "boolean",
            "null"
          ]
        },
        "isRtlSupportEnabled": {
          "default": false,
          "type": [
            "boolean",
            "null"
          ]
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "pagesToFooterGap": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      },
      "additionalProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "smFirstDialogLogin": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppStudioData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "widgets": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "codePackages": {
          "maxItems": 1,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "panels": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "dependencies": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "appDefId"
            ],
            "properties": {
              "appDefId": {
                "type": "string",
                "maxLength": 100
              },
              "dependencyData": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "PROVISION_ONLY_INSTALLATION",
                    "NOTIFY_USER_ON_DEPENDENCY",
                    "IS_BUNDLE"
                  ]
                }
              }
            }
          }
        },
        "dashboards": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "customDefinitions": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "ssrCache": {
          "type": "boolean"
        }
      }
    },
    "CodePackagesDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayName": {
          "type": "string",
          "maxLength": 30,
          "minLength": 1
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "minLength": 3
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true
    },
    "CustomDefinitionDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "structure": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "$id",
              "title",
              "description",
              "default",
              "propertiesOrder"
            ],
            "properties": {
              "$id": {
                "type": "string"
              },
              "type": {
                "type": "string",
                "default": "object"
              },
              "title": {
                "type": "string"
              },
              "description": {
                "type": "string"
              },
              "properties": {
                "type": "object",
                "additionalProperties": {
                  "additionalProperties": true
                }
              },
              "default": {
                "type": "object",
                "default": {}
              },
              "propertiesOrder": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "default": []
              }
            }
          }
        }
      }
    },
    "WidgetDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "devCenterWidgetId": {
          "type": [
            "string",
            "null"
          ]
        },
        "devCenterEditorReactComponentId": {
          "type": [
            "string",
            "null"
          ]
        },
        "kind": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "container",
            "section"
          ]
        },
        "panels": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "defaultSize": {
          "type": [
            "object",
            "null"
          ],
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        },
        "variations": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "presets": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "plugin": {
          "type": "object",
          "properties": {
            "placements": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "appDefinitionId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "widgetId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "slotId": {
                    "type": "string",
                    "maxLength": 100
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "containedWidgets": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "widgetApi": {
          "type": "object",
          "default": {},
          "properties": {
            "functions": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "required": [
                  "name"
                ],
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "params": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "name": {
                          "type": "string"
                        },
                        "description": {
                          "type": [
                            "string",
                            "null"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "returnsDescription": {
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "propertiesSchemas": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "properties": {
                  "structure": {
                    "type": "object",
                    "additionalProperties": {
                      "additionalProperties": true
                    },
                    "default": {}
                  }
                },
                "additionalProperties": false
              }
            },
            "events": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "required": [
                  "name"
                ],
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "args": {
                    "type": "array",
                    "items": {
                      "properties": {
                        "name": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "structureRef": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "rootCompId": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "compType": {
          "type": "string"
        }
      }
    },
    "DashboardDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "routePath": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideInSidebar": {
          "type": "boolean"
        },
        "activeSidebarPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "isRoutePathConnectedToTitle": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "PanelDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "devCenterPanelId": {
          "type": [
            "string",
            "null"
          ]
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "kind": {
          "type": "string",
          "enum": [
            "settings"
          ]
        },
        "helpId": {
          "type": "string",
          "maxLength": 100
        },
        "pageUrl": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2048
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "VariationDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "PresetDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "presetId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      }
    },
    "FlatTheme": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "font": {
          "type": "string",
          "format": "font-family",
          "default": "Arial,sans-serif"
        },
        "bgId": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "bgSize": {
          "type": "string",
          "default": ","
        },
        "bgType": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "siteBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "mobileBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "siteBgColor": {
          "default": "0,0,0,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerTextColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerBgColor": {
          "default": "0,0,0,0",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "areaBgColor": {
          "default": "130,81,13,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "iconBgColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "borderColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fontHeader": {
          "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
          "type": [
            "string"
          ]
        },
        "fontTitle": {
          "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontSubTitle": {
          "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontButton": {
          "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
          "type": [
            "string"
          ]
        },
        "fontText": {
          "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontSmallText": {
          "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "borderContainer": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderThumb": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderButton": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderIcon": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "radiusContainer": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusThumb": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusButton": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusIcon": {
          "default": "0.6em 0.0em 0.0em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding1": {
          "default": "1em 1em 1em 1em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "default": "0.0em 0.5em 0.0em 0.5em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "default": "1.0em 0.0em 1.0em 0.0em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "default": "3.2",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "default": "1.5",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "default": "0em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "default": "0.45em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "default": "0.23em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        }
      }
    },
    "Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "description": "Original Image before edit",
          "type": [
            "null",
            "string"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "description": "Information about the artist of the image.",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ImageA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageReference": {
      "type": [
        "null",
        "string"
      ]
    },
    "GlobalImageQuality": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "quality": {
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "unsharpMask": {
          "type": "object",
          "minProperties": 3,
          "additionalProperties": false,
          "properties": {
            "radius": {
              "type": "number",
              "minimum": 0,
              "maximum": 500
            },
            "amount": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "threshold": {
              "type": "number",
              "minimum": 0,
              "maximum": 255
            }
          }
        }
      }
    },
    "ImageQuality": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "quality": {
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "unsharpMask": {
          "type": "object",
          "minProperties": 3,
          "additionalProperties": false,
          "properties": {
            "radius": {
              "type": "number",
              "minimum": 0,
              "maximum": 500
            },
            "amount": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "threshold": {
              "type": "number",
              "minimum": 0,
              "maximum": 255
            }
          }
        }
      }
    },
    "ClassicSectionA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "type": "number"
        }
      }
    },
    "StripColumnsContainerA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        }
      }
    },
    "StripColumnsContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ClassicSection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StripContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ImageList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "Link": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      }
    },
    "TextLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      }
    },
    "AnchorLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "anchorName": {
          "type": "string"
        },
        "anchorDataId": {
          "anyOf": [
            {
              "type": [
                "null",
                "string"
              ]
            },
            {
              "enum": [
                "SCROLL_TO_TOP"
              ]
            }
          ]
        },
        "pageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "DocumentLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "docId": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "indexable": {
          "type": "boolean"
        }
      }
    },
    "PhoneLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WhatsAppLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "AddressLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "address": {
          "type": "string",
          "maxLength": 200
        }
      }
    },
    "EmailLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "recipient": {
          "type": "string",
          "description": "Email address of the recipient."
        },
        "subject": {
          "type": "string",
          "description": "Subject of the email."
        },
        "body": {
          "type": "string",
          "description": "Body or content of the email."
        }
      }
    },
    "FormSubmitButtonLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ExternalLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "allOf": [
            {
              "type": "string"
            },
            {
              "not": {
                "type": "string",
                "pattern": ".*script://.*"
              }
            }
          ],
          "description": "URL of the external link."
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_blank",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "default": [
            "noreferrer",
            "noopener"
          ],
          "description": "Specifies the relationship between the current document and the linked document.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      }
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "routerId": {
          "type": "string"
        },
        "innerRoute": {
          "type": "string"
        },
        "anchorDataId": {
          "type": [
            "null",
            "string"
          ]
        },
        "isTpaRoute": {
          "type": "boolean"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "TpaPageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemTypeIdentifier": {
          "type": "string"
        },
        "itemId": {
          "type": "string"
        },
        "pageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "appDefinitionId": {
          "type": "string"
        },
        "path": {
          "type": "string"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      },
      "required": [
        "itemTypeIdentifier",
        "itemId",
        "pageId",
        "appDefinitionId",
        "path"
      ]
    },
    "LoginToWixLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "postLoginUrl": {
          "type": "string"
        },
        "postSignupUrl": {
          "type": "string"
        },
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ],
          "default": "login"
        },
        "sendMail": {
          "type": "boolean",
          "default": true
        },
        "mailTemplate": {
          "type": "string"
        },
        "userColor": {
          "type": "string"
        },
        "loginCompName": {
          "type": "string",
          "default": ""
        }
      }
    },
    "PageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pageId": {
          "description": "Page ID of the page to link to.",
          "type": [
            "null",
            "string"
          ]
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "description": "Specifies the relationship between the current document and the linked document.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "MediaRichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "componentDataList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "Page": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideTitle": {
          "type": "boolean"
        },
        "icon": {
          "type": "string"
        },
        "windowTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "descriptionSEO": {
          "type": "string",
          "maxLength": 1024
        },
        "advancedSeoData": {
          "type": "string",
          "maxLength": 10000
        },
        "metaKeywordsSEO": {
          "type": "string",
          "maxLength": 512
        },
        "pageTitleSEO": {
          "type": "string"
        },
        "pageUriSEO": {
          "type": "string"
        },
        "hidePage": {
          "type": "boolean"
        },
        "underConstruction": {
          "type": "boolean"
        },
        "tpaApplicationId": {
          "type": "number"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "managingAppDefId": {
          "type": [
            "string",
            "null"
          ]
        },
        "tpaPageId": {
          "type": "string"
        },
        "parentPageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSecurity": {
          "type": [
            "object",
            "null"
          ],
          "default": {
            "requireLogin": false,
            "passwordDigest": "",
            "dialogLanguage": ""
          }
        },
        "indexable": {
          "type": "boolean",
          "default": true
        },
        "mobileHidePage": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ],
                  "default": "viewport"
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isMobileLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isPopup": {
          "type": "boolean",
          "default": false
        },
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "ogImage": {
          "type": [
            "string",
            "null"
          ]
        },
        "ogImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        }
      }
    },
    "Text": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 4000
        }
      }
    },
    "RichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": ""
        },
        "defaultStyle": {
          "type": "string"
        }
      }
    },
    "RichTextImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": [
            "null",
            "string"
          ]
        },
        "image": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "BaseInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "BaseTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "TextInputA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "invalid": {
          "type": "boolean"
        },
        "multiline": {
          "type": "boolean"
        },
        "autocomplete": {
          "type": "boolean"
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        }
      }
    },
    "TextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textType": {
          "type": "string",
          "default": "text",
          "enum": [
            "text",
            "email",
            "url",
            "number",
            "tel",
            "password"
          ],
          "description": "input data type"
        },
        "maxLength": {
          "type": [
            "number",
            "null"
          ],
          "description": "maximum number of characters allowed"
        },
        "min": {
          "type": [
            "number",
            "null"
          ],
          "minimum": -2147483648,
          "maximum": 2147483647,
          "description": "minimum allowed value for a numeric type field"
        },
        "max": {
          "type": [
            "number",
            "null"
          ],
          "minimum": -2147483648,
          "maximum": 2147483647,
          "description": "maximum allowed value for a numeric type field"
        },
        "pattern": {
          "type": [
            "string",
            "null"
          ],
          "description": "specifies a regular expression against which the control's value will be validate",
          "maxLength": 500
        },
        "phoneFormat": {
          "type": [
            "string",
            "null"
          ],
          "description": "specifies a phone number format against which the control's value will be validated",
          "pattern": "^#*(((#+-)*)#+$)",
          "maxLength": 100
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefix": {
          "type": [
            "null",
            "string"
          ],
          "maxLength": 10
        },
        "step": {
          "type": "number"
        },
        "autoComplete": {
          "type": [
            "null",
            "string"
          ],
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "TextAreaInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "maxLength": {
          "type": [
            "number"
          ],
          "description": "maximum number of characters allowed"
        },
        "label": {
          "type": [
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string"
          ],
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CheckboxInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "checked": {
          "description": "The checked status of the input",
          "type": "boolean",
          "default": false
        },
        "linkLabel": {
          "type": "string",
          "default": "",
          "maxLength": 1000
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "indeterminate": {
          "description": "Used for three state check box",
          "type": "boolean",
          "default": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "DateItem": {
      "type": "string",
      "format": "date-time"
    },
    "DateString": {
      "type": "string",
      "format": "date"
    },
    "DateRange": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "type": "string",
          "format": "date"
        },
        "endDate": {
          "type": "string",
          "format": "date"
        }
      }
    },
    "DateRanges": {
      "type": "array",
      "default": [],
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "startDate",
          "endDate"
        ],
        "properties": {
          "startDate": {
            "type": "string",
            "format": "date"
          },
          "endDate": {
            "type": "string",
            "format": "date"
          }
        }
      }
    },
    "DatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "disabledDates": {
          "type": "array",
          "items": {
            "type": "string",
            "format": "date-time"
          },
          "default": [],
          "description": "array of disabled dates"
        },
        "disabledDaysOfWeek": {
          "type": "array",
          "items": {
            "type": [
              "number"
            ],
            "enum": [
              0,
              1,
              2,
              3,
              4,
              5,
              6
            ]
          },
          "default": [],
          "description": "array of disabled days"
        },
        "minDate": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "format": "date-time"
            }
          ],
          "description": "date input minimum date value"
        },
        "maxDate": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "format": "date-time"
            }
          ],
          "description": "date input maximum date value"
        },
        "allowPastDates": {
          "type": "boolean",
          "default": true,
          "description": "if true all past days are enabled, false otherwise"
        },
        "allowFutureDates": {
          "type": "boolean",
          "default": true,
          "description": "if true all future days are enabled, false otherwise"
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 200,
          "description": "the placeholder option in case nothing is selected"
        },
        "enabledDateRanges": {
          "description": "array of enabled dates. each date in the format YYYY/MM/DD",
          "type": "array",
          "default": [],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startDate",
              "endDate"
            ],
            "properties": {
              "startDate": {
                "type": "string",
                "format": "date"
              },
              "endDate": {
                "type": "string",
                "format": "date"
              }
            }
          }
        },
        "disabledDateRanges": {
          "description": "array of disabled dates. each date in the format YYYY/MM/DD",
          "type": "array",
          "default": [],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startDate",
              "endDate"
            ],
            "properties": {
              "startDate": {
                "type": "string",
                "format": "date"
              },
              "endDate": {
                "type": "string",
                "format": "date"
              }
            }
          }
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "Theme": {
      "additionalProperties": false,
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "properties": {
          "type": [
            "object",
            "null"
          ],
          "default": {}
        }
      }
    },
    "TwitterFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "accountToFollow": {
          "type": "string",
          "default": "wix"
        }
      }
    },
    "TwitterTweet": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultText": {
          "type": "string"
        },
        "accountToFollow": {
          "type": "string"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "MobileMetaData": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      },
      "additionalProperties": false
    },
    "Preloader": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "SocialLink": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "QuickActions": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "id",
              "url"
            ],
            "properties": {
              "id": {
                "type": "string",
                "enum": [
                  "facebook",
                  "twitter",
                  "pinterest",
                  "google_plus",
                  "tumblr",
                  "blogger",
                  "linkedin",
                  "youtube",
                  "vimeo",
                  "flickr"
                ]
              },
              "url": {
                "type": "string",
                "default": ""
              }
            },
            "additionalProperties": false
          },
          "default": []
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "itemType": {
          "maxLength": 50,
          "type": "string"
        },
        "text": {
          "maxLength": 40,
          "type": "string",
          "default": ""
        },
        "icon": {
          "maxLength": 200,
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "itemType"
      ]
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      },
      "additionalProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "Anchor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "compId": {
          "type": "string"
        },
        "urlFragment": {
          "type": "string",
          "maxLength": 60
        }
      }
    },
    "BasicMenuItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "slot": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        },
        "isVisibleMobile": {
          "type": "boolean",
          "default": true
        },
        "displayCount": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "iconRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "CustomMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "menuType": {
          "type": "string",
          "maxLength": 100
        },
        "syncWithPages": {
          "type": "boolean",
          "default": false
        },
        "appId": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "appDefinitionId": {
          "type": "string"
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "CustomMenusCollection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menus": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "CustomMenuDataRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "CustomMenuDataRefA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "Menu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "FacebookLikeBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "facebookPageId": {
          "type": "string",
          "default": "wix",
          "description": "Facebook page id"
        },
        "showFaces": {
          "type": "boolean",
          "default": true,
          "description": "Show profile photos in the plugin"
        },
        "colorScheme": {
          "type": "string",
          "default": "light",
          "enum": [
            "light",
            "dark"
          ],
          "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
        },
        "showStream": {
          "type": "boolean",
          "default": true,
          "description": "Show the profile stream for the public profile"
        },
        "showBorder": {
          "type": "boolean",
          "default": true,
          "description": "Show a border around the plugin"
        },
        "showHeader": {
          "type": "boolean",
          "default": true,
          "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
        }
      }
    },
    "ImageButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "defaultImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "hoverImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "activeImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "NumericStepper": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "1"
        }
      }
    },
    "PinItPinWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pinId": {
          "type": "string",
          "default": "http://www.pinterest.com/pin/204421270560540859/"
        }
      }
    },
    "PinterestPinIt": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": "Check it out!"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "SingleAudioPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": "",
          "description": "MP3 uri"
        },
        "originalFileName": {
          "type": "string",
          "default": "",
          "description": "Original MP3 file name"
        },
        "artist": {
          "type": "string",
          "default": "Unknown Artist",
          "description": "Artist Name"
        },
        "track": {
          "type": "string",
          "default": "Unknown Track",
          "description": "Track Name"
        }
      }
    },
    "SkypeCallButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "skypeName": {
          "type": "string"
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "call",
            "chat"
          ],
          "default": "call"
        }
      }
    },
    "SpotifyFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      }
    },
    "SpotifyPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": "",
          "description": "Spotify URI"
        }
      }
    },
    "SubscribeForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "firstNameFieldLabel": {
          "type": "string",
          "default": "First Name"
        },
        "lastNameFieldLabel": {
          "type": "string",
          "default": "Last Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Mobile number"
        },
        "subscribeFormTitle": {
          "type": "string",
          "default": "Subscribe for Updates"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Subscribe Now"
        },
        "successMessage": {
          "type": "string",
          "default": "Congrats! You’re subscribed"
        },
        "errorMessage": {
          "type": "string",
          "default": "Forgot your email? Try again."
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "To subscribe please fill in all the required info"
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "YouTubeSubscribeButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "youtubeChannelId": {
          "type": "string",
          "default": "wix",
          "description": "youtube channel id"
        }
      }
    },
    "AudioPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "loop": {
          "type": "boolean",
          "default": false
        },
        "visible": {
          "type": "boolean",
          "default": true
        },
        "volume": {
          "type": "number",
          "default": 100
        },
        "title": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": ""
        },
        "icon_uri": {
          "type": "string",
          "default": ""
        },
        "originalFileName": {
          "type": "string",
          "default": ""
        },
        "showToolTip": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      },
      "additionalProperties": false
    },
    "Grid": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "dataSource": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "static",
                "dynamic"
              ]
            },
            "revision": {
              "type": "number",
              "multipleOf": 1
            }
          },
          "additionalProperties": false
        },
        "rows": {
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "rowsCount": {
          "type": "number"
        },
        "revision": {
          "type": "number"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ContactForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "nameFieldLabel": {
          "type": "string",
          "default": "Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Phone"
        },
        "addressFieldLabel": {
          "type": "string",
          "default": "Address"
        },
        "subjectFieldLabel": {
          "type": "string",
          "default": "Subject"
        },
        "messageFieldLabel": {
          "type": "string",
          "default": "Message"
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "DynamicContactForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "formName": {
          "type": "string",
          "default": ""
        },
        "dynamicFields": {
          "type": "array",
          "default": [
            {
              "name": "email",
              "inputType": "email",
              "displayLabel": "Email",
              "required": true
            },
            {
              "name": "name",
              "inputType": "text",
              "displayLabel": "Name",
              "required": true
            },
            {
              "name": "subject",
              "inputType": "text",
              "displayLabel": "Subject",
              "required": false
            },
            {
              "name": "message",
              "inputType": "text",
              "displayLabel": "Message",
              "required": false
            }
          ],
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string",
                "maxLength": 50
              },
              "inputType": {
                "type": "string",
                "maxLength": 50
              },
              "displayLabel": {
                "type": "string",
                "maxLength": 200
              },
              "required": {
                "type": "boolean",
                "default": false
              },
              "displayed": {
                "type": "boolean",
                "default": false
              }
            },
            "additionalProperties": false
          }
        }
      }
    },
    "EbayItemsBySeller": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sellerId": {
          "type": "string"
        },
        "registrationSite": {
          "type": "string"
        }
      }
    },
    "FacebookShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "urlChoice": {
          "type": "string",
          "enum": [
            "Current page",
            "Site"
          ],
          "default": "Current page",
          "description": "Share: current/site url"
        },
        "label": {
          "type": "string",
          "default": "Share",
          "description": ""
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "FlashComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "maxLength": 1000
        },
        "height": {
          "type": "number",
          "default": 0
        },
        "width": {
          "type": "number",
          "default": 0
        },
        "placeHolderImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "FlickrBadgeWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "userId": {
          "type": "string",
          "default": "74009459@N07"
        },
        "userName": {
          "type": "string"
        },
        "tag": {
          "type": "string"
        },
        "imageCount": {
          "type": [
            "string",
            "number"
          ],
          "default": 3
        },
        "whichImages": {
          "type": "string",
          "default": "latest"
        },
        "imageSize": {
          "type": "string",
          "default": "t"
        },
        "layoutOrientation": {
          "type": "string",
          "default": "v"
        }
      }
    },
    "GeoMapLocation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
          "maxLength": 1000
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "title": {
          "type": "string",
          "default": "Wix Office",
          "maxLength": 10000
        },
        "description": {
          "type": "string",
          "default": "Wix HQ",
          "maxLength": 350
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "linkTitle": {
          "type": "string",
          "default": "Visit Wix's Site",
          "maxLength": 140
        },
        "pinIcon": {
          "type": "string",
          "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
          "maxLength": 1000
        },
        "pinColor": {
          "type": "string",
          "default": "#2A3688",
          "maxLength": 20
        }
      }
    },
    "GeoMap": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "language": {
          "type": "string",
          "enum": [
            "af",
            "sq",
            "am",
            "ar",
            "hy",
            "az",
            "eu",
            "be",
            "bn",
            "bs",
            "bg",
            "my",
            "ca",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "hr",
            "cs",
            "da",
            "nl",
            "en",
            "en-AU",
            "en-GB",
            "et",
            "fa",
            "fi",
            "fil",
            "fr",
            "fr-CA",
            "gl",
            "ka",
            "de",
            "el",
            "gu",
            "iw",
            "hi",
            "hu",
            "is",
            "id",
            "it",
            "ja",
            "kn",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "lv",
            "lt",
            "mk",
            "ms",
            "ml",
            "mr",
            "mn",
            "ne",
            "no",
            "pl",
            "pt",
            "pt-BR",
            "pt-PT",
            "pa",
            "ro",
            "ru",
            "sr",
            "si",
            "sk",
            "sl",
            "es",
            "es-419",
            "sw",
            "sv",
            "ta",
            "te",
            "th",
            "tr",
            "uk",
            "ur",
            "uz",
            "vi",
            "zu"
          ]
        },
        "locations": {
          "minItems": 0,
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "addressInfo": {
          "type": "string",
          "default": "Wix Office"
        },
        "defaultLocation": {
          "type": "number",
          "default": 0
        },
        "mapStyle": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "stylers"
            ],
            "properties": {
              "elementType": {
                "type": "string",
                "enum": [
                  "all",
                  "geometry",
                  "geometry.fill",
                  "geometry.stroke",
                  "labels",
                  "labels.icon",
                  "labels.text",
                  "labels.text.fill",
                  "labels.text.stroke"
                ],
                "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
              },
              "featureType": {
                "type": "string",
                "enum": [
                  "administrative",
                  "administrative.country",
                  "administrative.land_parcel",
                  "administrative.locality",
                  "administrative.neighborhood",
                  "administrative.province",
                  "all",
                  "landscape",
                  "landscape.man_made",
                  "landscape.natural",
                  "landscape.natural.landcover",
                  "landscape.natural.terrain",
                  "poi",
                  "poi.attraction",
                  "poi.business",
                  "poi.government",
                  "poi.medical",
                  "poi.park",
                  "poi.place_of_worship",
                  "poi.school",
                  "poi.sports_complex",
                  "road",
                  "road.arterial",
                  "road.highway",
                  "road.highway.controlled_access",
                  "road.local",
                  "transit",
                  "transit.line",
                  "transit.station",
                  "transit.station.airport",
                  "transit.station.bus",
                  "transit.station.rail",
                  "water"
                ],
                "description": "Selects the feature, or group of features, to which a styler should be applied."
              },
              "stylers": {
                "type": "array",
                "items": {
                  "type": "object",
                  "maxProperties": 1,
                  "additionalProperties": false,
                  "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                  "properties": {
                    "color": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "gamma": {
                      "type": "number",
                      "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                    },
                    "hue": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "invert_lightness": {
                      "type": "boolean",
                      "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                    },
                    "lightness": {
                      "type": "number",
                      "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "saturation": {
                      "type": "number",
                      "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "visibility": {
                      "type": "string",
                      "enum": [
                        "on",
                        "off",
                        "simplified"
                      ],
                      "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                    },
                    "weight": {
                      "type": "number",
                      "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                    }
                  }
                }
              }
            },
            "additionalProperties": false
          }
        }
      }
    },
    "HtmlComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sourceType": {
          "type": "string",
          "default": ""
        },
        "url": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string"
        },
        "freezeFrame": {
          "type": "boolean",
          "default": false
        },
        "allowFullScreen": {
          "type": "boolean",
          "default": false
        },
        "componentConsentPolicy": {
          "type": "string",
          "default": "essential",
          "enum": [
            "essential",
            "functional",
            "analytics",
            "advertising",
            "dataToThirdParty"
          ]
        }
      }
    },
    "DisqusComments": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "disqusId": {
          "type": "string",
          "default": ""
        }
      }
    },
    "ItunesButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "downloadUrl": {
          "type": "string",
          "default": "",
          "description": "Insert band URL"
        }
      }
    },
    "LinkableFlashComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "height": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "placeHolderImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LinkableButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LoginButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "language": {
          "type": "string",
          "default": ""
        }
      }
    },
    "TinyMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "loginSocialBarRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "menuRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LoginSocialBar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menuItemsRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "iconItemsRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "language": {
          "type": "string",
          "default": "en",
          "maxLength": 10
        },
        "loggedInMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText",
            "memberInitials"
          ],
          "default": "avatarAndText"
        },
        "loggedOutMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText"
          ]
        },
        "loggedInAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedOutAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ],
          "default": "profileImage"
        },
        "loggedInCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutText": {
          "type": "string",
          "default": "Log In",
          "maxLength": 50
        },
        "showLoggedInText": {
          "type": "boolean",
          "default": true
        },
        "loggedInTextState": {
          "type": "string",
          "enum": [
            "memberName",
            "custom"
          ]
        },
        "loggedInText": {
          "type": "string",
          "default": "Hello",
          "maxLength": 50
        },
        "customLoggedInText": {
          "type": "string",
          "maxLength": 50
        },
        "logOutText": {
          "type": "string",
          "default": "Log Out",
          "maxLength": 50
        }
      }
    },
    "PagesGroupData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appId": {
          "type": [
            "number",
            "null"
          ]
        },
        "appDefinitionId": {
          "type": "string"
        },
        "groupName": {
          "type": "string"
        },
        "pages": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        }
      }
    },
    "PagesGroupCollection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "groups": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "PayPalButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "merchantID": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        }
      }
    },
    "PermaLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appType": {
          "enum": [
            "ListsApps",
            "ThirdPartyApps"
          ]
        },
        "dataItemRef": {
          "default": "",
          "type": [
            "null",
            "string"
          ]
        },
        "mutableSeoTitle": {
          "type": "string"
        },
        "correctPermaLinkRef": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "appType"
      ]
    },
    "PinterestFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "urlChoice": {
          "type": "string",
          "default": "pinterest/",
          "description": ""
        },
        "label": {
          "type": "string",
          "default": "Pinterest",
          "description": ""
        }
      }
    },
    "SelectableList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "description": "direction of the label",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "description": "direction of the input",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "description": "direction of the dropdown",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "description": "direction of the error",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "description": "a list of SelectOption data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "SelectOption": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "selectedText": {
          "type": "string",
          "maxLength": 400
        },
        "disabled": {
          "type": "boolean"
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "RadioButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "RadioGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "defaultValue": {
          "type": [
            "null",
            "string"
          ]
        },
        "options": {
          "description": "a list of RadioButton data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CheckboxGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "options": {
          "description": "a list of CheckboxInput data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "FileUploader": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonLabel": {
          "type": "string",
          "default": "Upload File",
          "maxLength": 500
        },
        "placeholderLabel": {
          "type": "string",
          "default": "Max File Size 15MG",
          "maxLength": 500
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonLabelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "filesDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "iconPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      }
    },
    "UploadName": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SiteButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pressed": {
          "type": "boolean"
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "menu",
            "dialog",
            "listbox",
            "tree",
            "grid"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        }
      }
    },
    "SiteButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        }
      }
    },
    "SoundCloudWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string",
          "default": ""
        },
        "showArtWork": {
          "type": "boolean",
          "default": true
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "embedSource": {
          "type": "string",
          "default": ""
        }
      }
    },
    "StyledTextA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        }
      }
    },
    "StyledText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": "<p class='font_7'></p>",
          "not": {
            "pattern": "<script"
          }
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "SvgShape": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string"
        }
      }
    },
    "VectorImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "default": ""
        },
        "decorative": {
          "type": "boolean"
        },
        "title": {
          "type": "string",
          "maxLength": 100,
          "description": "Title or caption for the vector image."
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        }
      }
    },
    "Video": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "videoId": {
          "type": "string"
        },
        "userId": {
          "type": "string"
        },
        "posterImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ],
          "default": "YOUTUBE"
        }
      }
    },
    "VKShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "style": {
          "type": "string",
          "enum": [
            "Button",
            "ButtonWithoutCounter",
            "Link",
            "LinkWithoutIcon",
            "Icon"
          ],
          "default": "Button",
          "description": "the layout of the button"
        },
        "text": {
          "type": "string",
          "default": "Share",
          "description": "the text of the Button"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object"
        },
        "spriteOffset": {
          "type": "object"
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      },
      "additionalProperties": false
    },
    "TPAWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPAData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data",
          "maxLength": 4000
        }
      }
    },
    "TPAGlobalData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Definition ID"
        }
      }
    },
    "TPA": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "referenceId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "widget id"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPASection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPAMultiSection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "hidden tpaSection part of multi section app"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "RssButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "image": {
          "type": [
            "null",
            "string"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "AppPart": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appInnerID": {
          "type": [
            "string",
            "number"
          ]
        },
        "appLogicParams": {
          "type": "object",
          "default": {}
        },
        "appLogicCustomizations": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": {
                "type": "string"
              },
              "forType": {
                "type": "string"
              },
              "format": {
                "type": "string"
              },
              "key": {
                "type": "string"
              },
              "type": {
                "type": "string"
              },
              "view": {
                "type": "string"
              },
              "mode": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "value": {
                "type": [
                  "string",
                  "null"
                ]
              }
            },
            "additionalProperties": false
          },
          "default": []
        },
        "appPartName": {
          "type": "string"
        },
        "viewName": {
          "type": "string"
        }
      }
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppPage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appPageId": {
          "type": "string",
          "default": ""
        },
        "appInnerID": {
          "type": [
            "string",
            "number"
          ],
          "default": ""
        },
        "appPageType": {
          "type": "string"
        },
        "repeaterPage": {
          "type": "boolean",
          "default": false
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideTitle": {
          "type": "boolean"
        },
        "icon": {
          "type": "string"
        },
        "windowTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "descriptionSEO": {
          "type": "string",
          "maxLength": 1024
        },
        "advancedSeoData": {
          "type": "string",
          "maxLength": 10000
        },
        "metaKeywordsSEO": {
          "type": "string",
          "maxLength": 512
        },
        "pageTitleSEO": {
          "type": "string"
        },
        "pageUriSEO": {
          "type": "string"
        },
        "hidePage": {
          "type": "boolean"
        },
        "underConstruction": {
          "type": "boolean"
        },
        "tpaApplicationId": {
          "type": "number"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "managingAppDefId": {
          "type": [
            "string",
            "null"
          ]
        },
        "tpaPageId": {
          "type": "string"
        },
        "parentPageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSecurity": {
          "type": [
            "object",
            "null"
          ],
          "default": {
            "requireLogin": false,
            "passwordDigest": "",
            "dialogLanguage": ""
          }
        },
        "indexable": {
          "type": "boolean",
          "default": true
        },
        "mobileHidePage": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ],
                  "default": "viewport"
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isMobileLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isPopup": {
          "type": "boolean",
          "default": false
        },
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "ogImage": {
          "type": [
            "string",
            "null"
          ]
        },
        "ogImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        }
      }
    },
    "AppBuilderComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appInnerID": {
          "type": [
            "string",
            "null"
          ]
        },
        "appPartName": {
          "type": "string"
        }
      }
    },
    "BoxSlideShow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "BoxSlideShowSlide": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string"
        }
      }
    },
    "StripContainerSlideShow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "StripContainerSlideShowSlide": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string"
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "VerticalAnchorsMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pageTopLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Top"
        },
        "pageBottomLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Bottom"
        },
        "hiddenAnchorIds": {
          "type": [
            "null",
            "object"
          ],
          "default": {}
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "bulletPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      }
    },
    "WFacebookComment": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "WFacebookLike": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "AppController": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "default": ""
        },
        "controllerType": {
          "type": "string",
          "maxLength": 100
        },
        "settings": {
          "type": "string",
          "maxLength": 6000
        },
        "externalId": {
          "type": "string",
          "maxLength": 100
        }
      },
      "required": [
        "applicationId",
        "controllerType"
      ]
    },
    "RepeaterA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "none",
            "radiogroup",
            "list",
            "group"
          ]
        }
      }
    },
    "Repeater": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "default": [],
          "items": {
            "type": "string"
          },
          "description": "Unique identifiers for items of the repeater"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "RepeatedData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "original": {
          "type": "object",
          "description": "the original data item of a component inside a repeater according to the specific component schema"
        },
        "overrides": {
          "type": "object",
          "description": "a map from itemId in a repeater to its data item according to the specific component schema"
        }
      }
    },
    "ImageButtonWithText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 100
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "predefinedClass": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "Icon": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string"
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "title": {
          "type": "string"
        }
      }
    },
    "WidgetRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appDefinitionId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string"
        },
        "variationId": {
          "type": [
            "string",
            "null"
          ]
        },
        "name": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "InternalRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "string"
          ]
        },
        "pageId": {
          "type": "string"
        }
      }
    },
    "InternalBlocksRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": "string"
        },
        "pageId": {
          "type": "string"
        }
      }
    },
    "LightboxA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "LightboxContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ContainerA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "none",
            "status",
            "alert",
            "nav",
            "list",
            "listitem",
            "tablist",
            "tab",
            "tabpanel",
            "menubar",
            "presentation",
            "heading"
          ]
        },
        "roledescription": {
          "type": "string",
          "maxLength": 100
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ],
          "maxLength": 10
        },
        "hidden": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string",
          "enum": [
            "all",
            "additions",
            "text",
            "removals"
          ]
        }
      }
    },
    "ContainerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "MediaBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "SlotsPlaceholderData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "interfaces": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "maxItems": 20
        }
      },
      "required": [
        "interfaces"
      ]
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "MultiStateBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultStateId": {
          "default": "FIRST_STATE",
          "type": [
            "null",
            "string"
          ]
        },
        "selectedStateId": {
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "AppsInstallState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "stateMap": {
          "type": "object",
          "default": {},
          "additionalProperties": {
            "type": "object",
            "required": [
              "status"
            ],
            "properties": {
              "status": {
                "type": "string",
                "enum": [
                  "INSTALLED",
                  "REMOVED"
                ],
                "default": "INSTALLED"
              },
              "version": {
                "type": [
                  "string",
                  "null"
                ],
                "minLength": 1,
                "maxLength": 20
              }
            }
          },
          "properties": {}
        }
      }
    },
    "StateBoxA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StateBoxStateA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Builder.MenuItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "container": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "Builder.MenuItems": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "Builder.Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "maxLength": 1000,
          "description": "Identifier or URL for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Human-readable filename to use for the image."
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.Video": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "description": "Unique identifier for the video media",
          "maxLength": 1000
        },
        "sources": {
          "type": "array",
          "description": "Available video sources in different qualities",
          "items": {
            "type": "object",
            "required": [
              "quality",
              "width",
              "height",
              "types"
            ],
            "properties": {
              "quality": {
                "type": "string",
                "enum": [
                  "1080p",
                  "720p",
                  "480p",
                  "360p"
                ],
                "description": "Quality level of the video source"
              },
              "width": {
                "type": "number",
                "description": "Width of the video in pixels"
              },
              "height": {
                "type": "number",
                "description": "Height of the video in pixels"
              },
              "types": {
                "type": "array",
                "description": "Available format types and their URIs for this quality",
                "items": {
                  "type": "object",
                  "required": [
                    "format",
                    "uri"
                  ],
                  "properties": {
                    "format": {
                      "type": "string",
                      "enum": [
                        "mp4",
                        "mp4-luminance"
                      ],
                      "description": "Video format type"
                    },
                    "uri": {
                      "type": "string",
                      "description": "URI to access the video file"
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveSources": {
          "type": "array",
          "description": "Sources for adaptive streaming formats",
          "items": {
            "type": "object",
            "required": [
              "format",
              "uri"
            ],
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ],
                "description": "Adaptive streaming format"
              },
              "uri": {
                "type": "string",
                "description": "URI to access the stream manifest"
              }
            },
            "additionalProperties": false
          }
        },
        "hasAudio": {
          "type": "boolean",
          "description": "Whether the video contains an audio track"
        },
        "fps": {
          "type": "number",
          "description": "Frames per second of the video"
        },
        "poster": {
          "description": "Poster image for the video",
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number",
          "description": "Duration of the video in seconds"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.VectorArt": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.RichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "mobui.MobuiButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "contentType": {
          "default": "Text",
          "enum": [
            "Text",
            "Icon",
            "Text and icon"
          ],
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "iconPosition": {
          "default": "Left",
          "enum": [
            "Left",
            "Right"
          ],
          "type": "string"
        },
        "buttonType": {
          "default": "Full",
          "enum": [
            "Full",
            "Outline",
            "Link"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        }
      }
    },
    "mobui.MobuiDatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "initialText": {
          "default": "today's date",
          "enum": [
            "today's date",
            "placeholder"
          ],
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "settings",
            "filter"
          ],
          "type": "string"
        },
        "pickerType": {
          "default": "calendar",
          "enum": [
            "wheel",
            "calendar"
          ],
          "type": "string"
        },
        "pickerTitle": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "showPastDates": {
          "default": true,
          "type": "boolean"
        },
        "showFutureDates": {
          "default": true,
          "type": "boolean"
        },
        "wheelMode": {
          "default": "DD/MM/YY",
          "enum": [
            "DD/MM/YY",
            "MM/YY"
          ],
          "type": "string"
        },
        "firstDay": {
          "default": "Monday",
          "enum": [
            "Sunday",
            "Monday"
          ],
          "type": "string"
        },
        "disabledDaysOfWeek": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "enabledDateRanges": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "disabledDateRanges": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "This field is required",
          "maxLength": 1200,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "disabledDates": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "minDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "maxDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "timeZone": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "defaultItemSchemaType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "MobuiDateRangeType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "startDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "endDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "mobui.MobuiImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "src": {
          "type": [
            "null",
            "string"
          ]
        },
        "isExternalSource": {
          "default": false,
          "type": "boolean"
        },
        "resizeMode": {
          "default": "cover",
          "enum": [
            "cover",
            "contain",
            "stretch",
            "repeat",
            "center"
          ],
          "type": "string"
        }
      }
    },
    "mobui.MobuiPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "filter",
            "settings"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Select an option",
          "maxLength": 120,
          "type": "string"
        },
        "pickerType": {
          "default": "fullScreen",
          "enum": [
            "fullScreen",
            "dialog"
          ],
          "type": "string"
        },
        "optionsDialogTitle": {
          "default": "Select an Option",
          "maxLength": 120,
          "type": "string"
        },
        "optionsDialogSubtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasItemSubtitle": {
          "default": false,
          "type": "boolean"
        },
        "isMultiselect": {
          "default": false,
          "type": "boolean"
        },
        "selectionLimit": {
          "default": 3,
          "type": "number",
          "multipleOf": 1
        },
        "hasSearchBar": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "Please fill out this field",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": false,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "MobuiPickerItemType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "subtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isSelected": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "mobui.MobuiSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Add Title",
          "maxLength": 1200,
          "type": "string"
        },
        "selectable": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "inputType": {
          "default": "text",
          "enum": [
            "text",
            "password",
            "phone",
            "email",
            "url",
            "number"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "initialValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasCharLimit": {
          "default": false,
          "type": "boolean"
        },
        "maxInputLength": {
          "default": 300,
          "maximum": 120000,
          "type": "number",
          "multipleOf": 1
        },
        "prefixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "requiredErrorMessage": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorErrorMessageValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorType": {
          "default": "none",
          "enum": [
            "none",
            "number",
            "email",
            "url",
            "required"
          ],
          "type": "string"
        },
        "textContentType": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "autoComplete": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiVideoPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "default": "I am a Title",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
          "maxLength": 1200,
          "type": "string"
        },
        "poster": {
          "type": [
            "null",
            "string"
          ]
        },
        "isPlaying": {
          "default": false,
          "type": "boolean"
        },
        "muteOnStart": {
          "default": false,
          "type": "boolean"
        },
        "playInLoop": {
          "default": false,
          "type": "boolean"
        },
        "enableFullScreen": {
          "default": true,
          "type": "boolean"
        },
        "enableCasting": {
          "default": false,
          "type": "boolean"
        },
        "showVideoSettings": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiMultiStateBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultStateId": {
          "default": null,
          "type": [
            "null",
            "string"
          ]
        },
        "selectedStateId": {
          "default": null,
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "wixui.ExternalComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "compProps": {
          "default": "{}",
          "maxLength": 120000,
          "type": "string"
        },
        "isTrusted": {
          "default": false,
          "type": "boolean"
        },
        "importKey": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "wixui.HamburgerOverlay": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showBackgroundOverlay": {
          "default": true,
          "type": "boolean"
        },
        "tapOutsideToClose": {
          "default": true,
          "type": "boolean"
        },
        "isMenuContainerFullscreen": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "wixui.Logo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isLoadingData": {
          "default": true,
          "type": "boolean"
        },
        "logoId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alt": {
          "default": "Logo",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "preset": {
          "default": "original",
          "maxLength": 120,
          "type": "string"
        },
        "hasBackground": {
          "default": true,
          "type": "boolean"
        },
        "brandId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "backgroundColor": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "logoUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "wixui.LottieEmbed": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "animationUrl": {
          "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
          "maxLength": 1200,
          "type": "string"
        },
        "speed": {
          "default": 1,
          "minimum": 0,
          "type": "number"
        },
        "loop": {
          "default": true,
          "type": "boolean"
        },
        "autoplay": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": false,
          "type": "boolean"
        },
        "showPlaybackControl": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "wixui.ProductSpecification": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "wixui.RangeSlider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Set a range value",
          "maxLength": 120,
          "type": "string"
        },
        "sliderType": {
          "default": "Continuous",
          "enum": [
            "Continuous",
            "Stepped"
          ],
          "type": "string"
        },
        "stepType": {
          "default": "Number",
          "enum": [
            "Number",
            "Value"
          ],
          "type": "string"
        },
        "step": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "direction": {
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ],
          "type": "string"
        },
        "rootDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "labelDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "sliderDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "min": {
          "default": 0,
          "type": "number"
        },
        "max": {
          "default": 100,
          "type": "number"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 0,
          "type": "number"
        },
        "thumbShape": {
          "default": "Circle",
          "enum": [
            "Circle",
            "Square",
            "Rectangle",
            "Bar"
          ],
          "type": "string"
        },
        "marksTickShape": {
          "default": "Lines",
          "enum": [
            "Lines",
            "Dots"
          ],
          "type": "string"
        },
        "thumbSize": {
          "default": 24,
          "type": "number",
          "multipleOf": 1
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "accessibleName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "wixui.Rive": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "animationFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "thumbnailFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "artboard": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "stateMachine": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fit": {
          "default": "cover",
          "maxLength": 120,
          "type": "string"
        },
        "alignment": {
          "default": "center",
          "maxLength": 120,
          "type": "string"
        },
        "isAutoPlayOn": {
          "default": true,
          "type": "boolean"
        },
        "isTouchScrollEnabled": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fileName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "wixui.ShareButtons": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttons": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "pageToShare": {
          "default": "home",
          "maxLength": 1200,
          "type": "string"
        },
        "shareUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      }
    },
    "IShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "platformId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label"
      ]
    },
    "wixui.SingleTab": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabId": {
          "maxLength": 120,
          "type": "string"
        },
        "label": {
          "default": "Tab",
          "maxLength": 120,
          "type": "string"
        },
        "isParentStretched": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "tabId"
      ]
    },
    "AccordionContainerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "items": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "additionalProperties": false,
            "properties": {
              "id": {
                "type": "string"
              },
              "label": {
                "type": "string"
              }
            }
          },
          "default": []
        }
      }
    },
    "AccordionItemData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isParentStretched": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "AddressInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "locale": {
          "type": "string",
          "maxLength": 100
        },
        "googleMapsApiKey": {
          "type": "string",
          "maxLength": 400
        },
        "filter": {
          "type": "object",
          "properties": {
            "country": {
              "type": "string",
              "maxLength": 10
            }
          },
          "additionalProperties": false
        },
        "sorting": {
          "type": "object",
          "properties": {
            "location": {
              "type": "object",
              "properties": {
                "lat": {
                  "type": "number"
                },
                "lng": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "radius": {
              "type": "number",
              "default": 100
            },
            "formatted": {
              "type": "string",
              "maxLength": 10
            }
          },
          "additionalProperties": false
        },
        "placeholder": {
          "type": "string",
          "description": "The value of the placeholder if chosen",
          "maxLength": 1000
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "BoltComponentData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "Captcha": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "captchaType": {
          "type": "string",
          "enum": [
            "image",
            "audio"
          ],
          "default": "image",
          "description": "When set changes the type of the challenge (image or audio)"
        }
      }
    },
    "CollapsibleTextData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 120000
        },
        "readMoreText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "readLessText": {
          "type": "string",
          "default": "Read Less",
          "maxLength": 1200
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "linkText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "textDescription": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "tag": {
          "type": "string",
          "default": "p",
          "maxLength": 31
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ComboBoxInputData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "description": "direction of the label",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "description": "direction of the input",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "description": "direction of the dropdown",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "description": "direction of the error",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "description": "a list of SelectOption data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CustomElement": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tagName": {
          "type": "string",
          "default": "wix-default-custom-element"
        },
        "url": {
          "type": "string",
          "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
        },
        "hostedInCorvid": {
          "type": "boolean",
          "default": false
        },
        "initialAttributes": {
          "type": "string",
          "default": "{}",
          "maxLength": 4096
        },
        "shouldReload": {
          "type": "boolean",
          "description": "if iframe should be reloaded on initialAttributes change"
        },
        "scriptType": {
          "type": "string",
          "enum": [
            "none",
            "module"
          ],
          "default": "none"
        },
        "appDefinitionId": {
          "type": "string",
          "maxLength": 36
        },
        "widgetId": {
          "type": "string",
          "maxLength": 36
        }
      }
    },
    "wixui.FastGallery": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "itemClickAction": {
          "default": "ACTION",
          "enum": [
            "ACTION",
            "LINK",
            "NOTHING"
          ],
          "type": "string"
        },
        "downloadProtection": {
          "default": true,
          "type": "boolean"
        },
        "wixSDKItems": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "wixui.HamburgerMenuContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "wixui.HamburgerMenuRoot": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ImageX": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "image": {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "alt": {
              "type": "string",
              "default": ""
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "height": {
              "type": "number",
              "default": 200
            },
            "width": {
              "type": "number",
              "default": 200
            },
            "decorative": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "scopedData": {
          "description": "ImageX data per breakpoint",
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "breakpoint": {
                "type": "string"
              },
              "crop": {
                "type": "object",
                "required": [
                  "x",
                  "y",
                  "width",
                  "height"
                ],
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0
                  },
                  "width": {
                    "type": "number",
                    "minimum": 0
                  },
                  "height": {
                    "type": "number",
                    "minimum": 0
                  },
                  "svgId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "rotate": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 359,
                    "description": "Image rotation degrees"
                  },
                  "flip": {
                    "type": "string",
                    "enum": [
                      "x",
                      "y",
                      "xy",
                      "none"
                    ],
                    "default": "none",
                    "description": "Image flip value"
                  }
                },
                "additionalProperties": false
              },
              "focalPoint": {
                "type": "object",
                "required": [
                  "x",
                  "y"
                ],
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0
                  }
                },
                "additionalProperties": false
              },
              "displayMode": {
                "type": "string",
                "enum": [
                  "fill",
                  "fit",
                  "fitWidth"
                ],
                "default": "fill"
              },
              "scrollEffect": {
                "type": "string",
                "enum": [
                  "parallax",
                  "fixed",
                  "zoomIn",
                  "fadeIn",
                  "none"
                ]
              },
              "clickAction": {
                "type": "string",
                "enum": [
                  "none",
                  "goToLink"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "mask": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "x": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "y": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "width": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "svgId": {
              "type": "string"
            },
            "flip": {
              "type": "string",
              "enum": [
                "x",
                "y",
                "xy",
                "none"
              ]
            },
            "rotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "mode": {
              "type": "string",
              "enum": [
                "alpha",
                "luminance"
              ]
            }
          },
          "additionalProperties": false
        },
        "parallaxSpeed": {
          "type": "number"
        },
        "parallaxDirection": {
          "type": "string",
          "enum": [
            "normal",
            "reverse"
          ]
        },
        "hasAnimation": {
          "type": "boolean"
        }
      }
    },
    "Crop": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      },
      "additionalProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      },
      "additionalProperties": false
    },
    "LanguageSelector": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "wixui.MegaMenuContainerItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "default": "wixui.MegaMenuContainerItem",
          "maxLength": 120,
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "MenuData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "navAriaLabel": {
          "type": "string",
          "maxLength": 1000
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "wixui.MenuList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menus": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "MusicPlayerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "coverDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "audioRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "audioUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "playListId": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 255
        },
        "playlist": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "artistName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Artist"
              },
              "trackName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Track"
              },
              "url": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "cover": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "durationFormatted": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 16
              }
            },
            "additionalProperties": false
          },
          "default": []
        },
        "coverRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "coverUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "artistName": {
          "type": "string",
          "default": "Unknown Artist",
          "maxLength": 255
        },
        "trackName": {
          "type": "string",
          "default": "Unknown Track",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000
        }
      }
    },
    "WixAudio": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "duration": {
          "type": "number"
        }
      }
    },
    "Pagination": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "totalPages": {
          "type": "number",
          "description": "The total number of pages displayed by the component"
        },
        "currentPage": {
          "type": "number",
          "default": 1,
          "description": "The the page number marked as current"
        },
        "nextText": {
          "type": "string",
          "default": "Next",
          "maxLength": 400,
          "description": "Text to appear in NEXT button"
        },
        "previousText": {
          "type": "string",
          "default": "Previous",
          "maxLength": 400,
          "description": "Text to appear in PREVIOUS button"
        },
        "firstText": {
          "type": "string",
          "default": "First",
          "maxLength": 400,
          "description": "Text to appear in FIRST button"
        },
        "lastText": {
          "type": "string",
          "default": "Last",
          "maxLength": 400,
          "description": "Text to appear in LAST button"
        },
        "nextAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the NEXT button"
        },
        "previousAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the PREVIOUS button"
        },
        "firstAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the FIRST button"
        },
        "lastAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the LAST button"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "PaginationA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ProgressBar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "number",
          "description": "Current progress value"
        },
        "targetValue": {
          "type": "number",
          "default": 100,
          "description": "Progress target value to be defined as complete"
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "barDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "RatingsDisplay": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "ratingsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "rating": {
          "type": "number",
          "description": "The rating displayed by the component",
          "minimum": 1,
          "maximum": 5
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "numRatings": {
          "type": "number",
          "description": "The amount of ratings the rating is based on",
          "minimum": 0
        },
        "reviewsCountLabel": {
          "type": "string",
          "default": "Reviews",
          "maxLength": 400,
          "description": "Text that describes the numRatings value"
        },
        "noReviewsPlaceholder": {
          "type": "string",
          "default": "Be the first to rate this item",
          "maxLength": 1000,
          "description": "Placeholder text when there aren't any reviews"
        }
      }
    },
    "RatingsInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": [
            "number",
            "null"
          ],
          "description": "The rating value currently selected",
          "minimum": 0,
          "maximum": 5
        },
        "titleText": {
          "type": "string",
          "description": "the title before a value is selected",
          "maxLength": 300
        },
        "svgId": {
          "type": "string",
          "description": "the id of the svg that illustrates the rating",
          "maxLength": 100
        },
        "labels": {
          "type": "object",
          "description": "contains the labels for the different values. maps 1-5 as keys to strings",
          "default": {
            "1": "Bad",
            "2": "Fine",
            "3": "OK",
            "4": "Good",
            "5": "Great"
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "wixui.RichContentViewer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "object"
        },
        "trimEnabled": {
          "type": "boolean",
          "default": false
        },
        "trimMode": {
          "type": "string",
          "default": "paragraph",
          "maxLength": 100
        },
        "trimLengthParagraph": {
          "type": "number",
          "default": 3
        },
        "trimLengthWord": {
          "type": "number",
          "default": 10
        },
        "trimExclude": {
          "type": "string",
          "default": "plugins",
          "maxLength": 100
        },
        "trimEllipsisEnabled": {
          "type": "boolean",
          "default": true
        },
        "trimEllipsisExpandText": {
          "type": "string",
          "default": "Show More",
          "maxLength": 1200
        },
        "trimEllipsisCollapseText": {
          "type": "string",
          "default": "Show Less",
          "maxLength": 1200
        }
      }
    },
    "RichTextBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "maxLength": {
          "type": [
            "number",
            "null"
          ],
          "description": "maximum number of characters allowed"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "SearchBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "placeholder": {
          "type": "string",
          "default": "Search...",
          "maxLength": 255
        },
        "suggestionsEnabled": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the suggestions disabled or not"
        },
        "clearButtonText": {
          "type": "string",
          "default": "Clear",
          "maxLength": 255
        },
        "displaySettingsToggles": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the settings toggles are displayed or not"
        }
      }
    },
    "Section": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "SectionA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "alert",
            "status"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        }
      }
    },
    "wixui.SelectableContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "wixui.SelectableContainerInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SelectionTagsList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "options": {
          "description": "Array of items which behave like checkboxes and look similar to buttons",
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "value": {
          "description": "Array with the values of the selected options",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SelectionTag": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "maxLength": 400
        },
        "label": {
          "type": "string",
          "maxLength": 400
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "rel": {
          "type": "string",
          "enum": [
            "nofollow"
          ]
        }
      }
    },
    "SignatureInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "titleText": {
          "type": "string",
          "description": "The title of the field",
          "maxLength": 400
        },
        "clearButtonText": {
          "type": "string",
          "description": "The undo signature text",
          "minLength": 1,
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "radioButtonsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SiteButtonData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "Slider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "trackDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "tooltipDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "min": {
          "type": "number",
          "default": 0,
          "description": "Minimum value"
        },
        "max": {
          "type": "number",
          "default": 100,
          "description": "Maximum value"
        },
        "value": {
          "type": "number",
          "default": 50,
          "description": "Current value"
        },
        "step": {
          "type": "number",
          "default": 0,
          "description": "Step value"
        },
        "stepType": {
          "type": "string",
          "default": "value",
          "enum": [
            "value",
            "count"
          ],
          "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
        },
        "disabled": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is disabled or not"
        },
        "readOnly": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is read-only or not"
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "description": "Label text",
          "maxLength": 1200
        }
      }
    },
    "wixui.Slideshow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "default": "wixui.Slideshow",
          "maxLength": 120,
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      }
    },
    "SocialAuth": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "StylableButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON",
          "maxLength": 1200
        },
        "svgId": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "isIconAnimated": {
          "type": "boolean"
        },
        "animatedIcon": {
          "type": "object",
          "properties": {
            "svgIdAnimationSelected": {
              "type": "string",
              "maxLength": 100
            },
            "customAnimatedIcon": {
              "type": [
                "object"
              ],
              "properties": {
                "svgIdAnimationStart": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationEnd": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                }
              },
              "additionalProperties": false
            },
            "animationDuration": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "StylableButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "pressed": {
          "type": "boolean"
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "dialog",
            "menu"
          ]
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        }
      }
    },
    "Submenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "itemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "subItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "required": [
        "direction"
      ]
    },
    "SvgImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "decorative": {
          "type": "boolean"
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "maxLength": 120
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "stretch"
          ],
          "description": "should the shape maintain it's aspect ratio or stretch",
          "default": "fit"
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "svgId"
      ]
    },
    "wixui.Tabs": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabIds": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 120
          }
        },
        "defaultTabId": {
          "type": "string",
          "default": "",
          "maxLength": 120
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "TabsA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "TextEffectsSharedData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 500
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "default": "div"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction",
          "default": "inherit"
        },
        "patternScope": {
          "type": "string",
          "enum": [
            "none",
            "character",
            "word"
          ],
          "default": "none"
        }
      }
    },
    "TextMarqueeData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "movementDirection": {
          "type": "string",
          "description": "direction the text is moving to",
          "default": "rtl",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "speed": {
          "type": "number",
          "description": "speed of the animation in pixels per second"
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "pause animation on hover"
        },
        "textDirection": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "headingLevel": {
          "type": "number",
          "maximum": 6,
          "minimum": 0,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "svgId": {
          "type": "string"
        },
        "items": {
          "default": [],
          "description": "array of marquee items",
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "items",
        "speed"
      ]
    },
    "TextMarqueeItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "text": {
          "type": "string",
          "maxLength": 500
        }
      },
      "required": [
        "text"
      ]
    },
    "TextFxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 450
        },
        "headingLevel": {
          "type": "number",
          "minimum": 0,
          "maximum": 6,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        }
      }
    },
    "TextOnPathData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isDecorative": {
          "type": "boolean"
        },
        "text": {
          "type": "string",
          "description": "text",
          "maxLength": 500
        },
        "path": {
          "type": "string",
          "description": "path"
        },
        "pathLength": {
          "type": "number",
          "description": "Path length"
        },
        "viewBox": {
          "type": "string",
          "description": "View box"
        },
        "speed": {
          "type": "number",
          "description": "Speed",
          "default": 3
        },
        "movementDirection": {
          "type": "string",
          "description": "Direction the text is moving to",
          "default": "forward",
          "enum": [
            "forward",
            "reverse"
          ]
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "Pause animation on hover"
        },
        "direction": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "fillMode": {
          "type": "string",
          "enum": [
            "normal",
            "repeat",
            "justify"
          ],
          "default": "normal",
          "description": "How the text should be rendered on the path"
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "startOffset": {
          "type": "number",
          "description": "Starting point of the text on the path",
          "minimum": 0,
          "maximum": 100
        },
        "fontSize": {
          "type": "number",
          "description": "Font size as a number in percent",
          "minimum": 0,
          "maximum": 100
        },
        "pathStrokeWidth": {
          "type": "number",
          "description": "Width of the path stroke in em units",
          "minimum": 0,
          "maximum": 3
        }
      }
    },
    "TimePickerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "placeholder": {
          "type": "string",
          "description": "The value of the placeholder if chosen",
          "maxLength": 1000
        },
        "step": {
          "type": "number",
          "minimum": 1,
          "maximum": 60,
          "default": 1,
          "description": "Increment step in minutes"
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "margin": {
          "type": "number",
          "minimum": 1,
          "maximum": 30,
          "description": "Time picker layout label margin"
        },
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startTime",
              "endTime"
            ],
            "properties": {
              "startTime": {
                "type": "string",
                "maxLength": 100
              },
              "endTime": {
                "type": "string",
                "maxLength": 100
              }
            }
          },
          "default": [],
          "maxItems": 5,
          "description": "array of disabled times"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "ToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "checked": {
          "type": "boolean",
          "description": "The checked status of the input"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "UnsupportedComponentData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "migratedFrom": {
          "type": "string"
        }
      }
    },
    "VideoPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "videoType": {
          "type": "string",
          "enum": [
            "dailymotion",
            "facebook",
            "file",
            "twitch",
            "vimeo",
            "youtube"
          ],
          "default": "file"
        },
        "videoRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "videoUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "posterUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "videoTitle": {
          "type": "string",
          "default": "",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000,
          "description": "Video Description"
        },
        "logoRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "dsgnsys.ControlTypes": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "shortString": {
          "default": "ShortString",
          "maxLength": 120,
          "type": "string"
        },
        "longString": {
          "default": "LongString",
          "maxLength": 1200,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "dropdown": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "radioButtons": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "toggleSwitch": {
          "default": false,
          "type": "boolean"
        },
        "thumbnails": {
          "type": [
            "null",
            "string"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "slider": {
          "default": 1,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "numericInput": {
          "default": 0,
          "type": "number"
        },
        "colorPickerInput": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "selectedFont": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Save",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Light",
            "Destructive",
            "Premium",
            "Premium light",
            "Dark",
            "Transparent"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Primary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      },
      "required": [
        "label"
      ]
    },
    "dsgnsys.DashboardHeading": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Add Page title H1",
          "maxLength": 1200,
          "type": "string"
        },
        "size": {
          "default": "Page title H1",
          "enum": [
            "Page title H1",
            "Modal title H2",
            "Card title H3",
            "Section title H4",
            "Card section title H5",
            "Caption H6"
          ],
          "type": "string"
        },
        "invertColor": {
          "default": false,
          "type": "boolean"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardIconButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "tooltip": {
          "default": "More Actions",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Transparent"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Secondary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardInfoIcon": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tooltip": {
          "default": "This message explains the purpose of a feature.",
          "maxLength": 1200,
          "type": "string"
        },
        "addLink": {
          "default": false,
          "type": "boolean"
        },
        "tooltipLinkText": {
          "default": "Learn more",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipLink": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Event name",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter your event name...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixValue": {
          "default": ".com",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "setMaxLength": {
          "default": false,
          "type": "boolean"
        },
        "maxLength": {
          "default": 20,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardNumberInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Number of tickets",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter a number...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 25,
          "type": "number",
          "multipleOf": 1
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixValue": {
          "default": "%",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "minAndMaxValues": {
          "default": false,
          "type": "boolean"
        },
        "min": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "max": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepSize": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPlacement": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
          "maxLength": 1200,
          "type": "string"
        },
        "preset": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Standard secondary",
            "Light",
            "Light secondary",
            "Success",
            "Destructive",
            "Primary",
            "Premium",
            "Disabled"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Thin",
          "enum": [
            "Bold",
            "Normal",
            "Thin"
          ],
          "type": "string"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        },
        "overflow": {
          "default": "Wrap",
          "enum": [
            "Wrap",
            "Ellipsis"
          ],
          "type": "string"
        },
        "maxLines": {
          "default": 1,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        }
      }
    },
    "dsgnsys.DashboardTextButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "View All",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Dark",
            "Destructive"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "underline": {
          "default": "Never",
          "enum": [
            "Never",
            "On hover",
            "Always"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Regular",
          "enum": [
            "Regular",
            "Medium"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Set a reminder",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": true,
          "type": "boolean"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Success",
            "Destructive"
          ],
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Large",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Right",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.SettingsPanelContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "theme": {
          "default": "classic",
          "enum": [
            "classic",
            "responsive"
          ],
          "type": "string"
        },
        "debug": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuAccordion": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Label Example",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "openByDefault": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuBackButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Back",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "standard secondary",
            "premium",
            "premium secondary",
            "alert",
            "alert secondary",
            "inverted"
          ],
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "small",
            "medium",
            "large"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "fullWidth": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuCheckboxGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Multiple Choices",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColorPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Opacity & Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "opacity": {
          "default": 100,
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "showPercentage": {
          "default": true,
          "type": "boolean"
        },
        "opacitySliderEnabled": {
          "default": true,
          "type": "boolean"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColorSelector": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Color Selector",
          "maxLength": 120,
          "type": "string"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColumnControllerControl": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Column controller",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "enableReorder": {
          "default": true,
          "type": "boolean"
        },
        "minimumValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "dividerType": {
          "default": "none",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        },
        "columns": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "dsgnsys.WbuDatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose a Date",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuDrillDown": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Label Title",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "This is a description text",
          "maxLength": 1200,
          "type": "string"
        },
        "iconType": {
          "default": "None",
          "enum": [
            "None",
            "Info",
            "Alert"
          ],
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuDropdown": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Dropdown",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose an option",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuEmptyState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Link to Lightbox",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "Create your own lightboxes and link to them for any place in your site.",
          "maxLength": 1200,
          "type": "string"
        },
        "textButtonLabel": {
          "default": "Start Creating",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Pick Font and Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "font": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        },
        "color": {
          "default": "#FFC233",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuHorizontalTabs": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabsStyle": {
          "default": "Folder",
          "enum": [
            "Folder",
            "Arrowed",
            "Arrowed Without a Line"
          ],
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "maxVisibleTabs": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        },
        "tabsToScroll": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        }
      }
    },
    "dsgnsys.WbuLeftTextButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Text Button",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "tiny",
            "small",
            "medium"
          ],
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "normal",
          "enum": [
            "thin",
            "normal"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuMultilineTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 120000,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Write text here...",
          "maxLength": 1200,
          "type": "string"
        },
        "maxLength": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "closeOnEnterKeyPress": {
          "default": false,
          "type": "boolean"
        },
        "autoFocus": {
          "default": false,
          "type": "boolean"
        },
        "selectTextOnFocus": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "validationMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuNotificationBanner": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium",
            "alert",
            "success"
          ],
          "type": "string"
        },
        "linkText": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "linkUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "iconTooltipText": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "multiline": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuNumericInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 0,
          "type": "number"
        },
        "unitSuffix": {
          "default": "None",
          "enum": [
            "None",
            "Pixels",
            "Percentage",
            "Degrees"
          ],
          "type": "string"
        },
        "numberOfFractions": {
          "default": 2,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "steps": {
          "default": 1,
          "minimum": 1,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepControls": {
          "default": false,
          "type": "boolean"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 100,
          "type": "number"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Radio Buttons",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuRichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "richTextContent": {
          "default": "Your placeholder text goes here. Write, style and link it.",
          "maxLength": 120000,
          "type": "string"
        },
        "richTextLabel": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "richTextLink": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alignTextToCenter": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuSectionDivider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sectionTitle": {
          "default": "Section Divider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuSlider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Slider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "unitOfMeasurement": {
          "default": "number",
          "enum": [
            "number",
            "percentage",
            "pixels",
            "angle"
          ],
          "type": "string"
        },
        "defaultSelectedValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "minimumValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "maximumValue": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showNumericInput": {
          "default": true,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Text Input",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "defaultText": {
          "default": "Write it here...",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Placeholder text",
          "maxLength": 120,
          "type": "string"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "autofocus": {
          "default": false,
          "type": "boolean"
        },
        "selectedOnFocus": {
          "default": true,
          "type": "boolean"
        },
        "charactersLimit": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "errorMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuThumbnails": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "setNumberOfColumns": {
          "default": 3,
          "minimum": 1,
          "maximum": 5,
          "type": "number",
          "multipleOf": 1
        },
        "showEmptyThumbnail": {
          "default": false,
          "type": "boolean"
        },
        "thumbnailHeight": {
          "default": "Fixed ratio (1:1)",
          "enum": [
            "Fixed ratio (1:1)",
            "Fluid"
          ],
          "type": "string"
        },
        "displayLabels": {
          "default": true,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [
        "options"
      ]
    },
    "ThumbnailItemData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "dsgnsys.WbuToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Toggle Switch",
          "maxLength": 120,
          "type": "string"
        },
        "toggleSwitch": {
          "default": true,
          "type": "boolean"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WutAvatar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "firstName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "lastName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WutAvatarGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "maxAvatars": {
          "default": 5,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showHiddenAvatarCount": {
          "default": true,
          "type": "boolean"
        },
        "avatars": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "dsgnsys.WutBadge": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "My Badge",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "composition": {
          "default": "TextAndIcon",
          "enum": [
            "TextAndIcon",
            "Text",
            "Icon",
            "None"
          ],
          "type": "string"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "dsgnsys.WutRadioButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "radioGroupName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "value"
      ]
    }
  },
  "editorsettings.json": {
    "$id": "urn:dm:schemas:editorsettings.json",
    "EditorSettings": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "dockingBehavior": {
          "type": "string",
          "enum": [
            "heuristic",
            "keep"
          ]
        },
        "layoutIntent": {
          "type": "string",
          "enum": [
            "SuperGrid",
            "CssGrid"
          ]
        },
        "sizingBehavior": {
          "type": "string",
          "enum": [
            "preset",
            "advanced"
          ]
        },
        "aspectRatioLock": {
          "type": "boolean"
        },
        "disableAutoDOMOrder": {
          "type": "boolean"
        },
        "progressStatus": {
          "type": "string",
          "enum": [
            "UNKNOWN",
            "TO_DO",
            "IN_PROGRESS",
            "ITERATE",
            "DONE"
          ]
        },
        "linkedComponents": {
          "type": "object",
          "patternProperties": {
            "^comp_": {
              "type": [
                "string"
              ]
            }
          }
        }
      }
    }
  },
  "effects.json": {
    "$id": "urn:dm:schemas:effects.json",
    "KeyframeEffectList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "KeyframeEffect": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "keyframes": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "Keyframe": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "offset": {
          "type": "number",
          "minimum": 0,
          "maximum": 100,
          "multipleOf": 1
        },
        "effectStyle": {
          "type": "object",
          "properties": {
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1,
              "multipleOf": 0.01
            },
            "clipPath": {
              "type": "object",
              "required": [
                "clipType",
                "value"
              ],
              "properties": {
                "clipType": {
                  "type": "string",
                  "enum": [
                    "inset",
                    "circle",
                    "ellipse",
                    "polygon",
                    "path"
                  ]
                },
                "value": {
                  "type": "string",
                  "maxLength": 1000
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "transform": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "EffectsList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "CanvasAnimation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "CanvasAnimationOptions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "namedEffect": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TimeAnimationOptions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "duration": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0
        },
        "delay": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0
        },
        "endDelay": {
          "type": "number",
          "minimum": 0,
          "multipleOf": 1
        },
        "allowReplay": {
          "type": "string",
          "enum": [
            "perPageView",
            "always",
            "never"
          ],
          "default": "perPageView"
        },
        "keyframeEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "namedEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "customEffect": {
          "type": "object",
          "required": [
            "ranges"
          ],
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "name",
                  "min",
                  "max"
                ],
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "additionalProperties": false
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "description": "Easing function names",
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ]
    },
    "TimeAnimation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "ScrubAnimationOptions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "duration": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "startOffset": {
          "description": "Scrub animation range and offset",
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "enum": [
                "entry",
                "exit",
                "contain",
                "cover"
              ]
            },
            "offset": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "endOffset": {
          "description": "Scrub animation range and offset",
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "enum": [
                "entry",
                "exit",
                "contain",
                "cover"
              ]
            },
            "offset": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "percentage",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "centeredToTarget": {
          "type": "boolean"
        },
        "playbackRate": {
          "type": "number",
          "description": "Adds a lerp effect to animations",
          "minimum": 0,
          "maximum": 1
        },
        "transitionDuration": {
          "type": "number",
          "minimum": 0
        },
        "transitionDelay": {
          "type": "number",
          "minimum": 0
        },
        "transitionEasing": {
          "description": "Easing function names",
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "keyframeEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "namedEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "customEffect": {
          "type": "object",
          "required": [
            "ranges"
          ],
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "name",
                  "min",
                  "max"
                ],
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "additionalProperties": false
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "description": "Easing function names",
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ]
    },
    "ScrubAnimation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "value": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "name",
        "value"
      ]
    },
    "AnimationCommonOptions": {
      "description": "Common options for all animations: named effect, keyframe effect, easing, iterations, alternate, fill, reversed",
      "type": "object",
      "oneOf": [
        {
          "type": "object",
          "required": [
            "keyframeEffect"
          ]
        },
        {
          "type": "object",
          "required": [
            "namedEffect"
          ]
        },
        {
          "type": "object",
          "not": {
            "anyOf": [
              {
                "type": "object",
                "required": [
                  "keyframeEffect"
                ]
              },
              {
                "type": "object",
                "required": [
                  "namedEffect"
                ]
              }
            ]
          }
        }
      ],
      "properties": {
        "keyframeEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "namedEffect": {
          "type": [
            "null",
            "string"
          ]
        },
        "customEffect": {
          "type": "object",
          "required": [
            "ranges"
          ],
          "properties": {
            "ranges": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "name",
                  "min",
                  "max"
                ],
                "properties": {
                  "name": {
                    "type": "string",
                    "enum": [
                      "offset",
                      "intensity",
                      "mouse",
                      "scroll",
                      "mouseIntensity"
                    ]
                  },
                  "min": {
                    "type": "number",
                    "default": 0
                  },
                  "max": {
                    "type": "number",
                    "default": 1
                  },
                  "step": {
                    "type": "number"
                  }
                },
                "additionalProperties": false
              },
              "maxItems": 10,
              "minItems": 1
            }
          },
          "additionalProperties": false
        },
        "easing": {
          "description": "Easing function names",
          "type": "string",
          "enum": [
            "linear",
            "ease",
            "easeIn",
            "easeOut",
            "easeInOut",
            "sineIn",
            "sineOut",
            "sineInOut",
            "quadIn",
            "quadOut",
            "quadInOut",
            "cubicIn",
            "cubicOut",
            "cubicInOut",
            "quartIn",
            "quartOut",
            "quartInOut",
            "quintIn",
            "quintOut",
            "quintInOut",
            "expoIn",
            "expoOut",
            "expoInOut",
            "circIn",
            "circOut",
            "circInOut",
            "backIn",
            "backOut",
            "backInOut",
            "hardBackOut"
          ]
        },
        "iterations": {
          "type": "number",
          "minimum": 0,
          "default": 1
        },
        "alternate": {
          "type": "boolean"
        },
        "fill": {
          "type": "string",
          "enum": [
            "none",
            "backwards",
            "forwards",
            "both"
          ]
        },
        "reversed": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "RangeOffset": {
      "description": "Scrub animation range and offset",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "enum": [
            "entry",
            "exit",
            "contain",
            "cover"
          ]
        },
        "offset": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Easing": {
      "description": "Easing function names",
      "type": "string",
      "enum": [
        "linear",
        "ease",
        "easeIn",
        "easeOut",
        "easeInOut",
        "sineIn",
        "sineOut",
        "sineInOut",
        "quadIn",
        "quadOut",
        "quadInOut",
        "cubicIn",
        "cubicOut",
        "cubicInOut",
        "quartIn",
        "quartOut",
        "quartInOut",
        "quintIn",
        "quintOut",
        "quintInOut",
        "expoIn",
        "expoOut",
        "expoInOut",
        "circIn",
        "circOut",
        "circInOut",
        "backIn",
        "backOut",
        "backInOut",
        "hardBackOut"
      ]
    },
    "EffectPower": {
      "type": "string",
      "enum": [
        "soft",
        "medium",
        "hard"
      ]
    },
    "EffectScrollRange": {
      "type": "string",
      "enum": [
        "in",
        "out",
        "continuous"
      ]
    },
    "EffectScaleDirection": {
      "type": "string",
      "enum": [
        "up",
        "down"
      ]
    },
    "EffectFourDirections": {
      "type": "string",
      "enum": [
        "left",
        "right",
        "top",
        "bottom"
      ]
    },
    "EffectFourCorners": {
      "type": "string",
      "enum": [
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
      ]
    },
    "EffectEightDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right"
      ]
    },
    "EffectNineDirections": {
      "type": "string",
      "enum": [
        "right",
        "top-right",
        "top",
        "top-left",
        "left",
        "bottom-left",
        "bottom",
        "bottom-right",
        "center"
      ]
    },
    "EffectAxes": {
      "type": "string",
      "enum": [
        "horizontal",
        "vertical",
        "both"
      ]
    },
    "ArcIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "CurveIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "DropIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "initialScale": {
          "type": "number",
          "minimum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale"
          ]
        }
      ]
    },
    "ExpandIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "direction"
          ]
        }
      ]
    },
    "FadeIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "FlipIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialRotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialRotate",
            "direction"
          ]
        }
      ]
    },
    "FloatIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShuttersIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "shutters": {
          "type": "number",
          "minimum": 2
        },
        "staggered": {
          "type": "boolean"
        }
      },
      "required": [
        "direction",
        "shutters"
      ]
    },
    "FoldIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialRotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialRotate",
            "direction"
          ]
        }
      ]
    },
    "SlideIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "initialTranslate": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialTranslate",
            "direction"
          ]
        }
      ]
    },
    "SpinIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "spins": {
          "type": "number",
          "minimum": 0.25
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction",
            "spins"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "direction",
            "spins"
          ]
        }
      ]
    },
    "BounceIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "left",
                "right",
                "top",
                "bottom"
              ]
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distanceFactor": {
          "type": "number",
          "minimum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "distanceFactor",
            "direction"
          ]
        }
      ]
    },
    "PunchIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "anyOf": [
            {
              "type": "string",
              "enum": [
                "top-left",
                "top-right",
                "bottom-left",
                "bottom-right"
              ]
            },
            {
              "type": "string",
              "enum": [
                "center"
              ]
            }
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      }
    },
    "GlideIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "startFromOffScreen": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "GlitchIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "startFromOffScreen": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "TurnIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "CircleIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "WinkIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "TiltIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShapeIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "required": [
        "shape",
        "direction"
      ]
    },
    "GrowIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "initialScale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "distance",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "initialScale",
            "distance",
            "direction"
          ]
        }
      ]
    },
    "FlyIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "RevealIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "BlurIn": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "blur": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "blur"
          ]
        }
      ]
    },
    "Breathe": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal",
            "center"
          ]
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "direction",
        "distance"
      ]
    },
    "Blink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "distance",
            "scale"
          ]
        }
      ]
    },
    "Pulse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Spin": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "Poke": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity",
            "direction"
          ]
        }
      ]
    },
    "Flash": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Swing": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "swing": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "swing"
          ]
        }
      ]
    },
    "Flip": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "Rubber": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Fold": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "angle": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "direction"
          ]
        },
        {
          "type": "object",
          "required": [
            "angle",
            "direction"
          ]
        }
      ]
    },
    "Jello": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Wiggle": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Bounce": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity"
          ]
        }
      ]
    },
    "Cross": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "DVD": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "required": [
        "power"
      ]
    },
    "ArcScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "BlurScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "blur": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "blur"
          ]
        }
      ]
    },
    "FadeScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      }
    },
    "FlipScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "rotate": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "vertical",
            "horizontal"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "rotate"
          ]
        }
      ]
    },
    "GrowScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "MoveScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "distance",
            "angle"
          ]
        }
      ]
    },
    "PanScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "startFromOffScreen": {
          "type": "boolean"
        }
      },
      "required": [
        "direction",
        "distance",
        "startFromOffScreen"
      ]
    },
    "ParallaxScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "speed": {
          "type": "number"
        }
      },
      "required": [
        "speed"
      ]
    },
    "RevealScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ShapeScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "intensity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "shape": {
          "type": "string",
          "enum": [
            "ellipse",
            "circle",
            "rectangle",
            "diamond",
            "window"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "shape"
          ]
        },
        {
          "type": "object",
          "required": [
            "intensity",
            "shape"
          ]
        }
      ]
    },
    "ShrinkScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "right",
            "top-right",
            "top",
            "top-left",
            "left",
            "bottom-left",
            "bottom",
            "bottom-right",
            "center"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "ShuttersScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "shutters": {
          "type": "number",
          "minimum": 2
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        },
        "staggered": {
          "type": "boolean"
        }
      },
      "required": [
        "shutters",
        "direction"
      ]
    },
    "SkewPanScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "skew": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "skew"
          ]
        }
      ]
    },
    "SlideScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "top",
            "bottom"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "Spin3dScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "rotate": {
          "type": "number"
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "rotate"
          ]
        }
      ]
    },
    "SpinScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "spins": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scale": {
          "type": "number",
          "minimum": 0
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "spins",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "spins",
            "scale"
          ]
        }
      ]
    },
    "StretchScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "stretch": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "stretch"
          ]
        }
      ]
    },
    "TiltScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "distance": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "TurnScroll": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out",
            "continuous"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "spin": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "direction",
            "spin",
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "direction",
            "spin",
            "scale"
          ]
        }
      ]
    },
    "TrackMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      }
    },
    "Tilt3DMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "SwivelMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "pivotAxis": {
          "type": "string",
          "enum": [
            "center-vertical",
            "center-horizontal",
            "top",
            "bottom",
            "left",
            "right"
          ]
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BlobMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "ScaleMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        },
        "scaleDirection": {
          "type": "string",
          "enum": [
            "up",
            "down"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power",
            "scaleDirection"
          ]
        },
        {
          "type": "object",
          "required": [
            "scale"
          ]
        }
      ]
    },
    "Track3DMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "perspective": {
          "type": "number",
          "minimum": 0
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle",
            "perspective"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "AiryMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BlurMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "blur": {
          "type": "number",
          "minimum": 1
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number",
          "minimum": 0
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "power"
          ]
        },
        {
          "type": "object",
          "required": [
            "angle",
            "scale"
          ]
        }
      ]
    },
    "SkewMouse": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "distance": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "percentage",
                "vh",
                "vw",
                "vmin",
                "vmax"
              ]
            }
          },
          "additionalProperties": false
        },
        "axis": {
          "type": "string",
          "enum": [
            "horizontal",
            "vertical",
            "both"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": -90,
          "maximum": 90
        },
        "inverted": {
          "type": "boolean"
        },
        "power": {
          "type": "string",
          "enum": [
            "soft",
            "medium",
            "hard"
          ]
        }
      },
      "oneOf": [
        {
          "type": "object",
          "required": [
            "angle"
          ]
        },
        {
          "type": "object",
          "required": [
            "power"
          ]
        }
      ]
    },
    "BgCloseUp": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number"
        }
      }
    },
    "BgFade": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "range": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "required": [
        "range"
      ]
    },
    "BgFadeBack": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number"
        }
      }
    },
    "BgFake3D": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "zoom": {
          "type": "number"
        },
        "stretch": {
          "type": "number"
        }
      }
    },
    "BgPan": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "speed": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "BgParallax": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "speed": {
          "type": "number"
        }
      }
    },
    "BgPullBack": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "number"
        }
      }
    },
    "BgReveal": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "BgRotate": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      }
    },
    "BgSkew": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "angle": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "clockwise",
            "counter-clockwise"
          ]
        }
      }
    },
    "BgZoom": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "zoom": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "in",
            "out"
          ]
        }
      },
      "required": [
        "direction"
      ]
    },
    "ImageParallax": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "speed": {
          "type": "number"
        },
        "inverted": {
          "type": "boolean"
        }
      }
    },
    "Kaleidoscope": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "segments": {
          "type": "number"
        },
        "rotation": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        }
      }
    },
    "RGBSplit": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "splitType": {
          "type": "string",
          "enum": [
            "all",
            "red-cyan",
            "green-magenta",
            "blue-yellow"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "intensity": {
          "type": "number"
        },
        "frequency": {
          "type": "number"
        },
        "octaves": {
          "type": "number",
          "minimum": 1
        },
        "speed": {
          "type": "number"
        },
        "radius": {
          "type": "number"
        }
      }
    },
    "RGBOrb": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "splitType": {
          "type": "string",
          "enum": [
            "all",
            "red-cyan",
            "green-magenta",
            "blue-yellow"
          ]
        },
        "angle": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "intensity": {
          "type": "number"
        },
        "frequency": {
          "type": "number"
        },
        "octaves": {
          "type": "number",
          "minimum": 1
        },
        "speed": {
          "type": "number"
        },
        "radius": {
          "type": "number"
        }
      }
    },
    "SlitScan": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "speed": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "frequency": {
          "type": "number"
        },
        "direction": {
          "type": "string",
          "enum": [
            "x",
            "y"
          ]
        }
      }
    },
    "NoisyTrack": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "radius": {
          "type": "number"
        },
        "spread": {
          "type": "number"
        }
      }
    },
    "Smear": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "radius": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "duration": {
          "type": "number",
          "minimum": 1
        },
        "decayPower": {
          "type": "number"
        }
      }
    },
    "Ripples": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoplay": {
          "type": "boolean"
        },
        "isTriggeredByMouse": {
          "type": "boolean"
        },
        "isTriggeredByScroll": {
          "type": "boolean"
        },
        "frequency": {
          "type": "number"
        },
        "octaves": {
          "type": "number",
          "minimum": 1
        },
        "aspectRatio": {
          "type": "number"
        },
        "intensity": {
          "type": "number"
        },
        "speed": {
          "type": "number"
        }
      }
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "fixerVersions.json": {
    "$id": "urn:dm:schemas:fixerVersions.json",
    "FixerVersions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "viewer_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        },
        "migration_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        },
        "ds_fixer": {
          "oneOf": [
            {
              "type": "object",
              "additionalProperties": {
                "type": "number"
              }
            },
            {
              "type": "string",
              "maxLength": 400
            }
          ]
        }
      }
    }
  },
  "grouping.json": {
    "$id": "urn:dm:schemas:grouping.json",
    "GroupRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "groupId": {
          "type": "string"
        }
      }
    }
  },
  "innerElements.json": {
    "$id": "urn:dm:schemas:innerElements.json",
    "InnerElementQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "InnerElement": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "referredType": {
          "type": "string"
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "referredType"
      ]
    }
  },
  "innerElementsMetaData.json": {
    "$id": "urn:dm:schemas:innerElementsMetaData.json",
    "InnerElementsMetaData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "elementsRemovalState": {
          "type": "object",
          "additionalProperties": {
            "type": "string",
            "enum": [
              "REMOVED"
            ]
          }
        }
      }
    }
  },
  "intent.json": {
    "$id": "urn:dm:schemas:intent.json",
    "Intent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "intent": {
          "type": "string",
          "maxLength": 30
        }
      },
      "required": [
        "intent"
      ]
    }
  },
  "layoutSettings.json": {
    "$id": "urn:dm:schemas:layoutSettings.json",
    "LayoutSettings": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "enum": [
            "LayoutSettings"
          ]
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "autoResponsivenessSettings": {
          "type": "object",
          "properties": {
            "mode": {
              "enum": [
                "adaptive"
              ]
            },
            "lastGroupingsHash": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "layout_data.json": {
    "$id": "urn:dm:schemas:layout_data.json",
    "KeywordSize": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "auto",
            "maxContent",
            "minContent",
            "unset",
            "fit"
          ]
        }
      },
      "additionalProperties": false
    },
    "Calculation": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "Calc"
          ]
        },
        "value": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "CalculationFormula": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "additionalProperties": false,
      "properties": {
        "type": {
          "enum": [
            "CalcFormula"
          ]
        },
        "value": {
          "type": "object",
          "required": [
            "formula",
            "values"
          ],
          "properties": {
            "formula": {
              "type": "string",
              "description": "A valid css calc formula, with constants formatted like ${constName}"
            },
            "values": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Number"
                        ]
                      },
                      "value": {
                        "type": "number"
                      }
                    }
                  }
                ]
              },
              "minProperties": 1,
              "properties": {}
            }
          },
          "additionalProperties": false
        }
      }
    },
    "AspectRatioSize": {
      "type": "object",
      "required": [
        "value",
        "type"
      ],
      "properties": {
        "type": {
          "enum": [
            "aspectRatio"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "SystemVariableSize": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "SystemVariable"
          ]
        },
        "value": {
          "enum": [
            "siteWidth",
            "topBannerHeight"
          ]
        }
      },
      "additionalProperties": false
    },
    "NumberSize": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "Number"
          ]
        },
        "value": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "LayoutSize": {
      "type": "object",
      "anyOf": [
        {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "type": {
              "enum": [
                "Calc"
              ]
            },
            "value": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "additionalProperties": false,
          "properties": {
            "type": {
              "enum": [
                "CalcFormula"
              ]
            },
            "value": {
              "type": "object",
              "required": [
                "formula",
                "values"
              ],
              "properties": {
                "formula": {
                  "type": "string",
                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                },
                "values": {
                  "type": "object",
                  "additionalProperties": {
                    "type": "object",
                    "anyOf": [
                      {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "fr",
                              "percentage",
                              "vh",
                              "vw",
                              "spx",
                              "siteWidthPercentage"
                            ]
                          }
                        }
                      },
                      {
                        "type": "object",
                        "required": [
                          "type",
                          "value"
                        ],
                        "properties": {
                          "type": {
                            "enum": [
                              "SystemVariable"
                            ]
                          },
                          "value": {
                            "enum": [
                              "siteWidth",
                              "topBannerHeight"
                            ]
                          }
                        }
                      },
                      {
                        "type": "object",
                        "required": [
                          "type",
                          "value"
                        ],
                        "properties": {
                          "type": {
                            "enum": [
                              "Number"
                            ]
                          },
                          "value": {
                            "type": "number"
                          }
                        }
                      }
                    ]
                  },
                  "minProperties": 1,
                  "properties": {}
                }
              },
              "additionalProperties": false
            }
          }
        },
        {
          "type": "object",
          "required": [
            "type",
            "value"
          ],
          "properties": {
            "type": {
              "enum": [
                "SystemVariable"
              ]
            },
            "value": {
              "enum": [
                "siteWidth",
                "topBannerHeight"
              ]
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "required": [
            "type"
          ],
          "properties": {
            "type": {
              "enum": [
                "auto",
                "maxContent",
                "minContent",
                "unset",
                "fit"
              ]
            }
          },
          "additionalProperties": false
        }
      ]
    },
    "SpxStopper": {
      "type": "object",
      "properties": {
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "StretchWithSoftMargins": {
      "type": "object",
      "required": [
        "type",
        "value"
      ],
      "properties": {
        "type": {
          "enum": [
            "StretchWithSoftMargins"
          ]
        },
        "value": {
          "type": "object",
          "properties": {
            "margins": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "Height": {
      "type": "object",
      "anyOf": [
        {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "type": {
              "enum": [
                "aspectRatio"
              ]
            },
            "value": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      ]
    },
    "MinMaxSize": {
      "type": "object",
      "required": [
        "min",
        "max",
        "type"
      ],
      "properties": {
        "type": {
          "type": "string",
          "default": "MinMaxSize"
        },
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "GridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "value": {
          "type": [
            "string",
            "number",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string"
              },
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": {
                "type": [
                  "string",
                  "number"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "length": {
          "anyOf": [
            {
              "type": "number"
            },
            {
              "enum": [
                "auto-fill",
                "auto-fit"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "BaseGridTrackSize": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "min": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "max": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "value": {
          "type": [
            "string",
            "number"
          ]
        }
      },
      "additionalProperties": false
    },
    "KeywordLength": {
      "enum": [
        "auto-fill",
        "auto-fit"
      ]
    },
    "ItemsAlignment": {
      "type": "string",
      "enum": [
        "start",
        "end",
        "center",
        "stretch",
        "content"
      ]
    },
    "ContainerLayoutIntent": {
      "type": "object",
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        }
      },
      "additionalProperties": false
    },
    "Alignment": {
      "type": "string",
      "enum": [
        "auto",
        "stretch",
        "start",
        "center",
        "end"
      ]
    },
    "Direction": {
      "enum": [
        "rtl",
        "ltr"
      ]
    },
    "Margins": {
      "type": "object",
      "properties": {
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "Padding": {
      "type": "object",
      "properties": {
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "FlexDirection": {
      "enum": [
        "row",
        "rowReverse",
        "column",
        "columnReverse"
      ]
    },
    "FlexWrap": {
      "enum": [
        "nowrap",
        "wrap"
      ]
    },
    "Overflow": {
      "enum": [
        "auto",
        "scroll",
        "hidden",
        "visible",
        "clip"
      ]
    },
    "Contain": {
      "enum": [
        "none",
        "paint"
      ]
    },
    "AutoFlow": {
      "enum": [
        "row",
        "column",
        "dense",
        "row dense",
        "column dense"
      ]
    },
    "JustifyContent": {
      "enum": [
        "start",
        "center",
        "end",
        "spaceBetween",
        "spaceAround",
        "spaceEvenly"
      ]
    },
    "GridArea": {
      "type": "object",
      "required": [
        "rowStart",
        "rowEnd",
        "columnStart",
        "columnEnd"
      ],
      "properties": {
        "rowStart": {
          "type": "number"
        },
        "columnStart": {
          "type": "number"
        },
        "rowEnd": {
          "type": "number"
        },
        "columnEnd": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "LayoutData": {
      "type": "object",
      "properties": {
        "componentLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "itemLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "containerLayouts": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "SingleLayoutData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right|containerLayout\\/contentArea\\/width)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/width|componentLayout\\/width\\/value\\/margins\\/left|componentLayout\\/width\\/value\\/margins\\/right|componentLayout\\/height|componentLayout\\/minWidth|componentLayout\\/minHeight|componentLayout\\/maxWidth|componentLayout\\/maxHeight|componentLayout\\/margins\\/top|componentLayout\\/margins\\/bottom|componentLayout\\/margins\\/left|componentLayout\\/margins\\/right|itemLayout\\/margins\\/top|itemLayout\\/margins\\/bottom|itemLayout\\/margins\\/left|itemLayout\\/margins\\/right|itemLayout\\/top|itemLayout\\/bottom|itemLayout\\/left|itemLayout\\/right|itemLayout\\/basis|containerLayout\\/rows\\/\\d+?\\/|containerLayout\\/rows\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/max|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/rows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/|containerLayout\\/columns\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/max|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/columns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/rowGap|containerLayout\\/columnGap|containerLayout\\/autoRows\\/\\d+?\\/|containerLayout\\/autoRows\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/max|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoRows\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/|containerLayout\\/autoColumns\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/max|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/min|containerLayout\\/autoColumns\\/\\d+?\\/value\\/\\d+?\\/max|containerLayout\\/padding\\/top|containerLayout\\/padding\\/bottom|containerLayout\\/padding\\/left|containerLayout\\/padding\\/right|containerLayout\\/contentMaxWidth\\/maxWidth|containerLayout\\/spxStopper\\/min|containerLayout\\/spxStopper\\/max|containerLayout\\/margins\\/top|containerLayout\\/margins\\/bottom|containerLayout\\/margins\\/left|containerLayout\\/margins\\/right|containerLayout\\/top|containerLayout\\/bottom|containerLayout\\/left|containerLayout\\/right|containerLayout\\/contentArea\\/width)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:componentLayout\\/height)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/position|containerLayout\\/position)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/gridArea\\/rowStart|itemLayout\\/gridArea\\/columnStart|itemLayout\\/gridArea\\/rowEnd|itemLayout\\/gridArea\\/columnEnd|containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:itemLayout\\/alignSelf|itemLayout\\/justifySelf|containerLayout\\/alignItems|containerLayout\\/contentArea\\/alignment)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:containerLayout\\/rows\\/\\d+?\\/length|containerLayout\\/columns\\/\\d+?\\/length|containerLayout\\/autoRows\\/\\d+?\\/length|containerLayout\\/autoColumns\\/\\d+?\\/length)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:containerLayout\\/justifyContent)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "containerType": {
                  "type": "string",
                  "enum": [
                    "inline-size"
                  ],
                  "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
                },
                "width": {
                  "oneOf": [
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "StretchWithSoftMargins"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "margins": {
                              "type": "object",
                              "properties": {
                                "left": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "value": {
                                          "type": "number"
                                        },
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": {
                                          "type": "string"
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "additionalProperties": false,
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "required": [
                                            "formula",
                                            "values"
                                          ],
                                          "properties": {
                                            "formula": {
                                              "type": "string",
                                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                                            },
                                            "values": {
                                              "type": "object",
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "value",
                                                      "type"
                                                    ],
                                                    "properties": {
                                                      "value": {
                                                        "type": "number"
                                                      },
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": {
                                                        "type": "number"
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              "minProperties": 1,
                                              "properties": {}
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      }
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type",
                                        "value"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                },
                                "right": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "value": {
                                          "type": "number"
                                        },
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": {
                                          "type": "string"
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "additionalProperties": false,
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "required": [
                                            "formula",
                                            "values"
                                          ],
                                          "properties": {
                                            "formula": {
                                              "type": "string",
                                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                                            },
                                            "values": {
                                              "type": "object",
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "value",
                                                      "type"
                                                    ],
                                                    "properties": {
                                                      "value": {
                                                        "type": "number"
                                                      },
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": {
                                                        "type": "number"
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              "minProperties": 1,
                                              "properties": {}
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      }
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type",
                                        "value"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "height": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "aspectRatio"
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  ]
                },
                "minWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "minHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "rotationInDegrees": {
                  "type": "number"
                },
                "fixed": {
                  "type": "boolean"
                },
                "hidden": {
                  "type": "boolean"
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "ComponentLayout"
                  ]
                }
              }
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "containerType": {
                  "type": "string",
                  "enum": [
                    "inline-size"
                  ],
                  "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
                },
                "width": {
                  "oneOf": [
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "StretchWithSoftMargins"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "properties": {
                            "margins": {
                              "type": "object",
                              "properties": {
                                "left": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "value": {
                                          "type": "number"
                                        },
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": {
                                          "type": "string"
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "additionalProperties": false,
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "required": [
                                            "formula",
                                            "values"
                                          ],
                                          "properties": {
                                            "formula": {
                                              "type": "string",
                                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                                            },
                                            "values": {
                                              "type": "object",
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "value",
                                                      "type"
                                                    ],
                                                    "properties": {
                                                      "value": {
                                                        "type": "number"
                                                      },
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": {
                                                        "type": "number"
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              "minProperties": 1,
                                              "properties": {}
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      }
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type",
                                        "value"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                },
                                "right": {
                                  "type": "object",
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "value": {
                                          "type": "number"
                                        },
                                        "type": {
                                          "enum": [
                                            "px",
                                            "em",
                                            "rem",
                                            "fr",
                                            "percentage",
                                            "vh",
                                            "vw",
                                            "spx",
                                            "siteWidthPercentage"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "Calc"
                                          ]
                                        },
                                        "value": {
                                          "type": "string"
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "value",
                                        "type"
                                      ],
                                      "additionalProperties": false,
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "CalcFormula"
                                          ]
                                        },
                                        "value": {
                                          "type": "object",
                                          "required": [
                                            "formula",
                                            "values"
                                          ],
                                          "properties": {
                                            "formula": {
                                              "type": "string",
                                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                                            },
                                            "values": {
                                              "type": "object",
                                              "additionalProperties": {
                                                "type": "object",
                                                "anyOf": [
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "value",
                                                      "type"
                                                    ],
                                                    "properties": {
                                                      "value": {
                                                        "type": "number"
                                                      },
                                                      "type": {
                                                        "enum": [
                                                          "px",
                                                          "em",
                                                          "rem",
                                                          "fr",
                                                          "percentage",
                                                          "vh",
                                                          "vw",
                                                          "spx",
                                                          "siteWidthPercentage"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "SystemVariable"
                                                        ]
                                                      },
                                                      "value": {
                                                        "enum": [
                                                          "siteWidth",
                                                          "topBannerHeight"
                                                        ]
                                                      }
                                                    }
                                                  },
                                                  {
                                                    "type": "object",
                                                    "required": [
                                                      "type",
                                                      "value"
                                                    ],
                                                    "properties": {
                                                      "type": {
                                                        "enum": [
                                                          "Number"
                                                        ]
                                                      },
                                                      "value": {
                                                        "type": "number"
                                                      }
                                                    }
                                                  }
                                                ]
                                              },
                                              "minProperties": 1,
                                              "properties": {}
                                            }
                                          },
                                          "additionalProperties": false
                                        }
                                      }
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type",
                                        "value"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "SystemVariable"
                                          ]
                                        },
                                        "value": {
                                          "enum": [
                                            "siteWidth",
                                            "topBannerHeight"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    },
                                    {
                                      "type": "object",
                                      "required": [
                                        "type"
                                      ],
                                      "properties": {
                                        "type": {
                                          "enum": [
                                            "auto",
                                            "maxContent",
                                            "minContent",
                                            "unset",
                                            "fit"
                                          ]
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "height": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "aspectRatio"
                          ]
                        },
                        "value": {
                          "type": "number"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  ]
                },
                "minWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "minHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxWidth": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "maxHeight": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "direction": {
                  "enum": [
                    "rtl",
                    "ltr"
                  ]
                },
                "rotationInDegrees": {
                  "type": "number"
                },
                "fixed": {
                  "type": "boolean"
                },
                "hidden": {
                  "type": "boolean"
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "ClassicComponentLayout"
                  ]
                }
              }
            }
          ]
        },
        "itemLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "GridItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "gridArea": {
                  "type": "object",
                  "required": [
                    "rowStart",
                    "rowEnd",
                    "columnStart",
                    "columnEnd"
                  ],
                  "properties": {
                    "rowStart": {
                      "type": "number"
                    },
                    "columnStart": {
                      "type": "number"
                    },
                    "rowEnd": {
                      "type": "number"
                    },
                    "columnEnd": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              }
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "FixedItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              }
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "FlexItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": {
                  "type": "number"
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": {
                  "type": "number"
                },
                "shrink": {
                  "type": "number"
                }
              }
            },
            {
              "type": [
                "object"
              ],
              "additionalProperties": false,
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "OrganizerItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": {
                  "type": "number"
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": {
                  "type": "number"
                },
                "shrink": {
                  "type": "number"
                }
              }
            },
            {
              "type": [
                "object"
              ],
              "additionalProperties": false,
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "StackItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "order": {
                  "type": "number"
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "basis": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "grow": {
                  "type": "number"
                },
                "shrink": {
                  "type": "number"
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MultiColumnsItemLayout"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "meshData",
                "type"
              ],
              "properties": {
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "meshData": {
                  "type": "object",
                  "required": [
                    "width",
                    "height",
                    "x",
                    "y"
                  ],
                  "properties": {
                    "width": {
                      "type": "number"
                    },
                    "height": {
                      "type": "number"
                    },
                    "x": {
                      "type": "number"
                    },
                    "y": {
                      "type": "number"
                    },
                    "rotationInDegrees": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MeshItemLayout"
                  ]
                },
                "isAbsolutePosition": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "FixedPositionItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                }
              }
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "BackgroundLayerItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "alignSelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifySelf": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                }
              }
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MasterPageItemLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "isFixed": {
                  "type": "boolean"
                }
              }
            }
          ]
        },
        "containerLayout": {
          "type": "object",
          "default": {},
          "anyOf": [
            {
              "type": "object",
              "required": [
                "rows",
                "columns"
              ],
              "properties": {
                "rows": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": {
                        "type": [
                          "string",
                          "number",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string"
                            },
                            "min": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "max": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "value": {
                              "type": [
                                "string",
                                "number"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "columns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": {
                        "type": [
                          "string",
                          "number",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string"
                            },
                            "min": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "max": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "value": {
                              "type": [
                                "string",
                                "number"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "autoRows": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": {
                        "type": [
                          "string",
                          "number",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string"
                            },
                            "min": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "max": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "value": {
                              "type": [
                                "string",
                                "number"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "autoColumns": {
                  "type": "array",
                  "items": {
                    "type": "object",
                    "properties": {
                      "type": {
                        "type": "string"
                      },
                      "min": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "max": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Calc"
                                ]
                              },
                              "value": {
                                "type": "string"
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "additionalProperties": false,
                            "properties": {
                              "type": {
                                "enum": [
                                  "CalcFormula"
                                ]
                              },
                              "value": {
                                "type": "object",
                                "required": [
                                  "formula",
                                  "values"
                                ],
                                "properties": {
                                  "formula": {
                                    "type": "string",
                                    "description": "A valid css calc formula, with constants formatted like ${constName}"
                                  },
                                  "values": {
                                    "type": "object",
                                    "additionalProperties": {
                                      "type": "object",
                                      "anyOf": [
                                        {
                                          "type": "object",
                                          "required": [
                                            "value",
                                            "type"
                                          ],
                                          "properties": {
                                            "value": {
                                              "type": "number"
                                            },
                                            "type": {
                                              "enum": [
                                                "px",
                                                "em",
                                                "rem",
                                                "fr",
                                                "percentage",
                                                "vh",
                                                "vw",
                                                "spx",
                                                "siteWidthPercentage"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "SystemVariable"
                                              ]
                                            },
                                            "value": {
                                              "enum": [
                                                "siteWidth",
                                                "topBannerHeight"
                                              ]
                                            }
                                          }
                                        },
                                        {
                                          "type": "object",
                                          "required": [
                                            "type",
                                            "value"
                                          ],
                                          "properties": {
                                            "type": {
                                              "enum": [
                                                "Number"
                                              ]
                                            },
                                            "value": {
                                              "type": "number"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    "minProperties": 1,
                                    "properties": {}
                                  }
                                },
                                "additionalProperties": false
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            },
                            "additionalProperties": false
                          },
                          {
                            "type": "object",
                            "required": [
                              "type"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "auto",
                                  "maxContent",
                                  "minContent",
                                  "unset",
                                  "fit"
                                ]
                              }
                            },
                            "additionalProperties": false
                          }
                        ]
                      },
                      "value": {
                        "type": [
                          "string",
                          "number",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "type": {
                              "type": "string"
                            },
                            "min": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "max": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Calc"
                                      ]
                                    },
                                    "value": {
                                      "type": "string"
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "additionalProperties": false,
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "CalcFormula"
                                      ]
                                    },
                                    "value": {
                                      "type": "object",
                                      "required": [
                                        "formula",
                                        "values"
                                      ],
                                      "properties": {
                                        "formula": {
                                          "type": "string",
                                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                                        },
                                        "values": {
                                          "type": "object",
                                          "additionalProperties": {
                                            "type": "object",
                                            "anyOf": [
                                              {
                                                "type": "object",
                                                "required": [
                                                  "value",
                                                  "type"
                                                ],
                                                "properties": {
                                                  "value": {
                                                    "type": "number"
                                                  },
                                                  "type": {
                                                    "enum": [
                                                      "px",
                                                      "em",
                                                      "rem",
                                                      "fr",
                                                      "percentage",
                                                      "vh",
                                                      "vw",
                                                      "spx",
                                                      "siteWidthPercentage"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "SystemVariable"
                                                    ]
                                                  },
                                                  "value": {
                                                    "enum": [
                                                      "siteWidth",
                                                      "topBannerHeight"
                                                    ]
                                                  }
                                                }
                                              },
                                              {
                                                "type": "object",
                                                "required": [
                                                  "type",
                                                  "value"
                                                ],
                                                "properties": {
                                                  "type": {
                                                    "enum": [
                                                      "Number"
                                                    ]
                                                  },
                                                  "value": {
                                                    "type": "number"
                                                  }
                                                }
                                              }
                                            ]
                                          },
                                          "minProperties": 1,
                                          "properties": {}
                                        }
                                      },
                                      "additionalProperties": false
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "auto",
                                        "maxContent",
                                        "minContent",
                                        "unset",
                                        "fit"
                                      ]
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              ]
                            },
                            "value": {
                              "type": [
                                "string",
                                "number"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      },
                      "length": {
                        "anyOf": [
                          {
                            "type": "number"
                          },
                          {
                            "enum": [
                              "auto-fill",
                              "auto-fit"
                            ]
                          }
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                },
                "autoFlow": {
                  "enum": [
                    "row",
                    "column",
                    "dense",
                    "row dense",
                    "column dense"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": {
                  "type": "boolean"
                },
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehavior": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "GridContainerLayout"
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            {
              "additionalProperties": false,
              "type": [
                "object"
              ],
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "FlexContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": {
                  "type": "boolean"
                },
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              }
            },
            {
              "type": [
                "object"
              ],
              "additionalProperties": false,
              "properties": {
                "layoutIntent": {
                  "type": "string",
                  "enum": [
                    "Rows",
                    "Cols",
                    "Mosaic",
                    "Slider",
                    "SlideShow",
                    "Bricks"
                  ]
                },
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "OrganizerContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": {
                  "type": "boolean"
                },
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              }
            },
            {
              "type": [
                "object"
              ],
              "additionalProperties": false,
              "properties": {
                "id": {
                  "type": [
                    "string",
                    "null"
                  ]
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "StackContainerLayout"
                  ]
                },
                "scrollSnapAlign": {
                  "enum": [
                    "center",
                    "end",
                    "start",
                    "none"
                  ]
                },
                "pinnedToContainer": {
                  "type": "boolean"
                },
                "margins": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "position": {
                  "enum": [
                    "sticky",
                    "stickyToHeader",
                    "absolute",
                    "relative"
                  ]
                },
                "isInFront": {
                  "type": "boolean"
                },
                "top": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "bottom": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "left": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "right": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "direction": {
                  "enum": [
                    "row",
                    "rowReverse",
                    "column",
                    "columnReverse"
                  ]
                },
                "wrap": {
                  "enum": [
                    "nowrap",
                    "wrap"
                  ]
                },
                "alignItems": {
                  "type": "string",
                  "enum": [
                    "start",
                    "end",
                    "center",
                    "stretch",
                    "content"
                  ]
                },
                "justifyContent": {
                  "enum": [
                    "start",
                    "center",
                    "end",
                    "spaceBetween",
                    "spaceAround",
                    "spaceEvenly"
                  ]
                },
                "overflowY": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "overflowX": {
                  "enum": [
                    "auto",
                    "scroll",
                    "hidden",
                    "visible",
                    "clip"
                  ]
                },
                "hideScrollbar": {
                  "type": "boolean"
                },
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollSnap": {
                  "type": "object",
                  "properties": {
                    "scrollSnapType": {
                      "enum": [
                        "mandatory",
                        "proximity",
                        "none"
                      ]
                    },
                    "scrollSnapDirection": {
                      "enum": [
                        "x",
                        "y"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "scrollBehaviour": {
                  "enum": [
                    "auto",
                    "smooth"
                  ]
                },
                "contentMaxWidth": {
                  "type": "object",
                  "properties": {
                    "maxWidth": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "align": {
                      "type": "string",
                      "enum": [
                        "center",
                        "right",
                        "left"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "contain": {
                  "enum": [
                    "none",
                    "paint"
                  ]
                }
              }
            },
            {
              "type": "object",
              "required": [
                "columnCount",
                "type"
              ],
              "properties": {
                "alignContent": {
                  "type": "string",
                  "enum": [
                    "auto",
                    "stretch",
                    "start",
                    "center",
                    "end"
                  ]
                },
                "columnCount": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 1
                },
                "padding": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "bottom": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "left": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "right": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "rowGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "columnGap": {
                  "type": "object",
                  "anyOf": [
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "em",
                            "rem",
                            "fr",
                            "percentage",
                            "vh",
                            "vw",
                            "spx",
                            "siteWidthPercentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "Calc"
                          ]
                        },
                        "value": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "additionalProperties": false,
                      "properties": {
                        "type": {
                          "enum": [
                            "CalcFormula"
                          ]
                        },
                        "value": {
                          "type": "object",
                          "required": [
                            "formula",
                            "values"
                          ],
                          "properties": {
                            "formula": {
                              "type": "string",
                              "description": "A valid css calc formula, with constants formatted like ${constName}"
                            },
                            "values": {
                              "type": "object",
                              "additionalProperties": {
                                "type": "object",
                                "anyOf": [
                                  {
                                    "type": "object",
                                    "required": [
                                      "value",
                                      "type"
                                    ],
                                    "properties": {
                                      "value": {
                                        "type": "number"
                                      },
                                      "type": {
                                        "enum": [
                                          "px",
                                          "em",
                                          "rem",
                                          "fr",
                                          "percentage",
                                          "vh",
                                          "vw",
                                          "spx",
                                          "siteWidthPercentage"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "SystemVariable"
                                        ]
                                      },
                                      "value": {
                                        "enum": [
                                          "siteWidth",
                                          "topBannerHeight"
                                        ]
                                      }
                                    }
                                  },
                                  {
                                    "type": "object",
                                    "required": [
                                      "type",
                                      "value"
                                    ],
                                    "properties": {
                                      "type": {
                                        "enum": [
                                          "Number"
                                        ]
                                      },
                                      "value": {
                                        "type": "number"
                                      }
                                    }
                                  }
                                ]
                              },
                              "minProperties": 1,
                              "properties": {}
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    {
                      "type": "object",
                      "required": [
                        "type",
                        "value"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "SystemVariable"
                          ]
                        },
                        "value": {
                          "enum": [
                            "siteWidth",
                            "topBannerHeight"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    {
                      "type": "object",
                      "required": [
                        "type"
                      ],
                      "properties": {
                        "type": {
                          "enum": [
                            "auto",
                            "maxContent",
                            "minContent",
                            "unset",
                            "fit"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  ]
                },
                "spxStopper": {
                  "type": "object",
                  "properties": {
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "type": {
                  "type": "string",
                  "enum": [
                    "MultiColumnsContainerLayout"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "MeshContainerLayout"
                  ]
                },
                "meshData": {
                  "type": "object",
                  "required": [
                    "contentHeight"
                  ],
                  "properties": {
                    "contentHeight": {
                      "oneOf": [
                        {
                          "type": "number"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "auto"
                          ]
                        }
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "contentArea": {
                  "type": "object",
                  "required": [
                    "alignment",
                    "width"
                  ],
                  "properties": {
                    "alignment": {
                      "type": "string",
                      "enum": [
                        "start",
                        "end",
                        "center",
                        "stretch",
                        "content"
                      ]
                    },
                    "width": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "ratio": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "spx": {
          "type": "object",
          "required": [
            "refWidth",
            "resolverType"
          ],
          "properties": {
            "refWidth": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 1
            },
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "itemLayout",
        "componentLayout",
        "containerLayout"
      ]
    },
    "ScrollSnapType": {
      "enum": [
        "mandatory",
        "proximity",
        "none"
      ]
    },
    "ScrollSnapDirection": {
      "enum": [
        "x",
        "y"
      ]
    },
    "ScrollBehavior": {
      "enum": [
        "auto",
        "smooth"
      ]
    },
    "ScrollSnapAlignType": {
      "enum": [
        "center",
        "end",
        "start",
        "none"
      ]
    },
    "ScrollSnapData": {
      "type": "object",
      "properties": {
        "scrollSnapType": {
          "enum": [
            "mandatory",
            "proximity",
            "none"
          ]
        },
        "scrollSnapDirection": {
          "enum": [
            "x",
            "y"
          ]
        }
      },
      "additionalProperties": false
    },
    "ContentMaxWidth": {
      "type": "object",
      "properties": {
        "maxWidth": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        },
        "align": {
          "type": "string",
          "enum": [
            "center",
            "right",
            "left"
          ]
        }
      },
      "additionalProperties": false
    },
    "GridContainerLayout": {
      "type": "object",
      "required": [
        "rows",
        "columns"
      ],
      "properties": {
        "rows": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string"
              },
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": {
                "type": [
                  "string",
                  "number",
                  "array"
                ],
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "value": {
                      "type": [
                        "string",
                        "number"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "columns": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string"
              },
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": {
                "type": [
                  "string",
                  "number",
                  "array"
                ],
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "value": {
                      "type": [
                        "string",
                        "number"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "autoRows": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string"
              },
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": {
                "type": [
                  "string",
                  "number",
                  "array"
                ],
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "value": {
                      "type": [
                        "string",
                        "number"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "autoColumns": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "type": {
                "type": "string"
              },
              "min": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "max": {
                "type": "object",
                "anyOf": [
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "fr",
                          "percentage",
                          "vh",
                          "vw",
                          "spx",
                          "siteWidthPercentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "Calc"
                        ]
                      },
                      "value": {
                        "type": "string"
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "additionalProperties": false,
                    "properties": {
                      "type": {
                        "enum": [
                          "CalcFormula"
                        ]
                      },
                      "value": {
                        "type": "object",
                        "required": [
                          "formula",
                          "values"
                        ],
                        "properties": {
                          "formula": {
                            "type": "string",
                            "description": "A valid css calc formula, with constants formatted like ${constName}"
                          },
                          "values": {
                            "type": "object",
                            "additionalProperties": {
                              "type": "object",
                              "anyOf": [
                                {
                                  "type": "object",
                                  "required": [
                                    "value",
                                    "type"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "number"
                                    },
                                    "type": {
                                      "enum": [
                                        "px",
                                        "em",
                                        "rem",
                                        "fr",
                                        "percentage",
                                        "vh",
                                        "vw",
                                        "spx",
                                        "siteWidthPercentage"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "SystemVariable"
                                      ]
                                    },
                                    "value": {
                                      "enum": [
                                        "siteWidth",
                                        "topBannerHeight"
                                      ]
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "required": [
                                    "type",
                                    "value"
                                  ],
                                  "properties": {
                                    "type": {
                                      "enum": [
                                        "Number"
                                      ]
                                    },
                                    "value": {
                                      "type": "number"
                                    }
                                  }
                                }
                              ]
                            },
                            "minProperties": 1,
                            "properties": {}
                          }
                        },
                        "additionalProperties": false
                      }
                    }
                  },
                  {
                    "type": "object",
                    "required": [
                      "type",
                      "value"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "SystemVariable"
                        ]
                      },
                      "value": {
                        "enum": [
                          "siteWidth",
                          "topBannerHeight"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  {
                    "type": "object",
                    "required": [
                      "type"
                    ],
                    "properties": {
                      "type": {
                        "enum": [
                          "auto",
                          "maxContent",
                          "minContent",
                          "unset",
                          "fit"
                        ]
                      }
                    },
                    "additionalProperties": false
                  }
                ]
              },
              "value": {
                "type": [
                  "string",
                  "number",
                  "array"
                ],
                "items": {
                  "type": "object",
                  "properties": {
                    "type": {
                      "type": "string"
                    },
                    "min": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "max": {
                      "type": "object",
                      "anyOf": [
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "fr",
                                "percentage",
                                "vh",
                                "vw",
                                "spx",
                                "siteWidthPercentage"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "Calc"
                              ]
                            },
                            "value": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "additionalProperties": false,
                          "properties": {
                            "type": {
                              "enum": [
                                "CalcFormula"
                              ]
                            },
                            "value": {
                              "type": "object",
                              "required": [
                                "formula",
                                "values"
                              ],
                              "properties": {
                                "formula": {
                                  "type": "string",
                                  "description": "A valid css calc formula, with constants formatted like ${constName}"
                                },
                                "values": {
                                  "type": "object",
                                  "additionalProperties": {
                                    "type": "object",
                                    "anyOf": [
                                      {
                                        "type": "object",
                                        "required": [
                                          "value",
                                          "type"
                                        ],
                                        "properties": {
                                          "value": {
                                            "type": "number"
                                          },
                                          "type": {
                                            "enum": [
                                              "px",
                                              "em",
                                              "rem",
                                              "fr",
                                              "percentage",
                                              "vh",
                                              "vw",
                                              "spx",
                                              "siteWidthPercentage"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "SystemVariable"
                                            ]
                                          },
                                          "value": {
                                            "enum": [
                                              "siteWidth",
                                              "topBannerHeight"
                                            ]
                                          }
                                        }
                                      },
                                      {
                                        "type": "object",
                                        "required": [
                                          "type",
                                          "value"
                                        ],
                                        "properties": {
                                          "type": {
                                            "enum": [
                                              "Number"
                                            ]
                                          },
                                          "value": {
                                            "type": "number"
                                          }
                                        }
                                      }
                                    ]
                                  },
                                  "minProperties": 1,
                                  "properties": {}
                                }
                              },
                              "additionalProperties": false
                            }
                          }
                        },
                        {
                          "type": "object",
                          "required": [
                            "type",
                            "value"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "SystemVariable"
                              ]
                            },
                            "value": {
                              "enum": [
                                "siteWidth",
                                "topBannerHeight"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        {
                          "type": "object",
                          "required": [
                            "type"
                          ],
                          "properties": {
                            "type": {
                              "enum": [
                                "auto",
                                "maxContent",
                                "minContent",
                                "unset",
                                "fit"
                              ]
                            }
                          },
                          "additionalProperties": false
                        }
                      ]
                    },
                    "value": {
                      "type": [
                        "string",
                        "number"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "length": {
                "anyOf": [
                  {
                    "type": "number"
                  },
                  {
                    "enum": [
                      "auto-fill",
                      "auto-fit"
                    ]
                  }
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "autoFlow": {
          "enum": [
            "row",
            "column",
            "dense",
            "row dense",
            "column dense"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehavior": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "GridContainerLayout"
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "ComponentLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "type": {
          "type": "string",
          "enum": [
            "ComponentLayout"
          ]
        }
      }
    },
    "ClassicComponentLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "type": {
          "type": "string",
          "enum": [
            "ClassicComponentLayout"
          ]
        }
      }
    },
    "BaseComponentLayout": {
      "type": "object",
      "properties": {
        "containerType": {
          "type": "string",
          "enum": [
            "inline-size"
          ],
          "description": "The css container type. This property is correct for normal components as well as containers,is used to define the type of containment used in a css container query."
        },
        "width": {
          "oneOf": [
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "StretchWithSoftMargins"
                  ]
                },
                "value": {
                  "type": "object",
                  "properties": {
                    "margins": {
                      "type": "object",
                      "properties": {
                        "left": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        },
                        "right": {
                          "type": "object",
                          "anyOf": [
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "value": {
                                  "type": "number"
                                },
                                "type": {
                                  "enum": [
                                    "px",
                                    "em",
                                    "rem",
                                    "fr",
                                    "percentage",
                                    "vh",
                                    "vw",
                                    "spx",
                                    "siteWidthPercentage"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "Calc"
                                  ]
                                },
                                "value": {
                                  "type": "string"
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "value",
                                "type"
                              ],
                              "additionalProperties": false,
                              "properties": {
                                "type": {
                                  "enum": [
                                    "CalcFormula"
                                  ]
                                },
                                "value": {
                                  "type": "object",
                                  "required": [
                                    "formula",
                                    "values"
                                  ],
                                  "properties": {
                                    "formula": {
                                      "type": "string",
                                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                                    },
                                    "values": {
                                      "type": "object",
                                      "additionalProperties": {
                                        "type": "object",
                                        "anyOf": [
                                          {
                                            "type": "object",
                                            "required": [
                                              "value",
                                              "type"
                                            ],
                                            "properties": {
                                              "value": {
                                                "type": "number"
                                              },
                                              "type": {
                                                "enum": [
                                                  "px",
                                                  "em",
                                                  "rem",
                                                  "fr",
                                                  "percentage",
                                                  "vh",
                                                  "vw",
                                                  "spx",
                                                  "siteWidthPercentage"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "SystemVariable"
                                                ]
                                              },
                                              "value": {
                                                "enum": [
                                                  "siteWidth",
                                                  "topBannerHeight"
                                                ]
                                              }
                                            }
                                          },
                                          {
                                            "type": "object",
                                            "required": [
                                              "type",
                                              "value"
                                            ],
                                            "properties": {
                                              "type": {
                                                "enum": [
                                                  "Number"
                                                ]
                                              },
                                              "value": {
                                                "type": "number"
                                              }
                                            }
                                          }
                                        ]
                                      },
                                      "minProperties": 1,
                                      "properties": {}
                                    }
                                  },
                                  "additionalProperties": false
                                }
                              }
                            },
                            {
                              "type": "object",
                              "required": [
                                "type",
                                "value"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "SystemVariable"
                                  ]
                                },
                                "value": {
                                  "enum": [
                                    "siteWidth",
                                    "topBannerHeight"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            },
                            {
                              "type": "object",
                              "required": [
                                "type"
                              ],
                              "properties": {
                                "type": {
                                  "enum": [
                                    "auto",
                                    "maxContent",
                                    "minContent",
                                    "unset",
                                    "fit"
                                  ]
                                }
                              },
                              "additionalProperties": false
                            }
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "height": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        },
        "minWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "minHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxWidth": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "maxHeight": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "rotationInDegrees": {
          "type": "number"
        },
        "fixed": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "GridItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "GridItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "gridArea": {
          "type": "object",
          "required": [
            "rowStart",
            "rowEnd",
            "columnStart",
            "columnEnd"
          ],
          "properties": {
            "rowStart": {
              "type": "number"
            },
            "columnStart": {
              "type": "number"
            },
            "rowEnd": {
              "type": "number"
            },
            "columnEnd": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      }
    },
    "FixedItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "FixedItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      }
    },
    "BackgroundLayerItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "BackgroundLayerItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      }
    },
    "FixedPositionItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "FixedPositionItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "MasterPageItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "MasterPageItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "isFixed": {
          "type": "boolean"
        }
      }
    },
    "FlexContainerLayoutBase": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      }
    },
    "FlexContainerLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "FlexContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      }
    },
    "FlexItemLayoutBase": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": {
          "type": "number"
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": {
          "type": "number"
        },
        "shrink": {
          "type": "number"
        }
      }
    },
    "FlexItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "FlexItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": {
          "type": "number"
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": {
          "type": "number"
        },
        "shrink": {
          "type": "number"
        }
      }
    },
    "OrganizerContainerLayout": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "layoutIntent": {
          "type": "string",
          "enum": [
            "Rows",
            "Cols",
            "Mosaic",
            "Slider",
            "SlideShow",
            "Bricks"
          ]
        },
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "OrganizerContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      }
    },
    "MultiColumnsContainerLayout": {
      "type": "object",
      "required": [
        "columnCount",
        "type"
      ],
      "properties": {
        "alignContent": {
          "type": "string",
          "enum": [
            "auto",
            "stretch",
            "start",
            "center",
            "end"
          ]
        },
        "columnCount": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsContainerLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "MultiColumnsItemLayout": {
      "type": "object",
      "required": [
        "type"
      ],
      "properties": {
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MultiColumnsItemLayout"
          ]
        }
      },
      "additionalProperties": false
    },
    "OrganizerItemLayout": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "OrganizerItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": {
          "type": "number"
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": {
          "type": "number"
        },
        "shrink": {
          "type": "number"
        }
      }
    },
    "StackContainerLayout": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "StackContainerLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "direction": {
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ]
        },
        "wrap": {
          "enum": [
            "nowrap",
            "wrap"
          ]
        },
        "alignItems": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifyContent": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        },
        "overflowY": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "overflowX": {
          "enum": [
            "auto",
            "scroll",
            "hidden",
            "visible",
            "clip"
          ]
        },
        "hideScrollbar": {
          "type": "boolean"
        },
        "padding": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollSnap": {
          "type": "object",
          "properties": {
            "scrollSnapType": {
              "enum": [
                "mandatory",
                "proximity",
                "none"
              ]
            },
            "scrollSnapDirection": {
              "enum": [
                "x",
                "y"
              ]
            }
          },
          "additionalProperties": false
        },
        "scrollBehaviour": {
          "enum": [
            "auto",
            "smooth"
          ]
        },
        "contentMaxWidth": {
          "type": "object",
          "properties": {
            "maxWidth": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "align": {
              "type": "string",
              "enum": [
                "center",
                "right",
                "left"
              ]
            }
          },
          "additionalProperties": false
        },
        "spxStopper": {
          "type": "object",
          "properties": {
            "min": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "max": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "rowGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "columnGap": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "contain": {
          "enum": [
            "none",
            "paint"
          ]
        }
      }
    },
    "StackItemLayout": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": "string",
          "enum": [
            "StackItemLayout"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "order": {
          "type": "number"
        },
        "alignSelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "basis": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "grow": {
          "type": "number"
        },
        "shrink": {
          "type": "number"
        }
      }
    },
    "LayoutDataItem": {
      "type": "object",
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "BaseItemLayout": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "id": {
          "type": [
            "string",
            "null"
          ]
        },
        "type": {
          "type": [
            "string",
            "null"
          ]
        },
        "scrollSnapAlign": {
          "enum": [
            "center",
            "end",
            "start",
            "none"
          ]
        },
        "pinnedToContainer": {
          "type": "boolean"
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "position": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        },
        "isInFront": {
          "type": "boolean"
        },
        "top": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "bottom": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "left": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "right": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "PositionType": {
      "enum": [
        "sticky",
        "stickyToHeader",
        "absolute",
        "relative"
      ]
    },
    "WedgeItem": {
      "type": "object",
      "required": [
        "distance",
        "startsAtRow"
      ],
      "properties": {
        "distance": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "startsAtRow": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        }
      },
      "additionalProperties": false
    },
    "MeshGridArea": {
      "type": "object",
      "required": [
        "rowStart",
        "rowEnd"
      ],
      "properties": {
        "rowStart": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 1
        },
        "rowEnd": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 2
        }
      },
      "additionalProperties": false
    },
    "ItemMeshData": {
      "type": "object",
      "required": [
        "width",
        "height",
        "x",
        "y"
      ],
      "properties": {
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "rotationInDegrees": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "MeshItemLayout": {
      "type": "object",
      "required": [
        "meshData",
        "type"
      ],
      "properties": {
        "justifySelf": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "margins": {
          "type": "object",
          "properties": {
            "top": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "bottom": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "left": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "right": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "meshData": {
          "type": "object",
          "required": [
            "width",
            "height",
            "x",
            "y"
          ],
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            },
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            },
            "rotationInDegrees": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "type": {
          "type": "string",
          "enum": [
            "MeshItemLayout"
          ]
        },
        "isAbsolutePosition": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "ContainerMeshData": {
      "type": "object",
      "required": [
        "contentHeight"
      ],
      "properties": {
        "contentHeight": {
          "oneOf": [
            {
              "type": "number"
            },
            {
              "type": "string",
              "enum": [
                "auto"
              ]
            }
          ]
        }
      },
      "additionalProperties": false
    },
    "ContentArea": {
      "type": "object",
      "required": [
        "alignment",
        "width"
      ],
      "properties": {
        "alignment": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        },
        "width": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        },
        "ratio": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "MeshContainerLayout": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeshContainerLayout"
          ]
        },
        "meshData": {
          "type": "object",
          "required": [
            "contentHeight"
          ],
          "properties": {
            "contentHeight": {
              "oneOf": [
                {
                  "type": "number"
                },
                {
                  "type": "string",
                  "enum": [
                    "auto"
                  ]
                }
              ]
            }
          },
          "additionalProperties": false
        },
        "contentArea": {
          "type": "object",
          "required": [
            "alignment",
            "width"
          ],
          "properties": {
            "alignment": {
              "type": "string",
              "enum": [
                "start",
                "end",
                "center",
                "stretch",
                "content"
              ]
            },
            "width": {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            },
            "ratio": {
              "type": "number"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    },
    "BreakpointRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "breakpoint": {
          "type": [
            "string"
          ]
        },
        "ref": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "breakpoint",
        "ref"
      ]
    }
  },
  "manifest.json": {
    "$id": "urn:dm:schemas:manifest.json",
    "Manifest": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "gfpp": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "desktop": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "mainAction1": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "label"
                      ],
                      "oneOf": [
                        {
                          "required": [
                            "actionId"
                          ]
                        },
                        {
                          "required": [
                            "actionType"
                          ]
                        }
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        },
                        "label": {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "value",
                            "shouldTranslate"
                          ],
                          "properties": {
                            "value": {
                              "type": "string",
                              "maxLength": 100
                            },
                            "shouldTranslate": {
                              "type": "boolean"
                            }
                          }
                        },
                        "actionType": {
                          "enum": [
                            "settings",
                            "layout",
                            "design",
                            "manage",
                            "background"
                          ]
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT",
                            "DEFAULT1",
                            "DEFAULT2"
                          ]
                        }
                      }
                    }
                  ]
                },
                "mainAction2": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "label"
                      ],
                      "oneOf": [
                        {
                          "required": [
                            "actionId"
                          ]
                        },
                        {
                          "required": [
                            "actionType"
                          ]
                        }
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        },
                        "label": {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "value",
                            "shouldTranslate"
                          ],
                          "properties": {
                            "value": {
                              "type": "string",
                              "maxLength": 100
                            },
                            "shouldTranslate": {
                              "type": "boolean"
                            }
                          }
                        },
                        "actionType": {
                          "enum": [
                            "settings",
                            "layout",
                            "design",
                            "manage",
                            "background"
                          ]
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT",
                            "DEFAULT1",
                            "DEFAULT2"
                          ]
                        }
                      }
                    }
                  ]
                },
                "iconButtons": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "settings": {
                      "anyOf": [
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior",
                            "actionId"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": {
                              "type": "string",
                              "maxLength": 50
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "add": {
                      "anyOf": [
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior",
                            "actionId"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": {
                              "type": "string",
                              "maxLength": 50
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "design": {
                      "anyOf": [
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior",
                            "actionId"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": {
                              "type": "string",
                              "maxLength": 50
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "crop": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "filters": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "animation": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "link": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "stretch": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "layout": {
                      "anyOf": [
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior",
                            "actionId"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": {
                              "type": "string",
                              "maxLength": 50
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "upgrade": {
                      "anyOf": [
                        {
                          "anyOf": [
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior",
                                "actionId"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": {
                                  "type": "string",
                                  "maxLength": 50
                                }
                              }
                            },
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            }
                          ]
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "SITE_UPGRADE"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    "connect": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "pinMode": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "customConnect": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "actionId"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    },
                    "focalPoint": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    },
                    "presets": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    }
                  }
                },
                "helpId": {
                  "type": "string",
                  "maxLength": 50
                }
              }
            }
          }
        },
        "behavior": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "duplicatable": {
              "type": "boolean"
            },
            "resizable": {
              "type": "boolean"
            },
            "preventHide": {
              "type": "boolean"
            },
            "dataEditOptions": {
              "type": "string",
              "maxLength": 50
            },
            "closed": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "selectable": {
                  "type": "boolean"
                },
                "hideFromHierarchy": {
                  "type": "boolean"
                }
              }
            }
          }
        },
        "displayName": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "value",
            "shouldTranslate"
          ],
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 100
            },
            "shouldTranslate": {
              "type": "boolean"
            }
          }
        },
        "connections": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "*": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "gfpp": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "desktop": {
                      "type": "object",
                      "additionalProperties": false,
                      "properties": {
                        "mainAction1": {
                          "anyOf": [
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior",
                                "label"
                              ],
                              "oneOf": [
                                {
                                  "required": [
                                    "actionId"
                                  ]
                                },
                                {
                                  "required": [
                                    "actionType"
                                  ]
                                }
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": {
                                  "type": "string",
                                  "maxLength": 50
                                },
                                "label": {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "value",
                                    "shouldTranslate"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "string",
                                      "maxLength": 100
                                    },
                                    "shouldTranslate": {
                                      "type": "boolean"
                                    }
                                  }
                                },
                                "actionType": {
                                  "enum": [
                                    "settings",
                                    "layout",
                                    "design",
                                    "manage",
                                    "background"
                                  ]
                                }
                              }
                            },
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT",
                                    "DEFAULT1",
                                    "DEFAULT2"
                                  ]
                                }
                              }
                            }
                          ]
                        },
                        "mainAction2": {
                          "anyOf": [
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior",
                                "label"
                              ],
                              "oneOf": [
                                {
                                  "required": [
                                    "actionId"
                                  ]
                                },
                                {
                                  "required": [
                                    "actionType"
                                  ]
                                }
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": {
                                  "type": "string",
                                  "maxLength": 50
                                },
                                "label": {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "value",
                                    "shouldTranslate"
                                  ],
                                  "properties": {
                                    "value": {
                                      "type": "string",
                                      "maxLength": 100
                                    },
                                    "shouldTranslate": {
                                      "type": "boolean"
                                    }
                                  }
                                },
                                "actionType": {
                                  "enum": [
                                    "settings",
                                    "layout",
                                    "design",
                                    "manage",
                                    "background"
                                  ]
                                }
                              }
                            },
                            {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT",
                                    "DEFAULT1",
                                    "DEFAULT2"
                                  ]
                                }
                              }
                            }
                          ]
                        },
                        "iconButtons": {
                          "type": "object",
                          "additionalProperties": false,
                          "properties": {
                            "settings": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior",
                                    "actionId"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": {
                                      "type": "string",
                                      "maxLength": 50
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            "add": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior",
                                    "actionId"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": {
                                      "type": "string",
                                      "maxLength": 50
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            "design": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior",
                                    "actionId"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": {
                                      "type": "string",
                                      "maxLength": 50
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            "crop": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "filters": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "animation": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "link": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "stretch": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "layout": {
                              "anyOf": [
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior",
                                    "actionId"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "CUSTOM_ACTION"
                                      ]
                                    },
                                    "actionId": {
                                      "type": "string",
                                      "maxLength": 50
                                    }
                                  }
                                },
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "HIDE",
                                        "DEFAULT"
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            "upgrade": {
                              "anyOf": [
                                {
                                  "anyOf": [
                                    {
                                      "type": "object",
                                      "additionalProperties": false,
                                      "required": [
                                        "behavior",
                                        "actionId"
                                      ],
                                      "properties": {
                                        "behavior": {
                                          "enum": [
                                            "CUSTOM_ACTION"
                                          ]
                                        },
                                        "actionId": {
                                          "type": "string",
                                          "maxLength": 50
                                        }
                                      }
                                    },
                                    {
                                      "type": "object",
                                      "additionalProperties": false,
                                      "required": [
                                        "behavior"
                                      ],
                                      "properties": {
                                        "behavior": {
                                          "enum": [
                                            "HIDE",
                                            "DEFAULT"
                                          ]
                                        }
                                      }
                                    }
                                  ]
                                },
                                {
                                  "type": "object",
                                  "additionalProperties": false,
                                  "required": [
                                    "behavior"
                                  ],
                                  "properties": {
                                    "behavior": {
                                      "enum": [
                                        "SITE_UPGRADE"
                                      ]
                                    }
                                  }
                                }
                              ]
                            },
                            "connect": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "pinMode": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "customConnect": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior",
                                "actionId"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "CUSTOM_ACTION"
                                  ]
                                },
                                "actionId": {
                                  "type": "string",
                                  "maxLength": 50
                                }
                              }
                            },
                            "focalPoint": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            },
                            "presets": {
                              "type": "object",
                              "additionalProperties": false,
                              "required": [
                                "behavior"
                              ],
                              "properties": {
                                "behavior": {
                                  "enum": [
                                    "HIDE",
                                    "DEFAULT"
                                  ]
                                }
                              }
                            }
                          }
                        },
                        "helpId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    "ComponentStageBehavior": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "duplicatable": {
          "type": "boolean"
        },
        "resizable": {
          "type": "boolean"
        },
        "preventHide": {
          "type": "boolean"
        },
        "dataEditOptions": {
          "type": "string",
          "maxLength": 50
        },
        "closed": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "selectable": {
              "type": "boolean"
            },
            "hideFromHierarchy": {
              "type": "boolean"
            }
          }
        }
      }
    },
    "GfppConfig": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "desktop": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "mainAction1": {
              "anyOf": [
                {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior",
                    "label"
                  ],
                  "oneOf": [
                    {
                      "required": [
                        "actionId"
                      ]
                    },
                    {
                      "required": [
                        "actionType"
                      ]
                    }
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": {
                      "type": "string",
                      "maxLength": 50
                    },
                    "label": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "value",
                        "shouldTranslate"
                      ],
                      "properties": {
                        "value": {
                          "type": "string",
                          "maxLength": 100
                        },
                        "shouldTranslate": {
                          "type": "boolean"
                        }
                      }
                    },
                    "actionType": {
                      "enum": [
                        "settings",
                        "layout",
                        "design",
                        "manage",
                        "background"
                      ]
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT",
                        "DEFAULT1",
                        "DEFAULT2"
                      ]
                    }
                  }
                }
              ]
            },
            "mainAction2": {
              "anyOf": [
                {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior",
                    "label"
                  ],
                  "oneOf": [
                    {
                      "required": [
                        "actionId"
                      ]
                    },
                    {
                      "required": [
                        "actionType"
                      ]
                    }
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": {
                      "type": "string",
                      "maxLength": 50
                    },
                    "label": {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "value",
                        "shouldTranslate"
                      ],
                      "properties": {
                        "value": {
                          "type": "string",
                          "maxLength": 100
                        },
                        "shouldTranslate": {
                          "type": "boolean"
                        }
                      }
                    },
                    "actionType": {
                      "enum": [
                        "settings",
                        "layout",
                        "design",
                        "manage",
                        "background"
                      ]
                    }
                  }
                },
                {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT",
                        "DEFAULT1",
                        "DEFAULT2"
                      ]
                    }
                  }
                }
              ]
            },
            "iconButtons": {
              "type": "object",
              "additionalProperties": false,
              "properties": {
                "settings": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "actionId"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    }
                  ]
                },
                "add": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "actionId"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    }
                  ]
                },
                "design": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "actionId"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    }
                  ]
                },
                "crop": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "filters": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "animation": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "link": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "stretch": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "layout": {
                  "anyOf": [
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior",
                        "actionId"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "CUSTOM_ACTION"
                          ]
                        },
                        "actionId": {
                          "type": "string",
                          "maxLength": 50
                        }
                      }
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "HIDE",
                            "DEFAULT"
                          ]
                        }
                      }
                    }
                  ]
                },
                "upgrade": {
                  "anyOf": [
                    {
                      "anyOf": [
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior",
                            "actionId"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "CUSTOM_ACTION"
                              ]
                            },
                            "actionId": {
                              "type": "string",
                              "maxLength": 50
                            }
                          }
                        },
                        {
                          "type": "object",
                          "additionalProperties": false,
                          "required": [
                            "behavior"
                          ],
                          "properties": {
                            "behavior": {
                              "enum": [
                                "HIDE",
                                "DEFAULT"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "type": "object",
                      "additionalProperties": false,
                      "required": [
                        "behavior"
                      ],
                      "properties": {
                        "behavior": {
                          "enum": [
                            "SITE_UPGRADE"
                          ]
                        }
                      }
                    }
                  ]
                },
                "connect": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "pinMode": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "customConnect": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior",
                    "actionId"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "CUSTOM_ACTION"
                      ]
                    },
                    "actionId": {
                      "type": "string",
                      "maxLength": 50
                    }
                  }
                },
                "focalPoint": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                },
                "presets": {
                  "type": "object",
                  "additionalProperties": false,
                  "required": [
                    "behavior"
                  ],
                  "properties": {
                    "behavior": {
                      "enum": [
                        "HIDE",
                        "DEFAULT"
                      ]
                    }
                  }
                }
              }
            },
            "helpId": {
              "type": "string",
              "maxLength": 50
            }
          }
        }
      }
    },
    "MainActionConfig": {
      "anyOf": [
        {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "behavior",
            "label"
          ],
          "oneOf": [
            {
              "required": [
                "actionId"
              ]
            },
            {
              "required": [
                "actionType"
              ]
            }
          ],
          "properties": {
            "behavior": {
              "enum": [
                "CUSTOM_ACTION"
              ]
            },
            "actionId": {
              "type": "string",
              "maxLength": 50
            },
            "label": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "value",
                "shouldTranslate"
              ],
              "properties": {
                "value": {
                  "type": "string",
                  "maxLength": 100
                },
                "shouldTranslate": {
                  "type": "boolean"
                }
              }
            },
            "actionType": {
              "enum": [
                "settings",
                "layout",
                "design",
                "manage",
                "background"
              ]
            }
          }
        },
        {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "behavior"
          ],
          "properties": {
            "behavior": {
              "enum": [
                "HIDE",
                "DEFAULT",
                "DEFAULT1",
                "DEFAULT2"
              ]
            }
          }
        }
      ]
    },
    "GfppMainActionButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT",
            "DEFAULT1",
            "DEFAULT2"
          ]
        }
      }
    },
    "GfppMainActionDefinition": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "label"
      ],
      "oneOf": [
        {
          "required": [
            "actionId"
          ]
        },
        {
          "required": [
            "actionType"
          ]
        }
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        },
        "label": {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "value",
            "shouldTranslate"
          ],
          "properties": {
            "value": {
              "type": "string",
              "maxLength": 100
            },
            "shouldTranslate": {
              "type": "boolean"
            }
          }
        },
        "actionType": {
          "enum": [
            "settings",
            "layout",
            "design",
            "manage",
            "background"
          ]
        }
      }
    },
    "IconButtonConfig": {
      "anyOf": [
        {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "behavior",
            "actionId"
          ],
          "properties": {
            "behavior": {
              "enum": [
                "CUSTOM_ACTION"
              ]
            },
            "actionId": {
              "type": "string",
              "maxLength": 50
            }
          }
        },
        {
          "type": "object",
          "additionalProperties": false,
          "required": [
            "behavior"
          ],
          "properties": {
            "behavior": {
              "enum": [
                "HIDE",
                "DEFAULT"
              ]
            }
          }
        }
      ]
    },
    "GfppIconButtonConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "HIDE",
            "DEFAULT"
          ]
        }
      }
    },
    "GfppIconActionConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior",
        "actionId"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "CUSTOM_ACTION"
          ]
        },
        "actionId": {
          "type": "string",
          "maxLength": 50
        }
      }
    },
    "GfppUpgradeConfig": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "behavior"
      ],
      "properties": {
        "behavior": {
          "enum": [
            "SITE_UPGRADE"
          ]
        }
      }
    },
    "TranslatableString": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "value",
        "shouldTranslate"
      ],
      "properties": {
        "value": {
          "type": "string",
          "maxLength": 100
        },
        "shouldTranslate": {
          "type": "boolean"
        }
      }
    }
  },
  "measurements.json": {
    "$id": "urn:dm:schemas:measurements.json",
    "MeasurementsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MeasurementsData"
          ]
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "x": {
          "type": "number"
        },
        "y": {
          "type": "number"
        },
        "viewportSize": {
          "type": "number",
          "minimum": 0
        },
        "isFixedPosition": {
          "type": "boolean"
        }
      },
      "required": [
        "type",
        "width",
        "height",
        "x",
        "y",
        "viewportSize"
      ]
    }
  },
  "migration.json": {
    "$id": "urn:dm:schemas:migration.json",
    "migration": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "migrationStatus": {
          "type": "string",
          "maxLength": 50
        },
        "migrationSource": {
          "enum": [
            "classic",
            "figma",
            "site-description-file",
            "editor-x",
            "editor-x-force-migration",
            "site-generation"
          ]
        },
        "migrationRevision": {
          "type": "string",
          "maxLength": 50
        }
      },
      "required": [
        "migrationStatus",
        "migrationSource"
      ]
    }
  },
  "mobile_hints.json": {
    "$id": "urn:dm:schemas:mobile_hints.json",
    "MobileHints": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "author": {
          "enum": [
            "studio",
            "duplicate"
          ],
          "description": "Data source"
        },
        "isLocked": {
          "type": "boolean",
          "description": "Skip element because user locked this element"
        },
        "hidden": {
          "type": "boolean",
          "description": "Should hide component on mobile"
        },
        "offsetX": {
          "type": "number",
          "description": "Horizontal distance from the corner of the previous sibling"
        },
        "offsetY": {
          "type": "number",
          "description": "Vertical distance from the corner of the previous sibling"
        },
        "offsetOrigin": {
          "enum": [
            "leftTop",
            "rightTop",
            "leftBottom"
          ],
          "description": "The corner of the previous sibling that the offsets are applied to"
        },
        "originalCompId": {
          "type": "string",
          "description": "Id of source component"
        },
        "recommendedScale": {
          "type": "number",
          "description": "Recommended component scale on mobile"
        },
        "recommendedWidth": {
          "type": "number",
          "description": "Recommended component width on mobile"
        },
        "recommendedHeight": {
          "type": "number",
          "description": "Recommended component height on mobile"
        },
        "orderIndex": {
          "type": "number",
          "description": "Recommended index of component in parent container"
        },
        "modifiedByUser": {
          "type": "boolean",
          "description": "Indicate is component was changed by user on mobile"
        },
        "shouldBeForceConverted": {
          "type": "boolean",
          "description": "Indicate that component need to be force converted to mobile"
        }
      }
    }
  },
  "multilingualTranslations.json": {
    "$id": "urn:dm:schemas:multilingualTranslations.json",
    "Direction": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl",
        "inherit"
      ]
    },
    "AppVars": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "vars": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "value": {
                "type": "string",
                "maxLength": 100
              },
              "type": {
                "type": "string",
                "enum": [
                  "AppPartParam"
                ]
              }
            }
          }
        },
        "appDefId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "SVGItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "SVGReference": {
      "type": [
        "null",
        "string"
      ]
    },
    "BackgroundImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string"
        },
        "positionx": {
          "type": "string",
          "enum": [
            "left",
            "right",
            "center"
          ],
          "default": "center"
        },
        "imagesizew": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "imagesizeh": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "positiony": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "center"
          ],
          "default": "center"
        },
        "width": {
          "type": "string"
        },
        "repeatx": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "repeaty": {
          "type": "string",
          "enum": [
            "no_repeat",
            "repeat"
          ],
          "default": "repeat"
        },
        "attachment": {
          "type": "string",
          "enum": [
            "scroll",
            "fixed",
            "inherit",
            "local"
          ],
          "default": "inherit"
        },
        "color": {
          "type": "string"
        }
      }
    },
    "BackgroundMedia": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "mediaRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "mediaTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "overlayTransforms": {
          "type": "object",
          "properties": {
            "scale": {
              "type": "number",
              "minimum": 0
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            }
          },
          "additionalProperties": false
        },
        "color": {
          "oneOf": [
            {
              "enum": [
                "transparent",
                "noColor"
              ]
            },
            {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          ]
        },
        "colorOpacity": {
          "type": "number"
        },
        "alignType": {
          "type": "string",
          "enum": [
            "top",
            "bottom",
            "left",
            "right",
            "center",
            "top_left",
            "top_right",
            "bottom_left",
            "bottom_right"
          ]
        },
        "fittingType": {
          "type": "string",
          "enum": [
            "fill",
            "fit",
            "stretch",
            "actual_size",
            "original_size",
            "tile",
            "tile_horizontal",
            "tile_vertical",
            "fit_and_tile",
            "legacy_tile",
            "legacy_tile_horizontal",
            "legacy_tile_vertical",
            "legacy_normal"
          ]
        },
        "scrollType": {
          "type": "string",
          "enum": [
            "none",
            "fixed",
            "scroll",
            "local",
            "parallax"
          ]
        },
        "showOverlayForMediaType": {
          "type": "string",
          "enum": [
            "all",
            "WixVideo",
            "Image"
          ],
          "default": "WixVideo"
        },
        "imageOverlay": {
          "type": [
            "null",
            "string"
          ]
        },
        "colorOverlay": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "colorOverlayOpacity": {
          "type": "number"
        },
        "overlayBlending": {
          "type": "object",
          "properties": {
            "color": {
              "type": "string"
            },
            "opacity": {
              "type": "number",
              "minimum": 0,
              "maximum": 1
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "saturate": {
              "type": "number",
              "minimum": 0,
              "maximum": 2
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            }
          },
          "additionalProperties": false
        },
        "filterEffect": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "effectType": {
              "type": "string",
              "enum": [
                "none",
                "normal",
                "ink",
                "kennedy",
                "feathered",
                "blur",
                "whistler",
                "3d",
                "blueray",
                "lighten",
                "darken",
                "pinkrinse",
                "redrum",
                "greenwash",
                "yellowstreak",
                "neonsky",
                "seaweed",
                "soledad",
                "sangria",
                "malibu",
                "candyfloss",
                "elmo",
                "unicorn",
                "kerouac",
                "koolaid",
                "hydra",
                "pixie",
                "nightrain",
                "bauhaus",
                "neptune",
                "orca",
                "manhattan",
                "goldie",
                "flamingo",
                "faded",
                "gotham",
                "hulk",
                "midnight",
                "lucille",
                "organic",
                "grayscale",
                "tvDuotone",
                "tvMonotoneDark",
                "tvMonotoneLight",
                "tvHue"
              ]
            },
            "brightness": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "contrast": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "saturation": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "hue": {
              "type": "number",
              "minimum": -180,
              "maximum": 180
            },
            "duotoneDark": {
              "type": "string"
            },
            "duotoneLight": {
              "type": "string"
            },
            "invert": {
              "type": "boolean",
              "default": false
            },
            "isCustom": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "colorLayers": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "WixVideo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "loop": {
          "type": "boolean"
        },
        "autoplay": {
          "type": "boolean"
        },
        "playbackSpeed": {
          "type": "number"
        },
        "preload": {
          "type": "string",
          "enum": [
            "auto",
            "metadata",
            "none"
          ]
        },
        "controls": {
          "type": "string",
          "enum": [
            "none",
            "full"
          ]
        },
        "mute": {
          "type": "boolean",
          "description": "deprecated, moved to properties"
        },
        "opacity": {
          "type": "number"
        },
        "mediaFeatures": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "alpha"
            ]
          }
        },
        "mask": {
          "anyOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "description": "CSS mask using an image",
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "width": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "height": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "svgId": {
                  "type": "string"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360
                },
                "mode": {
                  "type": "string",
                  "enum": [
                    "alpha",
                    "luminance"
                  ],
                  "default": "alpha"
                }
              },
              "additionalProperties": false
            }
          ]
        }
      }
    },
    "WixVideoData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "alt": {
          "type": "string",
          "maxLength": 1000
        },
        "videoId": {
          "type": "string"
        },
        "generatedPosters": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "qualities": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "quality": {
                "type": "string"
              },
              "width": {
                "type": "number"
              },
              "height": {
                "type": "number"
              },
              "formats": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "description": "Deprecated, replaced by 'format' and 'url' since we have a unique url for each quality"
              },
              "format": {
                "type": "string",
                "enum": [
                  "mp4",
                  "webm"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveVideo": {
          "type": [
            "array",
            "null"
          ],
          "items": {
            "type": "object",
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ]
              },
              "url": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        },
        "posterImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number"
        },
        "fps": {
          "type": "string",
          "maxLength": 50
        },
        "hasAudio": {
          "type": "boolean",
          "description": "video has no audio"
        },
        "artist": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Document": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "siteName": {
          "type": "string",
          "maxLength": 1000
        },
        "usedFonts": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 1000
          }
        },
        "characterSets": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "renderModifiers": {
          "type": "object"
        },
        "name": {
          "type": "string"
        },
        "mainPage": {
          "type": [
            "null",
            "string"
          ]
        },
        "mainPageId": {
          "type": "string"
        },
        "smSettings": {
          "type": [
            "object"
          ],
          "additionalProperties": false,
          "properties": {
            "socialLoginGoogleEnabled": {
              "type": "boolean"
            },
            "socialLoginFacebookEnabled": {
              "type": "boolean"
            },
            "privacyNoteType": {
              "type": "string",
              "enum": [
                "CHECKBOX",
                "NOTE"
              ]
            },
            "joinCommunityCheckedByDefault": {
              "type": "boolean"
            },
            "customSignUpPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "customSignInPageId": {
              "type": [
                "string",
                "null"
              ]
            },
            "customNoPermissionsPageId": {
              "type": [
                "string"
              ]
            },
            "termsOfUse": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "privacyPolicy": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "codeOfConduct": {
              "type": "object",
              "properties": {
                "enabled": {
                  "type": "boolean"
                },
                "link": {
                  "pattern": "^$|^#",
                  "type": [
                    "null",
                    "string"
                  ]
                }
              },
              "additionalProperties": false
            },
            "smFirstDialogLogin": {
              "type": [
                "boolean",
                "null"
              ]
            }
          }
        },
        "styleSettings": {
          "type": "object",
          "properties": {
            "stylesPerPage": {
              "type": "string",
              "maxLength": 20
            }
          },
          "additionalProperties": false
        },
        "accessibilitySettings": {
          "type": "object",
          "properties": {
            "visualFocusDisabled": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "skipToContent": {
              "default": true,
              "type": [
                "boolean",
                "null"
              ]
            },
            "isRtlSupportEnabled": {
              "default": false,
              "type": [
                "boolean",
                "null"
              ]
            },
            "currentSiteDirection": {
              "type": "string",
              "enum": [
                "ltr",
                "rtl"
              ]
            }
          },
          "additionalProperties": false
        },
        "mobileSettings": {
          "type": "object",
          "properties": {
            "animationsEnabled": {
              "type": [
                "boolean",
                "null"
              ]
            }
          },
          "additionalProperties": false
        },
        "layoutSettings": {
          "type": "object",
          "properties": {
            "useDesktopSectionsLayout": {
              "type": [
                "boolean",
                "null"
              ]
            },
            "isFluid": {
              "type": [
                "boolean"
              ]
            },
            "headerToPagesGap": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            },
            "pagesToFooterGap": {
              "type": [
                "number",
                "null"
              ],
              "multipleOf": 1
            },
            "mechanism": {
              "type": [
                "string"
              ],
              "enum": [
                "mesh",
                "anchors"
              ]
            },
            "soapCompsAroundPagesContainer": {
              "type": [
                "boolean",
                "null"
              ]
            }
          },
          "additionalProperties": false
        },
        "appStudioData": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean"
          ]
        },
        "anchorLockThreshold": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "supportMobile": {
          "type": "boolean"
        },
        "autoDomReorder": {
          "type": "boolean"
        },
        "appsInstallState": {
          "type": [
            "null",
            "string"
          ]
        },
        "usesNewAnimations": {
          "type": "boolean"
        }
      }
    },
    "AccessibilitySettings": {
      "type": "object",
      "properties": {
        "visualFocusDisabled": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "skipToContent": {
          "default": true,
          "type": [
            "boolean",
            "null"
          ]
        },
        "isRtlSupportEnabled": {
          "default": false,
          "type": [
            "boolean",
            "null"
          ]
        },
        "currentSiteDirection": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ]
        }
      },
      "additionalProperties": false
    },
    "MobileSettings": {
      "type": "object",
      "properties": {
        "animationsEnabled": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "LayoutSettings": {
      "type": "object",
      "properties": {
        "useDesktopSectionsLayout": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "isFluid": {
          "type": [
            "boolean"
          ]
        },
        "headerToPagesGap": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "pagesToFooterGap": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "mechanism": {
          "type": [
            "string"
          ],
          "enum": [
            "mesh",
            "anchors"
          ]
        },
        "soapCompsAroundPagesContainer": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "StyleSettings": {
      "type": "object",
      "properties": {
        "stylesPerPage": {
          "type": "string",
          "maxLength": 20
        }
      },
      "additionalProperties": false
    },
    "SiteMembersData": {
      "type": "object",
      "properties": {
        "socialLoginGoogleEnabled": {
          "type": "boolean"
        },
        "socialLoginFacebookEnabled": {
          "type": "boolean"
        },
        "privacyNoteType": {
          "type": "string",
          "enum": [
            "CHECKBOX",
            "NOTE"
          ]
        },
        "joinCommunityCheckedByDefault": {
          "type": "boolean"
        },
        "customSignUpPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customSignInPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "customNoPermissionsPageId": {
          "type": [
            "string"
          ]
        },
        "termsOfUse": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "privacyPolicy": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "codeOfConduct": {
          "type": "object",
          "properties": {
            "enabled": {
              "type": "boolean"
            },
            "link": {
              "pattern": "^$|^#",
              "type": [
                "null",
                "string"
              ]
            }
          },
          "additionalProperties": false
        },
        "smFirstDialogLogin": {
          "type": [
            "boolean",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppStudioData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "widgets": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "codePackages": {
          "maxItems": 1,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "panels": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "dependencies": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "appDefId"
            ],
            "properties": {
              "appDefId": {
                "type": "string",
                "maxLength": 100
              },
              "dependencyData": {
                "type": "array",
                "items": {
                  "type": "string",
                  "enum": [
                    "PROVISION_ONLY_INSTALLATION",
                    "NOTIFY_USER_ON_DEPENDENCY",
                    "IS_BUNDLE"
                  ]
                }
              }
            }
          }
        },
        "dashboards": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "customDefinitions": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "ssrCache": {
          "type": "boolean"
        }
      }
    },
    "CodePackagesDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "displayName": {
          "type": "string",
          "maxLength": 30,
          "minLength": 1
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "minLength": 3
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WidgetPropertyDefinition": {
      "additionalProperties": true
    },
    "CustomDefinitionDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "structure": {
          "type": "object",
          "additionalProperties": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "$id",
              "title",
              "description",
              "default",
              "propertiesOrder"
            ],
            "properties": {
              "$id": {
                "type": "string"
              },
              "type": {
                "type": "string",
                "default": "object"
              },
              "title": {
                "type": "string"
              },
              "description": {
                "type": "string"
              },
              "properties": {
                "type": "object",
                "additionalProperties": {
                  "additionalProperties": true
                }
              },
              "default": {
                "type": "object",
                "default": {}
              },
              "propertiesOrder": {
                "type": "array",
                "items": {
                  "type": "string"
                },
                "default": []
              }
            }
          }
        }
      }
    },
    "WidgetDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "devCenterWidgetId": {
          "type": [
            "string",
            "null"
          ]
        },
        "devCenterEditorReactComponentId": {
          "type": [
            "string",
            "null"
          ]
        },
        "kind": {
          "type": [
            "string",
            "null"
          ],
          "enum": [
            "container",
            "section"
          ]
        },
        "panels": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "defaultSize": {
          "type": [
            "object",
            "null"
          ],
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        },
        "variations": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "presets": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "plugin": {
          "type": "object",
          "properties": {
            "placements": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "appDefinitionId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "widgetId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "slotId": {
                    "type": "string",
                    "maxLength": 100
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "containedWidgets": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "widgetApi": {
          "type": "object",
          "default": {},
          "properties": {
            "functions": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "required": [
                  "name"
                ],
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": [
                      "string",
                      "null"
                    ]
                  },
                  "params": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "name": {
                          "type": "string"
                        },
                        "description": {
                          "type": [
                            "string",
                            "null"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "returnsDescription": {
                    "type": [
                      "string",
                      "null"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "propertiesSchemas": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "properties": {
                  "structure": {
                    "type": "object",
                    "additionalProperties": {
                      "additionalProperties": true
                    },
                    "default": {}
                  }
                },
                "additionalProperties": false
              }
            },
            "events": {
              "type": "array",
              "default": [],
              "items": {
                "type": "object",
                "required": [
                  "name"
                ],
                "properties": {
                  "name": {
                    "type": "string"
                  },
                  "description": {
                    "type": "string"
                  },
                  "args": {
                    "type": "array",
                    "items": {
                      "properties": {
                        "name": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "structureRef": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "rootCompId": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "compType": {
          "type": "string"
        }
      }
    },
    "DashboardDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "routePath": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideInSidebar": {
          "type": "boolean"
        },
        "activeSidebarPageId": {
          "type": [
            "string",
            "null"
          ]
        },
        "isRoutePathConnectedToTitle": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "PanelDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "devCenterPanelId": {
          "type": [
            "string",
            "null"
          ]
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "kind": {
          "type": "string",
          "enum": [
            "settings"
          ]
        },
        "helpId": {
          "type": "string",
          "maxLength": 100
        },
        "pageUrl": {
          "type": "string",
          "minLength": 1,
          "maxLength": 2048
        },
        "height": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "number"
            },
            "height": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "VariationDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "rootCompId": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "PresetDescriptor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:defaultSize\\/width|defaultSize\\/height)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "presetId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100
        },
        "defaultSize": {
          "type": "object",
          "minProperties": 1,
          "properties": {
            "width": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "height": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      }
    },
    "FlatTheme": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "font": {
          "type": "string",
          "format": "font-family",
          "default": "Arial,sans-serif"
        },
        "bgId": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "bgSize": {
          "type": "string",
          "default": ","
        },
        "bgType": {
          "type": "string",
          "default": "BG_USES_THEME_IMAGE"
        },
        "siteBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "mobileBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "siteBgColor": {
          "default": "0,0,0,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerTextColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "headerBgColor": {
          "default": "0,0,0,0",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "textColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "areaBgColor": {
          "default": "130,81,13,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "iconBgColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "borderColor": {
          "default": "255,255,255,1",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "fontHeader": {
          "default": "normal normal bold 2.4em/1.0em [font] {headerTextColor}",
          "type": [
            "string"
          ]
        },
        "fontTitle": {
          "default": "italic normal bold 2.0em/2.0em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontSubTitle": {
          "default": "normal normal bold 1.2em/1.4em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontButton": {
          "default": "normal normal bold 1.4em/2.2em [font] {areaBgColor}",
          "type": [
            "string"
          ]
        },
        "fontText": {
          "default": "normal normal normal 1.1em/1.1em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "fontSmallText": {
          "default": "normal normal normal 0.5em/0.7em [font] {siteBgColor}",
          "type": [
            "string"
          ]
        },
        "borderContainer": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderThumb": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderButton": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "borderIcon": {
          "default": "0.15em solid [borderColor]",
          "type": "string",
          "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
        },
        "radiusContainer": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusThumb": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusButton": {
          "default": "0.6em 0.6em 0.6em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "radiusIcon": {
          "default": "0.6em 0.0em 0.0em 0.6em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding1": {
          "default": "1em 1em 1em 1em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "default": "0.0em 0.5em 0.0em 0.5em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "default": "1.0em 0.0em 1.0em 0.0em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "default": "3.2",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "default": "1.5",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "default": "0em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "default": "0.45em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "default": "0.23em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        }
      }
    },
    "Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100,
          "description": "Title or caption for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Name identifier for the image."
        },
        "uri": {
          "type": "string",
          "pattern": "^[\\w:~\\-_+%.\\/,\\?=\\()]+$",
          "default": "3963cf22f5e14a25a77ebe37298a8d3b.png",
          "description": "Represents the URI or path to the image."
        },
        "description": {
          "type": "string",
          "maxLength": 1200,
          "description": "Textual description or details about the image."
        },
        "height": {
          "type": "number",
          "default": 200,
          "description": "Height dimension of the image."
        },
        "width": {
          "type": "number",
          "default": 200,
          "description": "Width dimension of the image."
        },
        "borderSize": {
          "type": "string",
          "description": "Size of the border around the image."
        },
        "alt": {
          "type": "string",
          "default": "",
          "description": "Alternative text for the image (for accessibility purposes)."
        },
        "decorative": {
          "type": "boolean"
        },
        "hasAnimation": {
          "type": "boolean",
          "description": "Indicates whether the image has animation valid for images in webP format"
        },
        "originalImageDataRef": {
          "description": "Original Image before edit",
          "type": [
            "null",
            "string"
          ]
        },
        "opacity": {
          "type": "number",
          "description": "Opacity level of the image."
        },
        "crop": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 4,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0
                },
                "y": {
                  "type": "number",
                  "minimum": 0
                },
                "width": {
                  "type": "number",
                  "minimum": 0
                },
                "height": {
                  "type": "number",
                  "minimum": 0
                },
                "svgId": {
                  "type": "string",
                  "description": "Defines an svg uri for a mask inside the crop boundaries"
                },
                "flip": {
                  "type": "string",
                  "enum": [
                    "x",
                    "y",
                    "xy",
                    "none"
                  ],
                  "description": "Defines whether the mask is flipped on the v or h axis"
                },
                "rotate": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 360,
                  "description": "Defines a rotation angle for the mask"
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Defines cropping boundaries and additional transformations for the image."
        },
        "upscaleMethod": {
          "type": "string",
          "description": "used for upscaling method when building an image url , expected values default|super"
        },
        "focalPoint": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "object",
              "minProperties": 2,
              "properties": {
                "x": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                },
                "y": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 100
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "Specifies the focal point within the image."
        },
        "artist": {
          "type": "object",
          "description": "Information about the artist of the image.",
          "properties": {
            "name": {
              "type": "string"
            },
            "id": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ImageA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageReference": {
      "type": [
        "null",
        "string"
      ]
    },
    "GlobalImageQuality": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "quality": {
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "unsharpMask": {
          "type": "object",
          "minProperties": 3,
          "additionalProperties": false,
          "properties": {
            "radius": {
              "type": "number",
              "minimum": 0,
              "maximum": 500
            },
            "amount": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "threshold": {
              "type": "number",
              "minimum": 0,
              "maximum": 255
            }
          }
        }
      }
    },
    "ImageQuality": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "quality": {
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "unsharpMask": {
          "type": "object",
          "minProperties": 3,
          "additionalProperties": false,
          "properties": {
            "radius": {
              "type": "number",
              "minimum": 0,
              "maximum": 500
            },
            "amount": {
              "type": "number",
              "minimum": 0,
              "maximum": 10
            },
            "threshold": {
              "type": "number",
              "minimum": 0,
              "maximum": 255
            }
          }
        }
      }
    },
    "ClassicSectionA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "type": "number"
        }
      }
    },
    "StripColumnsContainerA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        },
        "level": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        }
      }
    },
    "StripColumnsContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "itemsDirection": {
          "type": "string",
          "enum": [
            "rtl",
            "ltr"
          ],
          "default": "ltr"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ClassicSection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StripContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ImageList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "Link": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      }
    },
    "TextLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        }
      }
    },
    "AnchorLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "anchorName": {
          "type": "string"
        },
        "anchorDataId": {
          "anyOf": [
            {
              "type": [
                "null",
                "string"
              ]
            },
            {
              "enum": [
                "SCROLL_TO_TOP"
              ]
            }
          ]
        },
        "pageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "DocumentLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "docId": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "indexable": {
          "type": "boolean"
        }
      }
    },
    "PhoneLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "WhatsAppLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "phoneNumber": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "AddressLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "address": {
          "type": "string",
          "maxLength": 200
        }
      }
    },
    "EmailLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "recipient": {
          "type": "string",
          "description": "Email address of the recipient."
        },
        "subject": {
          "type": "string",
          "description": "Subject of the email."
        },
        "body": {
          "type": "string",
          "description": "Body or content of the email."
        }
      }
    },
    "FormSubmitButtonLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ExternalLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "allOf": [
            {
              "type": "string"
            },
            {
              "not": {
                "type": "string",
                "pattern": ".*script://.*"
              }
            }
          ],
          "description": "URL of the external link."
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_blank",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "default": [
            "noreferrer",
            "noopener"
          ],
          "description": "Specifies the relationship between the current document and the linked document.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          }
        }
      }
    },
    "LinkRelAttribute": {
      "type": "array",
      "items": {
        "type": "string",
        "enum": [
          "nofollow",
          "noopener",
          "noreferrer",
          "sponsored"
        ]
      },
      "default": []
    },
    "DynamicPageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "routerId": {
          "type": "string"
        },
        "innerRoute": {
          "type": "string"
        },
        "anchorDataId": {
          "type": [
            "null",
            "string"
          ]
        },
        "isTpaRoute": {
          "type": "boolean"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "TpaPageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "itemTypeIdentifier": {
          "type": "string"
        },
        "itemId": {
          "type": "string"
        },
        "pageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "appDefinitionId": {
          "type": "string"
        },
        "path": {
          "type": "string"
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self"
        },
        "rel": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      },
      "required": [
        "itemTypeIdentifier",
        "itemId",
        "pageId",
        "appDefinitionId",
        "path"
      ]
    },
    "LoginToWixLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "postLoginUrl": {
          "type": "string"
        },
        "postSignupUrl": {
          "type": "string"
        },
        "dialog": {
          "type": "string",
          "enum": [
            "createUser",
            "login",
            "showLogin"
          ],
          "default": "login"
        },
        "sendMail": {
          "type": "boolean",
          "default": true
        },
        "mailTemplate": {
          "type": "string"
        },
        "userColor": {
          "type": "string"
        },
        "loginCompName": {
          "type": "string",
          "default": ""
        }
      }
    },
    "PageLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pageId": {
          "description": "Page ID of the page to link to.",
          "type": [
            "null",
            "string"
          ]
        },
        "target": {
          "type": "string",
          "enum": [
            "_self",
            "_blank"
          ],
          "default": "_self",
          "description": "Specifies where to open the linked document."
        },
        "rel": {
          "description": "Specifies the relationship between the current document and the linked document.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "nofollow",
              "noopener",
              "noreferrer",
              "sponsored"
            ]
          },
          "default": []
        }
      }
    },
    "MediaItem": {
      "type": "object",
      "properties": {
        "componentType": {
          "type": "string"
        },
        "dateCreated": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "fileName": {
          "type": "string"
        },
        "fileSize": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "width": {
          "type": "number"
        },
        "iconURL": {
          "type": "string"
        },
        "mediaType": {
          "type": "string"
        },
        "mimeType": {
          "type": "string"
        },
        "originalFileName": {
          "type": "string"
        },
        "sourceURL": {
          "type": [
            "null",
            "string"
          ]
        },
        "tags": {
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "version": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "MediaRichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "componentDataList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "Page": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideTitle": {
          "type": "boolean"
        },
        "icon": {
          "type": "string"
        },
        "windowTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "descriptionSEO": {
          "type": "string",
          "maxLength": 1024
        },
        "advancedSeoData": {
          "type": "string",
          "maxLength": 10000
        },
        "metaKeywordsSEO": {
          "type": "string",
          "maxLength": 512
        },
        "pageTitleSEO": {
          "type": "string"
        },
        "pageUriSEO": {
          "type": "string"
        },
        "hidePage": {
          "type": "boolean"
        },
        "underConstruction": {
          "type": "boolean"
        },
        "tpaApplicationId": {
          "type": "number"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "managingAppDefId": {
          "type": [
            "string",
            "null"
          ]
        },
        "tpaPageId": {
          "type": "string"
        },
        "parentPageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSecurity": {
          "type": [
            "object",
            "null"
          ],
          "default": {
            "requireLogin": false,
            "passwordDigest": "",
            "dialogLanguage": ""
          }
        },
        "indexable": {
          "type": "boolean",
          "default": true
        },
        "mobileHidePage": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ],
                  "default": "viewport"
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isMobileLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isPopup": {
          "type": "boolean",
          "default": false
        },
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "ogImage": {
          "type": [
            "string",
            "null"
          ]
        },
        "ogImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        }
      }
    },
    "Text": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 4000
        }
      }
    },
    "RichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": ""
        },
        "defaultStyle": {
          "type": "string"
        }
      }
    },
    "RichTextImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": [
            "null",
            "string"
          ]
        },
        "image": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "BaseInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "BaseTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "TextInputA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "invalid": {
          "type": "boolean"
        },
        "multiline": {
          "type": "boolean"
        },
        "autocomplete": {
          "type": "boolean"
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        }
      }
    },
    "TextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textType": {
          "type": "string",
          "default": "text",
          "enum": [
            "text",
            "email",
            "url",
            "number",
            "tel",
            "password"
          ],
          "description": "input data type"
        },
        "maxLength": {
          "type": [
            "number",
            "null"
          ],
          "description": "maximum number of characters allowed"
        },
        "min": {
          "type": [
            "number",
            "null"
          ],
          "minimum": -2147483648,
          "maximum": 2147483647,
          "description": "minimum allowed value for a numeric type field"
        },
        "max": {
          "type": [
            "number",
            "null"
          ],
          "minimum": -2147483648,
          "maximum": 2147483647,
          "description": "maximum allowed value for a numeric type field"
        },
        "pattern": {
          "type": [
            "string",
            "null"
          ],
          "description": "specifies a regular expression against which the control's value will be validate",
          "maxLength": 500
        },
        "phoneFormat": {
          "type": [
            "string",
            "null"
          ],
          "description": "specifies a phone number format against which the control's value will be validated",
          "pattern": "^#*(((#+-)*)#+$)",
          "maxLength": 100
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefix": {
          "type": [
            "null",
            "string"
          ],
          "maxLength": 10
        },
        "step": {
          "type": "number"
        },
        "autoComplete": {
          "type": [
            "null",
            "string"
          ],
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "TextAreaInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "errorDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "maxLength": {
          "type": [
            "number"
          ],
          "description": "maximum number of characters allowed"
        },
        "label": {
          "type": [
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string"
          ],
          "maxLength": 4000,
          "description": "the placeholder option in case nothing is selected"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CheckboxInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "checked": {
          "description": "The checked status of the input",
          "type": "boolean",
          "default": false
        },
        "linkLabel": {
          "type": "string",
          "default": "",
          "maxLength": 1000
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "indeterminate": {
          "description": "Used for three state check box",
          "type": "boolean",
          "default": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "DateItem": {
      "type": "string",
      "format": "date-time"
    },
    "DateString": {
      "type": "string",
      "format": "date"
    },
    "DateRange": {
      "type": "object",
      "additionalProperties": false,
      "required": [
        "startDate",
        "endDate"
      ],
      "properties": {
        "startDate": {
          "type": "string",
          "format": "date"
        },
        "endDate": {
          "type": "string",
          "format": "date"
        }
      }
    },
    "DateRanges": {
      "type": "array",
      "default": [],
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "startDate",
          "endDate"
        ],
        "properties": {
          "startDate": {
            "type": "string",
            "format": "date"
          },
          "endDate": {
            "type": "string",
            "format": "date"
          }
        }
      }
    },
    "DatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "disabledDates": {
          "type": "array",
          "items": {
            "type": "string",
            "format": "date-time"
          },
          "default": [],
          "description": "array of disabled dates"
        },
        "disabledDaysOfWeek": {
          "type": "array",
          "items": {
            "type": [
              "number"
            ],
            "enum": [
              0,
              1,
              2,
              3,
              4,
              5,
              6
            ]
          },
          "default": [],
          "description": "array of disabled days"
        },
        "minDate": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "format": "date-time"
            }
          ],
          "description": "date input minimum date value"
        },
        "maxDate": {
          "oneOf": [
            {
              "type": "null"
            },
            {
              "type": "string",
              "format": "date-time"
            }
          ],
          "description": "date input maximum date value"
        },
        "allowPastDates": {
          "type": "boolean",
          "default": true,
          "description": "if true all past days are enabled, false otherwise"
        },
        "allowFutureDates": {
          "type": "boolean",
          "default": true,
          "description": "if true all future days are enabled, false otherwise"
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 200,
          "description": "the placeholder option in case nothing is selected"
        },
        "enabledDateRanges": {
          "description": "array of enabled dates. each date in the format YYYY/MM/DD",
          "type": "array",
          "default": [],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startDate",
              "endDate"
            ],
            "properties": {
              "startDate": {
                "type": "string",
                "format": "date"
              },
              "endDate": {
                "type": "string",
                "format": "date"
              }
            }
          }
        },
        "disabledDateRanges": {
          "description": "array of disabled dates. each date in the format YYYY/MM/DD",
          "type": "array",
          "default": [],
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startDate",
              "endDate"
            ],
            "properties": {
              "startDate": {
                "type": "string",
                "format": "date"
              },
              "endDate": {
                "type": "string",
                "format": "date"
              }
            }
          }
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "Theme": {
      "additionalProperties": false,
      "type": [
        "object",
        "null"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "properties": {
          "type": [
            "object",
            "null"
          ],
          "default": {}
        }
      }
    },
    "TwitterFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "accountToFollow": {
          "type": "string",
          "default": "wix"
        }
      }
    },
    "TwitterTweet": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultText": {
          "type": "string"
        },
        "accountToFollow": {
          "type": "string"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "MobileMetaData": {
      "type": "object",
      "required": [
        "adaptiveMobileOn"
      ],
      "properties": {
        "adaptiveMobileOn": {
          "type": "boolean",
          "default": true
        }
      },
      "additionalProperties": false
    },
    "Preloader": {
      "type": "object",
      "required": [
        "enabled",
        "uri"
      ],
      "properties": {
        "enabled": {
          "type": "boolean",
          "default": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "ContactInfo": {
      "type": "object",
      "required": [
        "companyName",
        "phone",
        "email",
        "address",
        "fax"
      ],
      "properties": {
        "companyName": {
          "type": "string",
          "default": ""
        },
        "phone": {
          "type": "string",
          "default": ""
        },
        "email": {
          "type": "string",
          "default": ""
        },
        "address": {
          "type": "string",
          "default": ""
        },
        "fax": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "SocialLink": {
      "type": "object",
      "required": [
        "id",
        "url"
      ],
      "properties": {
        "id": {
          "type": "string",
          "enum": [
            "facebook",
            "twitter",
            "pinterest",
            "google_plus",
            "tumblr",
            "blogger",
            "linkedin",
            "youtube",
            "vimeo",
            "flickr"
          ]
        },
        "url": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "QuickActions": {
      "type": "object",
      "required": [
        "colorScheme",
        "configuration",
        "socialLinks"
      ],
      "properties": {
        "colorScheme": {
          "type": "string",
          "enum": [
            "dark",
            "light"
          ],
          "default": "dark"
        },
        "configuration": {
          "type": "object",
          "default": {
            "addressEnabled": false,
            "emailEnabled": false,
            "navigationMenuEnabled": true,
            "phoneEnabled": false,
            "quickActionsMenuEnabled": false,
            "socialLinksEnabled": false
          },
          "properties": {
            "addressEnabled": {
              "type": "boolean",
              "default": false
            },
            "emailEnabled": {
              "type": "boolean",
              "default": false
            },
            "navigationMenuEnabled": {
              "type": "boolean",
              "default": true
            },
            "phoneEnabled": {
              "type": "boolean",
              "default": false
            },
            "quickActionsMenuEnabled": {
              "type": "boolean",
              "default": false
            },
            "socialLinksEnabled": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "socialLinks": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "id",
              "url"
            ],
            "properties": {
              "id": {
                "type": "string",
                "enum": [
                  "facebook",
                  "twitter",
                  "pinterest",
                  "google_plus",
                  "tumblr",
                  "blogger",
                  "linkedin",
                  "youtube",
                  "vimeo",
                  "flickr"
                ]
              },
              "url": {
                "type": "string",
                "default": ""
              }
            },
            "additionalProperties": false
          },
          "default": []
        }
      },
      "additionalProperties": false
    },
    "QuickActionBarItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "itemType": {
          "maxLength": 50,
          "type": "string"
        },
        "text": {
          "maxLength": 40,
          "type": "string",
          "default": ""
        },
        "icon": {
          "maxLength": 200,
          "type": "string",
          "default": ""
        }
      },
      "required": [
        "itemType"
      ]
    },
    "SiteSettings": {
      "type": "object",
      "properties": {
        "siteName": {
          "type": "string",
          "default": ""
        },
        "siteTitleSEO": {
          "type": "string",
          "default": ""
        },
        "siteDescriptionSEO": {
          "type": "string",
          "default": ""
        },
        "keywordsSEO": {
          "type": "string",
          "default": ""
        },
        "allowSEFindSite": {
          "type": "boolean",
          "default": false
        },
        "favicon": {
          "type": "string",
          "default": ""
        },
        "thumbnail": {
          "type": "string",
          "default": ""
        },
        "googleAnalyticsID": {
          "type": "string",
          "default": ""
        },
        "fbAdminsUserId": {
          "type": "string",
          "default": ""
        },
        "suppressTrackingCookies": {
          "type": "boolean",
          "default": false
        }
      },
      "additionalProperties": false
    },
    "AdvancedSeoSettingsDialog": {
      "type": "object",
      "properties": {
        "userMetaTags": {
          "type": "string",
          "default": ""
        }
      },
      "additionalProperties": false
    },
    "Anchor": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "compId": {
          "type": "string"
        },
        "urlFragment": {
          "type": "string",
          "maxLength": 60
        }
      }
    },
    "BasicMenuItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "slot": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        },
        "isVisibleMobile": {
          "type": "boolean",
          "default": true
        },
        "displayCount": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        },
        "iconRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "CustomMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "menuType": {
          "type": "string",
          "maxLength": 100
        },
        "syncWithPages": {
          "type": "boolean",
          "default": false
        },
        "appId": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "appDefinitionId": {
          "type": "string"
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "CustomMenusCollection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menus": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "CustomMenuDataRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "CustomMenuDataRefA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "Menu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "FacebookLikeBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "facebookPageId": {
          "type": "string",
          "default": "wix",
          "description": "Facebook page id"
        },
        "showFaces": {
          "type": "boolean",
          "default": true,
          "description": "Show profile photos in the plugin"
        },
        "colorScheme": {
          "type": "string",
          "default": "light",
          "enum": [
            "light",
            "dark"
          ],
          "description": "The color scheme of the plugin. Note that the background is always transparent to match your background color. This setting changes the foreground colors to work well on light or dark backgrounds."
        },
        "showStream": {
          "type": "boolean",
          "default": true,
          "description": "Show the profile stream for the public profile"
        },
        "showBorder": {
          "type": "boolean",
          "default": true,
          "description": "Show a border around the plugin"
        },
        "showHeader": {
          "type": "boolean",
          "default": true,
          "description": "Show the 'Find us on Facebook' bar at top. Only shown when either stream or faces are present"
        }
      }
    },
    "ImageButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ImageButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "defaultImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "hoverImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "activeImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "NumericStepper": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "1"
        }
      }
    },
    "PinItPinWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pinId": {
          "type": "string",
          "default": "http://www.pinterest.com/pin/204421270560540859/"
        }
      }
    },
    "PinterestPinIt": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": "Check it out!"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "SingleAudioPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": "",
          "description": "MP3 uri"
        },
        "originalFileName": {
          "type": "string",
          "default": "",
          "description": "Original MP3 file name"
        },
        "artist": {
          "type": "string",
          "default": "Unknown Artist",
          "description": "Artist Name"
        },
        "track": {
          "type": "string",
          "default": "Unknown Track",
          "description": "Track Name"
        }
      }
    },
    "SkypeCallButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "skypeName": {
          "type": "string"
        },
        "buttonType": {
          "type": "string",
          "enum": [
            "call",
            "chat"
          ],
          "default": "call"
        }
      }
    },
    "SpotifyFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        }
      }
    },
    "SpotifyPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": "",
          "description": "Spotify URI"
        }
      }
    },
    "SubscribeForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "firstNameFieldLabel": {
          "type": "string",
          "default": "First Name"
        },
        "lastNameFieldLabel": {
          "type": "string",
          "default": "Last Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Mobile number"
        },
        "subscribeFormTitle": {
          "type": "string",
          "default": "Subscribe for Updates"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Subscribe Now"
        },
        "successMessage": {
          "type": "string",
          "default": "Congrats! You’re subscribed"
        },
        "errorMessage": {
          "type": "string",
          "default": "Forgot your email? Try again."
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "To subscribe please fill in all the required info"
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "YouTubeSubscribeButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "youtubeChannelId": {
          "type": "string",
          "default": "wix",
          "description": "youtube channel id"
        }
      }
    },
    "AudioPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "loop": {
          "type": "boolean",
          "default": false
        },
        "visible": {
          "type": "boolean",
          "default": true
        },
        "volume": {
          "type": "number",
          "default": 100
        },
        "title": {
          "type": "string",
          "default": ""
        },
        "description": {
          "type": "string",
          "default": ""
        },
        "icon_uri": {
          "type": "string",
          "default": ""
        },
        "originalFileName": {
          "type": "string",
          "default": ""
        },
        "showToolTip": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "Boolean": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        }
      },
      "additionalProperties": false
    },
    "CheckBox": {
      "type": "object",
      "properties": {
        "value": {
          "type": "boolean"
        },
        "indeterminate": {
          "type": "boolean",
          "default": false,
          "description": "Used for three state check box"
        }
      },
      "additionalProperties": false
    },
    "Grid": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "dataSource": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "static",
                "dynamic"
              ]
            },
            "revision": {
              "type": "number",
              "multipleOf": 1
            }
          },
          "additionalProperties": false
        },
        "rows": {
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "rowsCount": {
          "type": "number"
        },
        "revision": {
          "type": "number"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ContactForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "nameFieldLabel": {
          "type": "string",
          "default": "Name"
        },
        "emailFieldLabel": {
          "type": "string",
          "default": "Email"
        },
        "phoneFieldLabel": {
          "type": "string",
          "default": "Phone"
        },
        "addressFieldLabel": {
          "type": "string",
          "default": "Address"
        },
        "subjectFieldLabel": {
          "type": "string",
          "default": "Subject"
        },
        "messageFieldLabel": {
          "type": "string",
          "default": "Message"
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "DynamicContactForm": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "toEmailAddress": {
          "type": "string",
          "default": ""
        },
        "bccEmailAddress": {
          "type": "string",
          "default": ""
        },
        "submitButtonLabel": {
          "type": "string",
          "default": "Send"
        },
        "successMessage": {
          "type": "string",
          "default": "Your details were sent successfully!"
        },
        "errorMessage": {
          "type": "string",
          "default": "Please provide a valid email"
        },
        "textDirection": {
          "type": "string",
          "default": "left",
          "enum": [
            "left",
            "right"
          ]
        },
        "validationErrorMessage": {
          "type": "string",
          "default": "Please fill in all required fields."
        },
        "onSubmitBehavior": {
          "type": "string",
          "default": "message",
          "enum": [
            "message",
            "link"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "formName": {
          "type": "string",
          "default": ""
        },
        "dynamicFields": {
          "type": "array",
          "default": [
            {
              "name": "email",
              "inputType": "email",
              "displayLabel": "Email",
              "required": true
            },
            {
              "name": "name",
              "inputType": "text",
              "displayLabel": "Name",
              "required": true
            },
            {
              "name": "subject",
              "inputType": "text",
              "displayLabel": "Subject",
              "required": false
            },
            {
              "name": "message",
              "inputType": "text",
              "displayLabel": "Message",
              "required": false
            }
          ],
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string",
                "maxLength": 50
              },
              "inputType": {
                "type": "string",
                "maxLength": 50
              },
              "displayLabel": {
                "type": "string",
                "maxLength": 200
              },
              "required": {
                "type": "boolean",
                "default": false
              },
              "displayed": {
                "type": "boolean",
                "default": false
              }
            },
            "additionalProperties": false
          }
        }
      }
    },
    "EbayItemsBySeller": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sellerId": {
          "type": "string"
        },
        "registrationSite": {
          "type": "string"
        }
      }
    },
    "FacebookShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "urlChoice": {
          "type": "string",
          "enum": [
            "Current page",
            "Site"
          ],
          "default": "Current page",
          "description": "Share: current/site url"
        },
        "label": {
          "type": "string",
          "default": "Share",
          "description": ""
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "FlashComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string"
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "title": {
          "type": "string",
          "maxLength": 100
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "maxLength": 1000
        },
        "height": {
          "type": "number",
          "default": 0
        },
        "width": {
          "type": "number",
          "default": 0
        },
        "placeHolderImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "FlickrBadgeWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "userId": {
          "type": "string",
          "default": "74009459@N07"
        },
        "userName": {
          "type": "string"
        },
        "tag": {
          "type": "string"
        },
        "imageCount": {
          "type": [
            "string",
            "number"
          ],
          "default": 3
        },
        "whichImages": {
          "type": "string",
          "default": "latest"
        },
        "imageSize": {
          "type": "string",
          "default": "t"
        },
        "layoutOrientation": {
          "type": "string",
          "default": "v"
        }
      }
    },
    "GeoMapLocation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158",
          "maxLength": 1000
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "title": {
          "type": "string",
          "default": "Wix Office",
          "maxLength": 10000
        },
        "description": {
          "type": "string",
          "default": "Wix HQ",
          "maxLength": 350
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "linkTitle": {
          "type": "string",
          "default": "Visit Wix's Site",
          "maxLength": 140
        },
        "pinIcon": {
          "type": "string",
          "default": "https://static.parastorage.com/services/santa-resources/resources/editor/designPanel/panelTypes/default_pin_icon.png",
          "maxLength": 1000
        },
        "pinColor": {
          "type": "string",
          "default": "#2A3688",
          "maxLength": 20
        }
      }
    },
    "GeoMap": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "language": {
          "type": "string",
          "enum": [
            "af",
            "sq",
            "am",
            "ar",
            "hy",
            "az",
            "eu",
            "be",
            "bn",
            "bs",
            "bg",
            "my",
            "ca",
            "zh",
            "zh-CN",
            "zh-HK",
            "zh-TW",
            "hr",
            "cs",
            "da",
            "nl",
            "en",
            "en-AU",
            "en-GB",
            "et",
            "fa",
            "fi",
            "fil",
            "fr",
            "fr-CA",
            "gl",
            "ka",
            "de",
            "el",
            "gu",
            "iw",
            "hi",
            "hu",
            "is",
            "id",
            "it",
            "ja",
            "kn",
            "kk",
            "km",
            "ko",
            "ky",
            "lo",
            "lv",
            "lt",
            "mk",
            "ms",
            "ml",
            "mr",
            "mn",
            "ne",
            "no",
            "pl",
            "pt",
            "pt-BR",
            "pt-PT",
            "pa",
            "ro",
            "ru",
            "sr",
            "si",
            "sk",
            "sl",
            "es",
            "es-419",
            "sw",
            "sv",
            "ta",
            "te",
            "th",
            "tr",
            "uk",
            "ur",
            "uz",
            "vi",
            "zu"
          ]
        },
        "locations": {
          "minItems": 0,
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "address": {
          "type": "string",
          "default": "500 Terry Francois Street, 6th Floor. San Francisco, CA 94158"
        },
        "latitude": {
          "type": "number",
          "default": 37.77065
        },
        "longitude": {
          "type": "number",
          "default": -122.387301
        },
        "addressInfo": {
          "type": "string",
          "default": "Wix Office"
        },
        "defaultLocation": {
          "type": "number",
          "default": 0
        },
        "mapStyle": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "stylers"
            ],
            "properties": {
              "elementType": {
                "type": "string",
                "enum": [
                  "all",
                  "geometry",
                  "geometry.fill",
                  "geometry.stroke",
                  "labels",
                  "labels.icon",
                  "labels.text",
                  "labels.text.fill",
                  "labels.text.stroke"
                ],
                "description": "Selects the element type to which a styler should be applied. An element type distinguishes between the different representations of a feature."
              },
              "featureType": {
                "type": "string",
                "enum": [
                  "administrative",
                  "administrative.country",
                  "administrative.land_parcel",
                  "administrative.locality",
                  "administrative.neighborhood",
                  "administrative.province",
                  "all",
                  "landscape",
                  "landscape.man_made",
                  "landscape.natural",
                  "landscape.natural.landcover",
                  "landscape.natural.terrain",
                  "poi",
                  "poi.attraction",
                  "poi.business",
                  "poi.government",
                  "poi.medical",
                  "poi.park",
                  "poi.place_of_worship",
                  "poi.school",
                  "poi.sports_complex",
                  "road",
                  "road.arterial",
                  "road.highway",
                  "road.highway.controlled_access",
                  "road.local",
                  "transit",
                  "transit.line",
                  "transit.station",
                  "transit.station.airport",
                  "transit.station.bus",
                  "transit.station.rail",
                  "water"
                ],
                "description": "Selects the feature, or group of features, to which a styler should be applied."
              },
              "stylers": {
                "type": "array",
                "items": {
                  "type": "object",
                  "maxProperties": 1,
                  "additionalProperties": false,
                  "description": "The style rules to apply to the selectors. The rules are applied to the map's elements in the order they are listed in this array.",
                  "properties": {
                    "color": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the color of the feature. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "gamma": {
                      "type": "number",
                      "description": "Modifies the gamma by raising the lightness to the given power.Valid values: Floating point numbers, [0.01, 10], with 1.0 representing no change."
                    },
                    "hue": {
                      "type": "string",
                      "maxLength": 100,
                      "description": "Sets the hue of the feature to match the hue of the color supplied. Note that the saturation and lightness of the feature is conserved, which means that the feature will not match the color supplied exactly. Valid values: An RGB hex string, i.e. '#ff0000'."
                    },
                    "invert_lightness": {
                      "type": "boolean",
                      "description": "A value of true will invert the lightness of the feature while preserving the hue and saturation."
                    },
                    "lightness": {
                      "type": "number",
                      "description": "Shifts lightness of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "saturation": {
                      "type": "number",
                      "description": "Shifts the saturation of colors by a percentage of the original value if decreasing and a percentage of the remaining value if increasing. Valid values: [-100, 100]."
                    },
                    "visibility": {
                      "type": "string",
                      "enum": [
                        "on",
                        "off",
                        "simplified"
                      ],
                      "description": "Sets the visibility of the feature. Valid values: 'on', 'off' or 'simplified'."
                    },
                    "weight": {
                      "type": "number",
                      "description": "Sets the weight of the feature, in pixels. Valid values: Integers greater than or equal to zero."
                    }
                  }
                }
              }
            },
            "additionalProperties": false
          }
        }
      }
    },
    "HtmlComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sourceType": {
          "type": "string",
          "default": ""
        },
        "url": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string"
        },
        "freezeFrame": {
          "type": "boolean",
          "default": false
        },
        "allowFullScreen": {
          "type": "boolean",
          "default": false
        },
        "componentConsentPolicy": {
          "type": "string",
          "default": "essential",
          "enum": [
            "essential",
            "functional",
            "analytics",
            "advertising",
            "dataToThirdParty"
          ]
        }
      }
    },
    "DisqusComments": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "disqusId": {
          "type": "string",
          "default": ""
        }
      }
    },
    "ItunesButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "downloadUrl": {
          "type": "string",
          "default": "",
          "description": "Insert band URL"
        }
      }
    },
    "LinkableFlashComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "title": {
          "type": "string"
        },
        "uri": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "height": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "placeHolderImage": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LinkableButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LoginButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "language": {
          "type": "string",
          "default": ""
        }
      }
    },
    "TinyMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "loginSocialBarRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "menuRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "LoginSocialBar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menuItemsRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "iconItemsRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "language": {
          "type": "string",
          "default": "en",
          "maxLength": 10
        },
        "loggedInMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText",
            "memberInitials"
          ],
          "default": "avatarAndText"
        },
        "loggedOutMember": {
          "type": "string",
          "enum": [
            "avatarOnly",
            "textOnly",
            "avatarAndText"
          ]
        },
        "loggedInAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ]
        },
        "loggedOutAvatarIcon": {
          "type": "string",
          "enum": [
            "profileImage",
            "initials",
            "custom"
          ],
          "default": "profileImage"
        },
        "loggedInCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutCustomAvatar": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "loggedOutText": {
          "type": "string",
          "default": "Log In",
          "maxLength": 50
        },
        "showLoggedInText": {
          "type": "boolean",
          "default": true
        },
        "loggedInTextState": {
          "type": "string",
          "enum": [
            "memberName",
            "custom"
          ]
        },
        "loggedInText": {
          "type": "string",
          "default": "Hello",
          "maxLength": 50
        },
        "customLoggedInText": {
          "type": "string",
          "maxLength": 50
        },
        "logOutText": {
          "type": "string",
          "default": "Log Out",
          "maxLength": 50
        }
      }
    },
    "PagesGroupData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appId": {
          "type": [
            "number",
            "null"
          ]
        },
        "appDefinitionId": {
          "type": "string"
        },
        "groupName": {
          "type": "string"
        },
        "pages": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        }
      }
    },
    "PagesGroupCollection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "groups": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "PayPalButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "merchantID": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        }
      }
    },
    "PermaLink": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appType": {
          "enum": [
            "ListsApps",
            "ThirdPartyApps"
          ]
        },
        "dataItemRef": {
          "default": "",
          "type": [
            "null",
            "string"
          ]
        },
        "mutableSeoTitle": {
          "type": "string"
        },
        "correctPermaLinkRef": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "appType"
      ]
    },
    "PinterestFollow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "urlChoice": {
          "type": "string",
          "default": "pinterest/",
          "description": ""
        },
        "label": {
          "type": "string",
          "default": "Pinterest",
          "description": ""
        }
      }
    },
    "SelectableList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "description": "direction of the label",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "description": "direction of the input",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "description": "direction of the dropdown",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "description": "direction of the error",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "description": "a list of SelectOption data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "SelectOption": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "selectedText": {
          "type": "string",
          "maxLength": 400
        },
        "disabled": {
          "type": "boolean"
        },
        "description": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "RadioButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "default": "",
          "maxLength": 400
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "RadioGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "defaultValue": {
          "type": [
            "null",
            "string"
          ]
        },
        "options": {
          "description": "a list of RadioButton data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CheckboxGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "options": {
          "description": "a list of CheckboxInput data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "FileUploader": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttonLabel": {
          "type": "string",
          "default": "Upload File",
          "maxLength": 500
        },
        "placeholderLabel": {
          "type": "string",
          "default": "Max File Size 15MG",
          "maxLength": 500
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonLabelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "filesDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "iconPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      }
    },
    "UploadName": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SiteButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pressed": {
          "type": "boolean"
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "menu",
            "dialog",
            "listbox",
            "tree",
            "grid"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        }
      }
    },
    "SiteButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "linkType": {
          "type": "string",
          "enum": [
            "SMS",
            "CALL",
            "SKYPE",
            "MAP",
            "EMAIL",
            "FACEBOOK",
            "FLICKR",
            "BLOGGER",
            "MYSPACE",
            "LINKEDIN",
            "TWITTER",
            "TUMBLR",
            "YOUTUBE",
            "VIMEO",
            "PAGE",
            "FREE_LINK",
            "TEXT",
            "DELICIOUS",
            "WEBSITE",
            "DOCUMENT",
            "ADMIN_LOGIN",
            "LOGIN"
          ],
          "default": "FREE_LINK"
        },
        "href": {
          "type": "string"
        },
        "text": {
          "type": "string",
          "maxLength": 1200
        },
        "target": {
          "type": "string"
        },
        "icon": {
          "type": "string"
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        }
      }
    },
    "SoundCloudWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string",
          "default": ""
        },
        "showArtWork": {
          "type": "boolean",
          "default": true
        },
        "autoPlay": {
          "type": "boolean",
          "default": false
        },
        "embedSource": {
          "type": "string",
          "default": ""
        }
      }
    },
    "StyledTextA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "status",
            "alert"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ]
        }
      }
    },
    "StyledText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000,
          "default": "<p class='font_7'></p>",
          "not": {
            "pattern": "<script"
          }
        },
        "stylesMapId": {
          "type": "string"
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StyledTextLinkHelper": {
      "type": "object",
      "properties": {
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "SvgShape": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string"
        }
      }
    },
    "VectorImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "default": ""
        },
        "decorative": {
          "type": "boolean"
        },
        "title": {
          "type": "string",
          "maxLength": 100,
          "description": "Title or caption for the vector image."
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        }
      }
    },
    "Video": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "videoId": {
          "type": "string"
        },
        "userId": {
          "type": "string"
        },
        "posterImage": {
          "type": [
            "null",
            "string"
          ]
        },
        "videoType": {
          "type": "string",
          "enum": [
            "YOUTUBE",
            "VIMEO",
            "FACEBOOK",
            "DAILYMOTION"
          ],
          "default": "YOUTUBE"
        }
      }
    },
    "VKShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "style": {
          "type": "string",
          "enum": [
            "Button",
            "ButtonWithoutCounter",
            "Link",
            "LinkWithoutIcon",
            "Icon"
          ],
          "default": "Button",
          "description": "the layout of the button"
        },
        "text": {
          "type": "string",
          "default": "Share",
          "description": "the text of the Button"
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "ButtonWithIcon": {
      "type": "object",
      "properties": {
        "label": {
          "type": "string",
          "format": "resourceKey"
        },
        "toggleMode": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "iconSrc": {
          "type": "string"
        },
        "iconSize": {
          "type": "object"
        },
        "spriteOffset": {
          "type": "object"
        },
        "command": {
          "type": "string"
        },
        "commandParameter": {
          "type": "string"
        },
        "action": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "EditorPreferences": {
      "type": "object",
      "properties": {
        "dontShowAgainTooltips": {
          "type": [
            "null",
            "array"
          ]
        },
        "dontShowAgainDialogs": {
          "type": [
            "null",
            "array"
          ]
        }
      },
      "additionalProperties": false
    },
    "TPAWidget": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "some amazing description"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPAData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data",
          "maxLength": 4000
        }
      }
    },
    "TPAGlobalData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "string",
          "default": "",
          "description": "storage for app data"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Definition ID"
        }
      }
    },
    "TPA": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "referenceId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "widget id"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPASection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "TPAMultiSection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "default": "",
          "description": "application ID"
        },
        "appDefinitionId": {
          "type": "string",
          "default": "",
          "description": "app Defitintion ID"
        },
        "widgetId": {
          "type": "string",
          "default": "",
          "description": "hidden tpaSection part of multi section app"
        },
        "referenceId": {
          "type": "string"
        },
        "usesCssPerBreakpoint": {
          "type": [
            "boolean"
          ],
          "description": "does the TPA supports CSS Per breakpoint"
        },
        "tpaData": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "RssButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "image": {
          "type": [
            "null",
            "string"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "AppPart": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appInnerID": {
          "type": [
            "string",
            "number"
          ]
        },
        "appLogicParams": {
          "type": "object",
          "default": {}
        },
        "appLogicCustomizations": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "fieldId": {
                "type": "string"
              },
              "forType": {
                "type": "string"
              },
              "format": {
                "type": "string"
              },
              "key": {
                "type": "string"
              },
              "type": {
                "type": "string"
              },
              "view": {
                "type": "string"
              },
              "mode": {
                "type": [
                  "string",
                  "null"
                ]
              },
              "value": {
                "type": [
                  "string",
                  "null"
                ]
              }
            },
            "additionalProperties": false
          },
          "default": []
        },
        "appPartName": {
          "type": "string"
        },
        "viewName": {
          "type": "string"
        }
      }
    },
    "AppPartCustomization": {
      "type": "object",
      "properties": {
        "fieldId": {
          "type": "string"
        },
        "forType": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "key": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "view": {
          "type": "string"
        },
        "mode": {
          "type": [
            "string",
            "null"
          ]
        },
        "value": {
          "type": [
            "string",
            "null"
          ]
        }
      },
      "additionalProperties": false
    },
    "AppPage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appPageId": {
          "type": "string",
          "default": ""
        },
        "appInnerID": {
          "type": [
            "string",
            "number"
          ],
          "default": ""
        },
        "appPageType": {
          "type": "string"
        },
        "repeaterPage": {
          "type": "boolean",
          "default": false
        },
        "title": {
          "type": "string",
          "minLength": 1,
          "maxLength": 100
        },
        "hideTitle": {
          "type": "boolean"
        },
        "icon": {
          "type": "string"
        },
        "windowTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "descriptionSEO": {
          "type": "string",
          "maxLength": 1024
        },
        "advancedSeoData": {
          "type": "string",
          "maxLength": 10000
        },
        "metaKeywordsSEO": {
          "type": "string",
          "maxLength": 512
        },
        "pageTitleSEO": {
          "type": "string"
        },
        "pageUriSEO": {
          "type": "string"
        },
        "hidePage": {
          "type": "boolean"
        },
        "underConstruction": {
          "type": "boolean"
        },
        "tpaApplicationId": {
          "type": "number"
        },
        "appDefinitionId": {
          "type": "string"
        },
        "managingAppDefId": {
          "type": [
            "string",
            "null"
          ]
        },
        "tpaPageId": {
          "type": "string"
        },
        "parentPageId": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSecurity": {
          "type": [
            "object",
            "null"
          ],
          "default": {
            "requireLogin": false,
            "passwordDigest": "",
            "dialogLanguage": ""
          }
        },
        "indexable": {
          "type": "boolean",
          "default": true
        },
        "mobileHidePage": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "pageBackgrounds": {
          "type": "object",
          "properties": {
            "desktop": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ]
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            },
            "mobile": {
              "type": "object",
              "properties": {
                "custom": {
                  "type": "boolean"
                },
                "mediaSizing": {
                  "type": "string",
                  "enum": [
                    "document",
                    "viewport"
                  ],
                  "default": "viewport"
                },
                "ref": {
                  "type": [
                    "null",
                    "string"
                  ]
                },
                "isPreset": {
                  "type": "boolean"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "isLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isMobileLandingPage": {
          "type": "boolean",
          "default": false
        },
        "isPopup": {
          "type": "boolean",
          "default": false
        },
        "translationData": {
          "type": "object",
          "properties": {
            "uriSEOTranslated": {
              "type": "boolean",
              "default": false
            }
          },
          "additionalProperties": false
        },
        "ogImage": {
          "type": [
            "string",
            "null"
          ]
        },
        "ogImageRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "ignoreBottomBottomAnchors": {
          "type": [
            "boolean",
            "null"
          ]
        },
        "cacheMode": {
          "enum": [
            "auto",
            "manual",
            "disabled"
          ]
        },
        "cacheMaxAgeHours": {
          "type": [
            "number",
            "null"
          ],
          "multipleOf": 1
        }
      }
    },
    "AppBuilderComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appInnerID": {
          "type": [
            "string",
            "null"
          ]
        },
        "appPartName": {
          "type": "string"
        }
      }
    },
    "BoxSlideShow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "BoxSlideShowSlide": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string"
        }
      }
    },
    "StripContainerSlideShow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "StripContainerSlideShowSlide": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "type": "string"
        },
        "background": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "VerticalAnchorsMenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "pageTopLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Top"
        },
        "pageBottomLabel": {
          "type": [
            "null",
            "string"
          ],
          "default": "Page Bottom"
        },
        "hiddenAnchorIds": {
          "type": [
            "null",
            "object"
          ],
          "default": {}
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "bulletPosition": {
          "type": [
            "string"
          ],
          "enum": [
            "row",
            "rowReverse",
            "column",
            "columnReverse"
          ],
          "description": "Flex direction"
        }
      }
    },
    "WFacebookComment": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "WFacebookLike": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isHttpsEnabled": {
          "type": "boolean",
          "default": false
        },
        "urlFormat": {
          "type": "string",
          "enum": [
            "hashBang",
            "slash"
          ],
          "default": "slash"
        }
      }
    },
    "AppController": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "applicationId": {
          "type": "string",
          "maxLength": 100
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "default": ""
        },
        "controllerType": {
          "type": "string",
          "maxLength": 100
        },
        "settings": {
          "type": "string",
          "maxLength": 6000
        },
        "externalId": {
          "type": "string",
          "maxLength": 100
        }
      },
      "required": [
        "applicationId",
        "controllerType"
      ]
    },
    "RepeaterA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "none",
            "radiogroup",
            "list",
            "group"
          ]
        }
      }
    },
    "Repeater": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "items": {
          "type": "array",
          "default": [],
          "items": {
            "type": "string"
          },
          "description": "Unique identifiers for items of the repeater"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "RepeatedData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "original": {
          "type": "object",
          "description": "the original data item of a component inside a repeater according to the specific component schema"
        },
        "overrides": {
          "type": "object",
          "description": "a map from itemId in a repeater to its data item according to the specific component schema"
        }
      }
    },
    "ImageButtonWithText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 100
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "predefinedClass": {
          "type": "string",
          "maxLength": 20
        }
      }
    },
    "Icon": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "type": "string"
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        },
        "title": {
          "type": "string"
        }
      }
    },
    "WidgetRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "appDefinitionId": {
          "type": "string"
        },
        "widgetId": {
          "type": "string"
        },
        "variationId": {
          "type": [
            "string",
            "null"
          ]
        },
        "name": {
          "type": "string",
          "maxLength": 100
        }
      }
    },
    "InternalRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": [
            "string"
          ]
        },
        "pageId": {
          "type": "string"
        }
      }
    },
    "InternalBlocksRef": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "rootCompId": {
          "type": "string"
        },
        "pageId": {
          "type": "string"
        }
      }
    },
    "LightboxA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "LightboxContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "ContainerA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "none",
            "status",
            "alert",
            "nav",
            "list",
            "listitem",
            "tablist",
            "tab",
            "tabpanel",
            "menubar",
            "presentation",
            "heading"
          ]
        },
        "roledescription": {
          "type": "string",
          "maxLength": 100
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false"
          ],
          "maxLength": 10
        },
        "hidden": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string",
          "enum": [
            "all",
            "additions",
            "text",
            "removals"
          ]
        }
      }
    },
    "ContainerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "MediaBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "SlotsPlaceholderData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "interfaces": {
          "type": "array",
          "items": {
            "type": "string"
          },
          "maxItems": 20
        }
      },
      "required": [
        "interfaces"
      ]
    },
    "LinkType": {
      "type": "string",
      "enum": [
        "SMS",
        "CALL",
        "SKYPE",
        "MAP",
        "EMAIL",
        "FACEBOOK",
        "FLICKR",
        "BLOGGER",
        "MYSPACE",
        "LINKEDIN",
        "TWITTER",
        "TUMBLR",
        "YOUTUBE",
        "VIMEO",
        "PAGE",
        "FREE_LINK",
        "TEXT",
        "DELICIOUS",
        "WEBSITE",
        "DOCUMENT",
        "ADMIN_LOGIN",
        "LOGIN"
      ],
      "default": "FREE_LINK"
    },
    "UrlFormat": {
      "type": "string",
      "enum": [
        "hashBang",
        "slash"
      ],
      "default": "slash"
    },
    "MultiStateBoxDataA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "MultiStateBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultStateId": {
          "default": "FIRST_STATE",
          "type": [
            "null",
            "string"
          ]
        },
        "selectedStateId": {
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "AppsInstallState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "stateMap": {
          "type": "object",
          "default": {},
          "additionalProperties": {
            "type": "object",
            "required": [
              "status"
            ],
            "properties": {
              "status": {
                "type": "string",
                "enum": [
                  "INSTALLED",
                  "REMOVED"
                ],
                "default": "INSTALLED"
              },
              "version": {
                "type": [
                  "string",
                  "null"
                ],
                "minLength": 1,
                "maxLength": 20
              }
            }
          },
          "properties": {}
        }
      }
    },
    "StateBoxA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "StateBoxStateA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "role": {
          "type": "string",
          "enum": [
            "region",
            "group",
            "tablist",
            "tab",
            "tabpanel",
            "alert",
            "status",
            "list",
            "menubar",
            "presentation",
            "none",
            "nav",
            "listitem"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "expanded": {
          "type": "boolean"
        },
        "relevant": {
          "type": "string"
        },
        "busy": {
          "type": "boolean"
        },
        "owns": {
          "type": "string"
        }
      }
    },
    "StateBoxState": {
      "type": "object",
      "properties": {
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Builder.MenuItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "container": {
          "type": "string"
        },
        "label": {
          "type": "string"
        },
        "isVisible": {
          "type": "boolean",
          "default": true
        }
      }
    },
    "Builder.MenuItems": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "Builder.Image": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "maxLength": 1000,
          "description": "Identifier or URL for the image."
        },
        "name": {
          "type": "string",
          "maxLength": 100,
          "description": "Human-readable filename to use for the image."
        },
        "width": {
          "type": "number"
        },
        "height": {
          "type": "number"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.Video": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "description": "Unique identifier for the video media",
          "maxLength": 1000
        },
        "sources": {
          "type": "array",
          "description": "Available video sources in different qualities",
          "items": {
            "type": "object",
            "required": [
              "quality",
              "width",
              "height",
              "types"
            ],
            "properties": {
              "quality": {
                "type": "string",
                "enum": [
                  "1080p",
                  "720p",
                  "480p",
                  "360p"
                ],
                "description": "Quality level of the video source"
              },
              "width": {
                "type": "number",
                "description": "Width of the video in pixels"
              },
              "height": {
                "type": "number",
                "description": "Height of the video in pixels"
              },
              "types": {
                "type": "array",
                "description": "Available format types and their URIs for this quality",
                "items": {
                  "type": "object",
                  "required": [
                    "format",
                    "uri"
                  ],
                  "properties": {
                    "format": {
                      "type": "string",
                      "enum": [
                        "mp4",
                        "mp4-luminance"
                      ],
                      "description": "Video format type"
                    },
                    "uri": {
                      "type": "string",
                      "description": "URI to access the video file"
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            "additionalProperties": false
          }
        },
        "adaptiveSources": {
          "type": "array",
          "description": "Sources for adaptive streaming formats",
          "items": {
            "type": "object",
            "required": [
              "format",
              "uri"
            ],
            "properties": {
              "format": {
                "type": "string",
                "enum": [
                  "hls",
                  "dash"
                ],
                "description": "Adaptive streaming format"
              },
              "uri": {
                "type": "string",
                "description": "URI to access the stream manifest"
              }
            },
            "additionalProperties": false
          }
        },
        "hasAudio": {
          "type": "boolean",
          "description": "Whether the video contains an audio track"
        },
        "fps": {
          "type": "number",
          "description": "Frames per second of the video"
        },
        "poster": {
          "description": "Poster image for the video",
          "type": [
            "null",
            "string"
          ]
        },
        "duration": {
          "type": "number",
          "description": "Duration of the video in seconds"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.VectorArt": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string"
        }
      },
      "required": [
        "uri"
      ]
    },
    "Builder.RichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 120000
        },
        "linkList": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "mobui.MobuiButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "contentType": {
          "default": "Text",
          "enum": [
            "Text",
            "Icon",
            "Text and icon"
          ],
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "iconPosition": {
          "default": "Left",
          "enum": [
            "Left",
            "Right"
          ],
          "type": "string"
        },
        "buttonType": {
          "default": "Full",
          "enum": [
            "Full",
            "Outline",
            "Link"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        }
      }
    },
    "mobui.MobuiDatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "initialText": {
          "default": "today's date",
          "enum": [
            "today's date",
            "placeholder"
          ],
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "settings",
            "filter"
          ],
          "type": "string"
        },
        "pickerType": {
          "default": "calendar",
          "enum": [
            "wheel",
            "calendar"
          ],
          "type": "string"
        },
        "pickerTitle": {
          "default": "Select Date",
          "maxLength": 120,
          "type": "string"
        },
        "showPastDates": {
          "default": true,
          "type": "boolean"
        },
        "showFutureDates": {
          "default": true,
          "type": "boolean"
        },
        "wheelMode": {
          "default": "DD/MM/YY",
          "enum": [
            "DD/MM/YY",
            "MM/YY"
          ],
          "type": "string"
        },
        "firstDay": {
          "default": "Monday",
          "enum": [
            "Sunday",
            "Monday"
          ],
          "type": "string"
        },
        "disabledDaysOfWeek": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "enabledDateRanges": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "disabledDateRanges": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "This field is required",
          "maxLength": 1200,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "disabledDates": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "minDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "maxDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "timeZone": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "defaultItemSchemaType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "MobuiDateRangeType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "startDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "endDate": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "mobui.MobuiImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "src": {
          "type": [
            "null",
            "string"
          ]
        },
        "isExternalSource": {
          "default": false,
          "type": "boolean"
        },
        "resizeMode": {
          "default": "cover",
          "enum": [
            "cover",
            "contain",
            "stretch",
            "repeat",
            "center"
          ],
          "type": "string"
        }
      }
    },
    "mobui.MobuiPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldType": {
          "default": "form",
          "enum": [
            "form",
            "filter",
            "settings"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Select an option",
          "maxLength": 120,
          "type": "string"
        },
        "pickerType": {
          "default": "fullScreen",
          "enum": [
            "fullScreen",
            "dialog"
          ],
          "type": "string"
        },
        "optionsDialogTitle": {
          "default": "Select an Option",
          "maxLength": 120,
          "type": "string"
        },
        "optionsDialogSubtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasItemSubtitle": {
          "default": false,
          "type": "boolean"
        },
        "isMultiselect": {
          "default": false,
          "type": "boolean"
        },
        "selectionLimit": {
          "default": 3,
          "type": "number",
          "multipleOf": 1
        },
        "hasSearchBar": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "requiredErrorMessage": {
          "default": "Please fill out this field",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": false,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "MobuiPickerItemType": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "subtitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isSelected": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "mobui.MobuiSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Add Title",
          "maxLength": 1200,
          "type": "string"
        },
        "selectable": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "inputType": {
          "default": "text",
          "enum": [
            "text",
            "password",
            "phone",
            "email",
            "url",
            "number"
          ],
          "type": "string"
        },
        "label": {
          "default": "Label",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "initialValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "hasCharLimit": {
          "default": false,
          "type": "boolean"
        },
        "maxInputLength": {
          "default": 300,
          "maximum": 120000,
          "type": "number",
          "multipleOf": 1
        },
        "prefixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffixValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "requiredErrorMessage": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorErrorMessageValue": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validatorType": {
          "default": "none",
          "enum": [
            "none",
            "number",
            "email",
            "url",
            "required"
          ],
          "type": "string"
        },
        "textContentType": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "autoComplete": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "validateOnStart": {
          "default": false,
          "type": "boolean"
        },
        "validateOnChange": {
          "default": false,
          "type": "boolean"
        },
        "validateOnBlur": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiVideoPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "default": "I am a Title",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "https://video.wixstatic.com/video/11062b_5ae1557b0cb244ab80dabfa817f48caa/1080p/mp4/file.mp4",
          "maxLength": 1200,
          "type": "string"
        },
        "poster": {
          "type": [
            "null",
            "string"
          ]
        },
        "isPlaying": {
          "default": false,
          "type": "boolean"
        },
        "muteOnStart": {
          "default": false,
          "type": "boolean"
        },
        "playInLoop": {
          "default": false,
          "type": "boolean"
        },
        "enableFullScreen": {
          "default": true,
          "type": "boolean"
        },
        "enableCasting": {
          "default": false,
          "type": "boolean"
        },
        "showVideoSettings": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "mobui.MobuiMultiStateBoxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "defaultStateId": {
          "default": null,
          "type": [
            "null",
            "string"
          ]
        },
        "selectedStateId": {
          "default": null,
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "wixui.ExternalComponent": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "compProps": {
          "default": "{}",
          "maxLength": 120000,
          "type": "string"
        },
        "isTrusted": {
          "default": false,
          "type": "boolean"
        },
        "importKey": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "wixui.HamburgerOverlay": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "showBackgroundOverlay": {
          "default": true,
          "type": "boolean"
        },
        "tapOutsideToClose": {
          "default": true,
          "type": "boolean"
        },
        "isMenuContainerFullscreen": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "wixui.Logo": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isLoadingData": {
          "default": true,
          "type": "boolean"
        },
        "logoId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alt": {
          "default": "Logo",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "preset": {
          "default": "original",
          "maxLength": 120,
          "type": "string"
        },
        "hasBackground": {
          "default": true,
          "type": "boolean"
        },
        "brandId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "backgroundColor": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "logoUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "wixui.LottieEmbed": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "animationUrl": {
          "default": "https://assets7.lottiefiles.com/packages/lf20_bh69rwvr.json",
          "maxLength": 1200,
          "type": "string"
        },
        "speed": {
          "default": 1,
          "minimum": 0,
          "type": "number"
        },
        "loop": {
          "default": true,
          "type": "boolean"
        },
        "autoplay": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": false,
          "type": "boolean"
        },
        "showPlaybackControl": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "wixui.ProductSpecification": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "wixui.RangeSlider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Set a range value",
          "maxLength": 120,
          "type": "string"
        },
        "sliderType": {
          "default": "Continuous",
          "enum": [
            "Continuous",
            "Stepped"
          ],
          "type": "string"
        },
        "stepType": {
          "default": "Number",
          "enum": [
            "Number",
            "Value"
          ],
          "type": "string"
        },
        "step": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "direction": {
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ],
          "type": "string"
        },
        "rootDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "labelDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "sliderDirection": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        },
        "min": {
          "default": 0,
          "type": "number"
        },
        "max": {
          "default": 100,
          "type": "number"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "suffix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 0,
          "type": "number"
        },
        "thumbShape": {
          "default": "Circle",
          "enum": [
            "Circle",
            "Square",
            "Rectangle",
            "Bar"
          ],
          "type": "string"
        },
        "marksTickShape": {
          "default": "Lines",
          "enum": [
            "Lines",
            "Dots"
          ],
          "type": "string"
        },
        "thumbSize": {
          "default": 24,
          "type": "number",
          "multipleOf": 1
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "accessibleName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "wixui.Rive": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "animationFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "thumbnailFileUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "artboard": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "stateMachine": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fit": {
          "default": "cover",
          "maxLength": 120,
          "type": "string"
        },
        "alignment": {
          "default": "center",
          "maxLength": 120,
          "type": "string"
        },
        "isAutoPlayOn": {
          "default": true,
          "type": "boolean"
        },
        "isTouchScrollEnabled": {
          "default": true,
          "type": "boolean"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "fileName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "isDecorative": {
          "default": true,
          "type": "boolean"
        }
      }
    },
    "wixui.ShareButtons": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "buttons": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "pageToShare": {
          "default": "home",
          "maxLength": 1200,
          "type": "string"
        },
        "shareUrl": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      }
    },
    "IShareButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "platformId": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "label"
      ]
    },
    "wixui.SingleTab": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabId": {
          "maxLength": 120,
          "type": "string"
        },
        "label": {
          "default": "Tab",
          "maxLength": 120,
          "type": "string"
        },
        "isParentStretched": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "tabId"
      ]
    },
    "AccordionContainerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "items": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "additionalProperties": false,
            "properties": {
              "id": {
                "type": "string"
              },
              "label": {
                "type": "string"
              }
            }
          },
          "default": []
        }
      }
    },
    "AccordionItemData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isParentStretched": {
          "type": "boolean",
          "default": false
        }
      }
    },
    "AddressInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "optionsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "locale": {
          "type": "string",
          "maxLength": 100
        },
        "googleMapsApiKey": {
          "type": "string",
          "maxLength": 400
        },
        "filter": {
          "type": "object",
          "properties": {
            "country": {
              "type": "string",
              "maxLength": 10
            }
          },
          "additionalProperties": false
        },
        "sorting": {
          "type": "object",
          "properties": {
            "location": {
              "type": "object",
              "properties": {
                "lat": {
                  "type": "number"
                },
                "lng": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "radius": {
              "type": "number",
              "default": 100
            },
            "formatted": {
              "type": "string",
              "maxLength": 10
            }
          },
          "additionalProperties": false
        },
        "placeholder": {
          "type": "string",
          "description": "The value of the placeholder if chosen",
          "maxLength": 1000
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "BoltComponentData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      },
      "anyOf": [
        {
          "properties": {},
          "additionalProperties": false
        }
      ]
    },
    "BreadcrumbsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        }
      }
    },
    "Captcha": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "captchaType": {
          "type": "string",
          "enum": [
            "image",
            "audio"
          ],
          "default": "image",
          "description": "When set changes the type of the challenge (image or audio)"
        }
      }
    },
    "CollapsibleTextData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "default": "",
          "maxLength": 120000
        },
        "readMoreText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "readLessText": {
          "type": "string",
          "default": "Read Less",
          "maxLength": 1200
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "linkText": {
          "type": "string",
          "default": "Read More",
          "maxLength": 1200
        },
        "textDescription": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "tag": {
          "type": "string",
          "default": "p",
          "maxLength": 31
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "ComboBoxInputData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "labelDirection": {
          "description": "direction of the label",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "inputDirection": {
          "description": "direction of the input",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "dropdownDirection": {
          "description": "direction of the dropdown",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "errorDirection": {
          "description": "direction of the error",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "options": {
          "description": "a list of SelectOption data items",
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "default": "",
          "maxLength": 400
        },
        "placeholder": {
          "type": "object",
          "properties": {
            "value": {
              "type": "string",
              "default": "-1",
              "description": "the value of the placeholder option",
              "maxLength": 400
            },
            "text": {
              "type": "string",
              "default": "",
              "description": "the text of the placeholder option",
              "maxLength": 400
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "CustomElement": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tagName": {
          "type": "string",
          "default": "wix-default-custom-element"
        },
        "url": {
          "type": "string",
          "default": "https://static.parastorage.com/services/editor-elements-library/dist/assets/CustomElement/wixDefaultCustomElement.js"
        },
        "hostedInCorvid": {
          "type": "boolean",
          "default": false
        },
        "initialAttributes": {
          "type": "string",
          "default": "{}",
          "maxLength": 4096
        },
        "shouldReload": {
          "type": "boolean",
          "description": "if iframe should be reloaded on initialAttributes change"
        },
        "scriptType": {
          "type": "string",
          "enum": [
            "none",
            "module"
          ],
          "default": "none"
        },
        "appDefinitionId": {
          "type": "string",
          "maxLength": 36
        },
        "widgetId": {
          "type": "string",
          "maxLength": 36
        }
      }
    },
    "wixui.FastGallery": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "itemClickAction": {
          "default": "ACTION",
          "enum": [
            "ACTION",
            "LINK",
            "NOTHING"
          ],
          "type": "string"
        },
        "downloadProtection": {
          "default": true,
          "type": "boolean"
        },
        "wixSDKItems": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "wixui.HamburgerMenuContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "wixui.HamburgerMenuRoot": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ImageX": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "image": {
          "type": "object",
          "properties": {
            "uri": {
              "type": "string",
              "default": ""
            },
            "alt": {
              "type": "string",
              "default": ""
            },
            "name": {
              "type": "string",
              "maxLength": 100
            },
            "height": {
              "type": "number",
              "default": 200
            },
            "width": {
              "type": "number",
              "default": 200
            },
            "decorative": {
              "type": "boolean"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "scopedData": {
          "description": "ImageX data per breakpoint",
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "breakpoint": {
                "type": "string"
              },
              "crop": {
                "type": "object",
                "required": [
                  "x",
                  "y",
                  "width",
                  "height"
                ],
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0
                  },
                  "width": {
                    "type": "number",
                    "minimum": 0
                  },
                  "height": {
                    "type": "number",
                    "minimum": 0
                  },
                  "svgId": {
                    "type": "string",
                    "maxLength": 100
                  },
                  "rotate": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 359,
                    "description": "Image rotation degrees"
                  },
                  "flip": {
                    "type": "string",
                    "enum": [
                      "x",
                      "y",
                      "xy",
                      "none"
                    ],
                    "default": "none",
                    "description": "Image flip value"
                  }
                },
                "additionalProperties": false
              },
              "focalPoint": {
                "type": "object",
                "required": [
                  "x",
                  "y"
                ],
                "properties": {
                  "x": {
                    "type": "number",
                    "minimum": 0
                  },
                  "y": {
                    "type": "number",
                    "minimum": 0
                  }
                },
                "additionalProperties": false
              },
              "displayMode": {
                "type": "string",
                "enum": [
                  "fill",
                  "fit",
                  "fitWidth"
                ],
                "default": "fill"
              },
              "scrollEffect": {
                "type": "string",
                "enum": [
                  "parallax",
                  "fixed",
                  "zoomIn",
                  "fadeIn",
                  "none"
                ]
              },
              "clickAction": {
                "type": "string",
                "enum": [
                  "none",
                  "goToLink"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "mask": {
          "type": [
            "object",
            "null"
          ],
          "properties": {
            "x": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "y": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "width": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "height": {
              "type": "number",
              "minimum": 0,
              "maximum": 100
            },
            "svgId": {
              "type": "string"
            },
            "flip": {
              "type": "string",
              "enum": [
                "x",
                "y",
                "xy",
                "none"
              ]
            },
            "rotate": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "mode": {
              "type": "string",
              "enum": [
                "alpha",
                "luminance"
              ]
            }
          },
          "additionalProperties": false
        },
        "parallaxSpeed": {
          "type": "number"
        },
        "parallaxDirection": {
          "type": "string",
          "enum": [
            "normal",
            "reverse"
          ]
        },
        "hasAnimation": {
          "type": "boolean"
        }
      }
    },
    "Crop": {
      "type": "object",
      "required": [
        "x",
        "y",
        "width",
        "height"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        },
        "width": {
          "type": "number",
          "minimum": 0
        },
        "height": {
          "type": "number",
          "minimum": 0
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "rotate": {
          "type": "number",
          "minimum": 0,
          "maximum": 359,
          "description": "Image rotation degrees"
        },
        "flip": {
          "type": "string",
          "enum": [
            "x",
            "y",
            "xy",
            "none"
          ],
          "default": "none",
          "description": "Image flip value"
        }
      },
      "additionalProperties": false
    },
    "FocalPoint": {
      "type": "object",
      "required": [
        "x",
        "y"
      ],
      "properties": {
        "x": {
          "type": "number",
          "minimum": 0
        },
        "y": {
          "type": "number",
          "minimum": 0
        }
      },
      "additionalProperties": false
    },
    "LanguageSelector": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "wixui.MegaMenuContainerItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "default": "wixui.MegaMenuContainerItem",
          "maxLength": 120,
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "MenuData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "itemDirection": {
          "description": "direction of the 1st (top) level menu items",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuDirection": {
          "description": "direction of the 2nd level menu item (submenu)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "submenuItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "submenuSubItemDirection": {
          "description": "direction of the 3rd level menu item (submenuSubItem)",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "navAriaLabel": {
          "type": "string",
          "maxLength": 1000
        },
        "menuRef": {
          "default": "#CUSTOM_MAIN_MENU",
          "type": [
            "null",
            "string"
          ]
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "wixui.MenuList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "menus": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "MusicPlayerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "coverDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "audioRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "audioUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "playListId": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 255
        },
        "playlist": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "artistName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Artist"
              },
              "trackName": {
                "type": "string",
                "maxLength": 255,
                "default": "Unknown Track"
              },
              "url": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "cover": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 2500
              },
              "durationFormatted": {
                "type": [
                  "string",
                  "null"
                ],
                "maxLength": 16
              }
            },
            "additionalProperties": false
          },
          "default": []
        },
        "coverRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "coverUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "artistName": {
          "type": "string",
          "default": "Unknown Artist",
          "maxLength": 255
        },
        "trackName": {
          "type": "string",
          "default": "Unknown Track",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000
        }
      }
    },
    "WixAudio": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "uri": {
          "type": "string",
          "default": ""
        },
        "title": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "duration": {
          "type": "number"
        }
      }
    },
    "Pagination": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "totalPages": {
          "type": "number",
          "description": "The total number of pages displayed by the component"
        },
        "currentPage": {
          "type": "number",
          "default": 1,
          "description": "The the page number marked as current"
        },
        "nextText": {
          "type": "string",
          "default": "Next",
          "maxLength": 400,
          "description": "Text to appear in NEXT button"
        },
        "previousText": {
          "type": "string",
          "default": "Previous",
          "maxLength": 400,
          "description": "Text to appear in PREVIOUS button"
        },
        "firstText": {
          "type": "string",
          "default": "First",
          "maxLength": 400,
          "description": "Text to appear in FIRST button"
        },
        "lastText": {
          "type": "string",
          "default": "Last",
          "maxLength": 400,
          "description": "Text to appear in LAST button"
        },
        "nextAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the NEXT button"
        },
        "previousAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the PREVIOUS button"
        },
        "firstAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the FIRST button"
        },
        "lastAriaLabel": {
          "type": "string",
          "maxLength": 400,
          "description": "Accessible name for the LAST button"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "PaginationA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "ProgressBar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "number",
          "description": "Current progress value"
        },
        "targetValue": {
          "type": "number",
          "default": 100,
          "description": "Progress target value to be defined as complete"
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "barDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "RatingsDisplay": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "ratingsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "rating": {
          "type": "number",
          "description": "The rating displayed by the component",
          "minimum": 1,
          "maximum": 5
        },
        "svgId": {
          "type": "string",
          "maxLength": 100
        },
        "numRatings": {
          "type": "number",
          "description": "The amount of ratings the rating is based on",
          "minimum": 0
        },
        "reviewsCountLabel": {
          "type": "string",
          "default": "Reviews",
          "maxLength": 400,
          "description": "Text that describes the numRatings value"
        },
        "noReviewsPlaceholder": {
          "type": "string",
          "default": "Be the first to rate this item",
          "maxLength": 1000,
          "description": "Placeholder text when there aren't any reviews"
        }
      }
    },
    "RatingsInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": [
            "number",
            "null"
          ],
          "description": "The rating value currently selected",
          "minimum": 0,
          "maximum": 5
        },
        "titleText": {
          "type": "string",
          "description": "the title before a value is selected",
          "maxLength": 300
        },
        "svgId": {
          "type": "string",
          "description": "the id of the svg that illustrates the rating",
          "maxLength": 100
        },
        "labels": {
          "type": "object",
          "description": "contains the labels for the different values. maps 1-5 as keys to strings",
          "default": {
            "1": "Bad",
            "2": "Fine",
            "3": "OK",
            "4": "Good",
            "5": "Great"
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "wixui.RichContentViewer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "content": {
          "type": "object"
        },
        "trimEnabled": {
          "type": "boolean",
          "default": false
        },
        "trimMode": {
          "type": "string",
          "default": "paragraph",
          "maxLength": 100
        },
        "trimLengthParagraph": {
          "type": "number",
          "default": 3
        },
        "trimLengthWord": {
          "type": "number",
          "default": 10
        },
        "trimExclude": {
          "type": "string",
          "default": "plugins",
          "maxLength": 100
        },
        "trimEllipsisEnabled": {
          "type": "boolean",
          "default": true
        },
        "trimEllipsisExpandText": {
          "type": "string",
          "default": "Show More",
          "maxLength": 1200
        },
        "trimEllipsisCollapseText": {
          "type": "string",
          "default": "Show Less",
          "maxLength": 1200
        }
      }
    },
    "RichTextBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "maxLength": {
          "type": [
            "number",
            "null"
          ],
          "description": "maximum number of characters allowed"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "SearchBox": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "placeholder": {
          "type": "string",
          "default": "Search...",
          "maxLength": 255
        },
        "suggestionsEnabled": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the suggestions disabled or not"
        },
        "clearButtonText": {
          "type": "string",
          "default": "Clear",
          "maxLength": 255
        },
        "displaySettingsToggles": {
          "type": "boolean",
          "default": true,
          "description": "Determines whether the settings toggles are displayed or not"
        }
      }
    },
    "Section": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "SectionA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        },
        "role": {
          "type": "string",
          "enum": [
            "heading",
            "alert",
            "status"
          ]
        },
        "atomic": {
          "type": "boolean"
        },
        "hidden": {
          "type": "boolean"
        },
        "current": {
          "type": "string",
          "enum": [
            "step",
            "page",
            "true",
            "false",
            "location",
            "date",
            "time"
          ]
        },
        "level": {
          "type": "number",
          "minimum": 1,
          "maximum": 6
        }
      }
    },
    "wixui.SelectableContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "wixui.SelectableContainerInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SelectionTagsList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "options": {
          "description": "Array of items which behave like checkboxes and look similar to buttons",
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "value": {
          "description": "Array with the values of the selected options",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SelectionTag": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "maxLength": 400
        },
        "label": {
          "type": "string",
          "maxLength": 400
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "rel": {
          "type": "string",
          "enum": [
            "nofollow"
          ]
        }
      }
    },
    "SignatureInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "titleText": {
          "type": "string",
          "description": "The title of the field",
          "maxLength": 400
        },
        "clearButtonText": {
          "type": "string",
          "description": "The undo signature text",
          "minLength": 1,
          "maxLength": 400
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "buttonDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "radioButtonsDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "SiteButtonData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "description": "direction of the component",
          "type": "string",
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON"
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "Slider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "trackDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "tooltipDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "min": {
          "type": "number",
          "default": 0,
          "description": "Minimum value"
        },
        "max": {
          "type": "number",
          "default": 100,
          "description": "Maximum value"
        },
        "value": {
          "type": "number",
          "default": 50,
          "description": "Current value"
        },
        "step": {
          "type": "number",
          "default": 0,
          "description": "Step value"
        },
        "stepType": {
          "type": "string",
          "default": "value",
          "enum": [
            "value",
            "count"
          ],
          "description": "When set to 'value', step represents the value of each step. When set to 'count', step represents the total steps count"
        },
        "disabled": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is disabled or not"
        },
        "readOnly": {
          "type": "boolean",
          "default": false,
          "description": "Determines whether the slider is read-only or not"
        },
        "label": {
          "type": [
            "null",
            "string"
          ],
          "description": "Label text",
          "maxLength": 1200
        }
      }
    },
    "wixui.Slideshow": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "default": "wixui.Slideshow",
          "maxLength": 120,
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "type": "string"
        }
      }
    },
    "SocialAuth": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "StylableButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "type": [
            "null",
            "string"
          ]
        },
        "label": {
          "type": "string",
          "default": "MY BUTTON",
          "maxLength": 1200
        },
        "svgId": {
          "type": "string",
          "default": "",
          "maxLength": 100
        },
        "isIconAnimated": {
          "type": "boolean"
        },
        "animatedIcon": {
          "type": "object",
          "properties": {
            "svgIdAnimationSelected": {
              "type": "string",
              "maxLength": 100
            },
            "customAnimatedIcon": {
              "type": [
                "object"
              ],
              "properties": {
                "svgIdAnimationStart": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationEnd": {
                  "type": "string",
                  "maxLength": 100
                },
                "svgIdAnimationSelected": {
                  "type": "string",
                  "maxLength": 100
                }
              },
              "additionalProperties": false
            },
            "animationDuration": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "StylableButtonA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "pressed": {
          "type": "boolean"
        },
        "expanded": {
          "type": "boolean"
        },
        "disabled": {
          "type": "boolean"
        },
        "haspopup": {
          "type": "string",
          "enum": [
            "true",
            "false",
            "dialog",
            "menu"
          ]
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "live": {
          "type": "string",
          "enum": [
            "polite",
            "assertive"
          ]
        }
      }
    },
    "Submenu": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "itemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "subItemDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      },
      "required": [
        "direction"
      ]
    },
    "SvgImage": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "decorative": {
          "type": "boolean"
        },
        "alt": {
          "type": "string",
          "description": "Alternative text for the vector image (for accessibility purposes).",
          "maxLength": 120
        },
        "displayMode": {
          "type": "string",
          "enum": [
            "fit",
            "stretch"
          ],
          "description": "should the shape maintain it's aspect ratio or stretch",
          "default": "fit"
        },
        "svgId": {
          "type": "string",
          "maxLength": 100,
          "description": "Identifier for the SVG image."
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "svgId"
      ]
    },
    "wixui.Tabs": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabIds": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 120
          }
        },
        "defaultTabId": {
          "type": "string",
          "default": "",
          "maxLength": 120
        },
        "a11y": {
          "type": [
            "null",
            "string"
          ]
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        }
      }
    },
    "TabsA11y": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabindex": {
          "type": "number",
          "minimum": -1,
          "maximum": 0
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        }
      }
    },
    "TextEffectsSharedData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 500
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "default": "div"
        },
        "textDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction",
          "default": "inherit"
        },
        "patternScope": {
          "type": "string",
          "enum": [
            "none",
            "character",
            "word"
          ],
          "default": "none"
        }
      }
    },
    "TextMarqueeData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "movementDirection": {
          "type": "string",
          "description": "direction the text is moving to",
          "default": "rtl",
          "enum": [
            "rtl",
            "ltr"
          ]
        },
        "speed": {
          "type": "number",
          "description": "speed of the animation in pixels per second"
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "pause animation on hover"
        },
        "textDirection": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "headingLevel": {
          "type": "number",
          "maximum": 6,
          "minimum": 0,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "svgId": {
          "type": "string"
        },
        "items": {
          "default": [],
          "description": "array of marquee items",
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "items",
        "speed"
      ]
    },
    "TextMarqueeItem": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "text": {
          "type": "string",
          "maxLength": 500
        }
      },
      "required": [
        "text"
      ]
    },
    "TextFxData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "type": "string",
          "maxLength": 450
        },
        "headingLevel": {
          "type": "number",
          "minimum": 0,
          "maximum": 6,
          "description": "Heading level to wrap the component (deprecated)"
        },
        "isDecorative": {
          "type": "boolean"
        },
        "direction": {
          "type": "string",
          "enum": [
            "ltr",
            "rtl"
          ],
          "default": "ltr"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div",
            "p"
          ],
          "description": "Semantic tag name to wrap the component"
        }
      }
    },
    "TextOnPathData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isDecorative": {
          "type": "boolean"
        },
        "text": {
          "type": "string",
          "description": "text",
          "maxLength": 500
        },
        "path": {
          "type": "string",
          "description": "path"
        },
        "pathLength": {
          "type": "number",
          "description": "Path length"
        },
        "viewBox": {
          "type": "string",
          "description": "View box"
        },
        "speed": {
          "type": "number",
          "description": "Speed",
          "default": 3
        },
        "movementDirection": {
          "type": "string",
          "description": "Direction the text is moving to",
          "default": "forward",
          "enum": [
            "forward",
            "reverse"
          ]
        },
        "pauseOnHover": {
          "type": "boolean",
          "description": "Pause animation on hover"
        },
        "direction": {
          "type": "string",
          "default": "ltr",
          "enum": [
            "ltr",
            "rtl"
          ]
        },
        "tagName": {
          "type": "string",
          "enum": [
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "div"
          ],
          "description": "Semantic tag name to wrap the component"
        },
        "fillMode": {
          "type": "string",
          "enum": [
            "normal",
            "repeat",
            "justify"
          ],
          "default": "normal",
          "description": "How the text should be rendered on the path"
        },
        "link": {
          "description": "Reference to a link associated with the vector image.",
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "startOffset": {
          "type": "number",
          "description": "Starting point of the text on the path",
          "minimum": 0,
          "maximum": 100
        },
        "fontSize": {
          "type": "number",
          "description": "Font size as a number in percent",
          "minimum": 0,
          "maximum": 100
        },
        "pathStrokeWidth": {
          "type": "number",
          "description": "Width of the path stroke in em units",
          "minimum": 0,
          "maximum": 3
        }
      }
    },
    "TimePickerData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "labelDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "inputDirection": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "placeholder": {
          "type": "string",
          "description": "The value of the placeholder if chosen",
          "maxLength": 1000
        },
        "step": {
          "type": "number",
          "minimum": 1,
          "maximum": 60,
          "default": 1,
          "description": "Increment step in minutes"
        },
        "label": {
          "type": "string",
          "maxLength": 1000
        },
        "margin": {
          "type": "number",
          "minimum": 1,
          "maximum": 30,
          "description": "Time picker layout label margin"
        },
        "disabledTimes": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "startTime",
              "endTime"
            ],
            "properties": {
              "startTime": {
                "type": "string",
                "maxLength": 100
              },
              "endTime": {
                "type": "string",
                "maxLength": 100
              }
            }
          },
          "default": [],
          "maxItems": 5,
          "description": "array of disabled times"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "ToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "checked": {
          "type": "boolean",
          "description": "The checked status of the input"
        },
        "direction": {
          "type": [
            "string"
          ],
          "enum": [
            "ltr",
            "rtl",
            "inherit"
          ],
          "description": "direction"
        },
        "value": {
          "type": "string",
          "default": "",
          "maxLength": 4000
        },
        "name": {
          "type": "string",
          "maxLength": 400
        },
        "formGroup": {
          "type": "string",
          "description": "form group that this component belongs to",
          "maxLength": 4000
        }
      }
    },
    "UnsupportedComponentData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "migratedFrom": {
          "type": "string"
        }
      }
    },
    "VideoPlayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "videoType": {
          "type": "string",
          "enum": [
            "dailymotion",
            "facebook",
            "file",
            "twitch",
            "vimeo",
            "youtube"
          ],
          "default": "file"
        },
        "videoRef": {
          "type": [
            "null",
            "string"
          ]
        },
        "videoUrl": {
          "type": [
            "string",
            "null"
          ],
          "maxLength": 256
        },
        "posterUrl": {
          "type": [
            "string",
            "null"
          ]
        },
        "videoTitle": {
          "type": "string",
          "default": "",
          "maxLength": 255
        },
        "description": {
          "type": "string",
          "default": "",
          "maxLength": 1000,
          "description": "Video Description"
        },
        "logoRef": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "dsgnsys.ControlTypes": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "shortString": {
          "default": "ShortString",
          "maxLength": 120,
          "type": "string"
        },
        "longString": {
          "default": "LongString",
          "maxLength": 1200,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "dropdown": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "radioButtons": {
          "default": "Options 1",
          "enum": [
            "Options 1",
            "Options 2",
            "Options 3",
            "Options 4"
          ],
          "type": "string"
        },
        "toggleSwitch": {
          "default": false,
          "type": "boolean"
        },
        "thumbnails": {
          "type": [
            "null",
            "string"
          ]
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "slider": {
          "default": 1,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "numericInput": {
          "default": 0,
          "type": "number"
        },
        "colorPickerInput": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "selectedFont": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Save",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Light",
            "Destructive",
            "Premium",
            "Premium light",
            "Dark",
            "Transparent"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Primary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      },
      "required": [
        "label"
      ]
    },
    "dsgnsys.DashboardHeading": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Add Page title H1",
          "maxLength": 1200,
          "type": "string"
        },
        "size": {
          "default": "Page title H1",
          "enum": [
            "Page title H1",
            "Modal title H2",
            "Card title H3",
            "Section title H4",
            "Card section title H5",
            "Caption H6"
          ],
          "type": "string"
        },
        "invertColor": {
          "default": false,
          "type": "boolean"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardIconButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "tooltip": {
          "default": "More Actions",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Transparent"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "priority": {
          "default": "Secondary",
          "enum": [
            "Primary",
            "Secondary"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardInfoIcon": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tooltip": {
          "default": "This message explains the purpose of a feature.",
          "maxLength": 1200,
          "type": "string"
        },
        "addLink": {
          "default": false,
          "type": "boolean"
        },
        "tooltipLinkText": {
          "default": "Learn more",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipLink": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Event name",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter your event name...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixValue": {
          "default": ".com",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "setMaxLength": {
          "default": false,
          "type": "boolean"
        },
        "maxLength": {
          "default": 20,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardNumberInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Number of tickets",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Enter a number...",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 25,
          "type": "number",
          "multipleOf": 1
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "prefixValue": {
          "default": "Units",
          "maxLength": 120,
          "type": "string"
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixType": {
          "default": "Icon",
          "enum": [
            "Icon",
            "Text"
          ],
          "type": "string"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixValue": {
          "default": "%",
          "maxLength": 120,
          "type": "string"
        },
        "required": {
          "default": false,
          "type": "boolean"
        },
        "minAndMaxValues": {
          "default": false,
          "type": "boolean"
        },
        "min": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "max": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepSize": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "border": {
          "default": "Default",
          "enum": [
            "Default",
            "Round",
            "Line",
            "None"
          ],
          "type": "string"
        },
        "labelPlacement": {
          "default": "Top",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "I’m a paragraph. Add your own text and edit me in settings. It’s easy.",
          "maxLength": 1200,
          "type": "string"
        },
        "preset": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Standard secondary",
            "Light",
            "Light secondary",
            "Success",
            "Destructive",
            "Primary",
            "Premium",
            "Disabled"
          ],
          "type": "string"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Thin",
          "enum": [
            "Bold",
            "Normal",
            "Thin"
          ],
          "type": "string"
        },
        "textAlignment": {
          "default": "Left",
          "enum": [
            "Left",
            "Center",
            "Right"
          ],
          "type": "string"
        },
        "overflow": {
          "default": "Wrap",
          "enum": [
            "Wrap",
            "Ellipsis"
          ],
          "type": "string"
        },
        "maxLines": {
          "default": 1,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        }
      }
    },
    "dsgnsys.DashboardTextButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "View All",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Premium",
            "Light",
            "Dark",
            "Destructive"
          ],
          "type": "string"
        },
        "showPrefix": {
          "default": false,
          "type": "boolean"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "showSuffix": {
          "default": false,
          "type": "boolean"
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "underline": {
          "default": "Never",
          "enum": [
            "Never",
            "On hover",
            "Always"
          ],
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Medium",
          "enum": [
            "Tiny",
            "Small",
            "Medium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "Regular",
          "enum": [
            "Regular",
            "Medium"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.DashboardToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Set a reminder",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": true,
          "type": "boolean"
        },
        "skin": {
          "default": "Standard",
          "enum": [
            "Standard",
            "Success",
            "Destructive"
          ],
          "type": "string"
        },
        "showTooltip": {
          "default": false,
          "type": "boolean"
        },
        "tooltip": {
          "default": "This message explains the purpose of a field.",
          "maxLength": 1200,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "size": {
          "default": "Large",
          "enum": [
            "Small",
            "Medium",
            "Large"
          ],
          "type": "string"
        },
        "labelPosition": {
          "default": "Right",
          "enum": [
            "Top",
            "Left",
            "Right"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.SettingsPanelContainer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "theme": {
          "default": "classic",
          "enum": [
            "classic",
            "responsive"
          ],
          "type": "string"
        },
        "debug": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuAccordion": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Label Example",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "openByDefault": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuBackButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Back",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "label": {
          "default": "Button",
          "maxLength": 120,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "standard secondary",
            "premium",
            "premium secondary",
            "alert",
            "alert secondary",
            "inverted"
          ],
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "small",
            "medium",
            "large"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "fullWidth": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuCheckboxGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Multiple Choices",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColorPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Opacity & Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "opacity": {
          "default": 100,
          "minimum": 0,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "showPercentage": {
          "default": true,
          "type": "boolean"
        },
        "opacitySliderEnabled": {
          "default": true,
          "type": "boolean"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColorSelector": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Color Selector",
          "maxLength": 120,
          "type": "string"
        },
        "color": {
          "default": "#EEE",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuColumnControllerControl": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Column controller",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "enableReorder": {
          "default": true,
          "type": "boolean"
        },
        "minimumValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "dividerType": {
          "default": "none",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        },
        "columns": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "dsgnsys.WbuDatePicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose a Date",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuDrillDown": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Label Title",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "This is a description text",
          "maxLength": 1200,
          "type": "string"
        },
        "iconType": {
          "default": "None",
          "enum": [
            "None",
            "Info",
            "Alert"
          ],
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuDropdown": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Dropdown",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Choose an option",
          "maxLength": 120,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuEmptyState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Link to Lightbox",
          "maxLength": 120,
          "type": "string"
        },
        "description": {
          "default": "Create your own lightboxes and link to them for any place in your site.",
          "maxLength": 1200,
          "type": "string"
        },
        "textButtonLabel": {
          "default": "Start Creating",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        }
      }
    },
    "dsgnsys.WbuFontAndColorPicker": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Pick Font and Color",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "font": {
          "default": "arial",
          "maxLength": 1200,
          "format": "font-family",
          "type": "string"
        },
        "color": {
          "default": "#FFC233",
          "maxLength": 120000,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuHorizontalTabs": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "tabsStyle": {
          "default": "Folder",
          "enum": [
            "Folder",
            "Arrowed",
            "Arrowed Without a Line"
          ],
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "maxVisibleTabs": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        },
        "tabsToScroll": {
          "default": 3,
          "minimum": 1,
          "maximum": 10,
          "type": "number",
          "multipleOf": 1
        }
      }
    },
    "dsgnsys.WbuLeftTextButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "Text Button",
          "maxLength": 120,
          "type": "string"
        },
        "url": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "size": {
          "default": "medium",
          "enum": [
            "tiny",
            "small",
            "medium"
          ],
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium"
          ],
          "type": "string"
        },
        "weight": {
          "default": "normal",
          "enum": [
            "thin",
            "normal"
          ],
          "type": "string"
        },
        "prefixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "suffixIcon": {
          "type": [
            "null",
            "string"
          ]
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuMultilineTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltip": {
          "default": "",
          "maxLength": 120000,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "placeholder": {
          "default": "Write text here...",
          "maxLength": 1200,
          "type": "string"
        },
        "maxLength": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "closeOnEnterKeyPress": {
          "default": false,
          "type": "boolean"
        },
        "autoFocus": {
          "default": false,
          "type": "boolean"
        },
        "selectTextOnFocus": {
          "default": false,
          "type": "boolean"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "validationMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuNotificationBanner": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "skin": {
          "default": "standard",
          "enum": [
            "standard",
            "premium",
            "alert",
            "success"
          ],
          "type": "string"
        },
        "linkText": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "linkUrl": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "iconTooltipText": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "multiline": {
          "default": false,
          "type": "boolean"
        }
      }
    },
    "dsgnsys.WbuNumericInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "title": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": 0,
          "type": "number"
        },
        "unitSuffix": {
          "default": "None",
          "enum": [
            "None",
            "Pixels",
            "Percentage",
            "Degrees"
          ],
          "type": "string"
        },
        "numberOfFractions": {
          "default": 2,
          "minimum": 0,
          "maximum": 2,
          "type": "number",
          "multipleOf": 1
        },
        "steps": {
          "default": 1,
          "minimum": 1,
          "maximum": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepControls": {
          "default": false,
          "type": "boolean"
        },
        "minValue": {
          "default": 0,
          "type": "number"
        },
        "maxValue": {
          "default": 100,
          "type": "number"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuRadioButtonGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Radio Buttons",
          "maxLength": 120,
          "type": "string"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuRichText": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "richTextContent": {
          "default": "Your placeholder text goes here. Write, style and link it.",
          "maxLength": 120000,
          "type": "string"
        },
        "richTextLabel": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "link": {
          "pattern": "^$|^#",
          "type": [
            "null",
            "string"
          ]
        },
        "richTextLink": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "alignTextToCenter": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuSectionDivider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "sectionTitle": {
          "default": "Section Divider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuSlider": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Slider",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "unitOfMeasurement": {
          "default": "number",
          "enum": [
            "number",
            "percentage",
            "pixels",
            "angle"
          ],
          "type": "string"
        },
        "defaultSelectedValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "minimumValue": {
          "default": 0,
          "type": "number",
          "multipleOf": 1
        },
        "maximumValue": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "stepValue": {
          "default": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showNumericInput": {
          "default": true,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuTextInput": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Text Input",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "defaultText": {
          "default": "Write it here...",
          "maxLength": 120,
          "type": "string"
        },
        "placeholder": {
          "default": "Placeholder text",
          "maxLength": 120,
          "type": "string"
        },
        "prefix": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "readOnly": {
          "default": false,
          "type": "boolean"
        },
        "autofocus": {
          "default": false,
          "type": "boolean"
        },
        "selectedOnFocus": {
          "default": true,
          "type": "boolean"
        },
        "charactersLimit": {
          "default": 100,
          "type": "number",
          "multipleOf": 1
        },
        "usePatternValidation": {
          "default": false,
          "type": "boolean"
        },
        "regexPattern": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "errorMessage": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WbuThumbnails": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "fieldTitle": {
          "default": "Field Title",
          "maxLength": 120,
          "type": "string"
        },
        "tooltipInfo": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        },
        "setNumberOfColumns": {
          "default": 3,
          "minimum": 1,
          "maximum": 5,
          "type": "number",
          "multipleOf": 1
        },
        "showEmptyThumbnail": {
          "default": false,
          "type": "boolean"
        },
        "thumbnailHeight": {
          "default": "Fixed ratio (1:1)",
          "enum": [
            "Fixed ratio (1:1)",
            "Fluid"
          ],
          "type": "string"
        },
        "displayLabels": {
          "default": true,
          "type": "boolean"
        },
        "options": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      },
      "required": [
        "options"
      ]
    },
    "ThumbnailItemData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "maxLength": 120,
          "type": "string"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "isDefault": {
          "default": false,
          "type": "boolean"
        },
        "unavailable": {
          "default": false,
          "type": "boolean"
        },
        "illustration": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "label",
        "value"
      ]
    },
    "dsgnsys.WbuToggleSwitch": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "label": {
          "default": "Toggle Switch",
          "maxLength": 120,
          "type": "string"
        },
        "toggleSwitch": {
          "default": true,
          "type": "boolean"
        },
        "disabled": {
          "default": false,
          "type": "boolean"
        },
        "divider": {
          "default": "long",
          "enum": [
            "long",
            "short",
            "none"
          ],
          "type": "string"
        }
      }
    },
    "dsgnsys.WutAvatar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "firstName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "lastName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "src": {
          "default": "",
          "maxLength": 1200,
          "type": "string"
        }
      }
    },
    "dsgnsys.WutAvatarGroup": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "maxAvatars": {
          "default": 5,
          "minimum": 1,
          "type": "number",
          "multipleOf": 1
        },
        "showHiddenAvatarCount": {
          "default": true,
          "type": "boolean"
        },
        "avatars": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "dsgnsys.WutBadge": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "text": {
          "default": "My Badge",
          "maxLength": 120,
          "type": "string"
        },
        "icon": {
          "type": [
            "null",
            "string"
          ]
        },
        "composition": {
          "default": "TextAndIcon",
          "enum": [
            "TextAndIcon",
            "Text",
            "Icon",
            "None"
          ],
          "type": "string"
        },
        "alt": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        }
      }
    },
    "dsgnsys.WutRadioButton": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "radioGroupName": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "value": {
          "default": "",
          "maxLength": 120,
          "type": "string"
        },
        "checked": {
          "default": false,
          "type": "boolean"
        },
        "required": {
          "default": false,
          "type": "boolean"
        }
      },
      "required": [
        "value"
      ]
    }
  },
  "naming.json": {
    "$id": "urn:dm:schemas:naming.json",
    "naming": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        }
      },
      "required": [
        "name"
      ]
    }
  },
  "notifications.json": {
    "$id": "urn:dm:schemas:notifications.json",
    "Notifications": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "fixedPages": {
                    "type": "array",
                    "items": {
                      "type": "string",
                      "maxLength": 50
                    }
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "SectionsFixer"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "required": [],
                "properties": {
                  "sticky": {
                    "type": "number",
                    "multipleOf": 1,
                    "minimum": 0,
                    "default": 0
                  },
                  "pinned": {
                    "type": "number",
                    "minimum": 0,
                    "default": 0
                  },
                  "masterVertical": {
                    "type": "number",
                    "minimum": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "PinToSticky"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        }
      }
    },
    "SectionsFixer": {
      "type": "object",
      "properties": {
        "fixedPages": {
          "type": "array",
          "items": {
            "type": "string",
            "maxLength": 50
          }
        },
        "type": {
          "type": "string",
          "enum": [
            "SectionsFixer"
          ]
        }
      },
      "additionalProperties": false
    },
    "PinToSticky": {
      "type": "object",
      "required": [],
      "properties": {
        "sticky": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "pinned": {
          "type": "number",
          "minimum": 0,
          "default": 0
        },
        "masterVertical": {
          "type": "number",
          "minimum": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "PinToSticky"
          ]
        }
      },
      "additionalProperties": false
    }
  },
  "pageSections.json": {
    "$id": "urn:dm:schemas:pageSections.json",
    "pageSections": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "isSectionsEnabled": {
          "type": "boolean"
        },
        "isMigratedFromAdi": {
          "type": "boolean",
          "default": false
        },
        "preserveEditorFontsOrder": {
          "type": "boolean",
          "default": false
        },
        "migrationVersion": {
          "type": "string",
          "maxLength": 20
        },
        "migrationSkipCount": {
          "type": "number"
        },
        "sections": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "name": {
                "type": "string"
              },
              "contentRole": {
                "type": "string"
              },
              "children": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              }
            },
            "additionalProperties": false
          }
        }
      }
    }
  },
  "patterns.json": {
    "$id": "urn:dm:schemas:patterns.json",
    "Pattern": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "items": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "items"
      ]
    },
    "NthChild": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "repeat": {
          "type": "number",
          "multipleOf": 1,
          "minimum": 0,
          "default": 0
        },
        "offset": {
          "type": "number",
          "multipleOf": 1
        },
        "variant": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "offset",
        "variant"
      ]
    }
  },
  "presets.json": {
    "$id": "urn:dm:schemas:presets.json",
    "PresetData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "layout": {
          "type": "string",
          "maxLength": 100
        },
        "style": {
          "type": "string",
          "maxLength": 100
        }
      },
      "required": [
        "layout",
        "style"
      ]
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "reactions.json": {
    "$id": "urn:dm:schemas:reactions.json",
    "Reactions": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "default": [],
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "values"
      ]
    },
    "BaseStateReaction": {
      "type": "object",
      "required": [
        "state"
      ],
      "properties": {
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "type": [
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "ToggleState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "state"
      ]
    },
    "RemoveState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "state"
      ]
    },
    "AddState": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "presetKey": {
          "type": "string",
          "maxLength": 100
        },
        "state": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "state"
      ]
    },
    "RemoveAllStates": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ScrollForward": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "ScrollBackward": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        }
      }
    },
    "Play": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "effect": {
          "type": [
            "string"
          ]
        },
        "once": {
          "type": "boolean"
        }
      },
      "required": [
        "effect"
      ]
    },
    "TogglePlay": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "effect": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "effect"
      ]
    },
    "Scrub": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "effect": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "effect"
      ]
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "slots.json": {
    "$id": "urn:dm:schemas:slots.json",
    "PlaceholderSlot": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "slots": {
          "type": "object",
          "properties": {
            "slot": {
              "type": [
                "string"
              ]
            }
          },
          "additionalProperties": false
        }
      }
    },
    "DynamicSlots": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "slots": {
          "type": "object",
          "additionalProperties": {
            "type": [
              "string"
            ]
          },
          "properties": {}
        }
      }
    },
    "SlotRef": {
      "type": [
        "string"
      ]
    }
  },
  "source.json": {
    "$id": "urn:dm:schemas:source.json",
    "Source": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "original": {
          "type": "string",
          "enum": [
            "template",
            "preset",
            "user",
            "application",
            "translation",
            "caas",
            "ai"
          ]
        },
        "current": {
          "type": "string",
          "enum": [
            "template",
            "preset",
            "user",
            "application",
            "translation",
            "caas",
            "ai"
          ]
        },
        "changed": {
          "type": "boolean",
          "default": false
        },
        "ai_semantics": {
          "type": "string",
          "maxLength": 4000,
          "description": "experimental field to add context for AI. This field is only for use within a POC for AI and may be removed. It should not be relied on in production"
        }
      }
    },
    "SourceEnumType": {
      "type": "string",
      "enum": [
        "template",
        "preset",
        "user",
        "application",
        "translation",
        "caas",
        "ai"
      ]
    }
  },
  "states.json": {
    "$id": "urn:dm:schemas:states.json",
    "States": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        }
      },
      "required": [
        "values"
      ]
    }
  },
  "structure.json": {
    "$id": "urn:dm:schemas:structure.json",
    "DesignQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PropertyQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StyleId": {
      "type": [
        "null",
        "string"
      ]
    },
    "MobileHintsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BehaviorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ConnectionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "AnchorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "BreakpointVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransformationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TransitionQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ModesDefinition": {
      "type": "object",
      "properties": {
        "definitions": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeId",
              "type"
            ],
            "properties": {
              "label": {
                "type": "string"
              },
              "modeId": {
                "type": "string"
              },
              "params": {
                "type": "string"
              },
              "settings": {
                "type": "object",
                "properties": {
                  "pagesGroupId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              "type": {
                "type": "string",
                "enum": [
                  "HOVER",
                  "DEFAULT",
                  "SHOW_ON_SOME_PAGES",
                  "POPOVER"
                ]
              }
            },
            "additionalProperties": false
          }
        },
        "isHiddenByModes": {
          "type": "boolean"
        },
        "overrides": {
          "type": "array",
          "items": {
            "type": "object",
            "required": [
              "modeIds"
            ],
            "properties": {
              "isHiddenByModes": {
                "type": "boolean"
              },
              "modeIds": {
                "type": "array",
                "items": {
                  "type": "string"
                }
              },
              "layout": {
                "type": "object",
                "properties": {
                  "x": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "y": {
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "minimum": -2147483648,
                    "maximum": 2147483647
                  },
                  "width": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "height": {
                    "minimum": 0,
                    "type": "number",
                    "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                    "default": 0,
                    "maximum": 2147483647
                  },
                  "rotationInDegrees": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 360
                  },
                  "fixedPosition": {
                    "type": "boolean"
                  },
                  "scale": {
                    "type": "number"
                  },
                  "docked": {
                    "type": "object",
                    "properties": {
                      "left": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "right": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "top": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "bottom": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "hCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      },
                      "vCenter": {
                        "type": "object",
                        "properties": {
                          "px": {
                            "type": "number"
                          },
                          "pct": {
                            "type": "number"
                          },
                          "vw": {
                            "type": "number"
                          },
                          "vh": {
                            "type": "number"
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "anchors": {
                    "type": [
                      "null",
                      "array"
                    ],
                    "items": {
                      "type": "object",
                      "properties": {
                        "distance": {
                          "type": "number",
                          "default": 0
                        },
                        "type": {
                          "type": "string",
                          "enum": [
                            "TOP_TOP",
                            "BOTTOM_TOP",
                            "BOTTOM_PARENT",
                            "BOTTOM_BOTTOM",
                            "LOCK_BOTTOM"
                          ]
                        },
                        "locked": {
                          "type": "boolean",
                          "default": false
                        },
                        "targetComponent": {
                          "type": "string"
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              },
              "designQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "propertyQuery": {
                "type": [
                  "null",
                  "string"
                ]
              },
              "styleId": {
                "type": [
                  "null",
                  "string"
                ]
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "AnchorDefinition": {
      "type": "object",
      "properties": {
        "distance": {
          "type": "number",
          "default": 0
        },
        "type": {
          "type": "string",
          "enum": [
            "TOP_TOP",
            "BOTTOM_TOP",
            "BOTTOM_PARENT",
            "BOTTOM_BOTTOM",
            "LOCK_BOTTOM"
          ]
        },
        "locked": {
          "type": "boolean",
          "default": false
        },
        "targetComponent": {
          "type": "string"
        }
      },
      "additionalProperties": false
    },
    "PartialLayoutObjectForMasterPage": {
      "type": "object",
      "properties": {
        "y": {
          "enum": [
            0
          ]
        },
        "rotationInDegrees": {
          "enum": [
            0
          ]
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "DockingUnitSize": {
      "type": "object",
      "properties": {
        "px": {
          "type": "number"
        },
        "pct": {
          "type": "number"
        },
        "vw": {
          "type": "number"
        },
        "vh": {
          "type": "number"
        }
      },
      "additionalProperties": false
    },
    "DockingDefinition": {
      "type": "object",
      "properties": {
        "left": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "right": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "top": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "bottom": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "hCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "vCenter": {
          "type": "object",
          "properties": {
            "px": {
              "type": "number"
            },
            "pct": {
              "type": "number"
            },
            "vw": {
              "type": "number"
            },
            "vh": {
              "type": "number"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "BaseComponentObject": {
      "type": "object",
      "required": [
        "id",
        "type"
      ],
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "MetaDataForComponents": {
      "type": "object",
      "properties": {},
      "additionalProperties": false
    },
    "LayoutObjectForComponents": {
      "type": "object",
      "properties": {
        "x": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "y": {
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "width": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "height": {
          "minimum": 0,
          "type": "number",
          "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
          "default": 0,
          "maximum": 2147483647
        },
        "rotationInDegrees": {
          "type": "number",
          "minimum": 0,
          "maximum": 360
        },
        "fixedPosition": {
          "type": "boolean"
        },
        "scale": {
          "type": "number"
        },
        "docked": {
          "type": "object",
          "properties": {
            "left": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "right": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "top": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "bottom": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "hCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            "vCenter": {
              "type": "object",
              "properties": {
                "px": {
                  "type": "number"
                },
                "pct": {
                  "type": "number"
                },
                "vw": {
                  "type": "number"
                },
                "vh": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "anchors": {
          "type": [
            "null",
            "array"
          ],
          "items": {
            "type": "object",
            "properties": {
              "distance": {
                "type": "number",
                "default": 0
              },
              "type": {
                "type": "string",
                "enum": [
                  "TOP_TOP",
                  "BOTTOM_TOP",
                  "BOTTOM_PARENT",
                  "BOTTOM_BOTTOM",
                  "LOCK_BOTTOM"
                ]
              },
              "locked": {
                "type": "boolean",
                "default": false
              },
              "targetComponent": {
                "type": "string"
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "ShouldReallyBeAnIntAtSomePoint": {
      "type": "number",
      "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
      "default": 0,
      "minimum": -2147483648,
      "maximum": 2147483647
    },
    "ComponentsList": {
      "uniqueItems": true,
      "type": [
        "array",
        "null"
      ],
      "items": [
        {
          "type": [
            "null",
            "string"
          ]
        }
      ]
    },
    "Component": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "ComponentQueries": {
      "type": "object",
      "properties": {
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "RefComponent": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType"
      ]
    },
    "RepeaterContainer": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "RepeaterVariantsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "RepeaterQueries": {
      "type": "object",
      "properties": {
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "patternsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Container": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "PageQueries": {
      "type": "object",
      "properties": {
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Page": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "y": {
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "minimum": -2147483648,
              "maximum": 2147483647
            },
            "width": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "height": {
              "minimum": 0,
              "type": "number",
              "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
              "default": 0,
              "maximum": 2147483647
            },
            "rotationInDegrees": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "fixedPosition": {
              "type": "boolean"
            },
            "scale": {
              "type": "number"
            },
            "docked": {
              "type": "object",
              "properties": {
                "left": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "right": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "top": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "bottom": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "hCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                },
                "vCenter": {
                  "type": "object",
                  "properties": {
                    "px": {
                      "type": "number"
                    },
                    "pct": {
                      "type": "number"
                    },
                    "vw": {
                      "type": "number"
                    },
                    "vh": {
                      "type": "number"
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components"
      ]
    },
    "DocumentProperties": {
      "type": "object",
      "required": [
        "documentType",
        "components"
      ],
      "properties": {
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "additionalProperties": false
    },
    "Document": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "sig": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "id": {
          "type": "string"
        },
        "type": {
          "type": "string"
        },
        "parent": {
          "type": [
            "null",
            "string"
          ]
        },
        "dataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "propertyQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "designQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "mobileHintsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "behaviorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "connectionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "anchorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "breakpointVariantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transformationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "transitionQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variantsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "styleId": {
          "type": [
            "null",
            "string"
          ]
        },
        "layout": {
          "type": "object",
          "properties": {
            "y": {
              "enum": [
                0
              ]
            },
            "rotationInDegrees": {
              "enum": [
                0
              ]
            },
            "anchors": {
              "type": [
                "null",
                "array"
              ],
              "items": {
                "type": "object",
                "properties": {
                  "distance": {
                    "type": "number",
                    "default": 0
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "TOP_TOP",
                      "BOTTOM_TOP",
                      "BOTTOM_PARENT",
                      "BOTTOM_BOTTOM",
                      "LOCK_BOTTOM"
                    ]
                  },
                  "locked": {
                    "type": "boolean",
                    "default": false
                  },
                  "targetComponent": {
                    "type": "string"
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "classnamesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "contentRoleQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "controllersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "cursorQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "discussionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "editorsettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "effectsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "groupingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "innerElementsMetaDataQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "intentQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "layoutSettingsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "manifestQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "measurementsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "migrationQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "namingQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "notificationsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "pageSectionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "presetsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "reactionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "slotsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "sourceQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "statesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "triggersQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "variablesQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "componentType": {
          "type": "string"
        },
        "skin": {
          "type": "string"
        },
        "modes": {
          "type": "object",
          "properties": {
            "definitions": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeId",
                  "type"
                ],
                "properties": {
                  "label": {
                    "type": "string"
                  },
                  "modeId": {
                    "type": "string"
                  },
                  "params": {
                    "type": "string"
                  },
                  "settings": {
                    "type": "object",
                    "properties": {
                      "pagesGroupId": {
                        "type": [
                          "null",
                          "string"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "type": {
                    "type": "string",
                    "enum": [
                      "HOVER",
                      "DEFAULT",
                      "SHOW_ON_SOME_PAGES",
                      "POPOVER"
                    ]
                  }
                },
                "additionalProperties": false
              }
            },
            "isHiddenByModes": {
              "type": "boolean"
            },
            "overrides": {
              "type": "array",
              "items": {
                "type": "object",
                "required": [
                  "modeIds"
                ],
                "properties": {
                  "isHiddenByModes": {
                    "type": "boolean"
                  },
                  "modeIds": {
                    "type": "array",
                    "items": {
                      "type": "string"
                    }
                  },
                  "layout": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "y": {
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "minimum": -2147483648,
                        "maximum": 2147483647
                      },
                      "width": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "height": {
                        "minimum": 0,
                        "type": "number",
                        "description": "If this value is used, then an int is returned from server even though we saved a double. We should align our 'rounding' logic to the server and only enable ints ",
                        "default": 0,
                        "maximum": 2147483647
                      },
                      "rotationInDegrees": {
                        "type": "number",
                        "minimum": 0,
                        "maximum": 360
                      },
                      "fixedPosition": {
                        "type": "boolean"
                      },
                      "scale": {
                        "type": "number"
                      },
                      "docked": {
                        "type": "object",
                        "properties": {
                          "left": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "right": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "top": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "bottom": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "hCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          },
                          "vCenter": {
                            "type": "object",
                            "properties": {
                              "px": {
                                "type": "number"
                              },
                              "pct": {
                                "type": "number"
                              },
                              "vw": {
                                "type": "number"
                              },
                              "vh": {
                                "type": "number"
                              }
                            },
                            "additionalProperties": false
                          }
                        },
                        "additionalProperties": false
                      },
                      "anchors": {
                        "type": [
                          "null",
                          "array"
                        ],
                        "items": {
                          "type": "object",
                          "properties": {
                            "distance": {
                              "type": "number",
                              "default": 0
                            },
                            "type": {
                              "type": "string",
                              "enum": [
                                "TOP_TOP",
                                "BOTTOM_TOP",
                                "BOTTOM_PARENT",
                                "BOTTOM_BOTTOM",
                                "LOCK_BOTTOM"
                              ]
                            },
                            "locked": {
                              "type": "boolean",
                              "default": false
                            },
                            "targetComponent": {
                              "type": "string"
                            }
                          },
                          "additionalProperties": false
                        }
                      }
                    },
                    "additionalProperties": false
                  },
                  "designQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "propertyQuery": {
                    "type": [
                      "null",
                      "string"
                    ]
                  },
                  "styleId": {
                    "type": [
                      "null",
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        },
        "components": {
          "uniqueItems": true,
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "documentType": {
          "enum": [
            "document"
          ]
        },
        "componentProperties": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "themeData": {
          "type": "object",
          "properties": {},
          "additionalProperties": false
        },
        "fixerVersionsQuery": {
          "type": [
            "null",
            "string"
          ]
        },
        "themeConfigQuery": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "type",
        "componentType",
        "components",
        "documentType"
      ]
    },
    "Parent": {
      "type": [
        "null",
        "string"
      ]
    },
    "ClassnamesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ContentRoleQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ControllersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "CursorQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "DiscussionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EditorsettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "EffectsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "FixerVersionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "GroupingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "InnerElementsMetaDataQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "IntentQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "LayoutSettingsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ManifestQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MeasurementsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "MigrationQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NamingQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "NotificationsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PageSectionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PatternsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "PresetsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ReactionsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SlotsQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "SourceQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "StatesQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "ThemeConfigQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "TriggersQuery": {
      "type": [
        "null",
        "string"
      ]
    },
    "VariablesQuery": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "themeConfig.json": {
    "$id": "urn:dm:schemas:themeConfig.json",
    "themeConfig": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "colorMapping": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "string",
              "pattern": "^$|^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$|__empty__"
            }
          }
        },
        "colorNaming": {
          "patternProperties": {
            "^color_([0-9]|(?:1|2|3|4|5)[0-9]|6[0-5])$": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "order": {
                  "type": "number",
                  "default": 0
                },
                "hidden": {
                  "type": "boolean"
                }
              }
            }
          }
        },
        "fontNaming": {
          "patternProperties": {
            "^font_([0-9]|10)$": {
              "type": "object",
              "properties": {
                "name": {
                  "type": "string",
                  "maxLength": 100
                },
                "order": {
                  "type": "number",
                  "default": 0
                },
                "hidden": {
                  "type": "boolean"
                }
              }
            }
          }
        }
      }
    }
  },
  "theme_data.json": {
    "$id": "urn:dm:schemas:theme_data.json",
    "WFlatTheme": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BG_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "CONTACT_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "NETWORKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "EXTERNAL_LINKS_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "PAGES_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "WEB_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "BASE_THEME_DIRECTORY": {
          "default": "base",
          "type": "string",
          "pattern": "^[\\/\\-|0-9|a-z|A-Z]*$"
        },
        "siteBg": {
          "type": "string",
          "default": "none 0 0 center center auto repeat no-repeat fixed {color_2}"
        },
        "color": {
          "type": "array",
          "items": {
            "type": [
              "string",
              "null"
            ],
            "pattern": "^(^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$)$"
          },
          "default": [
            "#000000",
            "#000000",
            "#FFFFFF",
            "#FF0000",
            "#00FF00",
            "#0000FF",
            "#333333",
            "#666666",
            "#999999",
            "#AAAAAA",
            "#DCDCDC",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF",
            "#FFFFFF"
          ]
        },
        "font": {
          "type": "array",
          "items": {
            "type": [
              "string",
              "null"
            ]
          },
          "default": [
            "normal normal normal 24px/1.2em Arial {color_5}",
            "normal normal bold 16px/1.1em Arial {color_5}",
            "italic normal bold 18px/1.1em Lobster {color_5}",
            "normal normal bold 22px/1.1em Arial {color_5}",
            "normal normal bold 20px/1.1em Arial {color_5}",
            "normal normal normal 18px/1.3em Arial {color_5}",
            "normal normal normal 16px/1.2em Arial {color_6}",
            "normal normal normal 14px/1.3em Arial {color_6}",
            "normal normal normal 12px/1.3em Arial {color_6}",
            "normal normal normal 10px/1.3em Arial {color_6}",
            "normal normal normal 8px/1.3em Arial {color_6}"
          ]
        },
        "textTheme": {
          "type": "array",
          "items": {
            "type": [
              "object"
            ],
            "additionalProperties": false,
            "properties": {
              "fontStyle": {
                "default": "normal",
                "type": "string",
                "enum": [
                  "normal",
                  "italic"
                ]
              },
              "fontWeight": {
                "default": "normal",
                "type": "string",
                "enum": [
                  "normal",
                  "bold",
                  "bolder",
                  "lighter",
                  "100",
                  "200",
                  "300",
                  "400",
                  "500",
                  "600",
                  "700",
                  "800",
                  "900"
                ]
              },
              "fontVariant": {
                "default": "normal",
                "type": "string",
                "enum": [
                  "normal",
                  "small-caps",
                  "inherit"
                ]
              },
              "fontSize": {
                "default": "60px",
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "minFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "maxFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "scale_maxFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "scale_minFontSize": {
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "fontFamily": {
                "default": "proxima-n-w01-reg",
                "type": "string",
                "format": "font-family"
              },
              "color": {
                "default": "{color_15}",
                "type": "string",
                "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
              },
              "lineHeight": {
                "default": "normal",
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              },
              "letterSpacing": {
                "default": "normal",
                "type": "string",
                "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
              }
            },
            "required": [
              "fontStyle",
              "fontWeight",
              "fontVariant",
              "fontSize",
              "lineHeight",
              "fontFamily"
            ]
          },
          "default": [
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "24px",
              "fontFamily": "Arial",
              "lineHeight": "1.2em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "16px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "italic",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "18px",
              "fontFamily": "Lobster",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "22px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "bold",
              "fontSize": "20px",
              "fontFamily": "Arial",
              "lineHeight": "1.1em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "18px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_5}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "16px",
              "fontFamily": "Arial",
              "lineHeight": "1.2em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "14px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "12px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "10px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            },
            {
              "fontStyle": "normal",
              "fontVariant": "normal",
              "fontWeight": "normal",
              "fontSize": "8px",
              "fontFamily": "Arial",
              "lineHeight": "1.3em",
              "color": "{color_6}",
              "letterSpacing": "0em"
            }
          ]
        },
        "theme": {
          "type": "object",
          "properties": {
            "spx": {
              "type": "object",
              "required": [
                "refWidth",
                "resolverType"
              ],
              "properties": {
                "refWidth": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 1
                },
                "resolverType": {
                  "type": "string",
                  "enum": [
                    "scale",
                    "fixed"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "fontDisplay": {
          "type": "string",
          "enum": [
            "auto",
            "block",
            "swap",
            "fallback",
            "optional"
          ],
          "description": "font-display css property. The default is 'block' in the viewer rendering"
        },
        "border": {
          "type": "array",
          "items": {
            "type": [
              "string",
              "null"
            ],
            "pattern": "^$|^(0|([0-9]*([.][0-9]+){0,1}(px|em)[\\s]*){1,4})([Ss][Oo][Ll][Ii][Dd]|[Dd][Aa][Ss][Hh][Ee][Dd]|[Dd][Oo][Tt][Tt][Ee][Dd]|[Dd][Oo][Uu][Bb][Ll][Ee]|[Gg][Rr][Oo][Oo][Vv][Ee]|[Ii][Nn][Ss][Ee][Tt]|[Nn][Oo][Nn][Ee]|[Oo][Uu][Tt][Ss][Ee][Tt]|[Rr][Ii][Dd][Gg][Ee]){0,1}[\\s]*([{\\[]color_([0-9]{1,2}|100)[}\\]]|(#(([0-9|a-f]){3}){1,2}){0,1})|\\[borderColor\\]?$"
          },
          "default": [
            "0.15em solid [color_0]",
            "0.15em solid [color_0]",
            "0.15em solid [color_0]"
          ]
        },
        "padding1": {
          "default": "0 0 0 0",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding2": {
          "default": "0.0em 0.5em 0.0em 0.5em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "padding3": {
          "default": "1.0em 0.0em 1.0em 0.0em",
          "type": "string",
          "pattern": "^$|^\\d*(.\\d+)?$|^(\\d+(.\\d+)?(em|px)|0(.0+)?)( +(\\d+(.\\d+)?(em|px)|0(.0+)?)){0,3}$"
        },
        "iconSize": {
          "default": "3.2",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "bulletSize": {
          "default": "1.5",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "headerSpacing": {
          "default": "0em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "componentSpacing": {
          "default": "0.45em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "itemSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "thumbSpacing": {
          "default": "0.23em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "iconSpacing": {
          "default": "0.75em",
          "type": "string",
          "pattern": "^\\d+(.\\d+)?(em|px)?$"
        },
        "mobileBg": {
          "type": "string",
          "default": "[siteBg]"
        },
        "themePresets": {
          "type": [
            "object",
            "null"
          ]
        }
      }
    },
    "OverridableTheme": {
      "type": "object",
      "properties": {
        "spx": {
          "type": "object",
          "required": [
            "refWidth",
            "resolverType"
          ],
          "properties": {
            "refWidth": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 1
            },
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "TextTheme": {
      "type": [
        "object"
      ],
      "additionalProperties": false,
      "properties": {
        "fontStyle": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "default": "60px",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": {
          "default": "proxima-n-w01-reg",
          "type": "string",
          "format": "font-family"
        },
        "color": {
          "default": "{color_15}",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "default": "normal",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "default": "normal",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      },
      "required": [
        "fontStyle",
        "fontWeight",
        "fontVariant",
        "fontSize",
        "lineHeight",
        "fontFamily"
      ]
    },
    "FontStyle": {
      "type": "string",
      "enum": [
        "normal",
        "italic"
      ]
    },
    "FontSize": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "FontWeight": {
      "type": "string",
      "enum": [
        "normal",
        "bold",
        "bolder",
        "lighter",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900"
      ]
    },
    "FontVariant": {
      "type": "string",
      "enum": [
        "normal",
        "small-caps",
        "inherit"
      ]
    },
    "FontFamily": {
      "type": "string",
      "format": "font-family"
    },
    "TextColor": {
      "type": "string",
      "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
    },
    "LineHeight": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "LetterSpacing": {
      "type": "string",
      "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
    },
    "PartialTextTheme": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "fontStyle": {
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": {
          "type": "string",
          "format": "font-family"
        },
        "color": {
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      }
    },
    "TextThemeWithDefaults": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "fontStyle": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "italic"
          ]
        },
        "fontWeight": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter",
            "100",
            "200",
            "300",
            "400",
            "500",
            "600",
            "700",
            "800",
            "900"
          ]
        },
        "fontVariant": {
          "default": "normal",
          "type": "string",
          "enum": [
            "normal",
            "small-caps",
            "inherit"
          ]
        },
        "fontSize": {
          "default": "60px",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_maxFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "scale_minFontSize": {
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "fontFamily": {
          "default": "proxima-n-w01-reg",
          "type": "string",
          "format": "font-family"
        },
        "color": {
          "default": "{color_15}",
          "type": "string",
          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
        },
        "lineHeight": {
          "default": "normal",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        },
        "letterSpacing": {
          "default": "normal",
          "type": "string",
          "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
        }
      }
    },
    "TopLevelStyle": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {}
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {}
            },
            "groups": {
              "type": "object"
            },
            "propertiesOverride": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": {
                    "type": "string",
                    "format": "font-family"
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                }
              },
              "properties": {}
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ],
          "description": "type of the style, defaults to custom",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        }
      }
    },
    "ComponentStyle": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {}
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {}
            },
            "groups": {
              "type": "object"
            },
            "propertiesOverride": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": {
                    "type": "string",
                    "format": "font-family"
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                }
              },
              "properties": {}
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "custom"
          ],
          "description": "style type for custom styles",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        },
        "spx": {
          "type": "object",
          "required": [
            "refWidth",
            "resolverType"
          ],
          "properties": {
            "refWidth": {
              "type": "number",
              "multipleOf": 1,
              "minimum": 1
            },
            "resolverType": {
              "type": "string",
              "enum": [
                "scale",
                "fixed"
              ]
            }
          },
          "additionalProperties": false
        },
        "themeOverrides": {
          "type": "object",
          "properties": {
            "spx": {
              "type": "object",
              "required": [
                "refWidth",
                "resolverType"
              ],
              "properties": {
                "refWidth": {
                  "type": "number",
                  "multipleOf": 1,
                  "minimum": 1
                },
                "resolverType": {
                  "type": "string",
                  "enum": [
                    "scale",
                    "fixed"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GlobalStylesCollection": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "styles": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      }
    },
    "StyleObjectDefinition": {
      "type": "object",
      "properties": {
        "skin": {
          "type": "string"
        },
        "style": {
          "type": "object",
          "properties": {
            "properties": {
              "type": "object",
              "default": {}
            },
            "background": {
              "type": "object",
              "properties": {
                "gradient": {
                  "type": [
                    "array",
                    "null"
                  ],
                  "items": [
                    {
                      "type": [
                        "null",
                        "string"
                      ]
                    }
                  ]
                }
              },
              "additionalProperties": false
            },
            "propertiesSource": {
              "type": "object",
              "additionalProperties": {
                "type": "string",
                "enum": [
                  "theme",
                  "value"
                ]
              },
              "default": {}
            },
            "groups": {
              "type": "object"
            },
            "propertiesOverride": {
              "type": "object",
              "additionalProperties": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "fontStyle": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "italic"
                    ]
                  },
                  "fontWeight": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "bold",
                      "bolder",
                      "lighter",
                      "100",
                      "200",
                      "300",
                      "400",
                      "500",
                      "600",
                      "700",
                      "800",
                      "900"
                    ]
                  },
                  "fontVariant": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "small-caps",
                      "inherit"
                    ]
                  },
                  "fontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_maxFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "scale_minFontSize": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "fontFamily": {
                    "type": "string",
                    "format": "font-family"
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "lineHeight": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  },
                  "letterSpacing": {
                    "type": "string",
                    "pattern": "^(-?\\d+(.\\d+)?(px|em|pt|ex|in|cm|mm|pc|spx))$|^normal$"
                  }
                }
              },
              "properties": {}
            }
          },
          "additionalProperties": false
        },
        "styleType": {
          "type": "string",
          "enum": [
            "system",
            "custom",
            "userDefined"
          ],
          "description": "type of the style, defaults to custom",
          "default": "custom"
        },
        "pageId": {
          "type": "string",
          "description": "for custom styles - id of the page where the component is"
        },
        "compId": {
          "type": "string",
          "description": "for custom styles - id of the component that has the custom style"
        },
        "componentClassName": {
          "type": "string",
          "description": "class name of the component type this style applies to"
        }
      },
      "additionalProperties": false
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    },
    "BreakpointRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "breakpoint": {
          "type": [
            "string"
          ]
        },
        "ref": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "breakpoint",
        "ref"
      ]
    },
    "GradientLinearLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientLinear"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientCircleLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientCircle"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "value",
                    "type"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                },
                {
                  "required": [],
                  "maxProperties": 0
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "vh",
                    "vw",
                    "vmin",
                    "vmax"
                  ]
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientEllipseLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientEllipse"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "size": {
              "type": "object",
              "oneOf": [
                {
                  "required": [
                    "width",
                    "height"
                  ]
                },
                {
                  "required": [
                    "keyword"
                  ]
                }
              ],
              "properties": {
                "keyword": {
                  "type": "string",
                  "enum": [
                    "closest-side",
                    "closest-corner",
                    "farthest-side",
                    "farthest-corner"
                  ]
                },
                "width": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "height": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "percentage",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientMeshLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientMesh"
              ]
            },
            "gradients": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": [
                      "GradientCircle"
                    ]
                  },
                  "repeat": {
                    "type": "boolean"
                  },
                  "blendMode": {
                    "type": "string",
                    "enum": [
                      "normal",
                      "multiply",
                      "screen",
                      "darken",
                      "lighten",
                      "overlay",
                      "colorDodge",
                      "colorBurn",
                      "hardLight",
                      "softLight",
                      "difference",
                      "exclusion",
                      "hue",
                      "saturation",
                      "color",
                      "luminosity"
                    ]
                  },
                  "size": {
                    "type": "object",
                    "oneOf": [
                      {
                        "required": [
                          "value",
                          "type"
                        ]
                      },
                      {
                        "required": [
                          "keyword"
                        ]
                      },
                      {
                        "required": [],
                        "maxProperties": 0
                      }
                    ],
                    "properties": {
                      "keyword": {
                        "type": "string",
                        "enum": [
                          "closest-side",
                          "closest-corner",
                          "farthest-side",
                          "farthest-corner"
                        ]
                      },
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "px",
                          "em",
                          "rem",
                          "vh",
                          "vw",
                          "vmin",
                          "vmax"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "position": {
                    "type": "object",
                    "properties": {
                      "x": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      },
                      "y": {
                        "type": "object",
                        "required": [
                          "value",
                          "type"
                        ],
                        "properties": {
                          "value": {
                            "type": "number"
                          },
                          "type": {
                            "enum": [
                              "px",
                              "em",
                              "rem",
                              "percentage",
                              "vh",
                              "vw",
                              "vmin",
                              "vmax"
                            ]
                          }
                        },
                        "additionalProperties": false
                      }
                    },
                    "additionalProperties": false
                  },
                  "colorStops": {
                    "type": "array",
                    "items": {
                      "type": "object",
                      "properties": {
                        "size": {
                          "type": "object",
                          "required": [
                            "value",
                            "type"
                          ],
                          "properties": {
                            "value": {
                              "type": "number"
                            },
                            "type": {
                              "enum": [
                                "px",
                                "em",
                                "rem",
                                "percentage",
                                "vh",
                                "vw",
                                "vmin",
                                "vmax"
                              ]
                            }
                          },
                          "additionalProperties": false
                        },
                        "color": {
                          "type": "string",
                          "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                        },
                        "opacity": {
                          "type": "number",
                          "minimum": 0,
                          "maximum": 1
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "GradientConicLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "GradientConic"
              ]
            },
            "repeat": {
              "type": "boolean"
            },
            "blendMode": {
              "type": "string",
              "enum": [
                "normal",
                "multiply",
                "screen",
                "darken",
                "lighten",
                "overlay",
                "colorDodge",
                "colorBurn",
                "hardLight",
                "softLight",
                "difference",
                "exclusion",
                "hue",
                "saturation",
                "color",
                "luminosity"
              ]
            },
            "angle": {
              "type": "number",
              "minimum": 0,
              "maximum": 360
            },
            "position": {
              "type": "object",
              "properties": {
                "x": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                "y": {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "percentage",
                        "vh",
                        "vw",
                        "vmin",
                        "vmax"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            },
            "colorStops": {
              "type": "array",
              "items": {
                "type": "object",
                "properties": {
                  "size": {
                    "type": "object",
                    "required": [
                      "value",
                      "type"
                    ],
                    "properties": {
                      "value": {
                        "type": "number"
                      },
                      "type": {
                        "enum": [
                          "deg",
                          "percentage"
                        ]
                      }
                    },
                    "additionalProperties": false
                  },
                  "color": {
                    "type": "string",
                    "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
                  },
                  "opacity": {
                    "type": "number",
                    "minimum": 0,
                    "maximum": 1
                  }
                },
                "additionalProperties": false
              }
            }
          },
          "additionalProperties": false
        }
      }
    },
    "SolidColorLayer": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "fill": {
          "type": "object",
          "properties": {
            "type": {
              "type": "string",
              "enum": [
                "SolidColor"
              ]
            },
            "color": {
              "type": "string",
              "pattern": "^$|^((((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5]),((0|1)?\\d{1,2}|2[0-4]\\d|25[0-5])(,0*(0?\\.\\d+|0|1))?)|(color_([0-9]{1,2}|100))|(\\{color_([0-9]{1,2}|100)\\})|(\\[color_([0-9]{1,2}|100)\\])|(#(([0-9|a-f|A-F]){3}){1,2}))$"
            }
          },
          "additionalProperties": false
        }
      }
    }
  },
  "transformations_data.json": {
    "$id": "urn:dm:schemas:transformations_data.json",
    "TransformData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:translate\\/x|translate\\/y|origin\\/x|origin\\/y)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "scale": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "rotate": {
          "type": "number"
        },
        "translate": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "skew": {
          "type": "object",
          "properties": {
            "x": {
              "type": "number"
            },
            "y": {
              "type": "number"
            }
          },
          "additionalProperties": false
        },
        "origin": {
          "type": "object",
          "properties": {
            "x": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            "y": {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            }
          },
          "additionalProperties": false
        },
        "opacity": {
          "type": "number",
          "minimum": 0,
          "maximum": 1
        },
        "hidden": {
          "type": "boolean"
        },
        "zLayer": {
          "type": "string",
          "enum": [
            "BELOW_PINNED",
            "ABOVE_PINNED",
            "ABOVE_ALL_COMPS"
          ]
        }
      }
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "transitions_data.json": {
    "$id": "urn:dm:schemas:transitions_data.json",
    "TransitionData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "timing-function": {
          "oneOf": [
            {
              "type": "string",
              "enum": [
                "ease",
                "linear",
                "ease-in",
                "ease-out",
                "ease-in-out"
              ]
            },
            {
              "type": "object",
              "required": [
                "type",
                "params"
              ],
              "properties": {
                "type": {
                  "type": "string",
                  "enum": [
                    "cubic-bezier"
                  ],
                  "description": "cubic bazier timing function"
                },
                "params": {
                  "type": "array",
                  "default": [],
                  "items": {
                    "type": "number"
                  }
                }
              },
              "additionalProperties": false
            }
          ],
          "description": "the placeholder option in case nothing is selected"
        },
        "duration": {
          "type": "number",
          "default": 0
        },
        "delay": {
          "type": "number",
          "default": 0
        },
        "viewPortThreshold": {
          "type": "number",
          "exclusiveMinimum": 0,
          "maximum": 1
        },
        "isLegacyCrossFade": {
          "type": "boolean"
        }
      },
      "required": [
        "timing-function"
      ]
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "triggers.json": {
    "$id": "urn:dm:schemas:triggers.json",
    "Triggers": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        }
      },
      "required": [
        "values"
      ]
    }
  },
  "variables.json": {
    "$id": "urn:dm:schemas:variables.json",
    "VariablesList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variables": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "variables"
      ]
    },
    "UnitSizeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "UnitSizeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "object",
          "required": [
            "value",
            "type"
          ],
          "properties": {
            "value": {
              "type": "number"
            },
            "type": {
              "enum": [
                "px",
                "em",
                "rem",
                "fr",
                "percentage",
                "vh",
                "vw",
                "spx",
                "siteWidthPercentage"
              ]
            }
          },
          "additionalProperties": false
        }
      },
      "required": [
        "value"
      ]
    },
    "NumberVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "NumberValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "number"
        }
      },
      "required": [
        "value"
      ]
    },
    "ItemsAlignmentVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "ItemsAlignmentValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "string",
          "enum": [
            "start",
            "end",
            "center",
            "stretch",
            "content"
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "JustifyContentVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "JustifyContentValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "enum": [
            "start",
            "center",
            "end",
            "spaceBetween",
            "spaceAround",
            "spaceEvenly"
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "PositionTypeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "PositionTypeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "enum": [
            "sticky",
            "stickyToHeader",
            "absolute",
            "relative"
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "LayoutSizeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "LayoutSizeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "value": {
                  "type": "number"
                },
                "type": {
                  "enum": [
                    "px",
                    "em",
                    "rem",
                    "fr",
                    "percentage",
                    "vh",
                    "vw",
                    "spx",
                    "siteWidthPercentage"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "Calc"
                  ]
                },
                "value": {
                  "type": "string"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "additionalProperties": false,
              "properties": {
                "type": {
                  "enum": [
                    "CalcFormula"
                  ]
                },
                "value": {
                  "type": "object",
                  "required": [
                    "formula",
                    "values"
                  ],
                  "properties": {
                    "formula": {
                      "type": "string",
                      "description": "A valid css calc formula, with constants formatted like ${constName}"
                    },
                    "values": {
                      "type": "object",
                      "additionalProperties": {
                        "type": "object",
                        "anyOf": [
                          {
                            "type": "object",
                            "required": [
                              "value",
                              "type"
                            ],
                            "properties": {
                              "value": {
                                "type": "number"
                              },
                              "type": {
                                "enum": [
                                  "px",
                                  "em",
                                  "rem",
                                  "fr",
                                  "percentage",
                                  "vh",
                                  "vw",
                                  "spx",
                                  "siteWidthPercentage"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "SystemVariable"
                                ]
                              },
                              "value": {
                                "enum": [
                                  "siteWidth",
                                  "topBannerHeight"
                                ]
                              }
                            }
                          },
                          {
                            "type": "object",
                            "required": [
                              "type",
                              "value"
                            ],
                            "properties": {
                              "type": {
                                "enum": [
                                  "Number"
                                ]
                              },
                              "value": {
                                "type": "number"
                              }
                            }
                          }
                        ]
                      },
                      "minProperties": 1,
                      "properties": {}
                    }
                  },
                  "additionalProperties": false
                }
              }
            },
            {
              "type": "object",
              "required": [
                "type",
                "value"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "SystemVariable"
                  ]
                },
                "value": {
                  "enum": [
                    "siteWidth",
                    "topBannerHeight"
                  ]
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "required": [
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "auto",
                    "maxContent",
                    "minContent",
                    "unset",
                    "fit"
                  ]
                }
              },
              "additionalProperties": false
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "HeightVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "HeightValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "type": "object",
          "anyOf": [
            {
              "type": "object",
              "required": [
                "value",
                "type"
              ],
              "properties": {
                "type": {
                  "enum": [
                    "aspectRatio"
                  ]
                },
                "value": {
                  "type": "number"
                }
              },
              "additionalProperties": false
            },
            {
              "type": "object",
              "anyOf": [
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "value": {
                      "type": "number"
                    },
                    "type": {
                      "enum": [
                        "px",
                        "em",
                        "rem",
                        "fr",
                        "percentage",
                        "vh",
                        "vw",
                        "spx",
                        "siteWidthPercentage"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "Calc"
                      ]
                    },
                    "value": {
                      "type": "string"
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "value",
                    "type"
                  ],
                  "additionalProperties": false,
                  "properties": {
                    "type": {
                      "enum": [
                        "CalcFormula"
                      ]
                    },
                    "value": {
                      "type": "object",
                      "required": [
                        "formula",
                        "values"
                      ],
                      "properties": {
                        "formula": {
                          "type": "string",
                          "description": "A valid css calc formula, with constants formatted like ${constName}"
                        },
                        "values": {
                          "type": "object",
                          "additionalProperties": {
                            "type": "object",
                            "anyOf": [
                              {
                                "type": "object",
                                "required": [
                                  "value",
                                  "type"
                                ],
                                "properties": {
                                  "value": {
                                    "type": "number"
                                  },
                                  "type": {
                                    "enum": [
                                      "px",
                                      "em",
                                      "rem",
                                      "fr",
                                      "percentage",
                                      "vh",
                                      "vw",
                                      "spx",
                                      "siteWidthPercentage"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "SystemVariable"
                                    ]
                                  },
                                  "value": {
                                    "enum": [
                                      "siteWidth",
                                      "topBannerHeight"
                                    ]
                                  }
                                }
                              },
                              {
                                "type": "object",
                                "required": [
                                  "type",
                                  "value"
                                ],
                                "properties": {
                                  "type": {
                                    "enum": [
                                      "Number"
                                    ]
                                  },
                                  "value": {
                                    "type": "number"
                                  }
                                }
                              }
                            ]
                          },
                          "minProperties": 1,
                          "properties": {}
                        }
                      },
                      "additionalProperties": false
                    }
                  }
                },
                {
                  "type": "object",
                  "required": [
                    "type",
                    "value"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "SystemVariable"
                      ]
                    },
                    "value": {
                      "enum": [
                        "siteWidth",
                        "topBannerHeight"
                      ]
                    }
                  },
                  "additionalProperties": false
                },
                {
                  "type": "object",
                  "required": [
                    "type"
                  ],
                  "properties": {
                    "type": {
                      "enum": [
                        "auto",
                        "maxContent",
                        "minContent",
                        "unset",
                        "fit"
                      ]
                    }
                  },
                  "additionalProperties": false
                }
              ]
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "KeywordLengthVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "KeywordLengthValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "enum": [
            "auto-fill",
            "auto-fit"
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "NumVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "NumValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-number",
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+$"
                    }
                  ],
                  "description": "Decimal or integer number"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "LengthVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "LengthValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-length",
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                    }
                  ],
                  "description": "CSS numeric length with all valid units"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "AngleVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "AngleValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-angle",
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
                    }
                  ],
                  "description": "Used in rotation, direction, etc."
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "ColorVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "ColorValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-color",
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                      "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                    },
                    {
                      "type": "string",
                      "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                      "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                    },
                    {
                      "type": "string",
                      "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                      "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                    },
                    {
                      "type": "string",
                      "enum": [
                        "transparent",
                        "currentColor",
                        "aliceblue",
                        "antiquewhite",
                        "aqua",
                        "aquamarine",
                        "azure",
                        "beige",
                        "bisque",
                        "black",
                        "blanchedalmond",
                        "blue",
                        "blueviolet",
                        "brown",
                        "burlywood",
                        "cadetblue",
                        "chartreuse",
                        "chocolate",
                        "coral",
                        "cornflowerblue",
                        "cornsilk",
                        "crimson",
                        "cyan",
                        "darkblue",
                        "darkcyan",
                        "darkgoldenrod",
                        "darkgray",
                        "darkgrey",
                        "darkgreen",
                        "darkkhaki",
                        "darkmagenta",
                        "darkolivegreen",
                        "darkorange",
                        "darkorchid",
                        "darkred",
                        "darksalmon",
                        "darkseagreen",
                        "darkslateblue",
                        "darkslategray",
                        "darkslategrey",
                        "darkturquoise",
                        "darkviolet",
                        "deeppink",
                        "deepskyblue",
                        "dimgray",
                        "dimgrey",
                        "dodgerblue",
                        "firebrick",
                        "floralwhite",
                        "forestgreen",
                        "fuchsia",
                        "gainsboro",
                        "ghostwhite",
                        "gold",
                        "goldenrod",
                        "gray",
                        "grey",
                        "green",
                        "greenyellow",
                        "honeydew",
                        "hotpink",
                        "indianred",
                        "indigo",
                        "ivory",
                        "khaki",
                        "lavender",
                        "lavenderblush",
                        "lawngreen",
                        "lemonchiffon",
                        "lightblue",
                        "lightcoral",
                        "lightcyan",
                        "lightgoldenrodyellow",
                        "lightgray",
                        "lightgrey",
                        "lightgreen",
                        "lightpink",
                        "lightsalmon",
                        "lightseagreen",
                        "lightskyblue",
                        "lightslategray",
                        "lightslategrey",
                        "lightsteelblue",
                        "lightyellow",
                        "lime",
                        "limegreen",
                        "linen",
                        "magenta",
                        "maroon",
                        "mediumaquamarine",
                        "mediumblue",
                        "mediumorchid",
                        "mediumpurple",
                        "mediumseagreen",
                        "mediumslateblue",
                        "mediumspringgreen",
                        "mediumturquoise",
                        "mediumvioletred",
                        "midnightblue",
                        "mintcream",
                        "mistyrose",
                        "moccasin",
                        "navajowhite",
                        "navy",
                        "oldlace",
                        "olive",
                        "olivedrab",
                        "orange",
                        "orangered",
                        "orchid",
                        "palegoldenrod",
                        "palegreen",
                        "paleturquoise",
                        "palevioletred",
                        "papayawhip",
                        "peachpuff",
                        "peru",
                        "pink",
                        "plum",
                        "powderblue",
                        "purple",
                        "rebeccapurple",
                        "red",
                        "rosybrown",
                        "royalblue",
                        "saddlebrown",
                        "salmon",
                        "sandybrown",
                        "seagreen",
                        "seashell",
                        "sienna",
                        "silver",
                        "skyblue",
                        "slateblue",
                        "slategray",
                        "slategrey",
                        "snow",
                        "springgreen",
                        "steelblue",
                        "tan",
                        "teal",
                        "thistle",
                        "tomato",
                        "turquoise",
                        "violet",
                        "wheat",
                        "white",
                        "whitesmoke",
                        "yellow",
                        "yellowgreen"
                      ],
                      "description": "CSS named colors including transparent and currentColor"
                    }
                  ],
                  "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "PercentageVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "PercentageValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-percentage",
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+%$"
                    }
                  ],
                  "description": "Number followed by %"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderEdgeStyleVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderEdgeStyleValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-border-top-style",
                  "enum": [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset"
                  ],
                  "description": "CSS line style keywords"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderEdgeWidthVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderEdgeWidthValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-border-top-width",
                  "anyOf": [
                    {
                      "allOf": [
                        {
                          "type": "string",
                          "pattern": "^[^-]",
                          "description": "CSS positive value"
                        },
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        }
                      ],
                      "description": "CSS positive numeric length with all valid units"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "thin",
                        "medium",
                        "thick"
                      ]
                    }
                  ],
                  "description": "CSS line width: length values or predefined keywords"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderWidthVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderWidthValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "description": "this ref needs to be changed to shorthand syntax of the ref",
                  "format": "css-border-width",
                  "pattern": "^(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderStyleVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderStyleValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "description": "this ref needs to be changed to shorthand syntax of the ref",
                  "format": "css-border-style",
                  "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderColorVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderColorValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-color",
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                              "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                            },
                            {
                              "type": "string",
                              "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                              "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                            },
                            {
                              "type": "string",
                              "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                              "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                            },
                            {
                              "type": "string",
                              "enum": [
                                "transparent",
                                "currentColor",
                                "aliceblue",
                                "antiquewhite",
                                "aqua",
                                "aquamarine",
                                "azure",
                                "beige",
                                "bisque",
                                "black",
                                "blanchedalmond",
                                "blue",
                                "blueviolet",
                                "brown",
                                "burlywood",
                                "cadetblue",
                                "chartreuse",
                                "chocolate",
                                "coral",
                                "cornflowerblue",
                                "cornsilk",
                                "crimson",
                                "cyan",
                                "darkblue",
                                "darkcyan",
                                "darkgoldenrod",
                                "darkgray",
                                "darkgrey",
                                "darkgreen",
                                "darkkhaki",
                                "darkmagenta",
                                "darkolivegreen",
                                "darkorange",
                                "darkorchid",
                                "darkred",
                                "darksalmon",
                                "darkseagreen",
                                "darkslateblue",
                                "darkslategray",
                                "darkslategrey",
                                "darkturquoise",
                                "darkviolet",
                                "deeppink",
                                "deepskyblue",
                                "dimgray",
                                "dimgrey",
                                "dodgerblue",
                                "firebrick",
                                "floralwhite",
                                "forestgreen",
                                "fuchsia",
                                "gainsboro",
                                "ghostwhite",
                                "gold",
                                "goldenrod",
                                "gray",
                                "grey",
                                "green",
                                "greenyellow",
                                "honeydew",
                                "hotpink",
                                "indianred",
                                "indigo",
                                "ivory",
                                "khaki",
                                "lavender",
                                "lavenderblush",
                                "lawngreen",
                                "lemonchiffon",
                                "lightblue",
                                "lightcoral",
                                "lightcyan",
                                "lightgoldenrodyellow",
                                "lightgray",
                                "lightgrey",
                                "lightgreen",
                                "lightpink",
                                "lightsalmon",
                                "lightseagreen",
                                "lightskyblue",
                                "lightslategray",
                                "lightslategrey",
                                "lightsteelblue",
                                "lightyellow",
                                "lime",
                                "limegreen",
                                "linen",
                                "magenta",
                                "maroon",
                                "mediumaquamarine",
                                "mediumblue",
                                "mediumorchid",
                                "mediumpurple",
                                "mediumseagreen",
                                "mediumslateblue",
                                "mediumspringgreen",
                                "mediumturquoise",
                                "mediumvioletred",
                                "midnightblue",
                                "mintcream",
                                "mistyrose",
                                "moccasin",
                                "navajowhite",
                                "navy",
                                "oldlace",
                                "olive",
                                "olivedrab",
                                "orange",
                                "orangered",
                                "orchid",
                                "palegoldenrod",
                                "palegreen",
                                "paleturquoise",
                                "palevioletred",
                                "papayawhip",
                                "peachpuff",
                                "peru",
                                "pink",
                                "plum",
                                "powderblue",
                                "purple",
                                "rebeccapurple",
                                "red",
                                "rosybrown",
                                "royalblue",
                                "saddlebrown",
                                "salmon",
                                "sandybrown",
                                "seagreen",
                                "seashell",
                                "sienna",
                                "silver",
                                "skyblue",
                                "slateblue",
                                "slategray",
                                "slategrey",
                                "snow",
                                "springgreen",
                                "steelblue",
                                "tan",
                                "teal",
                                "thistle",
                                "tomato",
                                "turquoise",
                                "violet",
                                "wheat",
                                "white",
                                "whitesmoke",
                                "yellow",
                                "yellowgreen"
                              ],
                              "description": "CSS named colors including transparent and currentColor"
                            }
                          ],
                          "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "description": "this ref needs to be changed to shorthand syntax of the ref",
                  "format": "css-border-color",
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
                      "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
                    },
                    {
                      "type": "string",
                      "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                      "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
                    },
                    {
                      "type": "string",
                      "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
                      "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
                    },
                    {
                      "type": "string",
                      "enum": [
                        "transparent",
                        "currentColor",
                        "aliceblue",
                        "antiquewhite",
                        "aqua",
                        "aquamarine",
                        "azure",
                        "beige",
                        "bisque",
                        "black",
                        "blanchedalmond",
                        "blue",
                        "blueviolet",
                        "brown",
                        "burlywood",
                        "cadetblue",
                        "chartreuse",
                        "chocolate",
                        "coral",
                        "cornflowerblue",
                        "cornsilk",
                        "crimson",
                        "cyan",
                        "darkblue",
                        "darkcyan",
                        "darkgoldenrod",
                        "darkgray",
                        "darkgrey",
                        "darkgreen",
                        "darkkhaki",
                        "darkmagenta",
                        "darkolivegreen",
                        "darkorange",
                        "darkorchid",
                        "darkred",
                        "darksalmon",
                        "darkseagreen",
                        "darkslateblue",
                        "darkslategray",
                        "darkslategrey",
                        "darkturquoise",
                        "darkviolet",
                        "deeppink",
                        "deepskyblue",
                        "dimgray",
                        "dimgrey",
                        "dodgerblue",
                        "firebrick",
                        "floralwhite",
                        "forestgreen",
                        "fuchsia",
                        "gainsboro",
                        "ghostwhite",
                        "gold",
                        "goldenrod",
                        "gray",
                        "grey",
                        "green",
                        "greenyellow",
                        "honeydew",
                        "hotpink",
                        "indianred",
                        "indigo",
                        "ivory",
                        "khaki",
                        "lavender",
                        "lavenderblush",
                        "lawngreen",
                        "lemonchiffon",
                        "lightblue",
                        "lightcoral",
                        "lightcyan",
                        "lightgoldenrodyellow",
                        "lightgray",
                        "lightgrey",
                        "lightgreen",
                        "lightpink",
                        "lightsalmon",
                        "lightseagreen",
                        "lightskyblue",
                        "lightslategray",
                        "lightslategrey",
                        "lightsteelblue",
                        "lightyellow",
                        "lime",
                        "limegreen",
                        "linen",
                        "magenta",
                        "maroon",
                        "mediumaquamarine",
                        "mediumblue",
                        "mediumorchid",
                        "mediumpurple",
                        "mediumseagreen",
                        "mediumslateblue",
                        "mediumspringgreen",
                        "mediumturquoise",
                        "mediumvioletred",
                        "midnightblue",
                        "mintcream",
                        "mistyrose",
                        "moccasin",
                        "navajowhite",
                        "navy",
                        "oldlace",
                        "olive",
                        "olivedrab",
                        "orange",
                        "orangered",
                        "orchid",
                        "palegoldenrod",
                        "palegreen",
                        "paleturquoise",
                        "palevioletred",
                        "papayawhip",
                        "peachpuff",
                        "peru",
                        "pink",
                        "plum",
                        "powderblue",
                        "purple",
                        "rebeccapurple",
                        "red",
                        "rosybrown",
                        "royalblue",
                        "saddlebrown",
                        "salmon",
                        "sandybrown",
                        "seagreen",
                        "seashell",
                        "sienna",
                        "silver",
                        "skyblue",
                        "slateblue",
                        "slategray",
                        "slategrey",
                        "snow",
                        "springgreen",
                        "steelblue",
                        "tan",
                        "teal",
                        "thistle",
                        "tomato",
                        "turquoise",
                        "violet",
                        "wheat",
                        "white",
                        "whitesmoke",
                        "yellow",
                        "yellowgreen"
                      ],
                      "description": "CSS named colors including transparent and currentColor"
                    }
                  ]
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-border",
                  "description": "CSS border shorthand. Complex syntax combining line-width, line-style, and color cannot be fully validated with regex as it allows various combinations and orders."
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderCornerRadiusVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderCornerRadiusValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                  "description": "CSS var() function- resolving a variable value from the variable"
                                },
                                {
                                  "type": "string",
                                  "format": "css-length",
                                  "allOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^[^-]",
                                      "description": "CSS positive value"
                                    },
                                    {
                                      "oneOf": [
                                        {
                                          "type": "string",
                                          "pattern": "^calc\\([^(),]+\\)$",
                                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                        },
                                        {
                                          "type": "string",
                                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                        }
                                      ],
                                      "description": "CSS numeric length with all valid units"
                                    }
                                  ],
                                  "description": "CSS positive numeric length with all valid units"
                                },
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ],
                                  "description": "Global values available for any CSS property"
                                }
                              ]
                            },
                            {
                              "maxLength": 150
                            }
                          ]
                        },
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                  "description": "CSS var() function- resolving a variable value from the variable"
                                },
                                {
                                  "type": "string",
                                  "format": "css-percentage",
                                  "allOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^[^-]",
                                      "description": "CSS positive value"
                                    },
                                    {
                                      "oneOf": [
                                        {
                                          "type": "string",
                                          "pattern": "^calc\\([^(),]+\\)$",
                                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                        },
                                        {
                                          "type": "string",
                                          "pattern": "^-?\\d*\\.?\\d+%$"
                                        }
                                      ],
                                      "description": "Number followed by %"
                                    }
                                  ],
                                  "description": "Positive number followed by %"
                                },
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ],
                                  "description": "Global values available for any CSS property"
                                }
                              ]
                            },
                            {
                              "maxLength": 150
                            }
                          ]
                        },
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length-percentage",
                          "anyOf": [
                            {
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                    }
                                  ],
                                  "description": "CSS numeric length with all valid units"
                                }
                              ],
                              "description": "CSS positive numeric length with all valid units"
                            },
                            {
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^-?\\d*\\.?\\d+%$"
                                    }
                                  ],
                                  "description": "Number followed by %"
                                }
                              ],
                              "description": "Positive number followed by %"
                            }
                          ],
                          "description": "Accepts both <positive-length> and <positive-percentage>"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-border-top-left-radius",
                  "pattern": "^(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
                  "description": "CSS border-top-left-radius shorthand"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BorderRadiusVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BorderRadiusValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "description": "border radius shorthand syntax",
                  "format": "css-border-radius",
                  "pattern": "^(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3}(\\s*/\\s*(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(0|calc\\([^(),]+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))){0,3})?$"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font",
                  "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontSizeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontSizeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-size",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "xx-small",
                        "x-small",
                        "small",
                        "medium",
                        "large",
                        "x-large",
                        "xx-large",
                        "xxx-large"
                      ],
                      "description": "CSS absolute font sizes"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "larger",
                        "smaller"
                      ],
                      "description": "CSS relative font sizes"
                    },
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        }
                      ],
                      "description": "Accepts both <positive-length> and <positive-percentage>"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "math"
                      ]
                    }
                  ],
                  "description": "CSS font size: length, percentage, or keyword values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontStretchVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontStretchValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^-?\\d*\\.?\\d+%$"
                            }
                          ],
                          "description": "Number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-stretch",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal",
                        "ultra-condensed",
                        "extra-condensed",
                        "condensed",
                        "semi-condensed",
                        "semi-expanded",
                        "expanded",
                        "extra-expanded",
                        "ultra-expanded"
                      ]
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+%$"
                        }
                      ],
                      "description": "Number followed by %"
                    }
                  ],
                  "description": "CSS font stretch absolute values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontStyleVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontStyleValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-style",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal",
                        "italic",
                        "oblique"
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^oblique\\s+\\d+deg$"
                    }
                  ],
                  "description": "CSS font style: keywords or oblique with angle"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontVariantVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontVariantValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-variant",
                  "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontWeightVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontWeightValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-weight",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal",
                        "bold",
                        "bolder",
                        "lighter"
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^(100|200|300|400|500|600|700|800|900)$"
                    }
                  ],
                  "description": "CSS font weight: keywords or numeric values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FontFamilyVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FontFamilyValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-string",
                          "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                          "description": "Quoted strings with escapes"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-font-family",
                  "anyOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
                          "description": "Quoted strings with escapes"
                        },
                        {
                          "type": "string",
                          "pattern": "^[a-zA-Z_][\\w-]*$",
                          "description": "CSS identifiers (excluding keywords)"
                        }
                      ],
                      "description": "CSS font family name: quoted string or unquoted identifier"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "serif",
                        "sans-serif",
                        "monospace",
                        "cursive",
                        "fantasy",
                        "system-ui",
                        "ui-serif",
                        "ui-sans-serif",
                        "ui-monospace",
                        "ui-rounded",
                        "math",
                        "emoji",
                        "fangsong"
                      ],
                      "description": "CSS generic font families"
                    },
                    {
                      "type": "string",
                      "pattern": "^['\"]?([^0-9][\\w\\s\\-]*)['\"]?(,\\s*['\"]?([^0-9][\\w\\s\\-]*)['\"]?)*$",
                      "description": "Complex family name with multiple family names separated by commas"
                    }
                  ],
                  "description": "CSS font family: generic families, quoted family names, or unquoted family names"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "LineHeightVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "LineHeightValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-number",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+$"
                                }
                              ],
                              "description": "Decimal or integer number"
                            }
                          ],
                          "description": "Positive decimal or integer number"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-line-height",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal"
                      ],
                      "description": "CSS normal keyword"
                    },
                    {
                      "allOf": [
                        {
                          "type": "string",
                          "pattern": "^[^-]",
                          "description": "CSS positive value"
                        },
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^-?\\d*\\.?\\d+$"
                            }
                          ],
                          "description": "Decimal or integer number"
                        }
                      ],
                      "description": "Positive decimal or integer number"
                    },
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        }
                      ],
                      "description": "Accepts both <positive-length> and <positive-percentage>"
                    }
                  ],
                  "description": "CSS line-height: normal, number, length, or percentage"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "LetterSpacingVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "LetterSpacingValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-letter-spacing",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal"
                      ],
                      "description": "CSS normal keyword"
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                        }
                      ],
                      "description": "CSS numeric length with all valid units"
                    }
                  ],
                  "description": "CSS letter-spacing: normal or length"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextAlignVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextAlignValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-align",
                  "enum": [
                    "left",
                    "right",
                    "center",
                    "justify",
                    "start",
                    "end",
                    "match-parent"
                  ],
                  "description": "CSS text-align property values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextTransformVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextTransformValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-transform",
                  "enum": [
                    "none",
                    "capitalize",
                    "uppercase",
                    "lowercase",
                    "full-width",
                    "full-size-kana"
                  ],
                  "description": "CSS text-transform values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextShadowVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextShadowValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-shadow",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "none"
                      ],
                      "description": "CSS none keyword"
                    },
                    {
                      "type": "string",
                      "description": "complex shadow value that cannot be fully validated with regex"
                    }
                  ],
                  "description": "CSS text-shadow: none or shadow values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextDecorationVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextDecorationValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-decoration",
                  "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextDecorationLineVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextDecorationLineValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-decoration-line",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "none",
                        "underline",
                        "overline",
                        "line-through",
                        "blink"
                      ],
                      "description": "single value text decoration line"
                    },
                    {
                      "type": "string",
                      "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
                      "description": "multiple values text decoration line that cannot be fully validated with regex"
                    }
                  ],
                  "description": "CSS text-decoration-line values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextDecorationStyleVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextDecorationStyleValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-decoration-style",
                  "enum": [
                    "solid",
                    "double",
                    "dotted",
                    "dashed",
                    "wavy"
                  ],
                  "description": "CSS text-decoration-style values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "TextDecorationThicknessVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "TextDecorationThicknessValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^-?\\d*\\.?\\d+%$"
                            }
                          ],
                          "description": "Number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-text-decoration-thickness",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "auto"
                      ],
                      "description": "CSS auto keyword"
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                        }
                      ],
                      "description": "CSS numeric length with all valid units"
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+%$"
                        }
                      ],
                      "description": "Number followed by %"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "from-font"
                      ]
                    }
                  ],
                  "description": "CSS text decoration thickness"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "PaddingVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "PaddingValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-padding",
              "description": "padding shorthand syntax",
              "pattern": "^(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))(\\s+(0|calc\\([^(),]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))){0,3}$"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "PaddingEdgeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "PaddingEdgeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                              "description": "CSS var() function- resolving a variable value from the variable"
                            },
                            {
                              "type": "string",
                              "format": "css-length",
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                    }
                                  ],
                                  "description": "CSS numeric length with all valid units"
                                }
                              ],
                              "description": "CSS positive numeric length with all valid units"
                            },
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ],
                              "description": "Global values available for any CSS property"
                            }
                          ]
                        },
                        {
                          "maxLength": 150
                        }
                      ]
                    },
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                              "description": "CSS var() function- resolving a variable value from the variable"
                            },
                            {
                              "type": "string",
                              "format": "css-percentage",
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^-?\\d*\\.?\\d+%$"
                                    }
                                  ],
                                  "description": "Number followed by %"
                                }
                              ],
                              "description": "Positive number followed by %"
                            },
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ],
                              "description": "Global values available for any CSS property"
                            }
                          ]
                        },
                        {
                          "maxLength": 150
                        }
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-length-percentage",
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        }
                      ],
                      "description": "Accepts both <positive-length> and <positive-percentage>"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-length",
                      "allOf": [
                        {
                          "type": "string",
                          "pattern": "^[^-]",
                          "description": "CSS positive value"
                        },
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        }
                      ],
                      "description": "CSS positive numeric length with all valid units"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-percentage",
                      "allOf": [
                        {
                          "type": "string",
                          "pattern": "^[^-]",
                          "description": "CSS positive value"
                        },
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^-?\\d*\\.?\\d+%$"
                            }
                          ],
                          "description": "Number followed by %"
                        }
                      ],
                      "description": "Positive number followed by %"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-padding-top",
              "description": "CSS padding-top values",
              "anyOf": [
                {
                  "allOf": [
                    {
                      "type": "string",
                      "pattern": "^[^-]",
                      "description": "CSS positive value"
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                        }
                      ],
                      "description": "CSS numeric length with all valid units"
                    }
                  ],
                  "description": "CSS positive numeric length with all valid units"
                },
                {
                  "allOf": [
                    {
                      "type": "string",
                      "pattern": "^[^-]",
                      "description": "CSS positive value"
                    },
                    {
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+%$"
                        }
                      ],
                      "description": "Number followed by %"
                    }
                  ],
                  "description": "Positive number followed by %"
                }
              ]
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "MarginVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "MarginValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "description": "margin shorthand syntax",
              "format": "css-margin"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "MarginEdgeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "MarginEdgeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                              "description": "CSS var() function- resolving a variable value from the variable"
                            },
                            {
                              "type": "string",
                              "format": "css-length",
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            },
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ],
                              "description": "Global values available for any CSS property"
                            }
                          ]
                        },
                        {
                          "maxLength": 150
                        }
                      ]
                    },
                    {
                      "allOf": [
                        {
                          "anyOf": [
                            {
                              "type": "string",
                              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                              "description": "CSS var() function- resolving a variable value from the variable"
                            },
                            {
                              "type": "string",
                              "format": "css-percentage",
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            },
                            {
                              "type": "string",
                              "enum": [
                                "inherit",
                                "initial",
                                "unset",
                                "revert",
                                "revert-layer"
                              ],
                              "description": "Global values available for any CSS property"
                            }
                          ]
                        },
                        {
                          "maxLength": 150
                        }
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-length-percentage",
                      "anyOf": [
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                            }
                          ],
                          "description": "CSS numeric length with all valid units"
                        },
                        {
                          "oneOf": [
                            {
                              "type": "string",
                              "pattern": "^calc\\([^(),]+\\)$",
                              "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                            },
                            {
                              "type": "string",
                              "pattern": "^-?\\d*\\.?\\d+%$"
                            }
                          ],
                          "description": "Number followed by %"
                        }
                      ],
                      "description": "Accepts both <length> and <percentage>"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-length",
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                        }
                      ],
                      "description": "CSS numeric length with all valid units"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-percentage",
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+%$"
                        }
                      ],
                      "description": "Number followed by %"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-margin-top",
              "anyOf": [
                {
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                    }
                  ],
                  "description": "CSS numeric length with all valid units"
                },
                {
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+%$"
                    }
                  ],
                  "description": "Number followed by %"
                },
                {
                  "type": "string",
                  "enum": [
                    "auto"
                  ],
                  "description": "CSS auto keyword"
                }
              ],
              "description": "CSS length, percentage, or auto"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BoxShadowVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BoxShadowValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-box-shadow"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "OpacityVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "OpacityValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-number",
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+$"
                        }
                      ],
                      "description": "Decimal or integer number"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "allOf": [
                {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                      "description": "CSS var() function- resolving a variable value from the variable"
                    },
                    {
                      "type": "string",
                      "format": "css-percentage",
                      "oneOf": [
                        {
                          "type": "string",
                          "pattern": "^calc\\([^(),]+\\)$",
                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                        },
                        {
                          "type": "string",
                          "pattern": "^-?\\d*\\.?\\d+%$"
                        }
                      ],
                      "description": "Number followed by %"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "inherit",
                        "initial",
                        "unset",
                        "revert",
                        "revert-layer"
                      ],
                      "description": "Global values available for any CSS property"
                    }
                  ]
                },
                {
                  "maxLength": 150
                }
              ]
            },
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-opacity",
              "anyOf": [
                {
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+$"
                    }
                  ],
                  "description": "Decimal or integer number"
                },
                {
                  "oneOf": [
                    {
                      "type": "string",
                      "pattern": "^calc\\([^(),]+\\)$",
                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                    },
                    {
                      "type": "string",
                      "pattern": "^-?\\d*\\.?\\d+%$"
                    }
                  ],
                  "description": "Number followed by %"
                }
              ],
              "description": "CSS opacity: number (0-1) or percentage"
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "CssJustifyContentVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "CssJustifyContentValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-justify-content",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "normal"
                      ],
                      "description": "CSS normal keyword"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "space-between",
                        "space-around",
                        "space-evenly",
                        "stretch"
                      ],
                      "description": "CSS content distribution values for alignment"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "center",
                        "start",
                        "end",
                        "flex-start",
                        "flex-end"
                      ],
                      "description": "CSS content position values for alignment"
                    },
                    {
                      "type": "string",
                      "enum": [
                        "left",
                        "right"
                      ]
                    },
                    {
                      "type": "string",
                      "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
                    }
                  ],
                  "description": "CSS justify-content values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "BackgroundVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "BackgroundValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
              "description": "CSS var() function- resolving a variable value from the variable"
            },
            {
              "type": "string",
              "format": "css-background",
              "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
            },
            {
              "type": "string",
              "enum": [
                "inherit",
                "initial",
                "unset",
                "revert",
                "revert-layer"
              ],
              "description": "Global values available for any CSS property"
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "WritingModeVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "WritingModeValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-writing-mode",
                  "enum": [
                    "horizontal-tb",
                    "vertical-rl",
                    "vertical-lr",
                    "sideways-rl",
                    "sideways-lr"
                  ],
                  "description": "CSS writing-mode values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "DisplayVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "DisplayValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-display",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "table-row-group",
                        "table-header-group",
                        "table-footer-group",
                        "table-row",
                        "table-cell",
                        "table-column-group",
                        "table-column",
                        "table-caption",
                        "ruby-base",
                        "ruby-text",
                        "ruby-base-container",
                        "ruby-text-container",
                        "contents",
                        "none",
                        "inline-block",
                        "inline-table",
                        "inline-flex",
                        "inline-grid"
                      ]
                    },
                    {
                      "type": "string",
                      "description": "complex display value that cannot be fully validated with regex"
                    }
                  ],
                  "description": "CSS display property values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "FilterVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "FilterValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-filter",
                  "anyOf": [
                    {
                      "type": "string",
                      "enum": [
                        "none"
                      ],
                      "description": "CSS none keyword"
                    },
                    {
                      "type": "string",
                      "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
                      "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
                    }
                  ],
                  "description": "CSS filter value"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "GapVar": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "name": {
          "type": "string"
        },
        "value": {
          "type": [
            "string"
          ]
        }
      }
    },
    "GapValue": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "variableConnections": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "type": "object",
                "properties": {
                  "path": {
                    "type": "string",
                    "pattern": "^(?:value)$"
                  },
                  "variableId": {
                    "type": [
                      "string"
                    ]
                  }
                },
                "additionalProperties": false
              }
            ]
          }
        },
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "value": {
          "allOf": [
            {
              "anyOf": [
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                  "description": "CSS var() function- resolving a variable value from the variable"
                                },
                                {
                                  "type": "string",
                                  "format": "css-length",
                                  "allOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^[^-]",
                                      "description": "CSS positive value"
                                    },
                                    {
                                      "oneOf": [
                                        {
                                          "type": "string",
                                          "pattern": "^calc\\([^(),]+\\)$",
                                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                        },
                                        {
                                          "type": "string",
                                          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                        }
                                      ],
                                      "description": "CSS numeric length with all valid units"
                                    }
                                  ],
                                  "description": "CSS positive numeric length with all valid units"
                                },
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ],
                                  "description": "Global values available for any CSS property"
                                }
                              ]
                            },
                            {
                              "maxLength": 150
                            }
                          ]
                        },
                        {
                          "allOf": [
                            {
                              "anyOf": [
                                {
                                  "type": "string",
                                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                                  "description": "CSS var() function- resolving a variable value from the variable"
                                },
                                {
                                  "type": "string",
                                  "format": "css-percentage",
                                  "allOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^[^-]",
                                      "description": "CSS positive value"
                                    },
                                    {
                                      "oneOf": [
                                        {
                                          "type": "string",
                                          "pattern": "^calc\\([^(),]+\\)$",
                                          "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                        },
                                        {
                                          "type": "string",
                                          "pattern": "^-?\\d*\\.?\\d+%$"
                                        }
                                      ],
                                      "description": "Number followed by %"
                                    }
                                  ],
                                  "description": "Positive number followed by %"
                                },
                                {
                                  "type": "string",
                                  "enum": [
                                    "inherit",
                                    "initial",
                                    "unset",
                                    "revert",
                                    "revert-layer"
                                  ],
                                  "description": "Global values available for any CSS property"
                                }
                              ]
                            },
                            {
                              "maxLength": 150
                            }
                          ]
                        },
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length-percentage",
                          "anyOf": [
                            {
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                    }
                                  ],
                                  "description": "CSS numeric length with all valid units"
                                }
                              ],
                              "description": "CSS positive numeric length with all valid units"
                            },
                            {
                              "allOf": [
                                {
                                  "type": "string",
                                  "pattern": "^[^-]",
                                  "description": "CSS positive value"
                                },
                                {
                                  "oneOf": [
                                    {
                                      "type": "string",
                                      "pattern": "^calc\\([^(),]+\\)$",
                                      "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                    },
                                    {
                                      "type": "string",
                                      "pattern": "^-?\\d*\\.?\\d+%$"
                                    }
                                  ],
                                  "description": "Number followed by %"
                                }
                              ],
                              "description": "Positive number followed by %"
                            }
                          ],
                          "description": "Accepts both <positive-length> and <positive-percentage>"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-length",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
                                }
                              ],
                              "description": "CSS numeric length with all valid units"
                            }
                          ],
                          "description": "CSS positive numeric length with all valid units"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "allOf": [
                    {
                      "anyOf": [
                        {
                          "type": "string",
                          "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                          "description": "CSS var() function- resolving a variable value from the variable"
                        },
                        {
                          "type": "string",
                          "format": "css-percentage",
                          "allOf": [
                            {
                              "type": "string",
                              "pattern": "^[^-]",
                              "description": "CSS positive value"
                            },
                            {
                              "oneOf": [
                                {
                                  "type": "string",
                                  "pattern": "^calc\\([^(),]+\\)$",
                                  "description": "CSS calc() function. The arithmetic expression inside cannot be fully validated with regex as it requires parsing of nested parentheses, operators, and mixed units."
                                },
                                {
                                  "type": "string",
                                  "pattern": "^-?\\d*\\.?\\d+%$"
                                }
                              ],
                              "description": "Number followed by %"
                            }
                          ],
                          "description": "Positive number followed by %"
                        },
                        {
                          "type": "string",
                          "enum": [
                            "inherit",
                            "initial",
                            "unset",
                            "revert",
                            "revert-layer"
                          ],
                          "description": "Global values available for any CSS property"
                        }
                      ]
                    },
                    {
                      "maxLength": 150
                    }
                  ]
                },
                {
                  "type": "string",
                  "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
                  "description": "CSS var() function- resolving a variable value from the variable"
                },
                {
                  "type": "string",
                  "format": "css-gap",
                  "pattern": "^(normal|0|calc\\([^(),]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
                  "description": "CSS gap values"
                },
                {
                  "type": "string",
                  "enum": [
                    "inherit",
                    "initial",
                    "unset",
                    "revert",
                    "revert-layer"
                  ],
                  "description": "Global values available for any CSS property"
                }
              ]
            },
            {
              "maxLength": 150
            }
          ]
        }
      },
      "required": [
        "value"
      ]
    },
    "RefArray": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ],
          "default": [],
          "type": [
            "array"
          ]
        }
      }
    },
    "VariantRelation": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "variants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          },
          "default": []
        },
        "remoteVariants": {
          "type": "array",
          "items": {
            "type": [
              "string"
            ]
          }
        },
        "from": {
          "type": [
            "string"
          ]
        },
        "to": {
          "type": [
            "string"
          ]
        }
      },
      "required": [
        "variants",
        "from",
        "to"
      ]
    }
  },
  "variants_data.json": {
    "$id": "urn:dm:schemas:variants_data.json",
    "Hover": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "Mobile": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "State": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        },
        "name": {
          "type": "string",
          "default": "state"
        }
      },
      "required": [
        "componentId",
        "name"
      ]
    },
    "Selected": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "Trigger": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        },
        "trigger": {
          "type": "string"
        },
        "params": {
          "type": "object",
          "additionalProperties": true
        }
      },
      "required": [
        "componentId",
        "trigger"
      ],
      "anyOf": [
        {
          "additionalProperties": true,
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "viewport-enter",
                "viewport-leave"
              ]
            },
            "params": {
              "type": "object",
              "properties": {
                "threshold": {
                  "type": "number",
                  "minimum": 0,
                  "maximum": 1
                },
                "margin": {
                  "type": "object",
                  "properties": {
                    "top": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "bottom": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "left": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    },
                    "right": {
                      "type": "object",
                      "required": [
                        "value",
                        "type"
                      ],
                      "properties": {
                        "value": {
                          "type": "number"
                        },
                        "type": {
                          "enum": [
                            "px",
                            "percentage"
                          ]
                        }
                      },
                      "additionalProperties": false
                    }
                  },
                  "additionalProperties": false
                }
              },
              "additionalProperties": false
            }
          }
        },
        {
          "additionalProperties": true,
          "required": [
            "params"
          ],
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "animation-start",
                "animation-end"
              ]
            },
            "params": {
              "type": "object",
              "required": [
                "effect"
              ],
              "additionalProperties": false,
              "properties": {
                "effect": {
                  "type": [
                    "string"
                  ]
                }
              }
            }
          }
        },
        {
          "additionalProperties": true,
          "properties": {
            "trigger": {
              "type": "string",
              "enum": [
                "pointer-move"
              ]
            },
            "params": {
              "type": "object",
              "required": [
                "hitArea"
              ],
              "properties": {
                "hitArea": {
                  "type": "string",
                  "default": "self",
                  "enum": [
                    "self",
                    "root"
                  ]
                }
              },
              "additionalProperties": false
            }
          }
        },
        {
          "additionalProperties": true,
          "properties": {
            "trigger": {
              "type": "string",
              "default": "click",
              "enum": [
                "click",
                "tap",
                "mouse-in",
                "mouse-out",
                "hover",
                "view-progress",
                "scroll-progress",
                "page-visible"
              ]
            },
            "params": {
              "type": "object",
              "additionalProperties": false
            }
          }
        }
      ]
    },
    "Preset": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "componentId"
      ]
    },
    "RepeaterPattern": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        },
        "tag": {
          "type": "string"
        }
      },
      "required": [
        "componentId",
        "tag"
      ]
    },
    "RepeaterPatternList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        },
        "values": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "componentId",
        "values"
      ]
    },
    "VariantsList": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "componentId": {
          "type": "string"
        },
        "values": {
          "default": [],
          "type": [
            "array"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        }
      },
      "required": [
        "componentId",
        "values"
      ]
    },
    "BreakpointsData": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "values": {
          "type": [
            "array",
            "null"
          ],
          "items": [
            {
              "type": [
                "null",
                "string"
              ]
            }
          ]
        },
        "componentId": {
          "type": "string"
        }
      },
      "required": [
        "values"
      ]
    },
    "BreakpointRange": {
      "additionalProperties": false,
      "type": [
        "object"
      ],
      "properties": {
        "type": {
          "type": "string"
        },
        "id": {
          "type": "string"
        },
        "metaData": {
          "type": "object",
          "properties": {
            "pageId": {
              "type": "string"
            },
            "isPreset": {
              "type": "boolean"
            },
            "schemaVersion": {
              "type": "string"
            },
            "isHidden": {
              "type": "boolean"
            },
            "logicalName": {
              "type": "string"
            },
            "description": {
              "type": "string",
              "maxLength": 4000
            },
            "sig": {
              "type": "string"
            },
            "fragmentInstance": {
              "type": "string"
            }
          },
          "additionalProperties": false
        },
        "min": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "max": {
          "type": "number",
          "default": 0,
          "multipleOf": 1,
          "minimum": -2147483648,
          "maximum": 2147483647
        },
        "canvasSize": {
          "type": "number",
          "multipleOf": 1
        }
      }
    }
  }
}
